
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("fTvEN", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4r9Pq = parcelRequire("4r9Pq");

var $iw2ID = parcelRequire("iw2ID");


var $d925B = parcelRequire("d925B");


var $btNLq = parcelRequire("btNLq");

var $gEb6G = parcelRequire("gEb6G");


var $4HWgE = parcelRequire("4HWgE");


var $3pLGZ = parcelRequire("3pLGZ");


var $l9FJJ = parcelRequire("l9FJJ");


var $dZ8uq = parcelRequire("dZ8uq");


var $adayn = parcelRequire("adayn");

const $7a3c52dd7aa30a82$export$de35616b4bcd2077 = (from, to, open = true)=>({ tr: tr })=>{
        const { expand: expand, nestedExpand: nestedExpand } = tr.doc.type.schema.nodes;
        const fromClamped = from && from >= 0 ? from : 0;
        const toClamped = to && to <= tr.doc.content.size ? to : tr.doc.content.size;
        tr.doc.nodesBetween(fromClamped, toClamped, (node)=>{
            if ([
                expand,
                nestedExpand
            ].includes(node.type)) (0, $adayn.expandedState).set(node, open);
        });
        return null;
    };






var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");








var $b3YrF = parcelRequire("b3YrF");


var $ks2lK = parcelRequire("ks2lK");


var $2GVu1 = parcelRequire("2GVu1");


var $cZifa = parcelRequire("cZifa");

const $0405d2e291010188$var$nodeName = 'expand';
const $0405d2e291010188$var$ExpandBlockMenuItem = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const selection = (0, $b3YrF.useSharedPluginStateSelector)(api, 'selection.selection');
    const isExpandSelected = (0, $42omo.useMemo)(()=>{
        if (!selection) return false;
        if (selection instanceof (0, $ks2lK.NodeSelection)) return selection.node.type.name === $0405d2e291010188$var$nodeName;
        return false;
    }, [
        selection
    ]);
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $d925B.INPUT_METHOD).KEYBOARD : (0, $d925B.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $d925B.INPUT_METHOD).BLOCK_MENU;
        api?.core.actions.execute(({ tr: tr })=>{
            const command = api?.blockMenu?.commands.transformNode(tr.doc.type.schema.nodes.expand, {
                inputMethod: inputMethod,
                triggeredFrom: triggeredFrom,
                targetTypeName: $0405d2e291010188$var$nodeName
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
        onClick: handleClick,
        isSelected: isExpandSelected,
        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cZifa))), {
            label: ""
        }),
        children: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).expand)
    });
};
const $0405d2e291010188$export$43e1eed033b6f3d3 = (api)=>{
    return ()=>/*#__PURE__*/ (0, $l998X.jsx)($0405d2e291010188$var$ExpandBlockMenuItem, {
            api: api
        });
};



var $9YoeD = parcelRequire("9YoeD");




var $e2wMq = parcelRequire("e2wMq");


var $adhil = parcelRequire("adhil");


var $iMS6j = parcelRequire("iMS6j");


var $hcbpx = parcelRequire("hcbpx");








var $8m4tT = parcelRequire("8m4tT");


var $id9O1 = parcelRequire("id9O1");


var $1oCLl = parcelRequire("1oCLl");




const $03a586ef1cfe8548$export$62b7afc61dbab067 = (state)=>(0, $8m4tT.hasParentNode)((node)=>node.type === state.schema.nodes.expand || node.type === state.schema.nodes.nestedExpand)(state.selection);



var $lkJUe = parcelRequire("lkJUe");




var $c9c406e5d4a9b269$export$2e2bcd8739ae039 = (pluginState, action)=>{
    switch(action.type){
        case 'SET_EXPAND_REF':
            return {
                ...pluginState,
                expandRef: action.data.ref
            };
        default:
            return pluginState;
    }
};


const $70a6c6d5a1b7b8ee$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('expandPlugin');
const { createPluginState: $70a6c6d5a1b7b8ee$export$656c7661095efe2e, createCommand: $70a6c6d5a1b7b8ee$export$8d4021544bdece00, getPluginState: $70a6c6d5a1b7b8ee$export$f05434c51e3762e } = (0, $lkJUe.pluginFactory)($70a6c6d5a1b7b8ee$export$18d4026d1ea86bb1, (0, $c9c406e5d4a9b269$export$2e2bcd8739ae039));


const $0fa109554c968699$export$491ffa7e89016e5c = (ref)=>(0, $70a6c6d5a1b7b8ee$export$8d4021544bdece00)({
        type: 'SET_EXPAND_REF',
        data: {
            ref: ref
        }
    }, (tr)=>tr.setMeta('addToHistory', false));
const $0fa109554c968699$export$ea222cb41be5bea0 = (editorAnalyticsAPI)=>(expandNodePos, expandNode)=>(state, dispatch)=>{
            if (!expandNode || isNaN(expandNodePos)) return false;
            const payload = {
                action: (0, $d925B.ACTION).DELETED,
                actionSubject: expandNode.type === state.schema.nodes.expand ? (0, $d925B.ACTION_SUBJECT).EXPAND : (0, $d925B.ACTION_SUBJECT).NESTED_EXPAND,
                attributes: {
                    inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
            if (expandNode && dispatch) {
                const { tr: tr } = state;
                tr.delete(expandNodePos, expandNodePos + expandNode.nodeSize);
                editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
                if (expandNode.type === state.schema.nodes.nestedExpand) {
                    const resolvedPos = tr.doc.resolve(expandNodePos + 1);
                    if (resolvedPos) tr.setSelection((0, $ks2lK.Selection).near(resolvedPos, -1));
                }
                dispatch(tr);
            }
            return true;
        };
const $0fa109554c968699$export$20123cb2952020ea = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const expandNode = (0, $hcbpx.findExpand)(state);
        if (!expandNode) return false;
        return $0fa109554c968699$export$ea222cb41be5bea0(editorAnalyticsAPI)(expandNode.pos, expandNode.node)(state, dispatch);
    };
const $0fa109554c968699$export$87b459c5dfcbe773 = ({ title: title, nodeType: nodeType, pos: pos, __livePage: __livePage })=>(state, dispatch)=>{
        const node = state.doc.nodeAt(pos);
        if (node && node.type === nodeType && dispatch) {
            const { tr: tr } = state;
            if (__livePage) tr.step(new (0, $9YoeD.SetAttrsStep)(pos, {
                ...node.attrs,
                title: title
            }));
            else tr.setNodeMarkup(pos, node.type, {
                ...node.attrs,
                title: title
            }, node.marks);
            dispatch(tr);
        }
        return true;
    };
const $0fa109554c968699$export$d94025373e8029d4 = ({ editorAnalyticsAPI: editorAnalyticsAPI, pos: pos, nodeType: nodeType, __livePage: __livePage })=>(state, dispatch)=>{
        const node = state.doc.nodeAt(pos);
        if (node && node.type === nodeType && dispatch) {
            const { tr: tr } = state;
            const isExpandedNext = !node.attrs.__expanded;
            if (__livePage) tr.step(new (0, $9YoeD.SetAttrsStep)(pos, {
                ...node.attrs,
                __expanded: isExpandedNext
            }));
            else tr.setNodeMarkup(pos, node.type, {
                ...node.attrs,
                __expanded: isExpandedNext
            }, node.marks);
            // If we're going to collapse the expand and our cursor is currently inside
            // Move to a right gap cursor, if the toolbar is interacted (or an API),
            // it will insert below rather than inside (which will be invisible).
            if (__livePage ? isExpandedNext === true : isExpandedNext === false && (0, $hcbpx.findExpand)(state)) tr.setSelection(new (0, $adhil.GapCursorSelection)(tr.doc.resolve(pos + node.nodeSize), (0, $adhil.Side).RIGHT));
            // log when people open/close expands
            // TODO: ED-8523 - make platform/mode global attributes?
            const payload = {
                action: (0, $d925B.ACTION).TOGGLE_EXPAND,
                actionSubject: nodeType === state.schema.nodes.expand ? (0, $d925B.ACTION_SUBJECT).EXPAND : (0, $d925B.ACTION_SUBJECT).NESTED_EXPAND,
                attributes: {
                    platform: (0, $e2wMq.PLATFORMS).WEB,
                    mode: (0, $e2wMq.MODE).EDITOR,
                    expanded: __livePage ? !isExpandedNext : isExpandedNext
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
            // `isRemote` meta prevents this step from being
            // sync'd between sessions in synchrony collab edit
            tr.setMeta('isRemote', true);
            editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
            dispatch(tr);
        }
        return true;
    };
const $0fa109554c968699$export$b7c6a6a1365fc215 = (state)=>{
    const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
    const isSelectionInTable = !!(0, $id9O1.findTable)(state.selection);
    const isSelectionInExpand = (0, $03a586ef1cfe8548$export$62b7afc61dbab067)(state);
    const expandType = isSelectionInTable || isSelectionInExpand ? nestedExpand : expand;
    return expandType.createAndFill({});
};
const $0fa109554c968699$export$4782944d4b10fd76 = (editorAnalyticsAPI)=>(inputMethod)=>(state, dispatch)=>{
            const expandNode = $0fa109554c968699$export$b7c6a6a1365fc215(state);
            if (!expandNode) return false;
            const tr = state.selection.empty ? (0, $8m4tT.safeInsert)(expandNode)(state.tr).scrollIntoView() : (0, $l9FJJ.createWrapSelectionTransaction)({
                state: state,
                type: expandNode.type
            });
            const payload = {
                action: (0, $d925B.ACTION).INSERTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: expandNode?.type === state.schema.nodes.expand ? (0, $d925B.ACTION_SUBJECT_ID).EXPAND : (0, $d925B.ACTION_SUBJECT_ID).NESTED_EXPAND,
                attributes: {
                    inputMethod: inputMethod
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
            if (dispatch && expandNode) {
                editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
                dispatch(tr);
            }
            return true;
        };
const $0fa109554c968699$export$982de01464f3ba33 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        return $0fa109554c968699$export$4782944d4b10fd76(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).INSERT_MENU)(state, dispatch);
    };
const $0fa109554c968699$export$ec60d41a1ae79321 = (pos)=>(state, dispatch, editorView)=>{
        if (editorView) {
            const dom = editorView.domAtPos(pos);
            const expandWrapper = dom.node.parentElement;
            if (expandWrapper) {
                $0fa109554c968699$export$289c5ebc50d962d9(pos)(state, dispatch, editorView);
                const input = expandWrapper.querySelector('input');
                if (input) {
                    input.focus();
                    return true;
                }
            }
        }
        return false;
    };
const $0fa109554c968699$export$2837c3a55abaa285 = (expand)=>(state, dispatch, editorView)=>{
        if (!(expand instanceof HTMLElement)) return false;
        // TODO: ED-29205 - During platform_editor_native_expand_button cleanup, rename `iconContainer` to `iconButton`.
        const iconContainer = (0, $1oCLl.expValEquals)('platform_editor_native_expand_button', 'isEnabled', true) ? expand.querySelector(`.${(0, $iMS6j.expandClassNames).iconButton}`) : expand.querySelector(`.${(0, $iMS6j.expandClassNames).iconContainer}`);
        if (iconContainer && iconContainer.focus) {
            const { tr: tr } = state;
            const pos = state.selection.from;
            tr.setSelection(new (0, $ks2lK.TextSelection)(tr.doc.resolve(pos)));
            if (dispatch) dispatch(tr);
            editorView?.dom.blur();
            iconContainer.focus();
            return true;
        }
        return false;
    };
const $0fa109554c968699$export$289c5ebc50d962d9 = (expandPos)=>(_state, dispatch, editorView)=>{
        if (editorView) {
            if (!editorView.hasFocus()) editorView.focus();
            const sel = (0, $ks2lK.Selection).findFrom(editorView.state.doc.resolve(expandPos), 1, true);
            if (sel && dispatch) dispatch(editorView.state.tr.setSelection(sel));
            return true;
        }
        return false;
    };
const $0fa109554c968699$export$6f1dc7179cebfcb1 = (_selection)=>({ tr: tr })=>{
        // this action exists so that we can keep the plugin types consistent across the
        // the legacy expand plugin and the single player expand plugin until
        // we will remove the legacy expand plugin
        return null;
    };






var $hgeg8 = parcelRequire("hgeg8");




var $cQ4aK = parcelRequire("cQ4aK");





var $l9G9n = parcelRequire("l9G9n");

var $caYZ2 = parcelRequire("caYZ2");


var $dus6D = parcelRequire("dus6D");





var $bMyNT = parcelRequire("bMyNT");





const $2ec9d324b9bded96$var$isExpandNode = (node)=>{
    return node?.type.name === 'expand' || node?.type.name === 'nestedExpand';
};
const $2ec9d324b9bded96$var$isExpandSelected = (selection)=>selection instanceof (0, $ks2lK.NodeSelection) && $2ec9d324b9bded96$var$isExpandNode(selection.node);
function $2ec9d324b9bded96$export$e4ebafd8ecd98be0(api, options) {
    const list = {};
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.moveRight).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection } = state;
        const selectionSharedState = api?.selection?.sharedState.currentState() || {};
        const { selectionRelativeToNode: selectionRelativeToNode } = selectionSharedState;
        if ($2ec9d324b9bded96$var$isExpandSelected(selection) && selectionRelativeToNode === (0, $cQ4aK.RelativeSelectionPos).Start) return (0, $0fa109554c968699$export$ec60d41a1ae79321)(selection.from + 1)(state, dispatch, editorView);
        return false;
    }, list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.moveLeft).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection } = state;
        const selectionSharedState = api?.selection?.sharedState.currentState() || {};
        const { selectionRelativeToNode: selectionRelativeToNode } = selectionSharedState;
        if ($2ec9d324b9bded96$var$isExpandSelected(selection) && (selectionRelativeToNode === undefined || selectionRelativeToNode === (0, $cQ4aK.RelativeSelectionPos).End)) return (0, $0fa109554c968699$export$ec60d41a1ae79321)(selection.from + 1)(state, dispatch, editorView);
        return false;
    }, list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.tab).common, (state, dispatch, editorView)=>{
        if (editorView && editorView.dom instanceof HTMLElement) {
            const { from: from } = state.selection;
            // if the node selected is an expand
            if ($2ec9d324b9bded96$var$isExpandSelected(state.selection)) {
                const expand = editorView.nodeDOM(from);
                if (!expand) return false;
                return (0, $0fa109554c968699$export$2837c3a55abaa285)(expand)(state, dispatch, editorView);
            } else if (state.selection instanceof (0, $ks2lK.TextSelection) && !(0, $bMyNT.isInTable)(state)) {
                const expand = (0, $hcbpx.findExpand)(state);
                if (expand) {
                    const expandNode = editorView.nodeDOM(expand.pos);
                    if (expandNode) return (0, $0fa109554c968699$export$2837c3a55abaa285)(expandNode)(state, dispatch, editorView);
                }
            }
        }
        return false;
    }, list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.moveUp).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection, schema: schema } = state;
        const { nodeBefore: nodeBefore } = selection.$from;
        if (selection instanceof (0, $adhil.GapCursorSelection) && selection.side === (0, $adhil.Side).RIGHT && nodeBefore && (nodeBefore.type === schema.nodes.expand || nodeBefore.type === schema.nodes.nestedExpand) && (options.__livePage ? nodeBefore.attrs.__expanded : !nodeBefore.attrs.__expanded)) {
            const { $from: $from } = selection;
            return (0, $0fa109554c968699$export$ec60d41a1ae79321)(Math.max($from.pos - 1, 0))(state, dispatch, editorView);
        }
        const { $from: $from } = state.selection;
        if (editorView.endOfTextblock('up')) {
            const expand = (0, $hcbpx.findExpand)(state);
            // Moving UP in a table should move the cursor to the row above
            // however when an expand is in a table cell to the left of the
            // current table cell, arrow UP moves the cursor to the left
            // see ED-15425
            if ((0, $caYZ2.isPositionNearTableRow)($from, schema, 'before') && !expand) return false;
            const prevCursorPos = Math.max($from.pos - $from.parentOffset - 1, 0);
            // move cursor from expand's content to its title
            if (expand && expand.start === prevCursorPos) return (0, $0fa109554c968699$export$ec60d41a1ae79321)(expand.start)(state, dispatch, editorView);
            const sel = (0, $ks2lK.Selection).findFrom(state.doc.resolve(prevCursorPos), -1);
            const expandBefore = (0, $hcbpx.findExpand)(state, sel);
            if (sel && expandBefore) {
                // moving cursor from outside of an expand to the title when it is collapsed
                if (options.__livePage ? expandBefore.node.attrs.__expanded : !expandBefore.node.attrs.__expanded) return (0, $0fa109554c968699$export$ec60d41a1ae79321)(expandBefore.start)(state, dispatch, editorView);
                else if (dispatch) dispatch(state.tr.setSelection(sel));
                return true;
            }
        }
        return false;
    }, list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.moveDown).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        const { selection: selection } = state;
        const { nodeAfter: nodeAfter } = selection.$from;
        if (selection instanceof (0, $adhil.GapCursorSelection) && selection.side === (0, $adhil.Side).LEFT && nodeAfter && (nodeAfter.type === expand || nodeAfter.type === nestedExpand) && (options.__livePage ? nodeAfter.attrs.__expanded : !nodeAfter.attrs.__expanded)) {
            const { $from: $from } = selection;
            return (0, $0fa109554c968699$export$ec60d41a1ae79321)($from.pos + 1)(state, dispatch, editorView);
        }
        if ((0, $1oCLl.expValEquals)('platform_editor_lovability_navigation_fixes', 'isEnabled', true)) {
            const nextExpandPos = (0, $adayn.getNextNodeExpandPos)(editorView, selection);
            if (nextExpandPos !== undefined) return (0, $0fa109554c968699$export$ec60d41a1ae79321)(nextExpandPos)(state, dispatch, editorView);
        }
        if (editorView.endOfTextblock('down')) {
            const { $from: $from } = state.selection;
            if ($from.depth === 0) return false;
            const $after = state.doc.resolve($from.after());
            if ($after.nodeAfter && ($after.nodeAfter.type === expand || $after.nodeAfter.type === nestedExpand)) return (0, $0fa109554c968699$export$ec60d41a1ae79321)($after.pos + 1)(state, dispatch, editorView);
        }
        return false;
    }, list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.backspace).common, (state, dispatch, editorView)=>{
        const { selection: selection } = state;
        const { $from: $from } = selection;
        if (!editorView || !selection.empty) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        const expandNode = (0, $hcbpx.findExpand)(state);
        if (!expandNode) {
            // @see ED-7977
            const sel = (0, $ks2lK.Selection).findFrom(state.doc.resolve(Math.max(selection.$from.pos - 1, 0)), -1);
            const expandBefore = (0, $hcbpx.findExpand)(state, sel);
            if (expandBefore && (expandBefore.node.type === expand || expandBefore.node.type === nestedExpand) && (options.__livePage ? expandBefore.node.attrs.__expanded : !expandBefore.node.attrs.__expanded)) return (0, $0fa109554c968699$export$ec60d41a1ae79321)(expandBefore.start)(state, dispatch, editorView);
            return false;
        }
        const parentNode = state.doc.nodeAt($from.before(Math.max($from.depth - 1, 1)));
        // ED-10012 catch cases where the expand has another node nested within it and
        // the backspace should be applied only to the inner node instead of the expand
        if (parentNode && !$2ec9d324b9bded96$var$isExpandNode(parentNode)) return false;
        const textSel = (0, $ks2lK.Selection).findFrom(state.doc.resolve(expandNode.pos), 1, true);
        if (textSel && selection.$from.pos === textSel.$from.pos && (0, $l9G9n.isEmptyNode)(state.schema)(expandNode.node) && dispatch) return (0, $0fa109554c968699$export$20123cb2952020ea)(api?.analytics?.actions)(state, dispatch);
        return false;
    }, list);
    return (0, $dus6D.keymap)(list);
}



var $1S4f7 = parcelRequire("1S4f7");


var $3tffm = parcelRequire("3tffm");














parcelRequire("42omo");


var $cUcZ5 = parcelRequire("cUcZ5");


var $kbdB6 = parcelRequire("kbdB6");










var $kSoKM = parcelRequire("kSoKM");


var $4vlwG = parcelRequire("4vlwG");




var $5SAOw = parcelRequire("5SAOw");








var $ke2AI = parcelRequire("ke2AI");





var $hTKp4 = parcelRequire("hTKp4");







function $d94ff661d09ba197$export$dde15965bbee9f3e(container, buttonProps) {
    const { allowInteractiveExpand: allowInteractiveExpand, expanded: expanded, intl: intl } = buttonProps;
    // Update existing button attributes
    const label = intl.formatMessage(expanded ? (0, $kSoKM.messages).collapseNode : (0, $kSoKM.messages).expandNode);
    const existingButton = container.querySelector(`.${(0, $iMS6j.expandClassNames).iconButton}`);
    if (existingButton) {
        existingButton.setAttribute('aria-label', label);
        existingButton.setAttribute('aria-expanded', String(expanded));
        if (allowInteractiveExpand) {
            existingButton.setAttribute('title', label);
            existingButton.removeAttribute('disabled');
        } else {
            existingButton.removeAttribute('title');
            existingButton.setAttribute('disabled', 'true');
        }
    } else {
        const doc = (0, $hTKp4.getDocument)();
        if (!doc) return;
        const button = doc.createElement('button');
        button.className = (0, $iMS6j.expandClassNames).iconButton;
        button.setAttribute('aria-label', label);
        button.setAttribute('aria-expanded', String(expanded));
        if (allowInteractiveExpand) button.setAttribute('title', label);
        else button.setAttribute('disabled', 'true');
        container.appendChild(button);
        const svgIcon = doc.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svgIcon.setAttribute('class', (0, $iMS6j.expandClassNames).iconSvg);
        svgIcon.setAttribute('width', '12');
        svgIcon.setAttribute('height', '12');
        svgIcon.setAttribute('viewBox', '0 0 16 16');
        svgIcon.setAttribute('role', 'presentation');
        const path = doc.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('fill', 'currentcolor');
        path.setAttribute('d', 'm6.03 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L10.44 8 4.97 2.53z');
        svgIcon.appendChild(path);
        button.appendChild(svgIcon);
    }
}



/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");


var $4KS7f = parcelRequire("4KS7f");








var $aFUXX = parcelRequire("aFUXX");


var $6R5uz = parcelRequire("6R5uz");


var $3gadb = parcelRequire("3gadb");

const $47829bbad8b17906$export$9a7250d72c34c156 = (WrapperComponent)=>{
    return class WithSortableColumn extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
        render() {
            const { label: label } = this.props;
            return(// @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
                content: label,
                position: "top",
                tag: (0, $kSoKM.ExpandLayoutWrapperWithRef)
            }, /*#__PURE__*/ (0, $9K4OG.jsx)(WrapperComponent, this.props)));
        }
        constructor(props){
            super(props);
        }
    };
};
const $47829bbad8b17906$export$aa86be27b687b166 = (props)=>{
    const { allowInteractiveExpand: allowInteractiveExpand, expanded: expanded, intl: intl } = props;
    const useTheme = (0, $42omo.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (currentTheme, themeProps)=>{
        const { buttonStyles: buttonStyles, ...rest } = currentTheme(themeProps);
        return {
            buttonStyles: {
                ...buttonStyles,
                height: '100%',
                '& svg': {
                    transform: props.expanded ? 'transform: rotate(90deg);' : 'transform: rotate(0deg);',
                    transition: `transform 0.2s ${0, $aFUXX.akEditorSwoopCubicBezier};`
                }
            },
            ...rest
        };
    }, [
        props
    ]);
    const label = expanded ? (0, $kSoKM.messages).collapseNode : (0, $kSoKM.messages).expandNode;
    const labelIntl = intl ? intl.formatMessage(label) : label.defaultMessage;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4KS7f.default), {
        appearance: "subtle",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $iMS6j.expandClassNames).iconContainer,
        iconBefore: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
            label: '',
            size: "small"
        }),
        shouldFitContainer: true,
        theme: useTheme,
        "aria-label": labelIntl,
        "aria-expanded": expanded,
        isDisabled: !allowInteractiveExpand
    });
};
const $47829bbad8b17906$var$ButtonWithTooltip = $47829bbad8b17906$export$9a7250d72c34c156($47829bbad8b17906$export$aa86be27b687b166);
const $47829bbad8b17906$var$ButtonWithoutTooltip = $47829bbad8b17906$export$aa86be27b687b166;
const $47829bbad8b17906$export$e20de71cd82a9fe9 = (props)=>{
    const { expanded: expanded, intl: intl } = props;
    const message = expanded ? (0, $kSoKM.messages).collapseNode : (0, $kSoKM.messages).expandNode;
    const label = intl && intl.formatMessage(message) || message.defaultMessage;
    // check to ensure device supports any-hover
    const supportsAnyHover = !!window.matchMedia ? window.matchMedia('(any-hover: hover)').matches !== window.matchMedia('(any-hover: none)').matches : false;
    const hoverEventCheck = supportsAnyHover ? window.matchMedia('(any-hover: hover)').matches : true;
    // hoverEventCheck is to disable tooltips for mobile to prevent incorrect hover state causing issues on iOS
    if (props.allowInteractiveExpand && hoverEventCheck) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $9K4OG.jsx)($47829bbad8b17906$var$ButtonWithTooltip, {
        label: label,
        ...props
    });
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $kSoKM.expandLayoutWrapperStyle)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)($47829bbad8b17906$var$ButtonWithoutTooltip, {
        label: label,
        ...props
    })));
};


function $303b6a7761c63646$var$buildExpandClassName(type, expanded) {
    return `${(0, $iMS6j.expandClassNames).prefix} ${(0, $iMS6j.expandClassNames).type(type)} ${expanded ? (0, $iMS6j.expandClassNames).expanded : ''}`;
}
const $303b6a7761c63646$var$toDOM = (node, __livePage, intl, titleReadOnly, contentEditable)=>[
        'div',
        {
            // prettier-ignore
            'class': $303b6a7761c63646$var$buildExpandClassName(node.type.name, __livePage ? !node.attrs.__expanded : node.attrs.__expanded),
            'data-node-type': node.type.name,
            'data-title': node.attrs.title,
            ...(0, $dh538.fg)('platform_editor_adf_with_localid') && {
                'data-local-id': node.attrs.localId
            }
        },
        [
            'div',
            {
                // prettier-ignore
                'class': (0, $iMS6j.expandClassNames).titleContainer,
                contenteditable: 'false',
                // Element gains access to focus events.
                // This is needed to prevent PM gaining access
                // on interacting with our controls.
                tabindex: '-1'
            },
            // prettier-ignore
            [
                'div',
                {
                    'class': (0, $iMS6j.expandClassNames).icon,
                    style: `display: flex; width: ${"var(--ds-space-300, 24px)"}; height: ${"var(--ds-space-300, 24px)"}`
                }
            ],
            [
                'div',
                {
                    // prettier-ignore
                    'class': (0, $iMS6j.expandClassNames).inputContainer
                },
                [
                    'input',
                    {
                        // prettier-ignore
                        'class': (0, $iMS6j.expandClassNames).titleInput,
                        'aria-label': intl && intl.formatMessage((0, $kSoKM.messages).expandArialabel) || (0, $kSoKM.messages).expandArialabel.defaultMessage,
                        value: node.attrs.title,
                        placeholder: intl && intl.formatMessage((0, $kSoKM.messages).expandPlaceholderText) || (0, $kSoKM.messages).expandPlaceholderText.defaultMessage,
                        type: 'text',
                        readonly: titleReadOnly ? 'true' : undefined
                    }
                ]
            ]
        ],
        [
            'div',
            {
                // prettier-ignore
                class: (0, $iMS6j.expandClassNames).content,
                contenteditable: contentEditable !== undefined ? contentEditable ? 'true' : 'false' : undefined
            },
            0
        ]
    ];
class $303b6a7761c63646$export$e6a0ba759c3724b0 {
    initHandlers() {
        if (this.dom) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.dom.addEventListener('click', this.handleClick);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.dom.addEventListener('input', this.handleInput);
        }
        if (this.input) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.addEventListener('keydown', this.handleTitleKeydown);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.addEventListener('blur', this.handleBlur);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.addEventListener('focus', this.handleInputFocus);
        }
        if (this.titleContainer) // If the user interacts in our title bar (either toggle or input)
        // Prevent ProseMirror from getting a focus event (causes weird selection issues).
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.titleContainer.addEventListener('focus', this.handleFocus);
        if (this.icon) // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.icon.addEventListener('keydown', this.handleIconKeyDown);
        if (this.api?.editorDisabled) this.cleanUpEditorDisabledOnChange = this.api.editorDisabled.sharedState.onChange((sharedState)=>{
            const editorDisabled = sharedState.nextSharedState.editorDisabled;
            if (this.input) {
                if (editorDisabled) this.input.setAttribute('readonly', 'true');
                else this.input.removeAttribute('readonly');
            }
            if (this.content) this.content.setAttribute('contenteditable', this.getContentEditable(this.node) ? 'true' : 'false');
        });
    }
    renderNativeIcon(node) {
        if (!this.icon) return;
        const { __expanded: __expanded } = node.attrs;
        (0, $d94ff661d09ba197$export$dde15965bbee9f3e)(this.icon, {
            expanded: this.__livePage ? !__expanded : __expanded,
            allowInteractiveExpand: this.allowInteractiveExpand,
            intl: this.intl
        });
    }
    renderIcon(intl, node) {
        if (!this.icon) return;
        const { __expanded: __expanded } = node && node.attrs || this.node.attrs;
        this.nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $47829bbad8b17906$export$e20de71cd82a9fe9), {
                intl: intl,
                allowInteractiveExpand: this.allowInteractiveExpand,
                expanded: this.__livePage ? !__expanded : __expanded
            }), this.icon, this.renderKey);
    }
    stopEvent(event) {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const target = event.target;
        return target === this.input || target === this.icon || !!(0, $4vlwG.closestElement)(target, `.${(0, $iMS6j.expandClassNames).icon}`);
    }
    ignoreMutation(mutationRecord) {
        // ME-1931: Mobile relies on composition which creates dom mutations. If we ignore them, prosemirror
        // does not recognise the changes and reverts them.
        if (this.isMobile && (mutationRecord.type === 'characterData' || mutationRecord.type === 'childList')) return false;
        if (mutationRecord.type === 'selection') return false;
        return true;
    }
    update(node, _decorations) {
        if (this.node.type === node.type) {
            if (this.node.attrs.__expanded !== node.attrs.__expanded) {
                // Instead of re-rendering the view on an expand toggle
                // we toggle a class name to hide the content and animate the chevron.
                if (this.dom) {
                    this.dom.classList.toggle((0, $iMS6j.expandClassNames).expanded);
                    if ((0, $1oCLl.expValEquals)('platform_editor_native_expand_button', 'isEnabled', true)) this.renderNativeIcon(node);
                    else this.renderIcon(this && this.intl, node);
                }
                if (this.content) // Disallow interaction/selection inside when collapsed.
                this.content.setAttribute('contenteditable', this.getContentEditable(node) ? 'true' : 'false');
            }
            // During a collab session the title doesn't sync with other users
            // since we're intentionally being less aggressive about re-rendering.
            // We also apply a rAF to avoid abrupt continuous replacement of the title.
            window.requestAnimationFrame(()=>{
                if (this.input && this.node.attrs.title !== this.input.value) this.input.value = this.node.attrs.title;
            });
            this.node = node;
            return true;
        }
        return false;
    }
    destroy() {
        if (this.dom) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.dom.removeEventListener('click', this.handleClick);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.dom.removeEventListener('input', this.handleInput);
        }
        if (this.input) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.removeEventListener('keydown', this.handleTitleKeydown);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.removeEventListener('blur', this.handleBlur);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.removeEventListener('focus', this.handleInputFocus);
        }
        if (this.titleContainer) // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.titleContainer.removeEventListener('focus', this.handleFocus);
        if (this.icon) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.icon.removeEventListener('keydown', this.handleIconKeyDown);
            this.nodeViewPortalProviderAPI.remove(this.renderKey);
        }
        this.decorationCleanup?.();
        if (this.cleanUpEditorDisabledOnChange) this.cleanUpEditorDisabledOnChange();
        // @ts-ignore - [unblock prosemirror bump] reset non optional prop to undefined to clear reference
        this.dom = undefined;
        this.contentDOM = undefined;
        this.icon = undefined;
        this.input = undefined;
        this.titleContainer = undefined;
        this.content = undefined;
        this.cleanUpEditorDisabledOnChange = undefined;
    }
    constructor(_node, view, getPos, getIntl, isMobile, selectNearNode, api, nodeViewPortalProviderAPI, allowInteractiveExpand = true, __livePage = false, cleanUpEditorDisabledOnChange){
        this.selectNearNode = selectNearNode;
        this.__livePage = __livePage;
        this.cleanUpEditorDisabledOnChange = cleanUpEditorDisabledOnChange;
        this.node = void 0;
        this.view = void 0;
        this.dom = void 0;
        this.contentDOM = void 0;
        this.icon = void 0;
        this.input = void 0;
        this.titleContainer = void 0;
        this.content = void 0;
        this.getPos = void 0;
        this.intl = void 0;
        this.allowInteractiveExpand = true;
        this.isMobile = false;
        this.api = void 0;
        this.nodeViewPortalProviderAPI = void 0;
        this.decorationCleanup = void 0;
        this.renderKey = void 0;
        this.focusTitle = ()=>{
            if (this.input) {
                const { state: state, dispatch: dispatch } = this.view;
                if (this.selectNearNode) {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: (0, $cQ4aK.RelativeSelectionPos).Start
                    })(state);
                    if (dispatch) dispatch(tr);
                }
                const pos = this.getPos();
                if (typeof pos === 'number') (0, $0fa109554c968699$export$289c5ebc50d962d9)(pos)(state, dispatch, this.view);
                this.input.focus();
            }
        };
        this.handleIconKeyDown = (event)=>{
            switch((0, $kbdB6.keyName)(event)){
                case 'Tab':
                    event.preventDefault();
                    this.focusTitle();
                    break;
                case 'Enter':
                    event.preventDefault();
                    this.handleClick(event);
                    break;
            }
        };
        this.handleClick = (event)=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const target = event.target;
            const { state: state, dispatch: dispatch } = this.view;
            if ((0, $4vlwG.closestElement)(target, `.${(0, $iMS6j.expandClassNames).icon}`)) {
                if (!this.allowInteractiveExpand) return;
                event.stopPropagation();
                // We blur the editorView, to prevent any keyboard showing on mobile
                // When we're interacting with the expand toggle
                if (this.view.dom instanceof HTMLElement) this.view.dom.blur();
                (0, $0fa109554c968699$export$d94025373e8029d4)({
                    editorAnalyticsAPI: this.api?.analytics?.actions,
                    pos: pos,
                    nodeType: this.node.type,
                    __livePage: this.__livePage
                })(state, dispatch);
                return;
            }
            if (target === this.input) {
                event.stopPropagation();
                this.focusTitle();
                return;
            }
        };
        this.handleInput = (event)=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const target = event.target;
            if (target === this.input) {
                event.stopPropagation();
                const { state: state, dispatch: dispatch } = this.view;
                (0, $0fa109554c968699$export$87b459c5dfcbe773)({
                    title: target.value,
                    pos: pos,
                    nodeType: this.node.type,
                    __livePage: this.__livePage
                })(state, dispatch);
            }
        };
        this.handleFocus = (event)=>{
            event.stopImmediatePropagation();
        };
        this.handleInputFocus = ()=>{
            this.decorationCleanup = this.api?.selectionMarker?.actions?.hideDecoration();
        };
        this.handleBlur = ()=>{
            this.decorationCleanup?.();
        };
        this.handleTitleKeydown = (event)=>{
            switch((0, $kbdB6.keyName)(event)){
                case 'Enter':
                    this.toggleExpand();
                    break;
                case 'Tab':
                case 'ArrowDown':
                    this.moveToOutsideOfTitle(event);
                    break;
                case 'ArrowRight':
                    this.handleArrowRightFromTitle(event);
                    break;
                case 'ArrowLeft':
                    this.handleArrowLeftFromTitle(event);
                    break;
                case 'ArrowUp':
                    if ((0, $1oCLl.expValEquals)('platform_editor_lovability_navigation_fixes', 'isEnabled', true)) this.moveToPreviousLine(event);
                    else this.setLeftGapCursor(event);
                    break;
                case 'Backspace':
                    this.deleteExpand(event);
                    break;
            }
            // 'Ctrl-y', 'Mod-Shift-z');
            if (event.ctrlKey && event.key === 'y' || (event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'z') {
                this.handleRedoFromTitle(event);
                return;
            }
            // 'Mod-z'
            if ((event.ctrlKey || event.metaKey) && event.key === 'z') {
                this.handleUndoFromTitle(event);
                return;
            }
            if ((0, $1oCLl.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) {
                if ((event.ctrlKey || event.metaKey) && event.altKey && (event.code === 'BracketLeft' || event.code === 'BracketRight')) this.view.dispatchEvent(new KeyboardEvent('keydown', {
                    key: event.key,
                    code: event.code,
                    metaKey: event.metaKey,
                    ctrlKey: event.ctrlKey,
                    altKey: event.altKey
                }));
            }
        };
        this.deleteExpand = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart !== selectionEnd || selectionStart !== 0) return;
            const { state: state } = this.view;
            const expandNode = this.node;
            if (expandNode && (0, $l9G9n.isEmptyNode)(state.schema)(expandNode)) (0, $0fa109554c968699$export$ea222cb41be5bea0)(this.api?.analytics?.actions)(pos, expandNode)(state, this.view.dispatch);
        };
        this.toggleExpand = ()=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            if (this.allowInteractiveExpand) {
                const { state: state, dispatch: dispatch } = this.view;
                (0, $0fa109554c968699$export$d94025373e8029d4)({
                    editorAnalyticsAPI: this.api?.analytics?.actions,
                    pos: pos,
                    nodeType: this.node.type,
                    __livePage: this.__livePage
                })(state, dispatch);
            }
        };
        this.moveToOutsideOfTitle = (event)=>{
            event.preventDefault();
            const { state: state, dispatch: dispatch } = this.view;
            const expandPos = this.getPos();
            if (typeof expandPos !== 'number') return;
            let pos = expandPos;
            if (this.isCollapsed()) pos = expandPos + this.node.nodeSize;
            const resolvedPos = state.doc.resolve(pos);
            if (!resolvedPos) return;
            if (this.isCollapsed() && resolvedPos.nodeAfter && [
                'expand',
                'nestedExpand'
            ].indexOf(resolvedPos.nodeAfter.type.name) > -1) return this.setRightGapCursor(event);
            const sel = (0, $ks2lK.Selection).findFrom(resolvedPos, 1, true);
            if (sel) {
                // If the input has focus, ProseMirror doesn't
                // Give PM focus back before changing our selection
                this.view.focus();
                dispatch(state.tr.setSelection(sel));
            }
        };
        this.isCollapsed = ()=>{
            if (this.__livePage) return this.node.attrs.__expanded;
            return !this.node.attrs.__expanded;
        };
        this.setRightGapCursor = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === value.length) {
                const { state: state, dispatch: dispatch } = this.view;
                event.preventDefault();
                this.view.focus();
                dispatch(state.tr.setSelection(new (0, $adhil.GapCursorSelection)(state.doc.resolve(this.node.nodeSize + pos), (0, $adhil.Side).RIGHT)));
            }
        };
        this.moveToPreviousLine = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                const resolvedPos = state.doc.resolve(pos);
                if (!resolvedPos) return;
                if (resolvedPos.pos === 0) {
                    this.setLeftGapCursor(event);
                    return;
                }
                const sel = (0, $ks2lK.Selection).findFrom(resolvedPos, -1);
                if (sel) {
                    this.view.focus();
                    dispatch(state.tr.setSelection(sel));
                }
            }
        };
        this.setLeftGapCursor = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                dispatch(state.tr.setSelection(new (0, $adhil.GapCursorSelection)(state.doc.resolve(pos), (0, $adhil.Side).LEFT)));
            }
        };
        this.handleArrowRightFromTitle = (event)=>{
            if (!this.input || !this.selectNearNode) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === value.length) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                const tr = this.selectNearNode({
                    selectionRelativeToNode: (0, $cQ4aK.RelativeSelectionPos).End,
                    selection: (0, $ks2lK.NodeSelection).create(state.doc, pos)
                })(state);
                if (dispatch) dispatch(tr);
            }
        };
        this.handleArrowLeftFromTitle = (event)=>{
            if (!this.input || !this.selectNearNode) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                const selectionSharedState = this.api?.selection?.sharedState.currentState() || {};
                // selectionRelativeToNode is undefined when user clicked to select node, then hit left to get focus in title
                // This is a special case where we want to bypass node selection and jump straight to gap cursor
                if (selectionSharedState?.selectionRelativeToNode === undefined) {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: undefined,
                        selection: new (0, $adhil.GapCursorSelection)(state.doc.resolve(pos), (0, $adhil.Side).LEFT)
                    })(state);
                    if (dispatch) dispatch(tr);
                } else {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: (0, $cQ4aK.RelativeSelectionPos).Start,
                        selection: (0, $ks2lK.NodeSelection).create(state.doc, pos)
                    })(state);
                    if (dispatch) dispatch(tr);
                }
            }
        };
        this.handleUndoFromTitle = (event)=>{
            const { state: state, dispatch: dispatch } = this.view;
            (0, $ke2AI.undo)(state, dispatch);
            event.preventDefault();
            return;
        };
        this.handleRedoFromTitle = (event)=>{
            const { state: state, dispatch: dispatch } = this.view;
            (0, $ke2AI.redo)(state, dispatch);
            event.preventDefault();
            return;
        };
        this.getContentEditable = (node)=>{
            const contentEditable = this.__livePage ? !node.attrs.__expanded : node.attrs.__expanded;
            if (this.api && this.api.editorDisabled) return !this.api.editorDisabled.sharedState.currentState()?.editorDisabled && contentEditable;
            return contentEditable;
        };
        this.intl = getIntl();
        const { dom: dom, contentDOM: contentDOM } = (0, $5SAOw.DOMSerializer).renderSpec(document, $303b6a7761c63646$var$toDOM(_node, this.__livePage, this.intl, api?.editorDisabled?.sharedState.currentState()?.editorDisabled));
        this.nodeViewPortalProviderAPI = nodeViewPortalProviderAPI;
        this.allowInteractiveExpand = allowInteractiveExpand;
        this.getPos = getPos;
        this.view = view;
        this.node = _node;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.dom = dom;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.contentDOM = contentDOM;
        this.isMobile = isMobile;
        this.api = api;
        this.icon = this.dom.querySelector(`.${(0, $iMS6j.expandClassNames).icon}`);
        this.input = this.dom.querySelector(`.${(0, $iMS6j.expandClassNames).titleInput}`);
        this.titleContainer = this.dom.querySelector(`.${(0, $iMS6j.expandClassNames).titleContainer}`);
        this.content = this.dom.querySelector(`.${(0, $iMS6j.expandClassNames).content}`);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.renderKey = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
        if ((0, $1oCLl.expValEquals)('platform_editor_native_expand_button', 'isEnabled', true)) this.renderNativeIcon(this.node);
        else this.renderIcon(this.intl);
        this.initHandlers();
    }
}
function $303b6a7761c63646$export$2e2bcd8739ae039({ getIntl: getIntl, isMobile: isMobile, api: api, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, allowInteractiveExpand: allowInteractiveExpand = true, __livePage: __livePage }) {
    return (node, view, getPos)=>new $303b6a7761c63646$export$e6a0ba759c3724b0(node, view, getPos, getIntl, isMobile, api?.selection?.actions?.selectNearNode, api, nodeViewPortalProviderAPI, allowInteractiveExpand, __livePage);
}



function $b81d4838f9c86ef1$export$366b6d00a7e2683b(element, className) {
    return Boolean(element?.classList?.contains(className));
}
const $b81d4838f9c86ef1$export$ae829ec7b2625219 = (dispatch, getIntl, appearance = 'full-page', useLongPressSelection = false, api, nodeViewPortalProviderAPI, allowInteractiveExpand = true, __livePage = false)=>{
    const state = (0, $70a6c6d5a1b7b8ee$export$656c7661095efe2e)(dispatch, {});
    const isMobile = false;
    return new (0, $1S4f7.SafePlugin)({
        state: state,
        key: (0, $70a6c6d5a1b7b8ee$export$18d4026d1ea86bb1),
        props: {
            nodeViews: {
                expand: (0, $303b6a7761c63646$export$2e2bcd8739ae039)({
                    getIntl: getIntl,
                    isMobile: isMobile,
                    api: api,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    allowInteractiveExpand: allowInteractiveExpand,
                    __livePage: __livePage
                }),
                nestedExpand: (0, $303b6a7761c63646$export$2e2bcd8739ae039)({
                    getIntl: getIntl,
                    isMobile: isMobile,
                    api: api,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    allowInteractiveExpand: allowInteractiveExpand,
                    __livePage: __livePage
                })
            },
            handleKeyDown (_view, event) {
                return $b81d4838f9c86ef1$export$366b6d00a7e2683b(event.target, (0, $iMS6j.expandClassNames).titleContainer);
            },
            handleKeyPress (_view, event) {
                return $b81d4838f9c86ef1$export$366b6d00a7e2683b(event.target, (0, $iMS6j.expandClassNames).titleContainer);
            },
            handleScrollToSelection () {
                return $b81d4838f9c86ef1$export$366b6d00a7e2683b(document.activeElement, (0, $iMS6j.expandClassNames).titleInput);
            },
            handleClickOn: (0, $3tffm.createSelectionClickHandler)([
                'expand',
                'nestedExpand'
            ], (target)=>target.classList.contains((0, $iMS6j.expandClassNames).prefix), {
                useLongPressSelection: useLongPressSelection
            }),
            handleDrop (view, event, slice, moved) {
                return $b81d4838f9c86ef1$export$5a8d0c1bf9e6992c(view, event, slice);
            }
        },
        // @see ED-8027 to follow up on this work-around
        filterTransaction (tr) {
            if ($b81d4838f9c86ef1$export$366b6d00a7e2683b(document.activeElement, (0, $iMS6j.expandClassNames).titleInput) && tr.selectionSet && (!tr.steps.length || tr.isGeneric)) return false;
            return true;
        },
        view: (editorView)=>{
            const domAtPos = editorView.domAtPos.bind(editorView);
            return {
                update: (view)=>{
                    const { state: state, dispatch: dispatch } = view;
                    const node = (0, $hcbpx.findExpand)(state);
                    if (node) {
                        const expandRef = (0, $8m4tT.findDomRefAtPos)(node.pos, domAtPos);
                        if ((0, $70a6c6d5a1b7b8ee$export$f05434c51e3762e)(state).expandRef !== expandRef) (0, $0fa109554c968699$export$491ffa7e89016e5c)(expandRef)(state, dispatch);
                    }
                }
            };
        }
    });
};
function $b81d4838f9c86ef1$export$5a8d0c1bf9e6992c(view, event, slice) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr;
    const { selection: selection } = state;
    const { from: from, to: to } = selection;
    let sliceContainsExpand = false;
    let sliceContainsNestedExpand = false;
    slice.content.forEach((node)=>{
        if (node.type === state.schema.nodes.expand) sliceContainsExpand = true;
        else if (node.type === state.schema.nodes.nestedExpand) sliceContainsNestedExpand = true;
    });
    // Check if the contents of the dragged slice contain a nested expand node or expand node.
    // Also not handling expands with nested expands for now.
    if (!sliceContainsExpand && !sliceContainsNestedExpand || sliceContainsExpand && sliceContainsNestedExpand) return false;
    const dropPos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    if (!dropPos) return false;
    const resolvedPos = state.doc.resolve(dropPos.pos);
    const dropLocationNodeType = resolvedPos.node().type;
    const dropLocationParentNodeType = resolvedPos.depth > 0 ? resolvedPos.node(resolvedPos.depth - 1).type : dropLocationNodeType;
    const nodesWithNestedExpandSupport = [
        state.schema.nodes.expand,
        state.schema.nodes.tableHeader,
        state.schema.nodes.tableCell
    ];
    const isNodeAtDropPosInsideNodesWithNestedExpandSupport = nodesWithNestedExpandSupport.includes(dropLocationNodeType) || nodesWithNestedExpandSupport.includes(dropLocationParentNodeType);
    const isNodeBeingDroppedInsideNestedExpand = dropLocationNodeType === state.schema.nodes.nestedExpand || dropLocationParentNodeType === state.schema.nodes.nestedExpand;
    let updatedSlice = slice;
    if (sliceContainsExpand && isNodeAtDropPosInsideNodesWithNestedExpandSupport) updatedSlice = (0, $hcbpx.transformSliceExpandToNestedExpand)(slice);
    else if (sliceContainsNestedExpand && !isNodeAtDropPosInsideNodesWithNestedExpandSupport && !isNodeBeingDroppedInsideNestedExpand) updatedSlice = (0, $hcbpx.transformSliceNestedExpandToExpand)(slice, state.schema);
    if (!updatedSlice || updatedSlice.eq(slice)) return false;
    // The drop position will be affected when the original slice is deleted from the document.
    let updatedDropPos = dropPos.pos > from ? dropPos.pos - updatedSlice.content.size : dropPos.pos;
    // Adjust the drop position to place the slice before the node at the position the cursor is pointing at, except when the drop location is the document node.
    // Otherwise causes weird behaviour with tables & quotes, splits them apart. Only do this for nested expand slice transformed to expand.
    if (dropLocationNodeType !== state.schema.nodes.doc && !sliceContainsExpand) updatedDropPos = updatedDropPos - 1;
    tr.delete(from, to);
    tr.insert(updatedDropPos, updatedSlice.content);
    dispatch(tr);
    return true;
}



var $61p3e = parcelRequire("61p3e");


var $gKvd9 = parcelRequire("gKvd9");



const $9ab18ecd727cc007$export$86ce8f8241c20a3 = (api)=>(state, { formatMessage: formatMessage })=>{
        const { hoverDecoration: hoverDecoration } = api?.decorations?.actions ?? {};
        const editorAnalyticsAPI = api?.analytics?.actions;
        // JST-1060364: We are observing this crashing the editor where the `expandPlugin` doesn't exist
        // in the editor (resulting in `Cannot destructure property 'expandRef' of ...`).
        // For now let's add a null check to ensure we don't crash while we investigate further.
        const { expandRef: expandRef } = (0, $70a6c6d5a1b7b8ee$export$f05434c51e3762e)(state) ?? {};
        if (expandRef) {
            const { nestedExpand: nestedExpand, expand: expand } = state.schema.nodes;
            return {
                title: 'Expand toolbar',
                getDomRef: ()=>expandRef,
                nodeType: [
                    nestedExpand,
                    expand
                ],
                offset: [
                    0,
                    6
                ],
                items: [
                    {
                        type: 'copy-button',
                        items: [
                            {
                                state: state,
                                formatMessage: formatMessage,
                                nodeType: [
                                    nestedExpand,
                                    expand
                                ]
                            }
                        ]
                    },
                    {
                        type: 'separator'
                    },
                    {
                        id: 'editor.expand.delete',
                        type: 'button',
                        appearance: 'danger',
                        focusEditoronEnter: true,
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
                        onClick: (0, $0fa109554c968699$export$20123cb2952020ea)(editorAnalyticsAPI),
                        onMouseEnter: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], true),
                        onMouseLeave: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], false),
                        onFocus: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], true),
                        onBlur: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], false),
                        title: formatMessage((0, $61p3e.default).remove),
                        tabIndex: null
                    }
                ]
            };
        }
        return;
    };


let $57efadb92d61d420$export$a4a90f0c2a6f7a01 = ({ config: options = {}, api: api })=>{
    if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) api?.blockMenu?.actions.registerBlockMenuComponents([
        {
            type: 'block-menu-item',
            key: (0, $btNLq.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $gEb6G.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $btNLq.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key]
            },
            component: (0, $0405d2e291010188$export$43e1eed033b6f3d3)(api)
        }
    ]);
    return {
        name: 'expand',
        nodes () {
            return [
                {
                    name: 'expand',
                    node: (0, $4r9Pq.expandWithNestedExpand)
                },
                {
                    name: 'nestedExpand',
                    node: (0, $iw2ID.nestedExpand)
                }
            ];
        },
        actions: {
            insertExpand: (0, $0fa109554c968699$export$982de01464f3ba33)(api?.analytics?.actions),
            insertExpandWithInputMethod: (0, $0fa109554c968699$export$4782944d4b10fd76)(api?.analytics?.actions)
        },
        commands: {
            toggleExpandWithMatch: (selection)=>(0, $0fa109554c968699$export$6f1dc7179cebfcb1)(selection),
            toggleExpandRange: $7a3c52dd7aa30a82$export$de35616b4bcd2077
        },
        pmPlugins () {
            return [
                {
                    name: 'expand',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        return (0, $b81d4838f9c86ef1$export$ae829ec7b2625219)(dispatch, getIntl, options.appearance, options.useLongPressSelection, api, nodeViewPortalProviderAPI, options.allowInteractiveExpand ?? true, options.__livePage);
                    }
                },
                {
                    name: 'expandKeymap',
                    plugin: ()=>(0, $2ec9d324b9bded96$export$e4ebafd8ecd98be0)(api, {
                            __livePage: options.__livePage
                        })
                }
            ];
        },
        pluginsOptions: {
            floatingToolbar: (0, $9ab18ecd727cc007$export$86ce8f8241c20a3)(api),
            quickInsert: ({ formatMessage: formatMessage })=>{
                if (options && options.allowInsertion !== true) return [];
                return [
                    {
                        id: 'expand',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).expand),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).expandDescription),
                        keywords: [
                            'accordion',
                            'collapse'
                        ],
                        priority: 600,
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconExpand), {}),
                        action (insert, state) {
                            const node = (0, $0fa109554c968699$export$b7c6a6a1365fc215)(state);
                            if (!node) return false;
                            const tr = state.selection.empty ? insert(node) : (0, $l9FJJ.createWrapSelectionTransaction)({
                                state: state,
                                type: node.type
                            });
                            api?.analytics?.actions.attachAnalyticsEvent({
                                action: (0, $d925B.ACTION).INSERTED,
                                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: node.type === state.schema.nodes.nestedExpand ? (0, $d925B.ACTION_SUBJECT_ID).NESTED_EXPAND : (0, $d925B.ACTION_SUBJECT_ID).EXPAND,
                                attributes: {
                                    inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $d925B.EVENT_TYPE).TRACK
                            })(tr);
                            return tr;
                        }
                    }
                ];
            }
        }
    };
};





parcelRequire("42omo");































// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead










































const $23dc4b86d38a9de7$export$b7c6a6a1365fc215 = (state, setExpandedState = true, addLocalId)=>{
    const { expand: expand, nestedExpand: nestedExpand, paragraph: paragraph } = state.schema.nodes;
    const isSelectionInTable = !!(0, $id9O1.findTable)(state.selection);
    const isSelectionInExpand = (0, $03a586ef1cfe8548$export$62b7afc61dbab067)(state);
    const expandType = isSelectionInTable || isSelectionInExpand ? nestedExpand : expand;
    const expandNode = (0, $dh538.fg)('platform_editor_adf_with_localid') ? expandType.createAndFill(addLocalId ? {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        localId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))()
    } : {}, // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    paragraph.createAndFill(addLocalId ? {
        localId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))()
    } : {})) : expandType.createAndFill({});
    if (setExpandedState) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $adayn.expandedState).set(expandNode, true);
    return expandNode;
};
const $23dc4b86d38a9de7$export$b07fdfa9172394f4 = (state, node)=>{
    const tr = (0, $l9FJJ.createWrapSelectionTransaction)({
        state: state,
        type: node.type,
        nodeAttributes: node.attrs
    });
    const wrapperNode = (0, $8m4tT.findParentNodeOfType)(node.type)(tr.selection);
    if (wrapperNode) (0, $adayn.expandedState).set(wrapperNode.node, true);
    return tr;
};
const $23dc4b86d38a9de7$export$4782944d4b10fd76 = (api)=>(inputMethod)=>(state, dispatch)=>{
            const expandNode = $23dc4b86d38a9de7$export$b7c6a6a1365fc215(state, false, !!api?.localId);
            if (!expandNode) return false;
            let tr;
            if (state.selection.empty) {
                tr = (0, $8m4tT.safeInsert)(expandNode)(state.tr).scrollIntoView();
                (0, $adayn.expandedState).set(expandNode, true);
            } else {
                tr = (0, $l9FJJ.createWrapSelectionTransaction)({
                    state: state,
                    type: expandNode.type,
                    ...(0, $dh538.fg)('platform_editor_adf_with_localid') && {
                        nodeAttributes: expandNode.attrs
                    }
                });
                const wrapperNode = (0, $8m4tT.findParentNodeOfType)(expandNode.type)(tr.selection);
                if (wrapperNode) (0, $adayn.expandedState).set(wrapperNode.node, true);
            }
            const payload = {
                action: (0, $d925B.ACTION).INSERTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: expandNode?.type === state.schema.nodes.expand ? (0, $d925B.ACTION_SUBJECT_ID).EXPAND : (0, $d925B.ACTION_SUBJECT_ID).NESTED_EXPAND,
                attributes: {
                    inputMethod: inputMethod
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
            if (dispatch) {
                api?.analytics?.actions?.attachAnalyticsEvent(payload)(tr);
                dispatch(tr);
            }
            return true;
        };
const $23dc4b86d38a9de7$export$982de01464f3ba33 = (api)=>(state, dispatch)=>{
        return $23dc4b86d38a9de7$export$4782944d4b10fd76(api)((0, $d925B.INPUT_METHOD).INSERT_MENU)(state, dispatch);
    };
const $23dc4b86d38a9de7$export$20123cb2952020ea = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const expandNode = (0, $hcbpx.findExpand)(state);
        if (!expandNode) return false;
        return $23dc4b86d38a9de7$export$ea222cb41be5bea0(editorAnalyticsAPI)(expandNode.pos, expandNode.node)(state, dispatch);
    };
const $23dc4b86d38a9de7$export$ea222cb41be5bea0 = (editorAnalyticsAPI)=>(expandNodePos, expandNode)=>(state, dispatch)=>{
            if (!expandNode || isNaN(expandNodePos)) return false;
            const payload = {
                action: (0, $d925B.ACTION).DELETED,
                actionSubject: expandNode.type === state.schema.nodes.expand ? (0, $d925B.ACTION_SUBJECT).EXPAND : (0, $d925B.ACTION_SUBJECT).NESTED_EXPAND,
                attributes: {
                    inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
            if (expandNode && dispatch) {
                const { tr: tr } = state;
                tr.delete(expandNodePos, expandNodePos + expandNode.nodeSize);
                editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
                if (expandNode.type === state.schema.nodes.nestedExpand) {
                    const resolvedPos = tr.doc.resolve(expandNodePos + 1);
                    if (resolvedPos) tr.setSelection((0, $ks2lK.Selection).near(resolvedPos, -1));
                }
                dispatch(tr);
            }
            return true;
        };
const $23dc4b86d38a9de7$export$289c5ebc50d962d9 = (expandPos)=>(_state, dispatch, editorView)=>{
        if (editorView) {
            if (!editorView.hasFocus()) editorView.focus();
            const sel = (0, $ks2lK.Selection).findFrom(editorView.state.doc.resolve(expandPos), 1, true);
            if (sel && dispatch) dispatch(editorView.state.tr.setSelection(sel));
            return true;
        }
        return false;
    };
const $23dc4b86d38a9de7$export$d94025373e8029d4 = ({ editorAnalyticsAPI: editorAnalyticsAPI, pos: pos, node: node })=>(state, dispatch)=>{
        if (node && dispatch) {
            const { tr: tr } = state;
            const expanded = (0, $adayn.expandedState).get(node) ?? false;
            const isExpandedNext = !expanded;
            (0, $adayn.expandedState).set(node, isExpandedNext);
            // If we're going to collapse the expand and our cursor is currently inside
            // Move to a right gap cursor, if the toolbar is interacted (or an API),
            // it will insert below rather than inside (which will be invisible).
            if (isExpandedNext === true) tr.setSelection(new (0, $adhil.GapCursorSelection)(tr.doc.resolve(pos + node.nodeSize), (0, $adhil.Side).RIGHT));
            // log when people open/close expands
            // TODO: ED-8523 - make platform/mode global attributes?
            const payload = {
                action: (0, $d925B.ACTION).TOGGLE_EXPAND,
                actionSubject: node.type === state.schema.nodes.expand ? (0, $d925B.ACTION_SUBJECT).EXPAND : (0, $d925B.ACTION_SUBJECT).NESTED_EXPAND,
                attributes: {
                    platform: (0, $e2wMq.PLATFORMS).WEB,
                    mode: (0, $e2wMq.MODE).EDITOR,
                    expanded: isExpandedNext
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
            tr.setMeta('scrollIntoView', false);
            editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
            dispatch(tr);
        }
        return true;
    };
const $23dc4b86d38a9de7$export$87b459c5dfcbe773 = ({ title: title, nodeType: nodeType, pos: pos })=>(state, dispatch)=>{
        const node = state.doc.nodeAt(pos);
        if (node && node.type === nodeType && dispatch) {
            const { tr: tr } = state;
            tr.step(new (0, $9YoeD.SetAttrsStep)(pos, {
                ...node.attrs,
                title: title
            }));
            dispatch(tr);
        }
        return true;
    };
const $23dc4b86d38a9de7$export$ec60d41a1ae79321 = (pos)=>(state, dispatch, editorView)=>{
        if (editorView) {
            const dom = editorView.domAtPos(pos);
            const expandWrapper = dom.node.parentElement;
            if (expandWrapper) {
                $23dc4b86d38a9de7$export$289c5ebc50d962d9(pos)(state, dispatch, editorView);
                const input = expandWrapper.querySelector('input');
                if (input) {
                    input.focus();
                    return true;
                }
            }
        }
        return false;
    };
const $23dc4b86d38a9de7$export$2837c3a55abaa285 = (expand)=>(state, dispatch, editorView)=>{
        if (!(expand instanceof HTMLElement)) return false;
        // TODO: ED-29205 - During platform_editor_native_expand_button cleanup, rename `iconContainer` to `iconButton`.
        const iconContainer = (0, $1oCLl.expValEquals)('platform_editor_native_expand_button', 'isEnabled', true) ? expand.querySelector(`.${(0, $iMS6j.expandClassNames).iconButton}`) : expand.querySelector(`.${(0, $iMS6j.expandClassNames).iconContainer}`);
        if (iconContainer && iconContainer.focus) {
            const { tr: tr } = state;
            const pos = state.selection.from;
            tr.setSelection(new (0, $ks2lK.TextSelection)(tr.doc.resolve(pos)));
            if (dispatch) dispatch(tr);
            editorView?.dom.blur();
            iconContainer.focus();
            return true;
        }
        return false;
    };
const $23dc4b86d38a9de7$export$6f1dc7179cebfcb1 = (selection)=>({ tr: tr })=>{
        const { expand: expand, nestedExpand: nestedExpand } = tr.doc.type.schema.nodes;
        // if match is inside a nested expand, open the nested expand
        const nestedExpandNode = (0, $8m4tT.findParentNodeOfType)(nestedExpand)(selection);
        if (nestedExpandNode && (0, $1oCLl.expValEquals)('platform_editor_toggle_expand_on_match_found', 'isEnabled', true)) {
            const expanded = (0, $adayn.expandedState).get(nestedExpandNode.node) ?? false;
            if (!expanded) (0, $adayn.expandedState).set(nestedExpandNode.node, true);
        }
        // if match is (also) inside an expand, open the expand
        const expandNode = (0, $8m4tT.findParentNodeOfType)(expand)(selection);
        if (expandNode && (0, $1oCLl.expValEquals)('platform_editor_toggle_expand_on_match_found', 'isEnabled', true)) {
            const expanded = (0, $adayn.expandedState).get(expandNode.node) ?? false;
            if (!expanded) (0, $adayn.expandedState).set(expandNode.node, true);
        }
        return tr;
    };


































const $e6879c09d9ccef0f$var$isExpandNode = (node)=>{
    return node?.type.name === 'expand' || node?.type.name === 'nestedExpand';
};
const $e6879c09d9ccef0f$var$isExpandSelected = (selection)=>selection instanceof (0, $ks2lK.NodeSelection) && $e6879c09d9ccef0f$var$isExpandNode(selection.node);
function $e6879c09d9ccef0f$export$e4ebafd8ecd98be0(api) {
    const list = {};
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.moveRight).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection } = state;
        const selectionSharedState = api?.selection?.sharedState.currentState() || {};
        const { selectionRelativeToNode: selectionRelativeToNode } = selectionSharedState;
        if ($e6879c09d9ccef0f$var$isExpandSelected(selection) && selectionRelativeToNode === (0, $cQ4aK.RelativeSelectionPos).Start) return (0, $23dc4b86d38a9de7$export$ec60d41a1ae79321)(selection.from + 1)(state, dispatch, editorView);
        return false;
    }, list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.moveLeft).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection } = state;
        const selectionSharedState = api?.selection?.sharedState.currentState() || {};
        const { selectionRelativeToNode: selectionRelativeToNode } = selectionSharedState;
        if ($e6879c09d9ccef0f$var$isExpandSelected(selection) && (selectionRelativeToNode === undefined || selectionRelativeToNode === (0, $cQ4aK.RelativeSelectionPos).End)) return (0, $23dc4b86d38a9de7$export$ec60d41a1ae79321)(selection.from + 1)(state, dispatch, editorView);
        return false;
    }, list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.tab).common, (state, dispatch, editorView)=>{
        if (editorView && editorView.dom instanceof HTMLElement) {
            const { from: from } = state.selection;
            // if the node selected is an expand
            if ($e6879c09d9ccef0f$var$isExpandSelected(state.selection)) {
                const expand = editorView.nodeDOM(from);
                if (!expand) return false;
                return (0, $23dc4b86d38a9de7$export$2837c3a55abaa285)(expand)(state, dispatch, editorView);
            } else if (state.selection instanceof (0, $ks2lK.TextSelection) && !(0, $bMyNT.isInTable)(state)) {
                const expand = (0, $hcbpx.findExpand)(state);
                if (expand) {
                    const expandNode = editorView.nodeDOM(expand.pos);
                    if (expandNode) return (0, $23dc4b86d38a9de7$export$2837c3a55abaa285)(expandNode)(state, dispatch, editorView);
                }
            }
        }
        return false;
    }, list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.moveUp).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection, schema: schema } = state;
        const { nodeBefore: nodeBefore } = selection.$from;
        if (selection instanceof (0, $adhil.GapCursorSelection) && selection.side === (0, $adhil.Side).RIGHT && nodeBefore && (nodeBefore.type === schema.nodes.expand || nodeBefore.type === schema.nodes.nestedExpand) && (0, $adayn.isExpandCollapsed)(nodeBefore)) {
            const { $from: $from } = selection;
            return (0, $23dc4b86d38a9de7$export$ec60d41a1ae79321)(Math.max($from.pos - 1, 0))(state, dispatch, editorView);
        }
        const { $from: $from } = state.selection;
        if (editorView.endOfTextblock('up')) {
            const expand = (0, $hcbpx.findExpand)(state);
            // Moving UP in a table should move the cursor to the row above
            // however when an expand is in a table cell to the left of the
            // current table cell, arrow UP moves the cursor to the left
            // see ED-15425
            if ((0, $caYZ2.isPositionNearTableRow)($from, schema, 'before') && !expand) return false;
            const prevCursorPos = Math.max($from.pos - $from.parentOffset - 1, 0);
            // move cursor from expand's content to its title
            if (expand && expand.start === prevCursorPos) return (0, $23dc4b86d38a9de7$export$ec60d41a1ae79321)(expand.start)(state, dispatch, editorView);
            const sel = (0, $ks2lK.Selection).findFrom(state.doc.resolve(prevCursorPos), -1);
            const expandBefore = (0, $hcbpx.findExpand)(state, sel);
            if (sel && expandBefore) {
                // moving cursor from outside of an expand to the title when it is collapsed
                if ((0, $adayn.isExpandCollapsed)(expandBefore.node)) return (0, $23dc4b86d38a9de7$export$ec60d41a1ae79321)(expandBefore.start)(state, dispatch, editorView);
                else if (dispatch) dispatch(state.tr.setSelection(sel));
                return true;
            }
        }
        return false;
    }, list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.moveDown).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        const { selection: selection } = state;
        const { nodeAfter: nodeAfter } = selection.$from;
        if (selection instanceof (0, $adhil.GapCursorSelection) && selection.side === (0, $adhil.Side).LEFT && nodeAfter && (nodeAfter.type === expand || nodeAfter.type === nestedExpand) && (0, $adayn.isExpandCollapsed)(nodeAfter)) {
            const { $from: $from } = selection;
            return (0, $23dc4b86d38a9de7$export$ec60d41a1ae79321)($from.pos + 1)(state, dispatch, editorView);
        }
        if ((0, $1oCLl.expValEquals)('platform_editor_lovability_navigation_fixes', 'isEnabled', true)) {
            const nextExpandPos = (0, $adayn.getNextNodeExpandPos)(editorView, selection);
            if (nextExpandPos !== undefined) return (0, $23dc4b86d38a9de7$export$ec60d41a1ae79321)(nextExpandPos)(state, dispatch, editorView);
        }
        if (editorView.endOfTextblock('down')) {
            const { $from: $from } = state.selection;
            if ($from.depth === 0) return false;
            const $after = state.doc.resolve($from.after());
            if ($after.nodeAfter && ($after.nodeAfter.type === expand || $after.nodeAfter.type === nestedExpand)) return (0, $23dc4b86d38a9de7$export$ec60d41a1ae79321)($after.pos + 1)(state, dispatch, editorView);
        }
        return false;
    }, list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.backspace).common, (state, dispatch, editorView)=>{
        const { selection: selection } = state;
        const { $from: $from } = selection;
        if (!editorView || !selection.empty) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        const expandNode = (0, $hcbpx.findExpand)(state);
        if (!expandNode) {
            // @see ED-7977
            const sel = (0, $ks2lK.Selection).findFrom(state.doc.resolve(Math.max(selection.$from.pos - 1, 0)), -1);
            const expandBefore = (0, $hcbpx.findExpand)(state, sel);
            if (expandBefore && (expandBefore.node.type === expand || expandBefore.node.type === nestedExpand) && (0, $adayn.isExpandCollapsed)(expandBefore.node)) return (0, $23dc4b86d38a9de7$export$ec60d41a1ae79321)(expandBefore.start)(state, dispatch, editorView);
            return false;
        }
        const parentNode = state.doc.nodeAt($from.before(Math.max($from.depth - 1, 1)));
        // ED-10012 catch cases where the expand has another node nested within it and
        // the backspace should be applied only to the inner node instead of the expand
        if (parentNode && !$e6879c09d9ccef0f$var$isExpandNode(parentNode)) return false;
        const textSel = (0, $ks2lK.Selection).findFrom(state.doc.resolve(expandNode.pos), 1, true);
        if (textSel && selection.$from.pos === textSel.$from.pos && (0, $l9G9n.isEmptyNode)(state.schema)(expandNode.node) && dispatch) return (0, $23dc4b86d38a9de7$export$20123cb2952020ea)(api?.analytics?.actions)(state, dispatch);
        return false;
    }, list);
    return (0, $dus6D.keymap)(list);
}




















parcelRequire("42omo");








































/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 























function $9e7b30065529e96c$var$withTooltip(Component) {
    return function WithTooltip(props) {
        return(// @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
            content: props.label,
            position: "top",
            tag: (0, $kSoKM.ExpandLayoutWrapperWithRef)
        }, /*#__PURE__*/ (0, $9K4OG.jsx)(Component, props)));
    };
}
const $9e7b30065529e96c$export$aca20190620a52ea = (props)=>{
    const useTheme = (0, $42omo.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (currentTheme, themeProps)=>{
        const { buttonStyles: buttonStyles, ...rest } = currentTheme(themeProps);
        return {
            buttonStyles: {
                ...buttonStyles,
                height: '100%',
                '& svg': {
                    transform: props.expanded ? 'transform: rotate(90deg);' : 'transform: rotate(0deg);',
                    transition: `transform 0.2s ${0, $aFUXX.akEditorSwoopCubicBezier};`
                }
            },
            ...rest
        };
    }, [
        props
    ]);
    const { intl: intl, expanded: expanded } = props;
    const label = expanded ? (0, $kSoKM.messages).collapseNode : (0, $kSoKM.messages).expandNode;
    const labelIntl = intl ? intl.formatMessage(label) : label.defaultMessage;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4KS7f.default), {
        appearance: "subtle",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $iMS6j.expandClassNames).iconContainer,
        iconBefore: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
            label: '',
            size: "small"
        }),
        shouldFitContainer: true,
        theme: useTheme,
        "aria-label": labelIntl,
        "aria-expanded": props.expanded,
        isDisabled: !props.allowInteractiveExpand
    });
};
const $9e7b30065529e96c$var$ButtonWithTooltip = $9e7b30065529e96c$var$withTooltip($9e7b30065529e96c$export$aca20190620a52ea);
const $9e7b30065529e96c$var$ButtonWithoutTooltip = $9e7b30065529e96c$export$aca20190620a52ea;
const $9e7b30065529e96c$export$5663c8f5aeb8c1c4 = (props)=>{
    const { expanded: expanded, intl: intl } = props;
    const message = expanded ? (0, $kSoKM.messages).collapseNode : (0, $kSoKM.messages).expandNode;
    const label = intl && intl.formatMessage(message) || message.defaultMessage;
    // check to ensure device supports any-hover
    const supportsAnyHover = !!window.matchMedia ? window.matchMedia('(any-hover: hover)').matches !== window.matchMedia('(any-hover: none)').matches : false;
    const hoverEventCheck = supportsAnyHover ? window.matchMedia('(any-hover: hover)').matches : true;
    // hoverEventCheck is to disable tooltips for mobile to prevent incorrect hover state causing issues on iOS
    if (props.allowInteractiveExpand && hoverEventCheck) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $9K4OG.jsx)($9e7b30065529e96c$var$ButtonWithTooltip, {
        label: label,
        ...props
    });
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $kSoKM.expandLayoutWrapperStyle)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)($9e7b30065529e96c$var$ButtonWithoutTooltip, {
        label: label,
        ...props
    })));
};














const $ae1f32e2614f45d5$export$f7373e0b2eb22549 = (type, expanded)=>{
    return `${(0, $iMS6j.expandClassNames).prefix} ${(0, $iMS6j.expandClassNames).type(type)} ${expanded ? (0, $iMS6j.expandClassNames).expanded : ''}`;
};
const $ae1f32e2614f45d5$export$289411c5a7970646 = (node, __livePage, intl, titleReadOnly, contentEditable)=>[
        'div',
        {
            // prettier-ignore
            'class': $ae1f32e2614f45d5$export$f7373e0b2eb22549(node.type.name, (0, $adayn.expandedState).get(node) ?? false),
            'data-node-type': node.type.name,
            'data-title': node.attrs.title,
            ...(0, $dh538.fg)('platform_editor_adf_with_localid') && {
                'data-local-id': node.attrs.localId
            }
        },
        [
            'div',
            {
                // prettier-ignore
                'class': (0, $iMS6j.expandClassNames).titleContainer,
                contenteditable: 'false',
                // Element gains access to focus events.
                // This is needed to prevent PM gaining access
                // on interacting with our controls.
                tabindex: '-1'
            },
            // prettier-ignore
            [
                'div',
                {
                    'class': (0, $iMS6j.expandClassNames).icon,
                    style: `display: flex; width: ${"var(--ds-space-300, 24px)"}; height: ${"var(--ds-space-300, 24px)"}`
                }
            ],
            [
                'div',
                {
                    // prettier-ignore
                    'class': (0, $iMS6j.expandClassNames).inputContainer
                },
                [
                    'input',
                    {
                        // prettier-ignore
                        'class': (0, $iMS6j.expandClassNames).titleInput,
                        'aria-label': intl && intl.formatMessage((0, $kSoKM.messages).expandArialabel) || (0, $kSoKM.messages).expandArialabel.defaultMessage,
                        value: node.attrs.title,
                        placeholder: intl && typeof intl.formatMessage === 'function' && intl.formatMessage((0, $kSoKM.messages).expandPlaceholderText) || (0, $kSoKM.messages).expandPlaceholderText.defaultMessage,
                        type: 'text',
                        readonly: titleReadOnly ? 'true' : undefined
                    }
                ]
            ]
        ],
        [
            'div',
            {
                // prettier-ignore
                class: (0, $iMS6j.expandClassNames).content,
                contenteditable: contentEditable !== undefined ? contentEditable ? 'true' : 'false' : undefined
            },
            0
        ]
    ];





// from platform/packages/editor/editor-plugin-find-replace/src/ui/styles.ts
const $0134e57ff27e25ee$var$darkModeSearchMatchClass = 'search-match-dark';
const $0134e57ff27e25ee$var$searchMatchExpandTitleClass = 'search-match-expand-title';
const $0134e57ff27e25ee$var$selectedSearchMatchClass = 'selected-search-match';
const $0134e57ff27e25ee$export$aabe75b53783c454 = (state)=>{
    return (0, $8m4tT.findParentNodeOfType)(state.schema.nodes.nestedExpand)(state.selection) || (0, $8m4tT.findParentNodeOfType)(state.schema.nodes.expand)(state.selection);
};
const $0134e57ff27e25ee$export$ce3a0b3822605e07 = [
    $0134e57ff27e25ee$var$darkModeSearchMatchClass,
    $0134e57ff27e25ee$var$searchMatchExpandTitleClass,
    $0134e57ff27e25ee$var$selectedSearchMatchClass
];


class $197804485c007bc9$export$e6a0ba759c3724b0 {
    stopEvent(event) {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const target = event.target;
        return target === this.input || target === this.icon || !!(0, $4vlwG.closestElement)(target, `.${(0, $iMS6j.expandClassNames).icon}`);
    }
    ignoreMutation(mutationRecord) {
        // ME-1931: Mobile relies on composition which creates dom mutations. If we ignore them, prosemirror
        // does not recognise the changes and reverts them.
        if (this.isMobile && (mutationRecord.type === 'characterData' || mutationRecord.type === 'childList')) return false;
        if (mutationRecord.type === 'selection') return false;
        return true;
    }
    update(node, _decorations) {
        if (this.node.type === node.type) {
            // During a collab session the title doesn't sync with other users
            // since we're intentionally being less aggressive about re-rendering.
            // We also apply a rAF to avoid abrupt continuous replacement of the title.
            window.requestAnimationFrame(()=>{
                if (this.input && this.node.attrs.title !== this.input.value) this.input.value = this.node.attrs.title;
            });
            // This checks if the node has been replaced with a different version
            // and updates the state of the new node to match the old one
            // Eg. typing in a node changes it to a new node so it must be updated
            // in the expandedState weak map
            if (this.node !== node) {
                const wasExpanded = (0, $adayn.expandedState).get(this.node);
                if (wasExpanded) (0, $adayn.expandedState).set(node, wasExpanded);
            }
            if ((0, $1oCLl.expValEquals)('platform_editor_toggle_expand_on_match_found', 'isEnabled', true)) {
                this.node = node;
                const hasChanged = this.isExpanded !== (0, $adayn.expandedState).get(node);
                if (hasChanged) this.updateExpandToggleIcon(node);
            } else {
                this.node = node;
                if (!(0, $dh538.fg)('platform_editor_disable_unnecessary_expand_renders')) this.updateExpandToggleIcon(this.node);
            }
            return true;
        }
        return false;
    }
    updateExpandToggleIcon(node) {
        const expanded = (0, $adayn.expandedState).get(node) ? (0, $adayn.expandedState).get(node) : false;
        if (this.dom && expanded !== undefined) {
            if ((0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true)) {
                const classes = this.dom.className.split(' ');
                // find & replace styles might be applied to the expand title and we need to keep them
                const findReplaceDecorationsApplied = classes.filter((className)=>(0, $0134e57ff27e25ee$export$ce3a0b3822605e07).includes(className)).join(' ');
                this.dom.className = findReplaceDecorationsApplied ? (0, $ae1f32e2614f45d5$export$f7373e0b2eb22549)(node.type.name, expanded) + ` ${findReplaceDecorationsApplied}` : (0, $ae1f32e2614f45d5$export$f7373e0b2eb22549)(node.type.name, expanded);
            } else this.dom.className = (0, $ae1f32e2614f45d5$export$f7373e0b2eb22549)(node.type.name, expanded);
            // Re-render the icon to update the aria-expanded attribute
            if ((0, $1oCLl.expValEquals)('platform_editor_native_expand_button', 'isEnabled', true)) this.renderNativeIcon(node);
            else this.renderIcon(this.icon ? this.icon : null, (0, $adayn.expandedState).get(node) ?? false);
        }
        this.updateExpandBodyContentEditable();
        if ((0, $1oCLl.expValEquals)('platform_editor_toggle_expand_on_match_found', 'isEnabled', true)) this.isExpanded = expanded;
    }
    updateExpandBodyContentEditable() {
        // Disallow interaction/selection inside expand body when collapsed.
        if (this.content) this.content.setAttribute('contenteditable', this.getContentEditable(this.node) ? 'true' : 'false');
    }
    renderNativeIcon(node) {
        if (!this.icon) return;
        (0, $d94ff661d09ba197$export$dde15965bbee9f3e)(this.icon, {
            expanded: !(0, $adayn.isExpandCollapsed)(node),
            allowInteractiveExpand: this.allowInteractiveExpand,
            intl: this.intl
        });
    }
    destroy() {
        if (!this.dom || !this.input || !this.titleContainer || !this.icon) return;
        this.dom.removeEventListener('click', this.handleClick);
        this.dom.removeEventListener('input', this.handleInput);
        this.input.removeEventListener('keydown', this.handleTitleKeydown);
        this.input.removeEventListener('blur', this.handleBlur);
        this.input.removeEventListener('focus', this.handleInputFocus);
        this.titleContainer.removeEventListener('focus', this.handleFocus);
        this.icon.removeEventListener('keydown', this.handleIconKeyDown);
        this.decorationCleanup?.();
        if (this.cleanUpEditorDisabledOnChange) this.cleanUpEditorDisabledOnChange();
        this.nodeViewPortalProviderAPI.remove(this.renderKey);
    }
    constructor(_node, view, getPos, getIntl, isMobile, selectNearNode, api, nodeViewPortalProviderAPI, allowInteractiveExpand = true, __livePage = false, cleanUpEditorDisabledOnChange, isExpanded = false){
        this.selectNearNode = selectNearNode;
        this.__livePage = __livePage;
        this.cleanUpEditorDisabledOnChange = cleanUpEditorDisabledOnChange;
        this.isExpanded = isExpanded;
        this.node = void 0;
        this.view = void 0;
        this.dom = void 0;
        this.contentDOM = void 0;
        this.icon = void 0;
        this.input = void 0;
        this.titleContainer = void 0;
        this.content = void 0;
        this.getPos = void 0;
        this.intl = void 0;
        this.allowInteractiveExpand = true;
        this.isMobile = false;
        this.api = void 0;
        this.nodeViewPortalProviderAPI = void 0;
        this.decorationCleanup = void 0;
        this.renderKey = void 0;
        this.focusTitle = ()=>{
            if (this.input) {
                const { state: state, dispatch: dispatch } = this.view;
                if (this.selectNearNode) {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: (0, $cQ4aK.RelativeSelectionPos).Start
                    })(state);
                    if (dispatch) dispatch(tr);
                }
                const pos = this.getPos();
                if (typeof pos === 'number') (0, $23dc4b86d38a9de7$export$289c5ebc50d962d9)(pos)(state, dispatch, this.view);
                this.input.focus();
            }
        };
        this.handleIconKeyDown = (event)=>{
            switch((0, $kbdB6.keyName)(event)){
                case 'Tab':
                    event.preventDefault();
                    this.focusTitle();
                    break;
                case 'Enter':
                    event.preventDefault();
                    this.handleClick(event);
                    break;
            }
        };
        this.handleClick = (event)=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const target = event.target;
            if ((0, $4vlwG.closestElement)(target, `.${(0, $iMS6j.expandClassNames).icon}`)) {
                if (!this.allowInteractiveExpand) return;
                event.stopPropagation();
                // We blur the editorView, to prevent any keyboard showing on mobile
                // When we're interacting with the expand toggle
                if (this.view.dom instanceof HTMLElement) this.view.dom.blur();
                (0, $23dc4b86d38a9de7$export$d94025373e8029d4)({
                    editorAnalyticsAPI: this.api?.analytics?.actions,
                    pos: pos,
                    node: this.node
                })(this.view.state, this.view.dispatch);
                this.updateExpandToggleIcon(this.node);
                return;
            }
            if (target === this.input) {
                event.stopPropagation();
                this.focusTitle();
                return;
            }
        };
        this.handleInput = (event)=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const target = event.target;
            if (target === this.input) {
                event.stopPropagation();
                const { state: state, dispatch: dispatch } = this.view;
                (0, $23dc4b86d38a9de7$export$87b459c5dfcbe773)({
                    title: target.value,
                    pos: pos,
                    nodeType: this.node.type
                })(state, dispatch);
            }
        };
        this.handleFocus = (event)=>{
            event.stopImmediatePropagation();
        };
        this.handleInputFocus = ()=>{
            this.decorationCleanup = this.api?.selectionMarker?.actions?.hideDecoration();
        };
        this.handleBlur = ()=>{
            this.decorationCleanup?.();
        };
        this.handleTitleKeydown = (event)=>{
            switch((0, $kbdB6.keyName)(event)){
                case 'Enter':
                    this.toggleExpand();
                    break;
                case 'Tab':
                case 'ArrowDown':
                    this.moveToOutsideOfTitle(event);
                    break;
                case 'ArrowRight':
                    this.handleArrowRightFromTitle(event);
                    break;
                case 'ArrowLeft':
                    this.handleArrowLeftFromTitle(event);
                    break;
                case 'ArrowUp':
                    if ((0, $1oCLl.expValEquals)('platform_editor_lovability_navigation_fixes', 'isEnabled', true)) this.moveToPreviousLine(event);
                    else this.setLeftGapCursor(event);
                    break;
                case 'Backspace':
                    this.deleteEmptyExpand();
                    break;
            }
            // 'Ctrl-y', 'Mod-Shift-z');
            if (event.ctrlKey && event.key === 'y' || (event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'z') {
                this.handleRedoFromTitle(event);
                return;
            }
            // 'Mod-z'
            if ((event.ctrlKey || event.metaKey) && event.key === 'z') {
                this.handleUndoFromTitle(event);
                return;
            }
            if ((0, $1oCLl.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) {
                if ((event.ctrlKey || event.metaKey) && event.altKey && (event.code === 'BracketLeft' || event.code === 'BracketRight')) this.view.dispatchEvent(new KeyboardEvent('keydown', {
                    key: event.key,
                    code: event.code,
                    metaKey: event.metaKey,
                    ctrlKey: event.ctrlKey,
                    altKey: event.altKey
                }));
            }
        };
        this.deleteEmptyExpand = ()=>{
            const { state: state } = this.view;
            const expandNode = this.node;
            if (!this.input) return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart !== selectionEnd || selectionStart !== 0) return;
            if (expandNode && (0, $l9G9n.isEmptyNode)(state.schema)(expandNode)) (0, $23dc4b86d38a9de7$export$20123cb2952020ea)(this.api?.analytics?.actions)(state, this.view.dispatch);
        };
        this.toggleExpand = ()=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            if (this.allowInteractiveExpand) {
                const { state: state, dispatch: dispatch } = this.view;
                (0, $23dc4b86d38a9de7$export$d94025373e8029d4)({
                    editorAnalyticsAPI: this.api?.analytics?.actions,
                    pos: pos,
                    node: this.node
                })(state, dispatch);
                this.updateExpandToggleIcon(this.node);
            }
        };
        this.moveToOutsideOfTitle = (event)=>{
            event.preventDefault();
            const { state: state, dispatch: dispatch } = this.view;
            const expandPos = this.getPos();
            if (typeof expandPos !== 'number') return;
            let pos = expandPos;
            if (this.isCollapsed()) pos = expandPos + this.node.nodeSize;
            const resolvedPos = state.doc.resolve(pos);
            if (!resolvedPos) return;
            if (this.isCollapsed() && resolvedPos.nodeAfter && [
                'expand',
                'nestedExpand'
            ].indexOf(resolvedPos.nodeAfter.type.name) > -1) return this.setRightGapCursor(event);
            const sel = (0, $ks2lK.Selection).findFrom(resolvedPos, 1, true);
            if (sel) {
                // If the input has focus, ProseMirror doesn't
                // Give PM focus back before changing our selection
                this.view.focus();
                dispatch(state.tr.setSelection(sel));
            }
        };
        this.isCollapsed = ()=>{
            return !(0, $adayn.expandedState).get(this.node);
        };
        this.setRightGapCursor = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            const selectionStartExists = selectionStart !== null && selectionStart !== undefined;
            const selectionEndExists = selectionEnd !== null && selectionEnd !== undefined;
            const selectionStartInsideTitle = selectionStartExists && selectionStart >= 0 && selectionStart <= value.length;
            const selectionEndInsideTitle = selectionEndExists && selectionEnd >= 0 && selectionEnd <= value.length;
            if (selectionStartInsideTitle && selectionEndInsideTitle) {
                const { state: state, dispatch: dispatch } = this.view;
                event.preventDefault();
                this.view.focus();
                dispatch(state.tr.setSelection(new (0, $adhil.GapCursorSelection)(state.doc.resolve(this.node.nodeSize + pos), (0, $adhil.Side).RIGHT)));
            }
        };
        this.moveToPreviousLine = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                const resolvedPos = state.doc.resolve(pos);
                if (!resolvedPos) return;
                if (resolvedPos.pos === 0) {
                    this.setLeftGapCursor(event);
                    return;
                }
                const sel = (0, $ks2lK.Selection).findFrom(resolvedPos, -1);
                if (sel) {
                    this.view.focus();
                    dispatch(state.tr.setSelection(sel));
                }
            }
        };
        this.setLeftGapCursor = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                dispatch(state.tr.setSelection(new (0, $adhil.GapCursorSelection)(state.doc.resolve(pos), (0, $adhil.Side).LEFT)));
            }
        };
        this.handleArrowRightFromTitle = (event)=>{
            if (!this.input || !this.selectNearNode) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === value.length) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                const tr = this.selectNearNode({
                    selectionRelativeToNode: (0, $cQ4aK.RelativeSelectionPos).End,
                    selection: (0, $ks2lK.NodeSelection).create(state.doc, pos)
                })(state);
                if (dispatch) dispatch(tr);
            }
        };
        this.handleArrowLeftFromTitle = (event)=>{
            if (!this.input || !this.selectNearNode) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                const selectionSharedState = this.api?.selection?.sharedState.currentState() || {};
                // selectionRelativeToNode is undefined when user clicked to select node, then hit left to get focus in title
                // This is a special case where we want to bypass node selection and jump straight to gap cursor
                if (selectionSharedState?.selectionRelativeToNode === undefined) {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: undefined,
                        selection: new (0, $adhil.GapCursorSelection)(state.doc.resolve(pos), (0, $adhil.Side).LEFT)
                    })(state);
                    if (dispatch) dispatch(tr);
                } else {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: (0, $cQ4aK.RelativeSelectionPos).Start,
                        selection: (0, $ks2lK.NodeSelection).create(state.doc, pos)
                    })(state);
                    if (dispatch) dispatch(tr);
                }
            }
        };
        this.handleUndoFromTitle = (event)=>{
            const { state: state, dispatch: dispatch } = this.view;
            (0, $ke2AI.undo)(state, dispatch);
            event.preventDefault();
            return;
        };
        this.handleRedoFromTitle = (event)=>{
            const { state: state, dispatch: dispatch } = this.view;
            (0, $ke2AI.redo)(state, dispatch);
            event.preventDefault();
            return;
        };
        this.getContentEditable = (node)=>{
            const contentEditable = !(0, $adayn.isExpandCollapsed)(node);
            if (this.api && this.api.editorDisabled) return !this.api.editorDisabled.sharedState.currentState()?.editorDisabled && contentEditable;
            return contentEditable;
        };
        this.renderIcon = (icon, expanded)=>{
            if (!icon) return;
            this.nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $9e7b30065529e96c$export$5663c8f5aeb8c1c4), {
                    intl: this.intl,
                    allowInteractiveExpand: this.allowInteractiveExpand,
                    expanded: expanded
                }), icon, this.renderKey);
        };
        this.intl = getIntl();
        this.nodeViewPortalProviderAPI = nodeViewPortalProviderAPI;
        this.allowInteractiveExpand = allowInteractiveExpand;
        this.getPos = getPos;
        this.view = view;
        this.node = _node;
        const { dom: dom, contentDOM: contentDOM } = (0, $5SAOw.DOMSerializer).renderSpec(document, (0, $ae1f32e2614f45d5$export$289411c5a7970646)(_node, this.__livePage, this.intl, api?.editorDisabled?.sharedState.currentState()?.editorDisabled));
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.dom = dom;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.contentDOM = contentDOM;
        this.isMobile = isMobile;
        this.api = api;
        this.icon = this.dom.querySelector(`.${(0, $iMS6j.expandClassNames).icon}`);
        this.input = this.dom.querySelector(`.${(0, $iMS6j.expandClassNames).titleInput}`);
        this.titleContainer = this.dom.querySelector(`.${(0, $iMS6j.expandClassNames).titleContainer}`);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.renderKey = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
        this.content = this.dom.querySelector(`.${(0, $iMS6j.expandClassNames).content}`);
        if (!(0, $adayn.expandedState).has(this.node)) (0, $adayn.expandedState).set(this.node, false);
        if ((0, $1oCLl.expValEquals)('platform_editor_native_expand_button', 'isEnabled', true)) this.renderNativeIcon(this.node);
        else this.renderIcon(this.icon, !(0, $adayn.isExpandCollapsed)(this.node));
        if (!this.input || !this.titleContainer || !this.icon) return;
        // Add event listeners
        /* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners*/ this.dom.addEventListener('click', this.handleClick);
        this.dom.addEventListener('input', this.handleInput);
        this.input.addEventListener('keydown', this.handleTitleKeydown);
        this.input.addEventListener('blur', this.handleBlur);
        this.input.addEventListener('focus', this.handleInputFocus);
        // If the user interacts in our title bar (either toggle or input)
        // Prevent ProseMirror from getting a focus event (causes weird selection issues).
        this.titleContainer.addEventListener('focus', this.handleFocus);
        this.icon.addEventListener('keydown', this.handleIconKeyDown);
        if (this.api?.editorDisabled) this.cleanUpEditorDisabledOnChange = this.api.editorDisabled.sharedState.onChange((sharedState)=>{
            const editorDisabled = sharedState.nextSharedState.editorDisabled;
            if (this.input) {
                if (editorDisabled) this.input.setAttribute('readonly', 'true');
                else this.input.removeAttribute('readonly');
            }
            if (this.content) this.content.setAttribute('contenteditable', this.getContentEditable(this.node) ? 'true' : 'false');
        });
    }
}
function $197804485c007bc9$export$2e2bcd8739ae039({ getIntl: getIntl, isMobile: isMobile, api: api, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, allowInteractiveExpand: allowInteractiveExpand = true, __livePage: __livePage }) {
    return (node, view, getPos)=>new $197804485c007bc9$export$e6a0ba759c3724b0(node, view, getPos, getIntl, isMobile, api?.selection?.actions?.selectNearNode, api, nodeViewPortalProviderAPI, allowInteractiveExpand, __livePage);
}


const $361634b7ec855877$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('expandPlugin');
function $361634b7ec855877$export$366b6d00a7e2683b(element, className) {
    return Boolean(element?.classList?.contains(className));
}
const $361634b7ec855877$export$ae829ec7b2625219 = (dispatch, getIntl, appearance = 'full-page', useLongPressSelection = false, api, nodeViewPortalProviderAPI, allowInteractiveExpand = true, __livePage = false)=>{
    const isMobile = false;
    return new (0, $1S4f7.SafePlugin)({
        key: $361634b7ec855877$export$18d4026d1ea86bb1,
        props: {
            nodeViews: {
                expand: (0, $197804485c007bc9$export$2e2bcd8739ae039)({
                    getIntl: getIntl,
                    isMobile: isMobile,
                    api: api,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    allowInteractiveExpand: allowInteractiveExpand,
                    __livePage: __livePage
                }),
                nestedExpand: (0, $197804485c007bc9$export$2e2bcd8739ae039)({
                    getIntl: getIntl,
                    isMobile: isMobile,
                    api: api,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    allowInteractiveExpand: allowInteractiveExpand,
                    __livePage: __livePage
                })
            },
            handleKeyDown (_view, event) {
                return $361634b7ec855877$export$366b6d00a7e2683b(event.target, (0, $iMS6j.expandClassNames).titleContainer);
            },
            handleKeyPress (_view, event) {
                return $361634b7ec855877$export$366b6d00a7e2683b(event.target, (0, $iMS6j.expandClassNames).titleContainer);
            },
            handleScrollToSelection () {
                return $361634b7ec855877$export$366b6d00a7e2683b(document.activeElement, (0, $iMS6j.expandClassNames).titleInput);
            },
            handleClickOn: (0, $3tffm.createSelectionClickHandler)([
                'expand',
                'nestedExpand'
            ], (target)=>target.classList.contains((0, $iMS6j.expandClassNames).prefix), {
                useLongPressSelection: useLongPressSelection
            }),
            handleDrop (view, event, slice, moved) {
                return $361634b7ec855877$export$5a8d0c1bf9e6992c(view, event, slice);
            }
        },
        // @see ED-8027 to follow up on this work-around
        filterTransaction (tr) {
            if ($361634b7ec855877$export$366b6d00a7e2683b(document.activeElement, (0, $iMS6j.expandClassNames).titleInput) && tr.selectionSet && (!tr.steps.length || tr.isGeneric)) return false;
            return true;
        }
    });
};
function $361634b7ec855877$export$5a8d0c1bf9e6992c(view, event, slice) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr;
    const { selection: selection } = state;
    const { from: from, to: to } = selection;
    let sliceContainsExpand = false;
    let sliceContainsNestedExpand = false;
    slice.content.forEach((node)=>{
        if (node.type === state.schema.nodes.expand) sliceContainsExpand = true;
        else if (node.type === state.schema.nodes.nestedExpand) sliceContainsNestedExpand = true;
    });
    // Check if the contents of the dragged slice contain a nested expand node or expand node.
    // Also not handling expands with nested expands for now.
    if (!sliceContainsExpand && !sliceContainsNestedExpand || sliceContainsExpand && sliceContainsNestedExpand) return false;
    const dropPos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    if (!dropPos) return false;
    const resolvedPos = state.doc.resolve(dropPos.pos);
    const dropLocationNodeType = resolvedPos.node().type;
    const dropLocationParentNodeType = resolvedPos.depth > 0 ? resolvedPos.node(resolvedPos.depth - 1).type : dropLocationNodeType;
    const nodesWithNestedExpandSupport = [
        state.schema.nodes.expand,
        state.schema.nodes.tableHeader,
        state.schema.nodes.tableCell
    ];
    const isNodeAtDropPosInsideNodesWithNestedExpandSupport = nodesWithNestedExpandSupport.includes(dropLocationNodeType) || nodesWithNestedExpandSupport.includes(dropLocationParentNodeType);
    const isNodeBeingDroppedInsideNestedExpand = dropLocationNodeType === state.schema.nodes.nestedExpand || dropLocationParentNodeType === state.schema.nodes.nestedExpand;
    let updatedSlice = slice;
    if (sliceContainsExpand && isNodeAtDropPosInsideNodesWithNestedExpandSupport) updatedSlice = (0, $hcbpx.transformSliceExpandToNestedExpand)(slice);
    else if (sliceContainsNestedExpand && !isNodeAtDropPosInsideNodesWithNestedExpandSupport && !isNodeBeingDroppedInsideNestedExpand) updatedSlice = (0, $hcbpx.transformSliceNestedExpandToExpand)(slice, state.schema);
    if (!updatedSlice || updatedSlice.eq(slice)) return false;
    // The drop position will be affected when the original slice is deleted from the document.
    let updatedDropPos = dropPos.pos > from ? dropPos.pos - updatedSlice.content.size : dropPos.pos;
    // Adjust the drop position to place the slice before the node at the position the cursor is pointing at, except when the drop location is the document node.
    // Otherwise causes weird behaviour with tables & quotes, splits them apart. Only do this for nested expand slice transformed to expand.
    if (dropLocationNodeType !== state.schema.nodes.doc && !sliceContainsExpand) updatedDropPos = updatedDropPos - 1;
    tr.delete(from, to);
    tr.insert(updatedDropPos, updatedSlice.content);
    dispatch(tr);
    return true;
}













const $294c9fc9dbf7e37f$export$86ce8f8241c20a3 = (api)=>(state, { formatMessage: formatMessage })=>{
        const { hoverDecoration: hoverDecoration } = api?.decorations?.actions ?? {};
        const editorAnalyticsAPI = api?.analytics?.actions;
        const selectedExpandNode = (0, $0134e57ff27e25ee$export$aabe75b53783c454)(state);
        if (selectedExpandNode) {
            const { nestedExpand: nestedExpand, expand: expand } = state.schema.nodes;
            return {
                title: 'Expand toolbar',
                getDomRef: (view)=>// Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    (0, $8m4tT.findDomRefAtPos)(selectedExpandNode.pos, view.domAtPos.bind(view)),
                nodeType: [
                    nestedExpand,
                    expand
                ],
                offset: [
                    0,
                    6
                ],
                items: [
                    {
                        type: 'copy-button',
                        items: [
                            {
                                state: state,
                                formatMessage: formatMessage,
                                nodeType: [
                                    nestedExpand,
                                    expand
                                ]
                            }
                        ]
                    },
                    {
                        type: 'separator'
                    },
                    {
                        id: 'editor.expand.delete',
                        type: 'button',
                        appearance: 'danger',
                        focusEditoronEnter: true,
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
                        onClick: (0, $23dc4b86d38a9de7$export$20123cb2952020ea)(editorAnalyticsAPI),
                        onMouseEnter: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], true),
                        onMouseLeave: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], false),
                        onFocus: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], true),
                        onBlur: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], false),
                        title: formatMessage((0, $61p3e.default).remove),
                        tabIndex: null
                    }
                ]
            };
        }
        return;
    };


let $34ab5564dede0481$export$a4a90f0c2a6f7a01 = ({ config: options = {}, api: api })=>{
    if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) api?.blockMenu?.actions.registerBlockMenuComponents([
        {
            type: 'block-menu-item',
            key: (0, $btNLq.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $gEb6G.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $btNLq.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key]
            },
            component: (0, $0405d2e291010188$export$43e1eed033b6f3d3)(api)
        }
    ]);
    return {
        name: 'expand',
        nodes () {
            return [
                {
                    name: 'expand',
                    node: (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $4r9Pq.expandWithNestedExpandLocalId) : (0, $4r9Pq.expandWithNestedExpand)
                },
                {
                    name: 'nestedExpand',
                    node: (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $iw2ID.nestedExpandWithLocalId) : (0, $iw2ID.nestedExpand)
                }
            ];
        },
        actions: {
            insertExpand: (0, $23dc4b86d38a9de7$export$982de01464f3ba33)(api),
            insertExpandWithInputMethod: (0, $23dc4b86d38a9de7$export$4782944d4b10fd76)(api)
        },
        commands: {
            toggleExpandWithMatch: (selection)=>(0, $23dc4b86d38a9de7$export$6f1dc7179cebfcb1)(selection),
            toggleExpandRange: $7a3c52dd7aa30a82$export$de35616b4bcd2077
        },
        pmPlugins () {
            return [
                {
                    name: 'expand',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        return (0, $361634b7ec855877$export$ae829ec7b2625219)(dispatch, getIntl, options.appearance, options.useLongPressSelection, api, nodeViewPortalProviderAPI, options.allowInteractiveExpand ?? true, options.__livePage);
                    }
                },
                {
                    name: 'expandKeymap',
                    plugin: ()=>(0, $e6879c09d9ccef0f$export$e4ebafd8ecd98be0)(api)
                }
            ];
        },
        pluginsOptions: {
            floatingToolbar: (0, $294c9fc9dbf7e37f$export$86ce8f8241c20a3)(api),
            quickInsert: ({ formatMessage: formatMessage })=>{
                if (options && options.allowInsertion !== true) return [];
                return [
                    {
                        id: 'expand',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).expand),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).expandDescription),
                        keywords: [
                            'accordion',
                            'collapse'
                        ],
                        priority: 600,
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconExpand), {}),
                        action (insert, state) {
                            const node = (0, $23dc4b86d38a9de7$export$b7c6a6a1365fc215)(state, undefined, !!api?.localId);
                            if (!node) return false;
                            const tr = state.selection.empty ? insert(node) : (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $23dc4b86d38a9de7$export$b07fdfa9172394f4)(state, node) : (0, $l9FJJ.createWrapSelectionTransaction)({
                                state: state,
                                type: node.type
                            });
                            api?.analytics?.actions.attachAnalyticsEvent({
                                action: (0, $d925B.ACTION).INSERTED,
                                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: node.type === state.schema.nodes.nestedExpand ? (0, $d925B.ACTION_SUBJECT_ID).NESTED_EXPAND : (0, $d925B.ACTION_SUBJECT_ID).EXPAND,
                                attributes: {
                                    inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $d925B.EVENT_TYPE).TRACK
                            })(tr);
                            return tr;
                        }
                    }
                ];
            }
        }
    };
};


let $a184b98f7d3b65cc$export$a4a90f0c2a6f7a01 = ({ config: options = {}, api: api })=>{
    if (options?.__livePage) return (0, $34ab5564dede0481$export$a4a90f0c2a6f7a01)({
        config: options,
        api: api
    });
    else {
        if ((0, $dh538.fg)('platform-editor-single-player-expand')) return (0, $34ab5564dede0481$export$a4a90f0c2a6f7a01)({
            config: options,
            api: api
        });
        else return (0, $57efadb92d61d420$export$a4a90f0c2a6f7a01)({
            config: options,
            api: api
        });
    }
};
module.exports["expandPlugin"] = $a184b98f7d3b65cc$export$a4a90f0c2a6f7a01;

});

parcelRegister("05jmd", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lifsC = parcelRequire("lifsC");

var $hVXQj = parcelRequire("hVXQj");





var $d925B = parcelRequire("d925B");


var $btNLq = parcelRequire("btNLq");

var $gEb6G = parcelRequire("gEb6G");


var $l51YQ = parcelRequire("l51YQ");

var $4HWgE = parcelRequire("4HWgE");


var $3pLGZ = parcelRequire("3pLGZ");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $dh538 = parcelRequire("dh538");


var $dZ8uq = parcelRequire("dZ8uq");


var $iu6m9 = parcelRequire("iu6m9");




var $eKaDU = parcelRequire("eKaDU");


var $dAtrv = parcelRequire("dAtrv");


var $3Ter7 = parcelRequire("3Ter7");

var $2pjJ5 = parcelRequire("2pjJ5");


var $5SAOw = parcelRequire("5SAOw");













const $65c263491f5c07f1$export$faa6744ce57d263b = {
    1: 100,
    2: 50,
    3: 33.33,
    4: 25,
    5: 20
};





const $3b01e13caf7407ac$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('layout');


const $9d764ec1dd06128c$export$6ff908759d68cbdd = [
    'single'
];
const $9d764ec1dd06128c$export$51fa5742354f60f2 = [
    'two_equal',
    'two_left_sidebar',
    'two_right_sidebar'
];
const $9d764ec1dd06128c$export$5a58dccaee34776e = [
    'three_equal',
    'three_with_sidebars'
];
const $9d764ec1dd06128c$var$getWidthsForPreset = (presetLayout)=>{
    if ((0, $iu6m9.editorExperiment)('advanced_layouts', true)) switch(presetLayout){
        case 'single':
            return [
                100
            ];
        case 'two_equal':
            return [
                50,
                50
            ];
        case 'three_equal':
            return [
                33.33,
                33.33,
                33.33
            ];
        case 'two_left_sidebar':
            return [
                33.33,
                66.66
            ];
        case 'two_right_sidebar':
            return [
                66.66,
                33.33
            ];
        case 'three_with_sidebars':
            return [
                25,
                50,
                25
            ];
        case 'three_left_sidebars':
            return [
                25,
                25,
                50
            ];
        case 'three_right_sidebars':
            return [
                50,
                25,
                25
            ];
        case 'four_equal':
            return [
                25,
                25,
                25,
                25
            ];
        case 'five_equal':
            return [
                20,
                20,
                20,
                20,
                20
            ];
    }
    switch(presetLayout){
        case 'single':
            return [
                100
            ];
        case 'two_equal':
            return [
                50,
                50
            ];
        case 'three_equal':
            return [
                33.33,
                33.33,
                33.33
            ];
        case 'two_left_sidebar':
            return [
                33.33,
                66.66
            ];
        case 'two_right_sidebar':
            return [
                66.66,
                33.33
            ];
        case 'three_with_sidebars':
            return [
                25,
                50,
                25
            ];
    }
    return [];
};
const $9d764ec1dd06128c$var$isValidLayoutWidthDistributions = (layoutSection)=>{
    let totalWidth = 0;
    let hasInvalidWidth = false;
    (0, $3Ter7.mapChildren)(layoutSection, (column)=>column.attrs.width).forEach((width)=>{
        if (typeof width === 'number' && isFinite(width) && width > 0 && width <= 100) totalWidth += width;
        else hasInvalidWidth = true;
    });
    return !hasInvalidWidth && Math.round(totalWidth) === 100;
};
const $9d764ec1dd06128c$export$e406155610be725b = (section)=>{
    const widths = (0, $3Ter7.mapChildren)(section, (column)=>column.attrs.width).join(',');
    if ((0, $iu6m9.editorExperiment)('advanced_layouts', true)) {
        switch(widths){
            case '100':
                return 'single';
            case '33.33,33.33,33.33':
                return 'three_equal';
            case '25,50,25':
                return 'three_with_sidebars';
            case '50,25,25':
                return 'three_right_sidebars';
            case '25,25,50':
                return 'three_left_sidebars';
            case '50,50':
                return 'two_equal';
            case '33.33,66.66':
                return 'two_left_sidebar';
            case '66.66,33.33':
                return 'two_right_sidebar';
            case '25,25,25,25':
                return 'four_equal';
            case '20,20,20,20,20':
                return 'five_equal';
        }
        return;
    }
    switch(widths){
        case '100':
            return 'single';
        case '33.33,33.33,33.33':
            return 'three_equal';
        case '25,50,25':
            return 'three_with_sidebars';
        case '50,50':
            return 'two_equal';
        case '33.33,66.66':
            return 'two_left_sidebar';
        case '66.66,33.33':
            return 'two_right_sidebar';
    }
    return;
};
const $9d764ec1dd06128c$var$isLayoutOutOfSync = (node, presetLayout)=>{
    return node.childCount !== $9d764ec1dd06128c$var$getWidthsForPreset(presetLayout).length;
};
const $9d764ec1dd06128c$export$4cb9903a94908763 = (maybeLayoutSection, current)=>{
    if (maybeLayoutSection && $9d764ec1dd06128c$var$isLayoutOutOfSync(maybeLayoutSection, current) && (0, $iu6m9.editorExperiment)('advanced_layouts', true)) return $9d764ec1dd06128c$var$getDefaultPresetLayout(maybeLayoutSection);
    if (maybeLayoutSection && $9d764ec1dd06128c$export$e406155610be725b(maybeLayoutSection)) return $9d764ec1dd06128c$export$e406155610be725b(maybeLayoutSection) || current;
    return current;
};
const $9d764ec1dd06128c$export$af0aef1ee58dfcf = (state, numberOfColumns = 2)=>{
    const { layoutSection: layoutSection, layoutColumn: layoutColumn } = state.schema.nodes;
    const columns = (0, $5SAOw.Fragment).fromArray(Array.from({
        length: numberOfColumns
    }, ()=>layoutColumn.createAndFill({
            width: (0, $65c263491f5c07f1$export$faa6744ce57d263b)[numberOfColumns]
        })));
    return layoutSection.createAndFill(undefined, columns);
};
const $9d764ec1dd06128c$export$24df8f7ba30643b8 = (state)=>{
    const { layoutSection: layoutSection, layoutColumn: layoutColumn } = state.schema.nodes;
    // create a 50-50 layout by default
    const columns = (0, $5SAOw.Fragment).fromArray([
        layoutColumn.createAndFill({
            width: 50
        }),
        layoutColumn.createAndFill({
            width: 50
        })
    ]);
    return layoutSection.createAndFill(undefined, columns);
};
const $9d764ec1dd06128c$export$924bd0d32fb42cf0 = (state, dispatch)=>{
    if (dispatch) dispatch((0, $8m4tT.safeInsert)($9d764ec1dd06128c$export$24df8f7ba30643b8(state))(state.tr));
    return true;
};
const $9d764ec1dd06128c$export$3517c001098bb0a9 = (editorAnalyticsAPI)=>(inputMethod)=>(0, $dAtrv.withAnalytics)(editorAnalyticsAPI, {
            action: (0, $d925B.ACTION).INSERTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).LAYOUT,
            attributes: {
                inputMethod: inputMethod,
                columnCount: (0, $dh538.fg)('platform_editor_column_count_analytics') ? 2 : undefined
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        })((state, dispatch)=>{
            if (dispatch) dispatch((0, $8m4tT.safeInsert)($9d764ec1dd06128c$export$24df8f7ba30643b8(state))(state.tr));
            return true;
        });
/**
 * Add a column to the right of existing layout
 */ function $9d764ec1dd06128c$var$addColumn(schema, pos) {
    if ((0, $iu6m9.editorExperiment)('advanced_layouts', false)) return (tr)=>{
        tr.replaceWith(tr.mapping.map(pos), tr.mapping.map(pos), schema.nodes.layoutColumn.createAndFill());
    };
    return (tr)=>{
        tr.replaceWith(tr.mapping.map(pos), tr.mapping.map(pos), schema.nodes.layoutColumn.createAndFill(undefined));
    };
}
function $9d764ec1dd06128c$var$removeLastColumnInLayout(column, columnPos, insideRightEdgePos) {
    return (tr)=>{
        // check if the column only contains a paragraph with a placeholder text
        // if so, remove the whole column, otherwise just remove the paragraph
        if ((0, $2pjJ5.isEmptyDocument)(column)) {
            const fromPos = (0, $iu6m9.editorExperiment)('single_column_layouts', true) ? columnPos : columnPos - 1;
            tr.replaceRange(tr.mapping.map(fromPos), tr.mapping.map(insideRightEdgePos), (0, $5SAOw.Slice).empty);
        } else tr.replaceRange(tr.mapping.map(columnPos - 1), tr.mapping.map(columnPos + 1), (0, $5SAOw.Slice).empty);
    };
}
const $9d764ec1dd06128c$var$fromTwoColsToThree = $9d764ec1dd06128c$var$addColumn;
const $9d764ec1dd06128c$var$fromOneColToTwo = $9d764ec1dd06128c$var$addColumn;
const $9d764ec1dd06128c$var$fromTwoColsToOne = $9d764ec1dd06128c$var$removeLastColumnInLayout;
const $9d764ec1dd06128c$var$fromThreeColsToTwo = $9d764ec1dd06128c$var$removeLastColumnInLayout;
const $9d764ec1dd06128c$var$fromOneColToThree = (schema, pos)=>{
    return (tr)=>{
        $9d764ec1dd06128c$var$addColumn(schema, pos)(tr);
        $9d764ec1dd06128c$var$addColumn(schema, pos)(tr);
    };
};
const $9d764ec1dd06128c$var$fromThreeColstoOne = (node, tr, insideRightEdgePos)=>{
    const thirdColumn = node.content.child(2);
    $9d764ec1dd06128c$var$fromThreeColsToTwo(thirdColumn, insideRightEdgePos - thirdColumn.nodeSize, insideRightEdgePos)(tr);
    const secondColumn = node.content.child(1);
    $9d764ec1dd06128c$var$fromTwoColsToOne(secondColumn, insideRightEdgePos - thirdColumn.nodeSize - secondColumn.nodeSize, insideRightEdgePos)(tr);
};
const $9d764ec1dd06128c$var$increaseColumns = (schema, pos, newColumnsNumber = 1)=>{
    return (tr)=>{
        for(let i = 0; i < newColumnsNumber; i++)$9d764ec1dd06128c$var$addColumn(schema, pos)(tr);
    };
};
const $9d764ec1dd06128c$var$decreaseColumns = (node, insideRightEdgePos, columnsNumberToRemove = 1)=>{
    return (tr)=>{
        let endPos = insideRightEdgePos;
        let lastColumn = node.content.lastChild;
        for(let i = 0; i < columnsNumberToRemove; i++){
            lastColumn && $9d764ec1dd06128c$var$removeLastColumnInLayout(lastColumn, endPos - lastColumn.nodeSize, endPos)(tr);
            endPos -= lastColumn?.nodeSize || 0;
            lastColumn = node.content.child(node.childCount - i - 2);
        }
    };
};
/**
 * Handles switching from 2 -> 3 cols, or 3 -> 2 cols
 * Switching from 2 -> 3 just adds a new one at the end
 * Switching from 3 -> 2 moves all the content of the third col inside the second before
 * removing it
 */ function $9d764ec1dd06128c$var$forceColumnStructure(state, node, pos, presetLayout) {
    const tr = state.tr;
    const insideRightEdgeOfLayoutSection = pos + node.nodeSize - 1;
    const numCols = node.childCount;
    // 3 columns -> 2 columns
    if ($9d764ec1dd06128c$export$51fa5742354f60f2.indexOf(presetLayout) >= 0 && numCols === 3) {
        const thirdColumn = node.content.child(2);
        const columnPos = insideRightEdgeOfLayoutSection - thirdColumn.nodeSize;
        $9d764ec1dd06128c$var$fromThreeColsToTwo(thirdColumn, columnPos, insideRightEdgeOfLayoutSection)(tr);
    // 2 columns -> 3 columns
    } else if ($9d764ec1dd06128c$export$5a58dccaee34776e.indexOf(presetLayout) >= 0 && numCols === 2) $9d764ec1dd06128c$var$fromTwoColsToThree(state.schema, insideRightEdgeOfLayoutSection)(tr);
    else if ($9d764ec1dd06128c$export$6ff908759d68cbdd.indexOf(presetLayout) >= 0 && numCols === 2) {
        const secondColumn = node.content.child(1);
        const columnPos = insideRightEdgeOfLayoutSection - secondColumn.nodeSize;
        $9d764ec1dd06128c$var$fromTwoColsToOne(secondColumn, columnPos, insideRightEdgeOfLayoutSection)(tr);
    // 3 columns -> 1 column
    } else if ($9d764ec1dd06128c$export$6ff908759d68cbdd.indexOf(presetLayout) >= 0 && numCols === 3) $9d764ec1dd06128c$var$fromThreeColstoOne(node, tr, insideRightEdgeOfLayoutSection);
    else if ($9d764ec1dd06128c$export$51fa5742354f60f2.indexOf(presetLayout) >= 0 && numCols === 1) $9d764ec1dd06128c$var$fromOneColToTwo(state.schema, insideRightEdgeOfLayoutSection)(tr);
    else if ($9d764ec1dd06128c$export$5a58dccaee34776e.indexOf(presetLayout) >= 0 && numCols === 1) $9d764ec1dd06128c$var$fromOneColToThree(state.schema, insideRightEdgeOfLayoutSection)(tr);
    return tr;
}
function $9d764ec1dd06128c$var$forceColumnStructureNew(state, node, pos, presetLayout) {
    const tr = state.tr;
    const insideRightEdgeOfLayoutSection = pos + node.nodeSize - 1;
    const numCols = node.childCount;
    const columnChange = $9d764ec1dd06128c$var$getWidthsForPreset(presetLayout).length - numCols;
    if (columnChange > 0) $9d764ec1dd06128c$var$increaseColumns(state.schema, insideRightEdgeOfLayoutSection, columnChange)(tr);
    else if (columnChange < 0) $9d764ec1dd06128c$var$decreaseColumns(node, insideRightEdgeOfLayoutSection, -columnChange)(tr);
    return tr;
}
function $9d764ec1dd06128c$var$columnWidth(node, schema, widths) {
    const { layoutColumn: layoutColumn } = schema.nodes;
    const truncatedWidths = widths.map((w)=>Number(w.toFixed(2)));
    return (0, $3Ter7.flatmap)(node.content, (column, idx)=>{
        if (column.type === layoutColumn) return layoutColumn.create({
            ...column.attrs,
            width: truncatedWidths[idx]
        }, column.content, column.marks);
        else return column;
    });
}
function $9d764ec1dd06128c$var$forceColumnWidths(state, tr, pos, presetLayout) {
    const node = tr.doc.nodeAt(pos);
    if (!node) return tr;
    return tr.replaceWith(pos + 1, pos + node.nodeSize - 1, $9d764ec1dd06128c$var$columnWidth(node, state.schema, $9d764ec1dd06128c$var$getWidthsForPreset(presetLayout)));
}
function $9d764ec1dd06128c$export$e91cd6bb1b715717(state, node, pos, presetLayout) {
    const forceColumnStructureFn = (0, $iu6m9.editorExperiment)('advanced_layouts', true) ? $9d764ec1dd06128c$var$forceColumnStructureNew : $9d764ec1dd06128c$var$forceColumnStructure;
    let tr = forceColumnStructureFn(state, node, pos, presetLayout);
    // save the selection here, since forcing column widths causes a change over the
    // entire layoutSection, which remaps selection to the end. not remapping here
    // is safe because the structure is no longer changing.
    const selection = tr.selection;
    tr = $9d764ec1dd06128c$var$forceColumnWidths(state, tr, pos, presetLayout);
    const selectionPos$ = tr.doc.resolve(selection.$from.pos);
    return tr.setSelection(state.selection instanceof (0, $ks2lK.NodeSelection) ? new (0, $ks2lK.NodeSelection)(selectionPos$) : new (0, $ks2lK.TextSelection)(selectionPos$));
}
const $9d764ec1dd06128c$export$6bb7269b95fae539 = (editorAnalyticsAPI)=>(layout)=>(state, dispatch)=>{
            const { pos: pos, selectedLayout: selectedLayout } = (0, $3b01e13caf7407ac$export$18d4026d1ea86bb1).getState(state);
            if (pos === null) return false;
            const node = state.doc.nodeAt(pos);
            if (!node) return false;
            if (selectedLayout === layout && node.childCount > 1) return false;
            const tr = $9d764ec1dd06128c$export$e91cd6bb1b715717(state, node, pos, layout);
            if (tr) {
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $d925B.ACTION).CHANGED_LAYOUT,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).LAYOUT,
                    attributes: {
                        previousLayout: $9d764ec1dd06128c$var$formatLayoutName(selectedLayout),
                        newLayout: $9d764ec1dd06128c$var$formatLayoutName(layout)
                    },
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                })(tr);
                tr.setMeta('scrollIntoView', false);
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };
function $9d764ec1dd06128c$var$layoutNeedChanges(node) {
    if ((0, $iu6m9.editorExperiment)('advanced_layouts', true)) return !$9d764ec1dd06128c$export$e406155610be725b(node) || !$9d764ec1dd06128c$var$isValidLayoutWidthDistributions(node);
    return !$9d764ec1dd06128c$export$e406155610be725b(node);
}
const $9d764ec1dd06128c$var$getDefaultPresetLayout = (layoutNode)=>{
    const layoutColumnCount = layoutNode.childCount;
    if (layoutColumnCount <= 1) return 'single';
    switch(layoutColumnCount){
        case 1:
            return 'single';
        case 2:
            return 'two_equal';
        case 3:
            return 'three_equal';
        case 4:
            return 'four_equal';
        case 5:
            return 'five_equal';
        default:
            return 'five_equal';
    }
};
function $9d764ec1dd06128c$var$getLayoutChange(node, pos, schema) {
    if (node.type === schema.nodes.layoutSection) {
        if (!$9d764ec1dd06128c$var$layoutNeedChanges(node)) return;
        const presetLayout = (0, $iu6m9.editorExperiment)('advanced_layouts', true) ? $9d764ec1dd06128c$var$getDefaultPresetLayout(node) : node.childCount === 2 ? 'two_equal' : node.childCount === 3 ? 'three_equal' : 'single';
        const fixedColumns = $9d764ec1dd06128c$var$columnWidth(node, schema, $9d764ec1dd06128c$var$getWidthsForPreset(presetLayout));
        return {
            from: pos + 1,
            to: pos + node.nodeSize - 1,
            slice: new (0, $5SAOw.Slice)(fixedColumns, 0, 0)
        };
    }
}
const $9d764ec1dd06128c$export$ea5c48c44d467c6 = (changedTr, state)=>{
    const { layoutSection: layoutSection } = state.schema.nodes;
    let change;
    const range = (0, $2pjJ5.getStepRange)(changedTr);
    if (!range) return undefined;
    changedTr.doc.nodesBetween(range.from, range.to, (node, pos)=>{
        if (node.type !== layoutSection) return true; // Check all internal nodes expect for layout section
        // Node is a section
        if ($9d764ec1dd06128c$var$layoutNeedChanges(node)) change = $9d764ec1dd06128c$var$getLayoutChange(node, pos, state.schema);
        return false; // We dont go deep, We dont accept nested layouts
    });
    // Hack to prevent: https://product-fabric.atlassian.net/browse/ED-7523
    // By default prosemirror try to recreate the node with the default attributes
    // The default attribute is invalid adf though. when this happen the node after
    // current position is a layout section
    const $pos = changedTr.doc.resolve(range.to);
    if ($pos.depth > 0) {
        // 'range.to' position could resolve to doc, in this ResolvedPos.after will throws
        const pos = $pos.after();
        const node = changedTr.doc.nodeAt(pos);
        if (node && node.type === layoutSection && $9d764ec1dd06128c$var$layoutNeedChanges(node)) change = $9d764ec1dd06128c$var$getLayoutChange(node, pos, state.schema);
    }
    return change;
};
const $9d764ec1dd06128c$export$35e1f731e4a1d52 = (state)=>{
    const { pos: pos, selectedLayout: selectedLayout } = (0, $3b01e13caf7407ac$export$18d4026d1ea86bb1).getState(state);
    if (pos !== null && selectedLayout) {
        const node = state.doc.nodeAt(pos);
        if (node) {
            if (node.childCount !== $9d764ec1dd06128c$var$getWidthsForPreset(selectedLayout).length) return $9d764ec1dd06128c$export$e91cd6bb1b715717(state, node, pos, selectedLayout);
            if (!$9d764ec1dd06128c$var$isValidLayoutWidthDistributions(node) && (0, $iu6m9.editorExperiment)('advanced_layouts', true)) return $9d764ec1dd06128c$export$e91cd6bb1b715717(state, node, pos, selectedLayout);
        }
    }
    return;
};
const $9d764ec1dd06128c$export$7472487719e2c16f = (editorAnalyticsAPI, inputMethod)=>(state, dispatch)=>{
        const { pos: pos, selectedLayout: selectedLayout } = (0, $3b01e13caf7407ac$export$18d4026d1ea86bb1).getState(state);
        if (pos !== null) {
            const node = state.doc.nodeAt(pos);
            if (dispatch) {
                const tr = state.tr.delete(pos, pos + node.nodeSize);
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $d925B.ACTION).DELETED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).LAYOUT,
                    attributes: {
                        layout: $9d764ec1dd06128c$var$formatLayoutName(selectedLayout),
                        inputMethod: inputMethod
                    },
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                })(tr);
                dispatch(tr);
            }
            return true;
        }
        return false;
    };
const $9d764ec1dd06128c$var$formatLayoutName = (layout)=>{
    if ((0, $iu6m9.editorExperiment)('advanced_layouts', true)) switch(layout){
        case 'single':
            return (0, $eKaDU.LAYOUT_TYPE).SINGLE_COL;
        case 'two_equal':
            return (0, $eKaDU.LAYOUT_TYPE).TWO_COLS_EQUAL;
        case 'three_equal':
            return (0, $eKaDU.LAYOUT_TYPE).THREE_COLS_EQUAL;
        case 'two_left_sidebar':
            return (0, $eKaDU.LAYOUT_TYPE).LEFT_SIDEBAR;
        case 'two_right_sidebar':
            return (0, $eKaDU.LAYOUT_TYPE).RIGHT_SIDEBAR;
        case 'three_with_sidebars':
            return (0, $eKaDU.LAYOUT_TYPE).THREE_WITH_SIDEBARS;
        case 'four_equal':
            return (0, $eKaDU.LAYOUT_TYPE).FOUR_COLS_EQUAL;
        case 'five_equal':
            return (0, $eKaDU.LAYOUT_TYPE).FIVE_COLS_EQUAL;
    }
    switch(layout){
        case 'single':
            return (0, $eKaDU.LAYOUT_TYPE).SINGLE_COL;
        case 'two_equal':
            return (0, $eKaDU.LAYOUT_TYPE).TWO_COLS_EQUAL;
        case 'three_equal':
            return (0, $eKaDU.LAYOUT_TYPE).THREE_COLS_EQUAL;
        case 'two_left_sidebar':
            return (0, $eKaDU.LAYOUT_TYPE).LEFT_SIDEBAR;
        case 'two_right_sidebar':
            return (0, $eKaDU.LAYOUT_TYPE).RIGHT_SIDEBAR;
        case 'three_with_sidebars':
            return (0, $eKaDU.LAYOUT_TYPE).THREE_WITH_SIDEBARS;
    }
};



var $1S4f7 = parcelRequire("1S4f7");


var $3tffm = parcelRequire("3tffm");


var $e7tBw = parcelRequire("e7tBw");


var $dus6D = parcelRequire("dus6D");











var $ftzrq = parcelRequire("ftzrq");








var $adhil = parcelRequire("adhil");










const $2bde854adcad6d37$export$9adba9ade368b431 = (state)=>{
    const { schema: { nodes: { layoutSection: layoutSection, layoutColumn: layoutColumn } }, selection: selection } = state;
    const isLayoutColumn = (0, $iu6m9.editorExperiment)('advanced_layouts', true) && (0, $8m4tT.findSelectedNodeOfType)([
        layoutColumn
    ])(selection);
    // When selection is on layoutColumn, we want to hide floating toolbar, hence don't return layoutSection node here
    return isLayoutColumn ? undefined : (0, $8m4tT.findParentNodeOfType)(layoutSection)(selection) || (0, $8m4tT.findSelectedNodeOfType)([
        layoutSection
    ])(selection);
};
/**
 * The depth of the layout column inside the layout section.
 * As per the current implementation, the layout column ALWAYS has a depth of 1.
 */ const $2bde854adcad6d37$var$LAYOUT_COLUMN_DEPTH = 1;
const $2bde854adcad6d37$export$c13dbc07830c6c42 = (view, posOfLayout, childIndex = 0)=>{
    const $maybeLayoutSection = view.state.doc.resolve(posOfLayout);
    if ($maybeLayoutSection.nodeAfter?.type.name === 'layoutSection') {
        const layoutSectionNode = $maybeLayoutSection.nodeAfter;
        // check if the childIndex is valid
        if (childIndex < 0 || childIndex >= layoutSectionNode.childCount) return;
        const childPos = $maybeLayoutSection.posAtIndex(childIndex, $2bde854adcad6d37$var$LAYOUT_COLUMN_DEPTH);
        const tr = view.state.tr;
        const $selectionPos = tr.doc.resolve(childPos);
        if (layoutSectionNode.firstChild?.type.name === 'paragraph') view.dispatch(tr.setSelection((0, $ks2lK.TextSelection).near($selectionPos)));
        else view.dispatch(tr.setSelection((0, $adhil.GapCursorSelection).near($selectionPos)));
        return tr;
    }
};


const $ef7d532c79770eba$export$cfaf3f619f4fde4d = 'two_equal';
const $ef7d532c79770eba$var$isWholeSelectionInsideLayoutColumn = (state)=>{
    // Since findParentNodeOfType doesn't check if selection.to shares the parent, we do this check ourselves
    const fromParent = (0, $8m4tT.findParentNodeOfType)(state.schema.nodes.layoutColumn)(state.selection);
    if (fromParent) {
        const isToPosInsideSameLayoutColumn = state.selection.from < fromParent.pos + fromParent.node.nodeSize;
        return isToPosInsideSameLayoutColumn;
    }
    return false;
};
const $ef7d532c79770eba$var$moveCursorToNextColumn = (state, dispatch)=>{
    const { selection: selection } = state;
    const { schema: { nodes: { layoutColumn: layoutColumn, layoutSection: layoutSection } } } = state;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const section = (0, $8m4tT.findParentNodeOfType)(layoutSection)(selection);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const column = (0, $8m4tT.findParentNodeOfType)(layoutColumn)(selection);
    if (column.node !== section.node.lastChild) {
        const $nextColumn = state.doc.resolve(column.pos + column.node.nodeSize);
        const shiftedSelection = (0, $ks2lK.TextSelection).findFrom($nextColumn, 1);
        if (dispatch) dispatch(state.tr.setSelection(shiftedSelection));
    }
    return true;
};
const $ef7d532c79770eba$var$getNodeDecoration = (pos, node)=>[
        (0, $ftzrq.Decoration).node(pos, pos + node.nodeSize, {
            class: 'selected'
        })
    ];
const $ef7d532c79770eba$var$getInitialPluginState = (options, state)=>{
    const maybeLayoutSection = (0, $2bde854adcad6d37$export$9adba9ade368b431)(state);
    const allowBreakout = options.allowBreakout || false;
    const addSidebarLayouts = options.UNSAFE_addSidebarLayouts || false;
    const allowSingleColumnLayout = options.UNSAFE_allowSingleColumnLayout || false;
    const pos = maybeLayoutSection ? maybeLayoutSection.pos : null;
    const selectedLayout = (0, $9d764ec1dd06128c$export$4cb9903a94908763)(maybeLayoutSection && maybeLayoutSection.node, $ef7d532c79770eba$export$cfaf3f619f4fde4d);
    return {
        pos: pos,
        allowBreakout: allowBreakout,
        addSidebarLayouts: addSidebarLayouts,
        selectedLayout: selectedLayout,
        allowSingleColumnLayout: allowSingleColumnLayout,
        isResizing: false
    };
};
// To prevent a single-column layout,
// if a user attempts to delete a layout column and
// we will force remove the content instead.
// There are some edge cases where user can delete a layout column
// see packages/editor/editor-plugin-layout-tests/src/__tests__/unit/delete.ts
const $ef7d532c79770eba$var$handleDeleteLayoutColumn = (state, dispatch)=>{
    const sel = state.selection;
    if (sel instanceof (0, $ks2lK.NodeSelection) && sel.node.type.name === 'layoutColumn' && sel.$from.parent.type.name === 'layoutSection' && sel.$from.parent.childCount === 2 && dispatch && (0, $iu6m9.editorExperiment)('advanced_layouts', true) && !(0, $iu6m9.editorExperiment)('single_column_layouts', true)) {
        const tr = state.tr;
        const layoutContentFragment = sel.$from.parentOffset === 0 ? (0, $5SAOw.Fragment).from(sel.$from.parent.lastChild?.content) : (0, $5SAOw.Fragment).from(sel.$from.parent.firstChild?.content);
        const parent = (0, $8m4tT.findParentNodeClosestToPos)(sel.$from, (node)=>{
            return node.type.name === 'layoutSection';
        });
        if (parent) {
            const layoutSectionPos = tr.mapping.map(parent.pos);
            const layoutSectionNodeSize = parent.node.nodeSize;
            dispatch(state.tr.replaceWith(layoutSectionPos, layoutSectionPos + layoutSectionNodeSize, layoutContentFragment));
            return true;
        }
        return false;
    }
    return false;
};
var $ef7d532c79770eba$export$2e2bcd8739ae039 = (options)=>new (0, $1S4f7.SafePlugin)({
        key: (0, $3b01e13caf7407ac$export$18d4026d1ea86bb1),
        state: {
            init: (_, state)=>$ef7d532c79770eba$var$getInitialPluginState(options, state),
            apply: (tr, pluginState, oldState, newState)=>{
                const isResizing = (0, $iu6m9.editorExperiment)('single_column_layouts', true) ? tr.getMeta('is-resizer-resizing') ?? (0, $3b01e13caf7407ac$export$18d4026d1ea86bb1).getState(oldState)?.isResizing : false;
                if (tr.docChanged || tr.selectionSet) {
                    const maybeLayoutSection = (0, $2bde854adcad6d37$export$9adba9ade368b431)(newState);
                    const newPluginState = {
                        ...pluginState,
                        pos: maybeLayoutSection ? maybeLayoutSection.pos : null,
                        isResizing: isResizing,
                        selectedLayout: (0, $9d764ec1dd06128c$export$4cb9903a94908763)(maybeLayoutSection && maybeLayoutSection.node, // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        pluginState.selectedLayout)
                    };
                    return newPluginState;
                }
                return {
                    ...pluginState,
                    isResizing: isResizing
                };
            }
        },
        props: {
            decorations (state) {
                const layoutState = (0, $3b01e13caf7407ac$export$18d4026d1ea86bb1).getState(state);
                if (layoutState.pos !== null) return (0, $ftzrq.DecorationSet).create(state.doc, $ef7d532c79770eba$var$getNodeDecoration(layoutState.pos, state.doc.nodeAt(layoutState.pos)));
                return undefined;
            },
            handleKeyDown: (0, $dus6D.keydownHandler)({
                Tab: (0, $e7tBw.filterCommand)($ef7d532c79770eba$var$isWholeSelectionInsideLayoutColumn, $ef7d532c79770eba$var$moveCursorToNextColumn),
                'Mod-Backspace': $ef7d532c79770eba$var$handleDeleteLayoutColumn,
                'Mod-Delete': $ef7d532c79770eba$var$handleDeleteLayoutColumn,
                Backspace: $ef7d532c79770eba$var$handleDeleteLayoutColumn,
                Delete: $ef7d532c79770eba$var$handleDeleteLayoutColumn
            }),
            handleClickOn: (0, $3tffm.createSelectionClickHandler)([
                'layoutColumn'
            ], (target)=>target.hasAttribute('data-layout-section') || target.hasAttribute('data-layout-column'), {
                useLongPressSelection: options.useLongPressSelection || false,
                getNodeSelectionPos: (state, nodePos)=>state.doc.resolve(nodePos).before()
            })
        },
        appendTransaction: (transactions, _oldState, newState)=>{
            const changes = [];
            transactions.forEach((prevTr)=>{
                // remap change segments across the transaction set
                changes.forEach((change)=>{
                    return {
                        from: prevTr.mapping.map(change.from),
                        to: prevTr.mapping.map(change.to),
                        slice: change.slice
                    };
                });
                // don't consider transactions that don't mutate
                if (!prevTr.docChanged) return;
                const change = (0, $9d764ec1dd06128c$export$ea5c48c44d467c6)(prevTr, newState);
                if (change) changes.push(change);
            });
            if ((0, $iu6m9.editorExperiment)('advanced_layouts', true) && changes.length === 1) {
                const change = changes[0];
                // When editorExperiment('single_column_layouts', true) is on
                // delete can create a single column layout
                // otherwise we replace the single column layout with its content
                if (!(0, $iu6m9.editorExperiment)('single_column_layouts', true) && change.slice.content.childCount === 1 && change.slice.content.firstChild?.type.name === 'layoutColumn' && change.slice.content.firstChild?.attrs.width === (0, $65c263491f5c07f1$export$faa6744ce57d263b)[1]) {
                    const tr = newState.tr;
                    const { content: content } = change.slice.content.firstChild;
                    tr.replaceWith(change.from - 1, change.to, content);
                    return tr;
                }
            }
            if (changes.length) {
                let tr = newState.tr;
                const selection = newState.selection.toJSON();
                changes.forEach((change)=>{
                    tr.replaceRange(change.from, change.to, change.slice);
                });
                // selecting and deleting across columns in 3 col layouts can remove
                // a layoutColumn so we fix the structure here
                tr = (0, $9d764ec1dd06128c$export$35e1f731e4a1d52)(newState) || tr;
                if (tr.docChanged) {
                    tr.setSelection((0, $ks2lK.Selection).fromJSON(tr.doc, selection));
                    return tr;
                }
            }
            return;
        }
    });













var $42omo = parcelRequire("42omo");


var $eiA8Z = parcelRequire("eiA8Z");


var $2gkmX = parcelRequire("2gkmX");





var $fFa3V = parcelRequire("fFa3V");


var $aFUXX = parcelRequire("aFUXX");





var $1oCLl = parcelRequire("1oCLl");








var $boKri = parcelRequire("boKri");


var $d7ZU3 = parcelRequire("d7ZU3");


var $8b5jG = parcelRequire("8b5jG");


var $7x0qS = parcelRequire("7x0qS");










const $946a54e61dd6924e$export$6cdb476c834bc60 = 8;
const $946a54e61dd6924e$var$GUIDELINE_KEYS = {
    lineLength: 'grid',
    wide: 'wide',
    fullWidth: 'full_width'
};
const $946a54e61dd6924e$var$CURRENT_LAYOUT_KEYS = {
    lineLength: 'center',
    wide: 'wide',
    fullWidth: 'full-width'
};
const $946a54e61dd6924e$var$roundToNearest = (value, interval = 0.5)=>Math.round(value / interval) * interval;
function $946a54e61dd6924e$export$54a1e15ba45852e2(getEditorWidth, isResizing, dynamicFullWidthGuidelineOffset = 0) {
    const widthState = getEditorWidth();
    const { lineLength: lineLength, wide: wide, fullWidth: fullWidth } = (0, $42omo.useMemo)(()=>{
        if (!isResizing) return {};
        const { width: width, lineLength: lineLength } = widthState || {};
        const wideCalWithRatio = lineLength ? Math.round(lineLength * (0, $aFUXX.breakoutWideScaleRatio)) : undefined;
        // When page is full width, lineLength from widthState can be much wider than 760.
        // But the lineLength variable here is being used like a const 760.
        // when the page is full width, the calculation of wide is wrong.
        // Actuall the wide is the wide breakout point, which is
        const wide = (0, $iu6m9.editorExperiment)('single_column_layouts', true) ? (0, $aFUXX.akEditorCalculatedWideLayoutWidth) : wideCalWithRatio;
        const padding = width && width <= (0, $aFUXX.akEditorFullPageNarrowBreakout) && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        }) ? (0, $aFUXX.akEditorGutterPaddingReduced) : (0, $aFUXX.akEditorGutterPaddingDynamic)();
        const layoutCalculatedWidth = width ? width - (padding + dynamicFullWidthGuidelineOffset) * 2 : undefined;
        const fullWidth = width && layoutCalculatedWidth ? Math.min(layoutCalculatedWidth, (0, $aFUXX.akEditorFullWidthLayoutWidth)) : undefined;
        return {
            wide: wide,
            fullWidth: fullWidth,
            // When page is full width, lineLength from widthState can be much wider than 760.
            // But the lineLength variable here is being used like a const 760.
            lineLength: (0, $iu6m9.editorExperiment)('single_column_layouts', true) ? (0, $aFUXX.akEditorDefaultLayoutWidth) : lineLength
        };
    }, [
        widthState,
        isResizing,
        dynamicFullWidthGuidelineOffset
    ]);
    // calculate snapping width
    const defaultSnappingWidths = (0, $42omo.useMemo)(()=>{
        if (!fullWidth || !wide || !lineLength || fullWidth <= ((0, $iu6m9.editorExperiment)('single_column_layouts', true) ? (0, $aFUXX.akEditorDefaultLayoutWidth) : lineLength)) return null;
        if (fullWidth - wide > $946a54e61dd6924e$export$6cdb476c834bc60) return {
            lineLength: lineLength,
            wide: wide,
            fullWidth: fullWidth
        };
        if (fullWidth <= wide && fullWidth - lineLength > $946a54e61dd6924e$export$6cdb476c834bc60) return {
            lineLength: lineLength,
            fullWidth: fullWidth
        };
        return null;
    }, [
        fullWidth,
        lineLength,
        wide
    ]);
    const snaps = (0, $42omo.useMemo)(()=>{
        if (!isResizing || !defaultSnappingWidths) return null;
        return {
            x: Object.values(defaultSnappingWidths)
        };
    }, [
        defaultSnappingWidths,
        isResizing
    ]);
    // calculate guidelines, and calculate which lines are active
    const [currentLayout, setCurrentLayout] = (0, $42omo.useState)(null);
    const guidelines = (0, $42omo.useMemo)(()=>{
        const guidelines = [];
        if (!defaultSnappingWidths) return guidelines;
        Object.entries(defaultSnappingWidths).map(([key, value])=>{
            if (value) {
                guidelines.push({
                    key: `${$946a54e61dd6924e$var$GUIDELINE_KEYS[key]}_left`,
                    position: {
                        x: -$946a54e61dd6924e$var$roundToNearest(value / 2)
                    },
                    active: currentLayout === $946a54e61dd6924e$var$CURRENT_LAYOUT_KEYS[key]
                });
                guidelines.push({
                    key: `${$946a54e61dd6924e$var$GUIDELINE_KEYS[key]}_right`,
                    position: {
                        x: $946a54e61dd6924e$var$roundToNearest(value / 2)
                    },
                    active: currentLayout === $946a54e61dd6924e$var$CURRENT_LAYOUT_KEYS[key]
                });
            }
        });
        return guidelines;
    }, [
        defaultSnappingWidths,
        currentLayout
    ]);
    const setCurrentWidth = (0, $42omo.useCallback)((newWidth)=>{
        if (typeof newWidth !== 'number') {
            setCurrentLayout(null);
            return;
        }
        if (lineLength && Math.abs(newWidth - lineLength) < $946a54e61dd6924e$export$6cdb476c834bc60 / 2) setCurrentLayout('center');
        else if (wide && Math.abs(newWidth - wide) < $946a54e61dd6924e$export$6cdb476c834bc60 / 2) setCurrentLayout('wide');
        else if (fullWidth && // we only allow snap from one side, so we don't use Math.abs here
        (fullWidth + (0, $aFUXX.akEditorGutterPadding) - newWidth < $946a54e61dd6924e$export$6cdb476c834bc60 / 2 || newWidth >= fullWidth)) setCurrentLayout('full-width');
        else setCurrentLayout(null);
    }, [
        lineLength,
        wide,
        fullWidth
    ]);
    return {
        snaps: snaps,
        currentLayout: currentLayout,
        guidelines: guidelines,
        setCurrentWidth: setCurrentWidth
    };
}


const $4cf13f9507f13269$var$breakoutSupportedNodes = [
    'layoutSection',
    'expand',
    'codeBlock'
];
const $4cf13f9507f13269$var$getHandleStyle = (node, hidden)=>{
    const layoutMarginOffset = 12;
    if (hidden) return {
        left: {
            display: 'none'
        },
        right: {
            display: 'none'
        }
    };
    switch(node){
        case 'codeBlock':
            return {
                left: {
                    left: '-12px'
                },
                right: {
                    right: '-12px'
                }
            };
        // expand and layout section elements have a negative margin applied
        default:
            const handleOffset = (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? (0, $boKri.LAYOUT_SECTION_MARGIN) * 2 + layoutMarginOffset : (0, $boKri.LAYOUT_COLUMN_PADDING) * 2;
            return {
                left: {
                    left: `-${handleOffset}px`,
                    height: 'calc(100% - 8px)',
                    bottom: '0px',
                    top: 'unset'
                },
                right: {
                    right: `-${handleOffset}px`,
                    height: 'calc(100% - 8px)',
                    bottom: '0px',
                    top: 'unset'
                }
            };
    }
};
const $4cf13f9507f13269$export$256eed97177e990e = (mutation)=>{
    if (mutation.target instanceof Element) return mutation.target.classList.contains('resizer-item') || mutation.type === 'attributes' && mutation.attributeName === 'style';
    return mutation.type === 'attributes' && mutation.attributeName === 'style';
};
const $4cf13f9507f13269$var$resizingStyles = {
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'grid'
};
// Apply grid to stop drag handles rendering inside .resizer-item affecting its height
const $4cf13f9507f13269$var$defaultStyles = {
    display: 'grid'
};
const $4cf13f9507f13269$var$RESIZE_STEP_VALUE = 10;
/**
 * BreakoutResizer is a common component used to resize nodes that support the 'Breakout' mark, so it requires
 * correct ADF support.
 *
 * use experiment platform_editor_advanced_layouts
 * @param root0
 * @param root0.editorView
 * @param root0.nodeType
 * @param root0.getPos
 * @param root0.getRef
 * @param root0.disabled
 * @param root0.getEditorWidth
 * @param root0.parentRef
 * @param root0.displayGuidelines
 * @param root0.editorAnalyticsApi
 * @param root0.displayGapCursor
 * @param root0.onResizeStart
 * @param root0.dynamicFullWidthGuidelineOffset
 * @param root0.hidden Hide the resizer handles without outright unrendering them
 * @returns BreakoutResizer component
 * @example
 */ const $4cf13f9507f13269$export$d6c278682f48fbc4 = ({ editorView: editorView, nodeType: nodeType, getPos: getPos, getRef: getRef, disabled: disabled, getEditorWidth: getEditorWidth, parentRef: parentRef, displayGuidelines: displayGuidelines, editorAnalyticsApi: editorAnalyticsApi, displayGapCursor: displayGapCursor, onResizeStart: onResizeStart, dynamicFullWidthGuidelineOffset: dynamicFullWidthGuidelineOffset, hidden: hidden = false })=>{
    const [{ minWidth: minWidth, maxWidth: maxWidth, isResizing: isResizing }, setResizingState] = (0, $42omo.useState)({
        minWidth: undefined,
        maxWidth: undefined,
        isResizing: false
    });
    const areResizeMetaKeysPressed = (0, $42omo.useRef)(false);
    const resizerRef = (0, $42omo.useRef)(null);
    const { snaps: snaps, currentLayout: currentLayout, guidelines: guidelines, setCurrentWidth: setCurrentWidth } = (0, $946a54e61dd6924e$export$54a1e15ba45852e2)(getEditorWidth, isResizing && (0, $iu6m9.editorExperiment)('single_column_layouts', true), dynamicFullWidthGuidelineOffset);
    const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
    (0, $42omo.useEffect)(()=>{
        if (displayGuidelines) displayGuidelines(guidelines || []);
    }, [
        displayGuidelines,
        guidelines
    ]);
    // Relying on re-renders caused by selection changes inside/around node
    const isSelectionInNode = (0, $42omo.useMemo)(()=>{
        const pos = getPos();
        if (pos === undefined) return false;
        const node = editorView.state.doc.nodeAt(pos);
        if (node === null) return false;
        const endPos = pos + node.nodeSize;
        const startPos = pos;
        const { $from: $from, $to: $to } = editorView.state.selection;
        return $from.pos >= startPos && endPos >= $to.pos;
    }, [
        editorView.state.doc,
        editorView.state.selection,
        getPos
    ]);
    const handleResizeStart = (0, $42omo.useCallback)(()=>{
        onResizeStart?.();
        let newMinWidth;
        let newMaxWidth;
        const widthState = getEditorWidth();
        const { dispatch: dispatch, state: state } = editorView;
        displayGapCursor(false);
        if (widthState !== undefined && widthState.lineLength !== undefined && widthState.width !== undefined) {
            const padding = widthState.width <= (0, $aFUXX.akEditorFullPageNarrowBreakout) && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                exposure: true
            }) ? (0, $aFUXX.akEditorGutterPaddingReduced) : (0, $aFUXX.akEditorGutterPaddingDynamic)();
            newMaxWidth = Math.min(widthState.width - padding * 2 - (0, $aFUXX.akEditorGutterPadding), (0, $aFUXX.akEditorFullWidthLayoutWidth));
            newMinWidth = Math.min(widthState.lineLength, (0, $aFUXX.akEditorDefaultLayoutWidth), newMaxWidth);
        }
        setResizingState({
            isResizing: true,
            minWidth: newMinWidth,
            maxWidth: newMaxWidth
        });
        dispatch(state.tr.setMeta('is-resizer-resizing', true));
    }, [
        onResizeStart,
        getEditorWidth,
        editorView,
        displayGapCursor
    ]);
    const handleResize = (0, $42omo.useCallback)((originalState, delta)=>{
        if ((0, $iu6m9.editorExperiment)('single_column_layouts', true)) {
            const newWidth = originalState.width + delta.width;
            setCurrentWidth(newWidth);
        }
    }, [
        setCurrentWidth
    ]);
    const handleResizeStop = (0, $42omo.useCallback)((originalState, delta)=>{
        const newWidth = originalState.width + delta.width;
        const pos = getPos();
        if (pos === undefined) return;
        const { state: state, dispatch: dispatch } = editorView;
        const { breakout: breakout } = state.schema.marks;
        const node = state.doc.nodeAt(pos);
        const newTr = state.tr;
        if (node && $4cf13f9507f13269$var$breakoutSupportedNodes.includes(node.type.name)) {
            if (currentLayout && [
                'wide',
                'full-width'
            ].includes(currentLayout) && (0, $iu6m9.editorExperiment)('single_column_layouts', true)) newTr.setNodeMarkup(pos, node.type, node.attrs, [
                breakout.create({
                    mode: currentLayout,
                    width: null
                })
            ]);
            else {
                const newBreakoutWidth = Math.max(newWidth, (0, $aFUXX.akEditorDefaultLayoutWidth));
                newTr.setNodeMarkup(pos, node.type, node.attrs, [
                    breakout.create({
                        width: newBreakoutWidth
                    })
                ]);
                const breakoutResizePayload = {
                    action: (0, $d925B.ACTION).RESIZED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).ELEMENT,
                    eventType: (0, $d925B.EVENT_TYPE).TRACK,
                    attributes: {
                        nodeType: node.type.name,
                        prevWidth: originalState.width,
                        newWidth: newBreakoutWidth
                    }
                };
                editorAnalyticsApi?.attachAnalyticsEvent(breakoutResizePayload)(newTr);
            }
        }
        newTr.setMeta('is-resizer-resizing', false).setMeta('scrollIntoView', false);
        displayGapCursor(true);
        dispatch(newTr);
        setResizingState({
            isResizing: false,
            minWidth: undefined,
            maxWidth: undefined
        });
        setCurrentWidth(null);
    }, [
        getPos,
        editorView,
        displayGapCursor,
        setCurrentWidth,
        currentLayout,
        editorAnalyticsApi
    ]);
    const handleEscape = (0, $42omo.useCallback)(()=>{
        editorView?.focus();
    }, [
        editorView
    ]);
    const handleLayoutSizeChangeOnKeypress = (0, $42omo.useCallback)((step)=>{
        if (!parentRef) return;
        const resizerItem = parentRef.closest('.resizer-item');
        if (!(resizerItem instanceof HTMLElement)) return;
        const newWidth = resizerItem.offsetWidth + step;
        if (maxWidth && newWidth > maxWidth || minWidth && newWidth < minWidth) return;
        handleResizeStop({
            width: resizerItem.offsetWidth,
            x: 0,
            y: 0,
            height: 0
        }, {
            width: step,
            height: 0
        });
    }, [
        handleResizeStop,
        maxWidth,
        minWidth,
        parentRef
    ]);
    const resizeHandleKeyDownHandler = (0, $42omo.useCallback)((event)=>{
        const isBracketKey = event.code === 'BracketRight' || event.code === 'BracketLeft';
        const metaKey = browser.mac ? event.metaKey : event.ctrlKey;
        if (event.altKey || metaKey || event.shiftKey) areResizeMetaKeysPressed.current = true;
        if (event.altKey && metaKey) {
            if (isBracketKey) {
                event.preventDefault();
                handleLayoutSizeChangeOnKeypress(event.code === 'BracketRight' ? $4cf13f9507f13269$var$RESIZE_STEP_VALUE : -$4cf13f9507f13269$var$RESIZE_STEP_VALUE);
            }
        } else if (!areResizeMetaKeysPressed.current) handleEscape();
    }, [
        handleEscape,
        handleLayoutSizeChangeOnKeypress,
        browser
    ]);
    const resizeHandleKeyUpHandler = (0, $42omo.useCallback)((event)=>{
        if (event.altKey || event.metaKey) areResizeMetaKeysPressed.current = false;
        return;
    }, [
        areResizeMetaKeysPressed
    ]);
    const resizerGlobalKeyDownHandler = (0, $42omo.useCallback)((event)=>{
        if (!resizerRef.current) return;
        const resizeHandleThumbEl = resizerRef.current.getResizerThumbEl();
        const metaKey = browser.mac ? event.metaKey : event.ctrlKey;
        const isTargetResizeHandle = event.target instanceof HTMLElement && event.target.classList.contains('resizer-handle-thumb');
        if (event.altKey && event.shiftKey && metaKey && event.code === 'KeyR' || isTargetResizeHandle && (event.altKey || metaKey || event.shiftKey)) {
            event.preventDefault();
            if (!resizeHandleThumbEl) return;
            resizeHandleThumbEl.focus();
            resizeHandleThumbEl.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest'
            });
        }
    }, [
        resizerRef,
        browser
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!resizerRef.current || !editorView) return;
        const resizeHandleThumbEl = resizerRef.current.getResizerThumbEl();
        if (!resizeHandleThumbEl) return;
        const editorViewDom = editorView.dom;
        const unbindEditorViewDom = (0, $fFa3V.bind)(editorViewDom, {
            type: 'keydown',
            listener: resizerGlobalKeyDownHandler
        });
        const unbindResizeHandle = (0, $fFa3V.bindAll)(resizeHandleThumbEl, [
            {
                type: 'keydown',
                listener: resizeHandleKeyDownHandler
            },
            {
                type: 'keyup',
                listener: resizeHandleKeyUpHandler
            }
        ]);
        return ()=>{
            unbindEditorViewDom();
            unbindResizeHandle();
        };
    }, [
        editorView,
        resizerGlobalKeyDownHandler,
        resizeHandleKeyDownHandler,
        resizeHandleKeyUpHandler
    ]);
    if (disabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "breakout-resizer-editor-view-wrapper",
        ref: (ref)=>getRef && getRef(ref)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8b5jG.default), {
        ref: resizerRef,
        enable: {
            left: true,
            right: true
        },
        snap: snaps || undefined,
        snapGap: (0, $946a54e61dd6924e$export$6cdb476c834bc60),
        handleStyles: $4cf13f9507f13269$var$getHandleStyle(nodeType, hidden),
        minWidth: minWidth,
        maxWidth: maxWidth,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: isResizing ? $4cf13f9507f13269$var$resizingStyles : $4cf13f9507f13269$var$defaultStyles,
        handleResizeStart: handleResizeStart,
        handleResizeStop: handleResizeStop,
        handleResize: handleResize,
        childrenDOMRef: getRef,
        resizeRatio: 2,
        isHandleVisible: isSelectionInNode,
        handleSize: "clamped",
        handleHighlight: "full-height",
        handlePositioning: "adjacent",
        handleAlignmentMethod: "sticky",
        labelComponent: currentLayout && (0, $iu6m9.editorExperiment)('single_column_layouts', true) && [
            'full-width',
            'wide'
        ].includes(currentLayout || '') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7x0qS.ResizerBreakoutModeLabel), {
            layout: currentLayout
        })
    });
};



var $b3YrF = parcelRequire("b3YrF");














const $ba567578d7e42e9a$var$layoutDynamicFullWidthGuidelineOffset = 16;
const $ba567578d7e42e9a$var$isEmptyParagraph = (node)=>{
    return !!node && node.type.name === 'paragraph' && !node.childCount;
};
const $ba567578d7e42e9a$var$isBreakoutAvailable = (schema)=>{
    return Boolean(schema.marks.breakout);
};
const $ba567578d7e42e9a$var$isEmptyLayout = (node)=>{
    if (!node) return false;
    // fast check
    // each column should have size 2 from layoutcolumn and 2 from empty paragraph
    if (node.content.size / node.childCount !== 4) return false;
    let isEmpty = true;
    node.content.forEach((maybelayoutColumn)=>{
        if (maybelayoutColumn.type.name !== 'layoutColumn' || maybelayoutColumn.childCount > 1 || !$ba567578d7e42e9a$var$isEmptyParagraph(maybelayoutColumn.firstChild)) {
            isEmpty = false;
            return;
        }
    });
    return isEmpty;
};
const $ba567578d7e42e9a$var$selector = (states)=>{
    return {
        editorDisabled: states.editorDisabledState?.editorDisabled
    };
};
const $ba567578d7e42e9a$var$LayoutBreakoutResizer = ({ pluginInjectionApi: pluginInjectionApi, forwardRef: forwardRef, getPos: getPos, view: view, parentRef: parentRef })=>{
    const { editorDisabled: editorDisabled } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'editorDisabled'
    ], $ba567578d7e42e9a$var$selector);
    const interactionState = (0, $b3YrF.useSharedPluginStateSelector)(pluginInjectionApi, 'interaction.interactionState');
    const getEditorWidth = ()=>{
        return pluginInjectionApi?.width?.sharedState.currentState();
    };
    const displayGapCursor = (0, $42omo.useCallback)((toggle)=>{
        return pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.selection?.commands.displayGapCursor(toggle)) ?? false;
    }, [
        pluginInjectionApi
    ]);
    const displayGuidelines = (0, $42omo.useCallback)((guidelines)=>{
        pluginInjectionApi?.guideline?.actions?.displayGuideline(view)({
            guidelines: guidelines
        });
    }, [
        pluginInjectionApi,
        view
    ]);
    // we want to hide the floating toolbar for other nodes.
    // e.g. info panel inside the current layout section
    const selectIntoCurrentLayout = (0, $42omo.useCallback)(()=>{
        const pos = getPos();
        if (pos === undefined) return;
        // put the selection into the first column of the layout
        (0, $2bde854adcad6d37$export$c13dbc07830c6c42)(view, pos, 0);
    }, [
        getPos,
        view
    ]);
    if (interactionState === 'hasNotHadInteraction' && !(0, $1oCLl.expValEquals)('platform_editor_breakout_interaction_rerender', 'isEnabled', true)) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4cf13f9507f13269$export$d6c278682f48fbc4), {
        getRef: forwardRef,
        getPos: getPos,
        editorView: view,
        nodeType: "layoutSection",
        getEditorWidth: getEditorWidth,
        disabled: (0, $iu6m9.editorExperiment)('platform_editor_breakout_resizing', true) ? true : editorDisabled === true || !$ba567578d7e42e9a$var$isBreakoutAvailable(view.state.schema),
        hidden: interactionState === 'hasNotHadInteraction' && (0, $1oCLl.expValEquals)('platform_editor_breakout_interaction_rerender', 'isEnabled', true),
        parentRef: parentRef,
        editorAnalyticsApi: pluginInjectionApi?.analytics?.actions,
        displayGuidelines: (0, $iu6m9.editorExperiment)('single_column_layouts', true) ? displayGuidelines : undefined,
        displayGapCursor: displayGapCursor,
        onResizeStart: ()=>{
            selectIntoCurrentLayout();
        },
        dynamicFullWidthGuidelineOffset: $ba567578d7e42e9a$var$layoutDynamicFullWidthGuidelineOffset
    });
};
const $ba567578d7e42e9a$var$toDOM = (node)=>[
        'div',
        {
            class: 'layout-section-container'
        },
        [
            'div',
            {
                'data-layout-section': true,
                ...(0, $dh538.fg)('platform_editor_adf_with_localid') && {
                    'data-local-id': node.attrs.localId
                }
            },
            0
        ]
    ];
class $ba567578d7e42e9a$export$8bfc7bdc15be731c extends (0, $2gkmX.default) {
    /**
   * getContentDOM
   * @example
   * @returns
   */ getContentDOM() {
        const { dom: container, contentDOM: contentDOM } = (0, $5SAOw.DOMSerializer).renderSpec(document, $ba567578d7e42e9a$var$toDOM(this.node));
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.layoutDOM = container.querySelector('[data-layout-section]');
        this.layoutDOM.setAttribute('data-column-rule-style', this.node.attrs.columnRuleStyle);
        this.layoutDOM.setAttribute('data-empty-layout', Boolean(this.isEmpty).toString());
        if ((0, $dh538.fg)('platform_editor_adf_with_localid')) this.layoutDOM.setAttribute('data-local-id', this.node.attrs.localId);
        return {
            dom: container,
            contentDOM: contentDOM
        };
    }
    /**
   * setDomAttrs
   * @param node
   * @param element
   * @example
   */ setDomAttrs(node, element) {
        if (this.layoutDOM) this.layoutDOM.setAttribute('data-column-rule-style', node.attrs.columnRuleStyle);
    }
    /**
   * render
   * @param props
   * @param forwardRef
   * @example
   * @returns
   */ render(props, forwardRef) {
        this.isEmpty = $ba567578d7e42e9a$var$isEmptyLayout(this.node);
        if (this.layoutDOM) this.layoutDOM.setAttribute('data-empty-layout', Boolean(this.isEmpty).toString());
        if ((0, $1oCLl.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)($ba567578d7e42e9a$var$LayoutBreakoutResizer, {
            pluginInjectionApi: props.pluginInjectionApi,
            forwardRef: forwardRef,
            getPos: props.getPos,
            view: props.view,
            parentRef: this.layoutDOM
        });
    }
    /**
   * ignoreMutation
   * @param mutation
   * @example
   * @returns
   */ ignoreMutation(mutation) {
        return (0, $4cf13f9507f13269$export$256eed97177e990e)(mutation);
    }
    /**
   * constructor
   * @param props
   * @param props.node
   * @param props.view
   * @param props.getPos
   * @param props.portalProviderAPI
   * @param props.eventDispatcher
   * @param props.pluginInjectionApi
   * @param props.options
   * @example
   */ constructor(props){
        super(props.node, props.view, props.getPos, props.portalProviderAPI, props.eventDispatcher, props);
        this.options = void 0;
        this.layoutDOM = void 0;
        this.isEmpty = void 0;
        this.isEmpty = $ba567578d7e42e9a$var$isEmptyLayout(this.node);
        this.options = props.options;
    }
}


const $2026add019094e18$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('layoutResizingPlugin');
var $2026add019094e18$export$2e2bcd8739ae039 = (options, pluginInjectionApi, portalProviderAPI, eventDispatcher)=>new (0, $1S4f7.SafePlugin)({
        key: $2026add019094e18$export$18d4026d1ea86bb1,
        props: {
            nodeViews: {
                layoutSection: (node, view, getPos)=>{
                    return new (0, $ba567578d7e42e9a$export$8bfc7bdc15be731c)({
                        node: node,
                        view: view,
                        getPos: getPos,
                        portalProviderAPI: portalProviderAPI,
                        eventDispatcher: eventDispatcher,
                        pluginInjectionApi: pluginInjectionApi,
                        options: options
                    }).init();
                }
            }
        }
    });


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");


var $8C5kA = parcelRequire("8C5kA");







const $cd4b583b7f685bd2$var$PLACEHOLDER_SELECTOR = '.ProseMirror-focused .layoutSectionView-content-wrap.selected [data-layout-column] > [data-layout-content] > p:only-child:has(.ProseMirror-trailingBreak:only-child)';
const $cd4b583b7f685bd2$var$getPlaceholderStyle = (message)=>{
    if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) return /*#__PURE__*/ (0, $9K4OG.css)({
        // when paragraph is the only child, and it only has a trailingBreak.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`${$cd4b583b7f685bd2$var$PLACEHOLDER_SELECTOR}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                content: `"${message}"`,
                position: 'absolute',
                color: "var(--ds-text-subtlest, #6B6E76)",
                pointerEvents: 'none'
            }
        }
    });
    return /*#__PURE__*/ (0, $9K4OG.css)({
        // when paragraph is the only child, and it only has a trailingBreak.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '.ProseMirror .layoutSectionView-content-wrap.selected [data-layout-column] > [data-layout-content] > p:only-child:has(.ProseMirror-trailingBreak:only-child)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                content: `"${message}"`,
                position: 'absolute',
                color: "var(--ds-text-disabled, #A5ADBA)",
                font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                marginTop: "var(--ds-space-050, 4px)",
                pointerEvents: 'none'
            }
        }
    });
};
const $cd4b583b7f685bd2$export$cc5403d58ddfa812 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const placeholderStyle = (0, $42omo.useMemo)(()=>{
        const placeholderText = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $l51YQ.toolbarMessages).controlslayoutPlaceholder : (0, $l51YQ.toolbarMessages).layoutPlaceholder;
        return $cd4b583b7f685bd2$var$getPlaceholderStyle(formatMessage(placeholderText));
    }, [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9K4OG.Global), {
        styles: placeholderStyle
    });
};















var $eKkkY = parcelRequire("eKkkY");








var $2GVu1 = parcelRequire("2GVu1");


var $asgOl = parcelRequire("asgOl");

const $2f8097f6f209c685$var$LayoutBlockMenuItem = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const selection = (0, $b3YrF.useSharedPluginStateSelector)(api, 'selection.selection');
    const isLayoutSelected = (0, $42omo.useMemo)(()=>{
        if (!selection) return false;
        if (selection instanceof (0, $ks2lK.NodeSelection)) return selection.node.type.name === 'layoutSection';
        return false;
    }, [
        selection
    ]);
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $d925B.INPUT_METHOD).KEYBOARD : (0, $d925B.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $d925B.INPUT_METHOD).BLOCK_MENU;
        api?.core.actions.execute(({ tr: tr })=>{
            const command = api?.blockMenu?.commands.transformNode(tr.doc.type.schema.nodes.layoutSection, {
                inputMethod: inputMethod,
                triggeredFrom: triggeredFrom,
                targetTypeName: 'layoutSection'
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
        onClick: handleClick,
        isSelected: isLayoutSelected,
        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($asgOl))), {
            label: ""
        }),
        children: formatMessage((0, $eKkkY.messages).layout)
    });
};
const $2f8097f6f209c685$export$83047c2fe2258f8 = (api)=>{
    return ()=>/*#__PURE__*/ (0, $l998X.jsx)($2f8097f6f209c685$var$LayoutBlockMenuItem, {
            api: api
        });
};





parcelRequire("42omo");





var $61p3e = parcelRequire("61p3e");




var $iHzeA = parcelRequire("iHzeA");








var $2MuFw = parcelRequire("2MuFw");


var $gKvd9 = parcelRequire("gKvd9");


var $bmsMK = parcelRequire("bmsMK");


var $f22ZH = parcelRequire("f22ZH");


var $5NtbR = parcelRequire("5NtbR");





var $e0qVa = parcelRequire("e0qVa");


var $dIYpm = parcelRequire("dIYpm");





/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $gF8oK = parcelRequire("gF8oK");


var $2q3lZ = parcelRequire("2q3lZ");

function $b6015fa02fe61471$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b6015fa02fe61471$var$wrapperStyle = {
    name: "dzd8y1",
    styles: "padding:0 4px"
};
const $b6015fa02fe61471$var$Wrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $b6015fa02fe61471$var$wrapperStyle
    }, children);
};
const $b6015fa02fe61471$export$3cfd1ab6a9856e7e = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)($b6015fa02fe61471$var$Wrapper, null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gF8oK))), {
        label: ""
    }));
};
const $b6015fa02fe61471$export$38b01bd15f6a5487 = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)($b6015fa02fe61471$var$Wrapper, null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2q3lZ))), {
        label: ""
    }));
};





parcelRequire("42omo");


var $4ED0i = parcelRequire("4ED0i");

const $43d7012a9bdae225$export$4518caee70c71b2e = (props)=>{
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ED0i))), {
        ...props
    });
};





parcelRequire("42omo");


var $hLZr6 = parcelRequire("hLZr6");

const $a8a38269ac67ed48$export$36efe6f2091df089 = (props)=>{
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hLZr6))), {
        ...props
    });
};


const $f6e81127694e1694$var$LAYOUT_TYPES = [
    {
        id: 'editor.layout.twoEquals',
        type: 'two_equal',
        title: (0, $l51YQ.toolbarMessages).twoColumns,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($asgOl)))
    },
    {
        id: 'editor.layout.threeEquals',
        type: 'three_equal',
        title: (0, $l51YQ.toolbarMessages).threeColumns,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f22ZH)))
    }
];
const $f6e81127694e1694$var$LAYOUT_TYPES_WITH_SINGLE_COL = [
    {
        id: 'editor.layout.singeLayout',
        type: 'single',
        title: (0, $l51YQ.toolbarMessages).singleColumn,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bmsMK)))
    },
    ...$f6e81127694e1694$var$LAYOUT_TYPES
];
const $f6e81127694e1694$var$SIDEBAR_LAYOUT_TYPES = [
    {
        id: 'editor.layout.twoRightSidebar',
        type: 'two_right_sidebar',
        title: (0, $l51YQ.toolbarMessages).rightSidebar,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dIYpm)))
    },
    {
        id: 'editor.layout.twoLeftSidebar',
        type: 'two_left_sidebar',
        title: (0, $l51YQ.toolbarMessages).leftSidebar,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0qVa)))
    },
    {
        id: 'editor.layout.threeWithSidebars',
        type: 'three_with_sidebars',
        title: (0, $l51YQ.toolbarMessages).threeColumnsWithSidebars,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5NtbR)))
    }
];
// These are used for advanced layout options
const $f6e81127694e1694$var$LAYOUT_WITH_TWO_COL_DISTRIBUTION = [
    {
        id: 'editor.layout.twoEquals',
        type: 'two_equal',
        title: (0, $l51YQ.toolbarMessages).twoColumns,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($asgOl)))
    },
    {
        id: 'editor.layout.twoRightSidebar',
        type: 'two_right_sidebar',
        title: (0, $l51YQ.toolbarMessages).rightSidebar,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dIYpm)))
    },
    {
        id: 'editor.layout.twoLeftSidebar',
        type: 'two_left_sidebar',
        title: (0, $l51YQ.toolbarMessages).leftSidebar,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0qVa)))
    }
];
const $f6e81127694e1694$var$LAYOUT_WITH_THREE_COL_DISTRIBUTION = [
    {
        id: 'editor.layout.threeEquals',
        type: 'three_equal',
        title: (0, $l51YQ.toolbarMessages).threeColumns,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f22ZH)))
    },
    {
        id: 'editor.layout.threeWithSidebars',
        type: 'three_with_sidebars',
        title: (0, $l51YQ.toolbarMessages).threeColumnsWithSidebars,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5NtbR)))
    },
    {
        id: 'editor.layout.threeRightSidebars',
        type: 'three_right_sidebars',
        title: (0, $l51YQ.toolbarMessages).threeColumnsWithRightSidebars,
        icon: (0, $a8a38269ac67ed48$export$36efe6f2091df089),
        iconFallback: (0, $a8a38269ac67ed48$export$36efe6f2091df089)
    },
    {
        id: 'editor.layout.threeLeftSidebars',
        type: 'three_left_sidebars',
        title: (0, $l51YQ.toolbarMessages).threeColumnsWithLeftSidebars,
        icon: (0, $43d7012a9bdae225$export$4518caee70c71b2e),
        iconFallback: (0, $43d7012a9bdae225$export$4518caee70c71b2e)
    }
];
const $f6e81127694e1694$var$buildLayoutButton = (intl, item, currentLayout, editorAnalyticsAPI)=>({
        id: item.id,
        type: 'button',
        icon: item.icon,
        iconFallback: item.iconFallback,
        testId: item.title.id ? `${item.title.id}` : undefined,
        title: intl.formatMessage(item.title),
        onClick: (0, $9d764ec1dd06128c$export$6bb7269b95fae539)(editorAnalyticsAPI)(item.type),
        selected: !!currentLayout && currentLayout === item.type,
        tabIndex: null
    });
const $f6e81127694e1694$export$cbec87ad92a1069a = 'Layout floating controls';
const $f6e81127694e1694$var$iconPlaceholder = (0, (/*@__PURE__*/$parcel$interopDefault($asgOl))); // TODO: ED-25466 - Replace with proper icon
const $f6e81127694e1694$var$getLayoutColumnsIcons = (colCount)=>{
    if (!(0, $iu6m9.editorExperiment)('single_column_layouts', true) && !(0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) return undefined;
    switch(colCount){
        case 1:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bmsMK))), {
                label: ""
            });
        case 2:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($asgOl))), {
                label: ""
            });
        case 3:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f22ZH))), {
                label: ""
            });
        case 4:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $b6015fa02fe61471$export$38b01bd15f6a5487), {});
        case 5:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $b6015fa02fe61471$export$3cfd1ab6a9856e7e), {});
        default:
            return undefined;
    }
};
const $f6e81127694e1694$var$getAdvancedLayoutItems = ({ addSidebarLayouts: addSidebarLayouts, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, state: state, node: node, nodeType: nodeType, separator: separator, deleteButton: deleteButton, currentLayout: currentLayout, allowAdvancedSingleColumnLayout: allowAdvancedSingleColumnLayout })=>{
    const numberOfColumns = node.content.childCount || 2;
    const distributionOptions = numberOfColumns === 2 ? $f6e81127694e1694$var$LAYOUT_WITH_TWO_COL_DISTRIBUTION : numberOfColumns === 3 ? $f6e81127694e1694$var$LAYOUT_WITH_THREE_COL_DISTRIBUTION : [];
    const columnOptions = [
        {
            title: intl.formatMessage((0, $l51YQ.toolbarMessages).columnOption, {
                count: 2
            }),
            //'2-columns',
            icon: $f6e81127694e1694$var$getLayoutColumnsIcons(2) || $f6e81127694e1694$var$iconPlaceholder,
            onClick: (0, $9d764ec1dd06128c$export$6bb7269b95fae539)(editorAnalyticsAPI)('two_equal'),
            selected: numberOfColumns === 2
        },
        {
            title: intl.formatMessage((0, $l51YQ.toolbarMessages).columnOption, {
                count: 3
            }),
            //'3-columns'
            icon: $f6e81127694e1694$var$getLayoutColumnsIcons(3) || $f6e81127694e1694$var$iconPlaceholder,
            onClick: (0, $9d764ec1dd06128c$export$6bb7269b95fae539)(editorAnalyticsAPI)('three_equal'),
            selected: numberOfColumns === 3
        },
        {
            title: intl.formatMessage((0, $l51YQ.toolbarMessages).columnOption, {
                count: 4
            }),
            //'4-columns'
            icon: $f6e81127694e1694$var$getLayoutColumnsIcons(4) || $f6e81127694e1694$var$iconPlaceholder,
            onClick: (0, $9d764ec1dd06128c$export$6bb7269b95fae539)(editorAnalyticsAPI)('four_equal'),
            selected: numberOfColumns === 4
        },
        {
            title: intl.formatMessage((0, $l51YQ.toolbarMessages).columnOption, {
                count: 5
            }),
            //'5-columns'
            icon: $f6e81127694e1694$var$getLayoutColumnsIcons(5) || $f6e81127694e1694$var$iconPlaceholder,
            onClick: (0, $9d764ec1dd06128c$export$6bb7269b95fae539)(editorAnalyticsAPI)('five_equal'),
            selected: numberOfColumns === 5
        }
    ];
    const singleColumnOption = allowAdvancedSingleColumnLayout ? {
        title: intl.formatMessage((0, $l51YQ.toolbarMessages).columnOption, {
            count: 1
        }),
        //'1-columns',
        icon: $f6e81127694e1694$var$getLayoutColumnsIcons(1) || $f6e81127694e1694$var$iconPlaceholder,
        onClick: (0, $9d764ec1dd06128c$export$6bb7269b95fae539)(editorAnalyticsAPI)('single'),
        selected: numberOfColumns === 1
    } : [];
    return [
        {
            type: 'dropdown',
            title: intl.formatMessage((0, $l51YQ.toolbarMessages).columnOption, {
                count: numberOfColumns
            }),
            //`${numberOfColumns}-columns`,
            options: [
                singleColumnOption,
                columnOptions
            ].flat(),
            showSelected: true,
            testId: 'column-options-button'
        },
        ...distributionOptions.length > 0 ? [
            separator
        ] : [],
        ...addSidebarLayouts ? distributionOptions.map((i)=>$f6e81127694e1694$var$buildLayoutButton(intl, i, currentLayout, editorAnalyticsAPI)) : []
    ];
};
const $f6e81127694e1694$var$fullHeightSeparator = {
    type: 'separator',
    fullHeight: true
};
const $f6e81127694e1694$export$6dd6ab35df8f7f86 = (state, intl, pos, _allowBreakout, addSidebarLayouts, allowSingleColumnLayout, allowAdvancedSingleColumnLayout, api)=>{
    const { hoverDecoration: hoverDecoration } = api?.decorations?.actions ?? {};
    const editorAnalyticsAPI = api?.analytics?.actions;
    const node = state.doc.nodeAt(pos);
    const toolbarFlagsEnabled = (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
    if (node) {
        const currentLayout = (0, $9d764ec1dd06128c$export$e406155610be725b)(node);
        const separator = {
            type: 'separator'
        };
        const nodeType = state.schema.nodes.layoutSection;
        const deleteButton = {
            id: 'editor.layout.delete',
            type: 'button',
            appearance: 'danger',
            focusEditoronEnter: true,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
            testId: (0, $61p3e.default).remove.id,
            title: intl.formatMessage((0, $61p3e.default).remove),
            onClick: (0, $9d764ec1dd06128c$export$7472487719e2c16f)(editorAnalyticsAPI, (0, $d925B.INPUT_METHOD).FLOATING_TB),
            onMouseEnter: hoverDecoration?.(nodeType, true),
            onMouseLeave: hoverDecoration?.(nodeType, false),
            onFocus: hoverDecoration?.(nodeType, true),
            onBlur: hoverDecoration?.(nodeType, false),
            tabIndex: null
        };
        const copyButton = {
            type: 'copy-button',
            items: [
                {
                    state: state,
                    formatMessage: intl.formatMessage,
                    nodeType: nodeType
                }
            ]
        };
        const layoutTypes = allowSingleColumnLayout ? $f6e81127694e1694$var$LAYOUT_TYPES_WITH_SINGLE_COL : $f6e81127694e1694$var$LAYOUT_TYPES;
        const hoverDecorationProps = (nodeType, className)=>({
                onMouseEnter: hoverDecoration?.(nodeType, true, className),
                onMouseLeave: hoverDecoration?.(nodeType, false, className),
                onFocus: hoverDecoration?.(nodeType, true, className),
                onBlur: hoverDecoration?.(nodeType, false, className)
            });
        // testId is required to show focus on trigger button on ESC key press
        // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
        const testId = 'layout-overflow-dropdown-trigger';
        const overflowMenu = {
            type: 'overflow-dropdown',
            testId: testId,
            options: [
                {
                    title: intl.formatMessage((0, $61p3e.default).copyToClipboard),
                    onClick: ()=>{
                        api?.core?.actions.execute(// @ts-ignore
                        api?.floatingToolbar?.commands.copyNode(nodeType, (0, $d925B.INPUT_METHOD).FLOATING_TB));
                        return true;
                    },
                    icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
                        label: ""
                    }),
                    ...hoverDecorationProps(nodeType, (0, $aFUXX.akEditorSelectedNodeClassName))
                },
                {
                    title: intl.formatMessage((0, $61p3e.default).delete),
                    onClick: (0, $9d764ec1dd06128c$export$7472487719e2c16f)(editorAnalyticsAPI, (0, $d925B.INPUT_METHOD).FLOATING_TB),
                    icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
                        label: ""
                    }),
                    ...hoverDecorationProps(nodeType)
                }
            ]
        };
        return {
            title: $f6e81127694e1694$export$cbec87ad92a1069a,
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getDomRef: (view)=>(0, $8m4tT.findDomRefAtPos)(pos, view.domAtPos.bind(view)),
            nodeType: nodeType,
            groupLabel: intl.formatMessage((0, $l51YQ.toolbarMessages).floatingToolbarRadioGroupAriaLabel),
            items: [
                ...(0, $iu6m9.editorExperiment)('advanced_layouts', true) ? $f6e81127694e1694$var$getAdvancedLayoutItems({
                    addSidebarLayouts: addSidebarLayouts,
                    intl: intl,
                    editorAnalyticsAPI: editorAnalyticsAPI,
                    state: state,
                    nodeType: nodeType,
                    node: node,
                    separator: separator,
                    deleteButton: deleteButton,
                    currentLayout: currentLayout,
                    allowAdvancedSingleColumnLayout: allowAdvancedSingleColumnLayout
                }) : [
                    ...layoutTypes.map((i)=>$f6e81127694e1694$var$buildLayoutButton(intl, i, currentLayout, editorAnalyticsAPI)),
                    ...addSidebarLayouts ? $f6e81127694e1694$var$SIDEBAR_LAYOUT_TYPES.map((i)=>$f6e81127694e1694$var$buildLayoutButton(intl, i, currentLayout, editorAnalyticsAPI)) : []
                ],
                ...toolbarFlagsEnabled ? [
                    $f6e81127694e1694$var$fullHeightSeparator,
                    overflowMenu
                ] : [
                    separator,
                    copyButton,
                    separator,
                    deleteButton
                ]
            ],
            scrollable: true
        };
    }
    return;
};


const $d82516aa109c1d2e$export$abf76f127fb6937c = (tr)=>{
    if (!(0, $iu6m9.editorExperiment)('single_column_layouts', true)) return tr;
    const { layoutSection: layoutSection, paragraph: paragraph } = tr.doc.type.schema.nodes;
    const nodeWithPos = (0, $8m4tT.findParentNode)((node)=>node.type === layoutSection)(tr.selection);
    if (!nodeWithPos || !nodeWithPos.node || nodeWithPos.node.type.name !== 'layoutSection' || nodeWithPos.node.firstChild?.firstChild?.type !== paragraph) return tr;
    // set text selection at the beginning of the layout section
    // will set the selection to the first column
    tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, nodeWithPos.pos));
    return tr;
};
const $d82516aa109c1d2e$export$2229806460c545ea = ({ config: options = {}, api: api })=>{
    const allowAdvancedSingleColumnLayout = (0, $iu6m9.editorExperiment)('advanced_layouts', true) && (0, $iu6m9.editorExperiment)('single_column_layouts', true, {
        exposure: true
    });
    if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) api?.blockMenu?.actions.registerBlockMenuComponents([
        {
            type: 'block-menu-item',
            key: (0, $btNLq.TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $gEb6G.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $btNLq.TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM).key]
            },
            component: (0, $2f8097f6f209c685$export$83047c2fe2258f8)(api)
        }
    ]);
    return {
        name: 'layout',
        nodes () {
            return [
                {
                    name: 'layoutSection',
                    node: (0, $iu6m9.editorExperiment)('advanced_layouts', true) ? (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $hVXQj.layoutSectionWithSingleColumnLocalId) : (0, $hVXQj.layoutSectionWithSingleColumn) : (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $hVXQj.layoutSectionWithLocalId) : (0, $hVXQj.layoutSection)
                },
                {
                    name: 'layoutColumn',
                    node: (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $lifsC.layoutColumnWithLocalId) : (0, $lifsC.layoutColumn)
                }
            ];
        },
        pmPlugins () {
            const plugins = [
                {
                    name: 'layout',
                    plugin: ()=>(0, $ef7d532c79770eba$export$2e2bcd8739ae039)(options)
                }
            ];
            if ((options.editorAppearance === 'full-page' || options.editorAppearance === 'full-width') && api && (0, $iu6m9.editorExperiment)('advanced_layouts', true)) plugins.push({
                name: 'layoutResizing',
                plugin: ({ portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher })=>(0, $2026add019094e18$export$2e2bcd8739ae039)(options, api, portalProviderAPI, eventDispatcher)
            });
            return plugins;
        },
        actions: {
            insertLayoutColumns: (0, $9d764ec1dd06128c$export$3517c001098bb0a9)(api?.analytics?.actions)
        },
        pluginsOptions: {
            floatingToolbar (state, intl) {
                const { pos: pos, allowBreakout: allowBreakout, addSidebarLayouts: addSidebarLayouts, allowSingleColumnLayout: allowSingleColumnLayout, isResizing: isResizing } = (0, $3b01e13caf7407ac$export$18d4026d1ea86bb1).getState(state);
                const shouldHideToolbar = isResizing && (0, $iu6m9.editorExperiment)('single_column_layouts', true);
                if (pos !== null && !shouldHideToolbar) return (0, $f6e81127694e1694$export$6dd6ab35df8f7f86)(state, intl, pos, allowBreakout, addSidebarLayouts, allowSingleColumnLayout, allowAdvancedSingleColumnLayout, api);
                return undefined;
            },
            quickInsert: ({ formatMessage: formatMessage })=>{
                const withInsertLayoutAnalytics = (tr, columnCount)=>{
                    api?.analytics?.actions?.attachAnalyticsEvent({
                        action: (0, $d925B.ACTION).INSERTED,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).LAYOUT,
                        attributes: {
                            inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT,
                            columnCount: columnCount
                        },
                        eventType: (0, $d925B.EVENT_TYPE).TRACK
                    })(tr);
                    return tr;
                };
                const advancedSingleColumnOption = allowAdvancedSingleColumnLayout ? [
                    {
                        id: 'onecolumnlayout',
                        title: formatMessage((0, $l51YQ.toolbarMessages).singleColumnAdvancedLayout),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).singleColumnsDescriptionAdvancedLayout),
                        keywords: [
                            'layout',
                            'column',
                            'section',
                            'single column'
                        ],
                        priority: 1100,
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconOneColumnLayout), {}),
                        action (insert, state) {
                            const tr = insert((0, $9d764ec1dd06128c$export$af0aef1ee58dfcf)(state, 1));
                            if ((0, $dh538.fg)('platform_editor_column_count_analytics')) withInsertLayoutAnalytics(tr, 1);
                            else withInsertLayoutAnalytics(tr);
                            $d82516aa109c1d2e$export$abf76f127fb6937c(tr);
                            return tr;
                        }
                    }
                ] : [];
                if ((0, $iu6m9.editorExperiment)('advanced_layouts', true)) return [
                    ...advancedSingleColumnOption,
                    {
                        id: 'twocolumnslayout',
                        title: formatMessage((0, $l51YQ.toolbarMessages).twoColumnsAdvancedLayout),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).columnsDescriptionAdvancedLayout, {
                            numberOfColumns: 'two'
                        }),
                        keywords: [
                            'layout',
                            'column',
                            'section',
                            'two column'
                        ],
                        priority: 1100,
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconTwoColumnLayout), {}),
                        action (insert, state) {
                            const tr = insert((0, $9d764ec1dd06128c$export$af0aef1ee58dfcf)(state, 2));
                            if ((0, $dh538.fg)('platform_editor_column_count_analytics')) withInsertLayoutAnalytics(tr, 2);
                            else withInsertLayoutAnalytics(tr);
                            $d82516aa109c1d2e$export$abf76f127fb6937c(tr);
                            return tr;
                        }
                    },
                    {
                        id: 'threecolumnslayout',
                        title: formatMessage((0, $l51YQ.toolbarMessages).threeColumnsAdvancedLayout),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).columnsDescriptionAdvancedLayout, {
                            numberOfColumns: 'three'
                        }),
                        keywords: [
                            'layout',
                            'column',
                            'section',
                            'three column'
                        ],
                        priority: 1100,
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconThreeColumnLayout), {}),
                        action (insert, state) {
                            const tr = insert((0, $9d764ec1dd06128c$export$af0aef1ee58dfcf)(state, 3));
                            if ((0, $dh538.fg)('platform_editor_column_count_analytics')) withInsertLayoutAnalytics(tr, 3);
                            else withInsertLayoutAnalytics(tr);
                            $d82516aa109c1d2e$export$abf76f127fb6937c(tr);
                            return tr;
                        }
                    },
                    {
                        id: 'fourcolumnslayout',
                        title: formatMessage((0, $l51YQ.toolbarMessages).fourColumns),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).columnsDescriptionAdvancedLayout, {
                            numberOfColumns: 'four'
                        }),
                        keywords: [
                            'layout',
                            'column',
                            'section',
                            'four column'
                        ],
                        priority: 1100,
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconFourColumnLayout), {}),
                        action (insert, state) {
                            const tr = insert((0, $9d764ec1dd06128c$export$af0aef1ee58dfcf)(state, 4));
                            if ((0, $dh538.fg)('platform_editor_column_count_analytics')) withInsertLayoutAnalytics(tr, 4);
                            else withInsertLayoutAnalytics(tr);
                            $d82516aa109c1d2e$export$abf76f127fb6937c(tr);
                            return tr;
                        }
                    },
                    {
                        id: 'fivecolumnslayout',
                        title: formatMessage((0, $l51YQ.toolbarMessages).fiveColumns),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).columnsDescriptionAdvancedLayout, {
                            numberOfColumns: 'five'
                        }),
                        keywords: [
                            'layout',
                            'column',
                            'section',
                            'five column'
                        ],
                        priority: 1100,
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconFiveColumnLayout), {}),
                        action (insert, state) {
                            const tr = insert((0, $9d764ec1dd06128c$export$af0aef1ee58dfcf)(state, 5));
                            if ((0, $dh538.fg)('platform_editor_column_count_analytics')) withInsertLayoutAnalytics(tr, 5);
                            else withInsertLayoutAnalytics(tr);
                            $d82516aa109c1d2e$export$abf76f127fb6937c(tr);
                            return tr;
                        }
                    }
                ];
                else return [
                    {
                        id: 'layout',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).columns),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).columnsDescription),
                        keywords: [
                            'column',
                            'section'
                        ],
                        priority: 1100,
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconLayout), {}),
                        action (insert, state) {
                            const tr = insert((0, $9d764ec1dd06128c$export$24df8f7ba30643b8)(state));
                            api?.analytics?.actions?.attachAnalyticsEvent({
                                action: (0, $d925B.ACTION).INSERTED,
                                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).LAYOUT,
                                attributes: {
                                    inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $d925B.EVENT_TYPE).TRACK
                            })(tr);
                            return tr;
                        }
                    }
                ];
            }
        },
        contentComponent () {
            return (0, $iu6m9.editorExperiment)('advanced_layouts', true) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $cd4b583b7f685bd2$export$cc5403d58ddfa812), {}) : null;
        }
    };
};
module.exports["layoutPlugin"] = $d82516aa109c1d2e$export$2229806460c545ea;

});

parcelRegister("b3BjA", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dGKc1 = parcelRequire("dGKc1");


var $d925B = parcelRequire("d925B");


var $btNLq = parcelRequire("btNLq");

var $gEb6G = parcelRequire("gEb6G");


var $zT4ZO = parcelRequire("zT4ZO");


var $2UWDO = parcelRequire("2UWDO");


var $42omo = parcelRequire("42omo");


var $1R4Hk = parcelRequire("1R4Hk");

function $3a491b7898bae957$export$2e2bcd8739ae039() {
    const { iconThemed: iconThemed } = (0, $1R4Hk.useIconThemed)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        focusable: "false",
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: iconThemed({
            light: '#fff',
            dark: '#161A1D'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8 13C8 12.4477 8.44772 12 9 12H40V28H9C8.44772 28 8 27.5523 8 27V13Z",
        fill: iconThemed({
            light: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
            dark: "var(--ds-background-accent-teal-subtlest, #E7F9FF)"
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M19.9999 16.2222C15.5817 16.2222 12.2222 19.5818 12.2222 24H16.0093C16.0093 21.7962 17.7964 20.0093 19.9999 20.0093V16.2222Z",
        fill: iconThemed({
            light: '#6E5DC6',
            dark: '#9F8FEF'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12 23.9998H12.676C12.676 19.9578 15.9502 16.6809 19.9909 16.676V16C15.5767 16.0051 12 19.5847 12 23.9998Z",
        fill: iconThemed({
            light: '#E34935',
            dark: '#EF5C48'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12.6851 24H13.3517C13.3517 20.3262 16.3273 17.3478 19.9999 17.3429V16.6762C15.9593 16.6811 12.6851 19.958 12.6851 24Z",
        fill: iconThemed({
            light: '#D97008',
            dark: '#F18D13'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.3518 24H14.0185C14.0185 20.6945 16.6956 18.0145 20 18.0096V17.3429C16.3274 17.3478 13.3518 20.3262 13.3518 24Z",
        fill: iconThemed({
            light: '#E2B203',
            dark: '#E2B203'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.0184 24H14.6851C14.6851 21.0629 17.064 18.6811 20 18.6762V18.0096C16.6955 18.0144 14.0184 20.6944 14.0184 24Z",
        fill: iconThemed({
            light: '#6A9A23',
            dark: '#82B536'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.6851 24H15.3517C15.3517 21.4311 17.4322 19.348 19.9999 19.3431V18.6762C17.0639 18.6811 14.6851 21.0629 14.6851 24Z",
        fill: iconThemed({
            light: '#0055CC',
            dark: '#579DFF'
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "8",
        height: "8",
        fill: iconThemed({
            light: '#fff',
            dark: '#fff'
        }),
        transform: "translate(12 16)"
    }))));
}


var $3pLGZ = parcelRequire("3pLGZ");


var $l9FJJ = parcelRequire("l9FJJ");


var $dh538 = parcelRequire("dh538");


var $6fnsQ = parcelRequire("6fnsQ");


var $1oCLl = parcelRequire("1oCLl");


var $dZ8uq = parcelRequire("dZ8uq");


var $iu6m9 = parcelRequire("iu6m9");








var $dAtrv = parcelRequire("dAtrv");


var $DoNsZ = parcelRequire("DoNsZ");


var $8vgNB = parcelRequire("8vgNB");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");








var $6icEc = parcelRequire("6icEc");










const $e0cd121451b09006$export$ddbd7c123a514b96 = (state, selection)=>{
    const { panel: panel } = state.schema.nodes;
    return (0, $8m4tT.findSelectedNodeOfType)(panel)(selection || state.selection) || (0, $8m4tT.findParentNodeOfType)(panel)(selection || state.selection);
};
const $e0cd121451b09006$export$4dbd81d91bb3604b = (attrs, allowCustomPanel)=>{
    const { panelColor: panelColor, panelType: panelType, panelIcon: panelIcon, panelIconId: panelIconId, panelIconText: panelIconText } = attrs;
    const isCustomPanel = panelType === (0, $dGKc1.PanelType).CUSTOM && allowCustomPanel;
    const hasIcon = !isCustomPanel || !!panelIcon || !!panelIconId;
    const tokenColor = panelColor && (0, $6icEc.hexToEditorBackgroundPaletteColor)(panelColor);
    const panelBackgroundColor = tokenColor || panelColor;
    const style = [
        `${panelColor && isCustomPanel ? `background-color: ${panelBackgroundColor};` : ''}`,
        `${!hasIcon && !(0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? `padding-left: 12px;padding-right: 12px;` : ''}`
    ].join('');
    let panelAttrs = {
        class: `${(0, $DoNsZ.PanelSharedCssClassName).prefix}${!hasIcon && (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? ` ${(0, $DoNsZ.PanelSharedCssClassName).noIcon}` : ''}`,
        'data-panel-type': panelType || (0, $dGKc1.PanelType).INFO,
        'data-testid': 'panel-node-view',
        style: style
    };
    if (panelColor && isCustomPanel) panelAttrs = {
        ...panelAttrs,
        'data-panel-color': panelColor,
        'data-panel-icon-id': panelIconId,
        'data-panel-icon-text': panelIconText
    };
    if ((0, $dh538.fg)('platform_editor_adf_with_localid')) panelAttrs = {
        ...panelAttrs,
        'data-local-id': attrs.localId
    };
    const iconDiv = [
        'div',
        // EDITOR-266 This fixes an issue in LCM where if you have nested panels
        // The icon colour will be overridden by the parent panel style, this is used to create a more specific css selector
        {
            class: (0, $DoNsZ.PanelSharedCssClassName).icon,
            'data-panel-type': panelType || (0, $dGKc1.PanelType).INFO
        }
    ];
    const contentDiv = [
        'div',
        {
            class: (0, $DoNsZ.PanelSharedCssClassName).content
        },
        0
    ];
    if (hasIcon) return [
        'div',
        panelAttrs,
        iconDiv,
        contentDiv
    ];
    else return [
        'div',
        panelAttrs,
        contentDiv
    ];
};
const $e0cd121451b09006$export$1c3f791fb2a5168 = (newState, oldState)=>{
    const newTr = newState.tr;
    const { schema: schema } = newState.doc.type;
    if ($e0cd121451b09006$export$2098521608ce5fc1(newState, oldState)) {
        // Create a panel using oldState with an empty paragraph node
        // and insert it in the same location when panel previously existed
        const emptyParagraph = schema.nodes.paragraph.create();
        const oldPanelNode = (0, $8m4tT.findParentNode)((node)=>node.type.name === 'panel')(oldState.tr.selection);
        const clonedPanelNode = oldPanelNode?.node.copy();
        const newPanelNode = schema.nodes.panel.create({
            ...clonedPanelNode?.attrs
        }, emptyParagraph);
        const endPos = oldState.tr.selection.$from.pos;
        if (oldPanelNode) {
            newTr.insert(oldPanelNode.pos, newPanelNode).setSelection(new (0, $ks2lK.TextSelection)(newTr.doc.resolve(endPos)));
            return newTr;
        }
    }
};
const $e0cd121451b09006$export$2098521608ce5fc1 = (newState, oldState)=>{
    // The following fuctions checks if *
    //  a. old selection is a NodeSelection.
    //  b. parent element a panel and does it have only one child
    //  c. parent node has a decision list and that decision list only has one decision item
    //     OR old selection is a codeblock OR old selection is a rule
    const isNodeSelection = oldState.tr.selection instanceof (0, $ks2lK.NodeSelection);
    const isNodeTypeRuleOrCodeBlock = isNodeSelection && [
        'codeBlock',
        'rule'
    ].includes(oldState.tr.selection.node.type.name);
    const isParentTypePanel = (0, $8m4tT.findParentNodeOfType)(newState.schema.nodes.panel)(oldState.tr.selection);
    const isparentTypeDecision = (0, $8m4tT.findParentNodeOfType)(newState.schema.nodes.decisionList)(oldState.tr.selection);
    return Boolean(isNodeSelection && isParentTypePanel?.node.childCount === 1 && (isparentTypeDecision?.node.childCount === 1 || isNodeTypeRuleOrCodeBlock));
};


const $c4a15bca763b3f4b$export$8784bcc8bfa6de8d = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { schema: { nodes: nodes }, tr: tr } = state;
        const payload = {
            action: (0, $d925B.ACTION).DELETED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).PANEL,
            attributes: {
                inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        };
        let deleteTr = tr;
        if ((0, $8m4tT.findSelectedNodeOfType)(nodes.panel)(tr.selection)) deleteTr = (0, $8m4tT.removeSelectedNode)(tr);
        else if ((0, $8m4tT.findParentNodeOfType)(nodes.panel)(tr.selection)) deleteTr = (0, $8m4tT.removeParentNodeOfType)(nodes.panel)(tr);
        if (!deleteTr) return false;
        if (dispatch) {
            editorAnalyticsAPI?.attachAnalyticsEvent(payload)(deleteTr);
            dispatch(deleteTr);
        }
        return true;
    };
const $c4a15bca763b3f4b$export$1e9f13c739b39e00 = (editorAnalyticsAPI)=>(panelType, panelOptions = {}, allowCustomPanel = false)=>(state, dispatch)=>{
            const { schema: { nodes: nodes }, tr: tr } = state;
            const panelNode = (0, $e0cd121451b09006$export$ddbd7c123a514b96)(state);
            if (panelNode === undefined) return false;
            const newType = panelType;
            const previousType = panelNode.node.attrs.panelType;
            let newTr;
            if (allowCustomPanel) {
                const previousColor = panelNode.node.attrs.panelType === 'custom' ? panelNode.node.attrs.panelColor || 'none' : (0, $DoNsZ.getPanelTypeBackgroundNoTokens)(previousType);
                const previousIcon = panelNode.node.attrs.panelIcon;
                const previousIconId = panelNode.node.attrs.panelIconId;
                const previousIconText = panelNode.node.attrs.panelIconText;
                const newPanelOptions = {
                    color: previousColor,
                    emoji: previousIcon,
                    emojiId: previousIconId,
                    emojiText: previousIconText,
                    ...panelOptions
                };
                newTr = tr.setNodeMarkup(panelNode.pos, nodes.panel, {
                    panelIcon: newPanelOptions.emoji,
                    panelIconId: newPanelOptions.emojiId,
                    panelIconText: newPanelOptions.emojiText,
                    panelColor: newPanelOptions.color,
                    panelType: panelType
                });
            } else newTr = tr.setNodeMarkup(panelNode.pos, nodes.panel, {
                panelType: panelType
            });
            const payload = {
                action: (0, $d925B.ACTION).CHANGED_TYPE,
                actionSubject: (0, $d925B.ACTION_SUBJECT).PANEL,
                attributes: {
                    newType: newType,
                    previousType: previousType
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
            // Select the panel if it was previously selected
            const newTrWithSelection = state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node.type.name === 'panel' ? newTr.setSelection(new (0, $ks2lK.NodeSelection)(tr.doc.resolve(panelNode.pos))) : newTr;
            editorAnalyticsAPI?.attachAnalyticsEvent(payload)(newTrWithSelection);
            newTrWithSelection.setMeta('scrollIntoView', false);
            if (dispatch) dispatch(newTrWithSelection);
            return true;
        };
function $c4a15bca763b3f4b$export$2bad565f1cff271f(inputMethod, analyticsAPI) {
    return (0, $dAtrv.withAnalytics)(analyticsAPI, {
        action: (0, $d925B.ACTION).INSERTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).PANEL,
        attributes: {
            inputMethod: inputMethod,
            panelType: (0, $dGKc1.PanelType).INFO
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    })(function(state, dispatch) {
        const { nodes: nodes } = state.schema;
        if (nodes.panel && nodes.paragraph) return (0, $8vgNB.wrapSelectionIn)(nodes.panel)(state, dispatch);
        return false;
    });
}



var $l9G9n = parcelRequire("l9G9n");


var $dus6D = parcelRequire("dus6D");




function $902d62fc2eaf77bf$var$findParentNode(selection, nodeType) {
    const parentPosition = (0, $8m4tT.findParentNodeOfType)(nodeType)(selection);
    if (parentPosition) return parentPosition.node;
    return null;
}
function $902d62fc2eaf77bf$var$isInsideAnEmptyNode(selection, nodeType, schema) {
    const parentNode = $902d62fc2eaf77bf$var$findParentNode(selection, nodeType);
    return parentNode && (0, $l9G9n.isEmptyNode)(schema)(parentNode);
}
function $902d62fc2eaf77bf$export$e832373cff8dec22() {
    const deleteCurrentItem = ($from, tr)=>{
        return tr.delete($from.before($from.depth) - 1, $from.end($from.depth) + 1);
    };
    const keymaps = {
        Backspace: (state, dispatch)=>{
            const { selection: selection, schema: { nodes: nodes }, tr: tr } = state;
            const { panel: panel, blockquote: blockquote, orderedList: orderedList, bulletList: bulletList, mediaSingle: mediaSingle, mediaGroup: mediaGroup, extension: extension } = nodes;
            const { $from: $from, $to: $to } = selection;
            // Don't do anything if selection is a range
            if ($from.pos !== $to.pos) return false;
            // If not at the start of a panel, no joining will happen so allow default behaviour (backspacing characters etc..)
            if ($from.parentOffset !== 0) return false;
            const $previousPos = tr.doc.resolve(Math.max(0, $from.before($from.depth) - 1));
            const previousNodeType = $previousPos.pos > 0 && $previousPos.parent && $previousPos.parent.type;
            const parentNodeType = $from.parent.type;
            const isPreviousNodeAPanel = previousNodeType === panel;
            const isParentNodeAPanel = parentNodeType === panel;
            const nodeBeforePanel = $previousPos?.nodeBefore;
            const isPreviousNodeMedia = previousNodeType === mediaSingle || previousNodeType === mediaGroup;
            const isPreviousNodeAList = previousNodeType === bulletList || previousNodeType === orderedList;
            // identifies if new position after backspace is at the start of a non-bodied extension node
            const isPreviousPosAtExtension = $previousPos.nodeAfter?.type === extension;
            // Stops merging panels when deleting empty paragraph in between
            // Stops merging blockquotes with panels when deleting from start of blockquote
            if (isPreviousNodeAPanel && !isParentNodeAPanel && !isPreviousPosAtExtension || $902d62fc2eaf77bf$var$isInsideAnEmptyNode(selection, panel, state.schema) || (0, $8m4tT.hasParentNodeOfType)(blockquote)(selection) && !isPreviousNodeAList && !isPreviousNodeMedia && !isPreviousPosAtExtension || // Lift line of panel content up and out of the panel, when backspacing
            // at the start of a panel, if the node before the panel is an 'isolating' node
            // (for e.g. a table, or an expand), otherwise the default prosemirror backspace
            // behaviour will fallback to 'select node backward' logic because the node
            // before is an isolating node.
            nodeBeforePanel?.type?.spec?.isolating && (0, $8m4tT.hasParentNodeOfType)(panel)(selection)) {
                const content = $from.node($from.depth).content;
                const insertPos = $previousPos.pos;
                deleteCurrentItem($from, tr).insert(insertPos, content);
                if (dispatch) dispatch((0, $8m4tT.setTextSelection)(insertPos)(tr).scrollIntoView());
                return true;
            }
            const nodeType = $from.node().type;
            if (nodeType !== panel) return false;
            return true;
        }
    };
    return (0, $dus6D.keymap)(keymaps);
}
var $902d62fc2eaf77bf$export$2e2bcd8739ae039 = $902d62fc2eaf77bf$export$e832373cff8dec22;






var $1S4f7 = parcelRequire("1S4f7");


var $3tffm = parcelRequire("3tffm");




parcelRequire("42omo");


var $cUcZ5 = parcelRequire("cUcZ5");








var $etuMO = parcelRequire("etuMO");

const $28f8b0c1361f9945$var$EmojiNodeFunctional = (props)=>{
    const { allowTextFallback: allowTextFallback, shortName: shortName, id: id, fallback: fallback, fitToHeight: fitToHeight, showTooltip: showTooltip, resourceConfig: resourceConfig, emojiProvider: emojiProvider } = props;
    const emojiId = (0, $42omo.useMemo)(()=>({
            shortName: shortName,
            id: id,
            fallback: fallback
        }), [
        shortName,
        id,
        fallback
    ]);
    const emojiProviderResolver = (0, $42omo.useMemo)(()=>Promise.resolve(emojiProvider), [
        emojiProvider
    ]);
    if (allowTextFallback && !emojiProvider) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-emoji-id": id,
        "data-emoji-short-name": shortName,
        "data-emoji-text": fallback || shortName
    }, fallback || shortName);
    if (!emojiProvider) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $etuMO.default), {
        emojiId: emojiId,
        emojiProvider: emojiProviderResolver,
        showTooltip: showTooltip,
        fitToHeight: fitToHeight,
        optimistic: true,
        optimisticImageURL: resourceConfig?.optimisticImageApi?.getUrl({
            id: id,
            fallback: fallback,
            shortName: shortName
        }),
        editorEmoji: true
    });
};
const $28f8b0c1361f9945$var$EmojiNode = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($28f8b0c1361f9945$var$EmojiNodeFunctional, props);
};
var $28f8b0c1361f9945$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo($28f8b0c1361f9945$var$EmojiNode);



var $eiA8Z = parcelRequire("eiA8Z");


var $cQMhV = parcelRequire("cQMhV");





var $5SAOw = parcelRequire("5SAOw");


var $aFUXX = parcelRequire("aFUXX");


var $3HOqx = parcelRequire("3HOqx");


const $96a452062b45ae95$export$4641b622f6c36f58 = {
    info: (0, $cQMhV.PanelInfoIcon),
    success: (0, $cQMhV.PanelSuccessIcon),
    note: (0, $cQMhV.PanelNoteIcon),
    tip: (0, (/*@__PURE__*/$parcel$interopDefault($3HOqx))),
    warning: (0, $cQMhV.PanelWarningIcon),
    error: (0, $cQMhV.PanelErrorIcon),
    custom: (0, $cQMhV.PanelInfoIcon)
};
const $96a452062b45ae95$var$selector = (states)=>{
    return {
        emojiState: states.emojiState
    };
};
const $96a452062b45ae95$export$2ba98455e5e9d756 = (props)=>{
    const { allowCustomPanel: allowCustomPanel, providerFactory: providerFactory, pluginInjectionApi: pluginInjectionApi, panelAttributes: { panelType: panelType, panelIcon: panelIcon, panelIconId: panelIconId, panelIconText: panelIconText } } = props;
    const { emojiState: emojiState } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'emoji'
    ], $96a452062b45ae95$var$selector);
    const emojiProvider = emojiState?.emojiProvider;
    if (allowCustomPanel && panelIcon && panelType === (0, $dGKc1.PanelType).CUSTOM) return /*#__PURE__*/ (0, $l998X.jsx)((0, $28f8b0c1361f9945$export$2e2bcd8739ae039), {
        emojiProvider: emojiProvider,
        providers: providerFactory,
        shortName: panelIcon,
        id: panelIconId,
        fallback: panelIconText,
        showTooltip: false,
        allowTextFallback: false,
        fitToHeight: (0, $aFUXX.akEditorCustomIconSize)
    });
    const Icon = $96a452062b45ae95$export$4641b622f6c36f58[panelType];
    return Icon ? /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
        label: `${panelType} panel`
    }) : null;
};
class $96a452062b45ae95$var$PanelNodeView {
    ignoreMutation(mutation) {
        // ignore mutation if it caused by the icon.
        if (!this.icon) return false;
        const isIcon = mutation.target === this.icon || mutation.target.parentNode === this.icon;
        // ignore mutation if it caused by the lazy load emoji inside icon.
        const isInsideIcon = this.icon.contains(mutation.target);
        return isIcon || isInsideIcon;
    }
    destroy() {
        this.nodeViewPortalProviderAPI.remove(this.key);
    }
    constructor(node, view, getPos, pluginOptions, api, nodeViewPortalProviderAPI, providerFactory){
        this.node = void 0;
        this.dom = void 0;
        this.contentDOM = void 0;
        this.icon = void 0;
        this.getPos = void 0;
        this.view = void 0;
        this.providerFactory = void 0;
        this.nodeViewPortalProviderAPI = void 0;
        this.pluginOptions = void 0;
        this.key = void 0;
        this.nodeViewPortalProviderAPI = nodeViewPortalProviderAPI;
        this.providerFactory = providerFactory;
        this.pluginOptions = pluginOptions;
        this.view = view;
        this.node = node;
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.key = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
        const { dom: dom, contentDOM: contentDOM } = (0, $5SAOw.DOMSerializer).renderSpec(document, (0, $e0cd121451b09006$export$4dbd81d91bb3604b)(node.attrs, pluginOptions.allowCustomPanel || false));
        this.getPos = getPos;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.dom = dom;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.contentDOM = contentDOM;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.icon = this.dom.querySelector(`.${(0, $DoNsZ.PanelSharedCssClassName).icon}`);
        if (!this.icon) return;
        // set contentEditable as false to be able to select the custom panels with keyboard
        this.icon.contentEditable = 'false';
        this.nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $l998X.jsx)($96a452062b45ae95$export$2ba98455e5e9d756, {
                pluginInjectionApi: api,
                allowCustomPanel: pluginOptions.allowCustomPanel,
                panelAttributes: node.attrs,
                providerFactory: this.providerFactory
            }), this.icon, this.key);
    }
}
const $96a452062b45ae95$export$544c25cc15cdca2 = (pluginOptions, api, nodeViewPortalProviderAPI, providerFactory)=>(node, view, getPos)=>{
        return new $96a452062b45ae95$var$PanelNodeView(node, view, getPos, pluginOptions, api, nodeViewPortalProviderAPI, providerFactory);
    };





const $f67a67bd596a2db4$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('panelPlugin');



const $45e5886bb64c7c75$export$ae829ec7b2625219 = (dispatch, providerFactory, pluginOptions, api, nodeViewPortalProviderAPI)=>{
    const { useLongPressSelection: useLongPressSelection = false } = pluginOptions;
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $f67a67bd596a2db4$export$18d4026d1ea86bb1),
        appendTransaction: (transactions, oldState, newState)=>{
            const tr = transactions.find((tr)=>tr.getMeta('uiEvent') === 'cut');
            if (tr) return (0, $e0cd121451b09006$export$1c3f791fb2a5168)(newState, oldState);
        },
        props: {
            nodeViews: {
                panel: (0, $96a452062b45ae95$export$544c25cc15cdca2)(pluginOptions, api, nodeViewPortalProviderAPI, providerFactory)
            },
            handleClickOn: (0, $3tffm.createSelectionClickHandler)([
                'panel'
            ], (target)=>!!target.closest(`.${(0, $DoNsZ.PanelSharedCssClassName).prefix}`), {
                useLongPressSelection: useLongPressSelection
            })
        }
    });
};









var $8C5kA = parcelRequire("8C5kA");








var $b3YrF = parcelRequire("b3YrF");





var $2GVu1 = parcelRequire("2GVu1");


var $8tSmd = parcelRequire("8tSmd");

const $3362d16afd56bb0c$var$nodeName = 'panel';
const $3362d16afd56bb0c$var$PanelBlockMenuItem = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const selection = (0, $b3YrF.useSharedPluginStateSelector)(api, 'selection.selection');
    const isPanelSelected = (0, $42omo.useMemo)(()=>{
        if (!selection) return false;
        if (selection instanceof (0, $ks2lK.NodeSelection)) // Note: we are checking for any type of panel, not just of type infopanel
        return selection.node.type.name === $3362d16afd56bb0c$var$nodeName;
        return false;
    }, [
        selection
    ]);
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $d925B.INPUT_METHOD).KEYBOARD : (0, $d925B.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $d925B.INPUT_METHOD).BLOCK_MENU;
        api?.core.actions.execute(({ tr: tr })=>{
            const command = api?.blockMenu?.commands.transformNode(tr.doc.type.schema.nodes.panel, {
                inputMethod: inputMethod,
                triggeredFrom: triggeredFrom,
                targetTypeName: $3362d16afd56bb0c$var$nodeName
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
        onClick: handleClick,
        isSelected: isPanelSelected,
        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tSmd))), {
            label: ""
        }),
        children: formatMessage((0, $2UWDO.messages).panel)
    });
};
const $3362d16afd56bb0c$export$33a19cd537147781 = (api)=>{
    return ()=>/*#__PURE__*/ (0, $l998X.jsx)($3362d16afd56bb0c$var$PanelBlockMenuItem, {
            api: api
        });
};





parcelRequire("42omo");











var $61p3e = parcelRequire("61p3e");

var $02xUP = parcelRequire("02xUP");





var $iHzeA = parcelRequire("iHzeA");


var $lhtyR = parcelRequire("lhtyR");
/* eslint-disable @atlassian/i18n/no-literal-string-in-object */ 





const $6f19e76ade7c1b04$export$4c05e6c3475702fb = [
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'White',
        value: '#FFFFFF'
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Light blue',
        value: '#DEEBFF'
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Light teal',
        value: '#E6FCFF'
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Light green',
        value: '#E3FCEF'
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Light yellow',
        value: '#FFFAE6'
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Light red',
        value: '#FFEBE6'
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Light purple',
        value: '#EAE6FF'
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Light gray',
        value: '#F4F5F7'
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Blue',
        value: '#B3D4FF'
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Teal',
        value: '#B3F5FF'
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Green',
        value: '#ABF5D1'
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Yellow',
        value: '#FFF0B3'
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Red',
        value: '#FFBDAD'
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Purple',
        value: '#C0B6F2'
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Gray',
        value: '#B3BAC5'
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Dark blue',
        value: '#4C9AFF'
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Dark teal',
        value: '#79E2F2'
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Dark green',
        value: '#57D9A3'
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Dark yellow',
        value: '#FFC400'
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Dark red',
        value: '#FF8F73'
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Dark purple',
        value: '#998DD9'
    }
].map((color)=>({
        ...color,
        border: `var(--ds-border, ${0, $lhtyR.DEFAULT_BORDER_COLOR})`
    }));
const $6f19e76ade7c1b04$export$735406282816eab = [
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Dark gray',
        value: (0, $DoNsZ.darkPanelColors).DarkGray
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Dark blue',
        value: (0, $DoNsZ.darkPanelColors).B1200S
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Dark teal',
        value: (0, $DoNsZ.darkPanelColors).T1200S
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Dark green',
        value: (0, $DoNsZ.darkPanelColors).G1200S
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Dark yellow',
        value: (0, $DoNsZ.darkPanelColors).Y1200S
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Dark red',
        value: (0, $DoNsZ.darkPanelColors).R1200S
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Dark purple',
        value: (0, $DoNsZ.darkPanelColors).P1200S
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Gray',
        value: (0, $DoNsZ.darkPanelColors).Gray
    },
    {
        label: 'blue',
        value: (0, $DoNsZ.darkPanelColors).B900
    },
    {
        label: 'teal',
        value: (0, $DoNsZ.darkPanelColors).T900
    },
    {
        label: 'green',
        value: (0, $DoNsZ.darkPanelColors).G900
    },
    {
        label: 'yellow',
        value: (0, $DoNsZ.darkPanelColors).Y900
    },
    {
        label: 'red',
        value: (0, $DoNsZ.darkPanelColors).R900
    },
    {
        label: 'purple',
        value: (0, $DoNsZ.darkPanelColors).P900
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Light gray',
        value: (0, $DoNsZ.darkPanelColors).LightGray
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Light blue',
        value: (0, $DoNsZ.darkPanelColors).B800S
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Light teal',
        value: (0, $DoNsZ.darkPanelColors).T900S
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Light green',
        value: (0, $DoNsZ.darkPanelColors).G900S
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Light yellow',
        value: (0, $DoNsZ.darkPanelColors).Y800S
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Light red',
        value: (0, $DoNsZ.darkPanelColors).R800S
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        label: 'Light purple',
        value: (0, $DoNsZ.darkPanelColors).P800S
    }
].map((color)=>({
        ...color,
        border: (0, $lhtyR.DEFAULT_BORDER_COLOR)
    }));









var $2MuFw = parcelRequire("2MuFw");


var $7yDmn = parcelRequire("7yDmn");


var $gKvd9 = parcelRequire("gKvd9");


var $2G5zx = parcelRequire("2G5zx");


var $3gddQ = parcelRequire("3gddQ");


var $eXmBZ = parcelRequire("eXmBZ");


var $3sFtD = parcelRequire("3sFtD");


var $ebrpi = parcelRequire("ebrpi");













var $isYda = parcelRequire("isYda");














const $f02842ff9c12a8ad$var$panelTitleAndIcon = {
    [(0, $dGKc1.PanelType).INFO]: {
        title: (0, $02xUP.panelMessages).info,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ)))({
            label: 'info-icon',
            color: "var(--ds-icon-information, #357DE8)"
        })
    },
    [(0, $dGKc1.PanelType).NOTE]: {
        title: (0, $02xUP.panelMessages).note,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3gddQ)))({
            label: 'note-icon',
            color: "var(--ds-icon-discovery, #AF59E1)"
        })
    },
    [(0, $dGKc1.PanelType).SUCCESS]: {
        title: (0, $02xUP.panelMessages).success,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3sFtD)))({
            label: 'success-icon',
            color: "var(--ds-icon-success, #6A9A23)"
        })
    },
    [(0, $dGKc1.PanelType).WARNING]: {
        title: (0, $02xUP.panelMessages).warning,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ebrpi)))({
            label: 'warning-icon',
            color: "var(--ds-icon-warning, #E06C00)"
        })
    },
    [(0, $dGKc1.PanelType).ERROR]: {
        title: (0, $02xUP.panelMessages).error,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7yDmn)))({
            label: 'error-icon',
            color: "var(--ds-icon-danger, #C9372C)"
        })
    },
    [(0, $dGKc1.PanelType).CUSTOM]: {
        title: (0, $02xUP.panelMessages).custom,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($isYda)))({
            label: 'custom-icon'
        })
    }
};
const $f02842ff9c12a8ad$export$b79ba0272604ac1c = ({ activePanelType: activePanelType, editorAnalyticsAPI: editorAnalyticsAPI, formatMessage: formatMessage })=>{
    const dropdownOptions = [
        {
            id: 'editor.panel.info',
            icon: $f02842ff9c12a8ad$var$panelTitleAndIcon[(0, $dGKc1.PanelType).INFO].icon,
            onClick: (0, $c4a15bca763b3f4b$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $dGKc1.PanelType).INFO),
            selected: activePanelType === (0, $dGKc1.PanelType).INFO,
            title: formatMessage($f02842ff9c12a8ad$var$panelTitleAndIcon[(0, $dGKc1.PanelType).INFO].title)
        },
        {
            id: 'editor.panel.note',
            icon: $f02842ff9c12a8ad$var$panelTitleAndIcon[(0, $dGKc1.PanelType).NOTE].icon,
            onClick: (0, $c4a15bca763b3f4b$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $dGKc1.PanelType).NOTE),
            selected: activePanelType === (0, $dGKc1.PanelType).NOTE,
            title: formatMessage($f02842ff9c12a8ad$var$panelTitleAndIcon[(0, $dGKc1.PanelType).NOTE].title)
        },
        {
            id: 'editor.panel.success',
            icon: $f02842ff9c12a8ad$var$panelTitleAndIcon[(0, $dGKc1.PanelType).SUCCESS].icon,
            onClick: (0, $c4a15bca763b3f4b$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $dGKc1.PanelType).SUCCESS),
            selected: activePanelType === (0, $dGKc1.PanelType).SUCCESS,
            title: formatMessage($f02842ff9c12a8ad$var$panelTitleAndIcon[(0, $dGKc1.PanelType).SUCCESS].title)
        },
        {
            id: 'editor.panel.warning',
            icon: $f02842ff9c12a8ad$var$panelTitleAndIcon[(0, $dGKc1.PanelType).WARNING].icon,
            onClick: (0, $c4a15bca763b3f4b$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $dGKc1.PanelType).WARNING),
            selected: activePanelType === (0, $dGKc1.PanelType).WARNING,
            title: formatMessage($f02842ff9c12a8ad$var$panelTitleAndIcon[(0, $dGKc1.PanelType).WARNING].title)
        },
        {
            id: 'editor.panel.error',
            icon: $f02842ff9c12a8ad$var$panelTitleAndIcon[(0, $dGKc1.PanelType).ERROR].icon,
            onClick: (0, $c4a15bca763b3f4b$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $dGKc1.PanelType).ERROR),
            selected: activePanelType === (0, $dGKc1.PanelType).ERROR,
            title: formatMessage($f02842ff9c12a8ad$var$panelTitleAndIcon[(0, $dGKc1.PanelType).ERROR].title)
        }
    ];
    const selectedPanelType = activePanelType || (0, $dGKc1.PanelType).INFO;
    const selectedTitleAndIcon = $f02842ff9c12a8ad$var$panelTitleAndIcon[selectedPanelType] || $f02842ff9c12a8ad$var$panelTitleAndIcon[(0, $dGKc1.PanelType).CUSTOM];
    return {
        id: 'panel-type-dropdown',
        testId: 'panel-type-dropdown-trigger',
        type: 'dropdown',
        options: dropdownOptions,
        showSelected: true,
        iconBefore: ()=>selectedTitleAndIcon.icon,
        title: formatMessage(selectedTitleAndIcon.title)
    };
};


const $470fc4451c578198$export$f17692e562e3afad = {
    [(0, $dGKc1.PanelType).INFO]: {
        shortName: ':info:',
        id: 'atlassian-info'
    },
    [(0, $dGKc1.PanelType).NOTE]: {
        shortName: ':note:',
        id: 'atlassian-note'
    },
    [(0, $dGKc1.PanelType).WARNING]: {
        shortName: ':warning:',
        id: 'atlassian-warning'
    },
    [(0, $dGKc1.PanelType).ERROR]: {
        shortName: ':cross_mark:',
        id: 'atlassian-cross_mark'
    },
    [(0, $dGKc1.PanelType).SUCCESS]: {
        shortName: ':check_mark:',
        id: 'atlassian-check_mark'
    },
    [(0, $dGKc1.PanelType).TIP]: {
        shortName: ':tip:',
        id: 'atlassian-tip'
    }
};
const $470fc4451c578198$export$b40dbe3b5f798829 = (formatMessage, panelNodeType, isCustomPanelEnabled, isCustomPanelEditable, providerFactory, hoverDecoration, editorAnalyticsAPI, activePanelType, activePanelColor, activePanelIcon, state, api)=>{
    const areAllNewToolbarFlagsDisabled = !(0, $iHzeA.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
    // TODO: ED-14403 - investigate why these titles are not getting translated for the tooltips
    const items = areAllNewToolbarFlagsDisabled ? [
        {
            id: 'editor.panel.info',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))),
            onClick: (0, $c4a15bca763b3f4b$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $dGKc1.PanelType).INFO),
            selected: activePanelType === (0, $dGKc1.PanelType).INFO,
            title: formatMessage((0, $02xUP.panelMessages).info),
            tabIndex: null
        },
        {
            id: 'editor.panel.note',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($3gddQ))),
            onClick: (0, $c4a15bca763b3f4b$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $dGKc1.PanelType).NOTE),
            selected: activePanelType === (0, $dGKc1.PanelType).NOTE,
            title: formatMessage((0, $02xUP.panelMessages).note),
            tabIndex: null
        },
        {
            id: 'editor.panel.success',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))),
            onClick: (0, $c4a15bca763b3f4b$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $dGKc1.PanelType).SUCCESS),
            selected: activePanelType === (0, $dGKc1.PanelType).SUCCESS,
            title: formatMessage((0, $02xUP.panelMessages).success),
            tabIndex: null
        },
        {
            id: 'editor.panel.warning',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))),
            onClick: (0, $c4a15bca763b3f4b$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $dGKc1.PanelType).WARNING),
            selected: activePanelType === (0, $dGKc1.PanelType).WARNING,
            title: formatMessage((0, $02xUP.panelMessages).warning),
            tabIndex: null
        },
        {
            id: 'editor.panel.error',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))),
            onClick: (0, $c4a15bca763b3f4b$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $dGKc1.PanelType).ERROR),
            selected: activePanelType === (0, $dGKc1.PanelType).ERROR,
            title: formatMessage((0, $02xUP.panelMessages).error),
            tabIndex: null
        }
    ] : [
        (0, $f02842ff9c12a8ad$export$b79ba0272604ac1c)({
            activePanelType: activePanelType,
            editorAnalyticsAPI: editorAnalyticsAPI,
            formatMessage: formatMessage
        }),
        ...Boolean(api?.toolbar) ? [] : [
            {
                type: 'separator'
            }
        ]
    ];
    if (isCustomPanelEnabled) {
        const changeColor = (color)=>(state, dispatch)=>{
                const panelNode = (0, $e0cd121451b09006$export$ddbd7c123a514b96)(state);
                if (panelNode === undefined) return false;
                const previousColor = panelNode.node.attrs.panelType === 'custom' ? panelNode.node.attrs.panelColor || 'none' : (0, $DoNsZ.getPanelTypeBackgroundNoTokens)(panelNode.node.attrs.panelType);
                const emojiInfo = panelNode.node.attrs.panelType;
                const panelEmoji = $470fc4451c578198$export$f17692e562e3afad[emojiInfo];
                const previousEmoji = panelEmoji ? {
                    emoji: panelEmoji.shortName,
                    emojiId: panelEmoji.id
                } : {};
                if (previousColor === color) {
                    (0, $c4a15bca763b3f4b$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $dGKc1.PanelType).CUSTOM, {
                        color: color,
                        ...previousEmoji
                    }, isCustomPanelEnabled)(state, dispatch);
                    return false;
                }
                const payload = {
                    action: (0, $d925B.ACTION).CHANGED_BACKGROUND_COLOR,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).PANEL,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).PANEL,
                    attributes: {
                        newColor: color,
                        previousColor: previousColor
                    },
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                };
                (0, $dAtrv.withAnalytics)(editorAnalyticsAPI, payload)((0, $c4a15bca763b3f4b$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $dGKc1.PanelType).CUSTOM, {
                    color: color,
                    ...previousEmoji
                }, isCustomPanelEnabled))(state, dispatch);
                return false;
            };
        const changeEmoji = (emoji)=>(state, dispatch)=>{
                const panelNode = (0, $e0cd121451b09006$export$ddbd7c123a514b96)(state);
                if (panelNode === undefined) return false;
                const previousIcon = panelNode.node.attrs.panelIcon || '';
                if (previousIcon === emoji.shortName) {
                    (0, $c4a15bca763b3f4b$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $dGKc1.PanelType).CUSTOM, {
                        emoji: emoji.shortName,
                        emojiId: emoji.id,
                        emojiText: emoji.fallback
                    }, true)(state, dispatch);
                    return false;
                }
                const payload = {
                    action: (0, $d925B.ACTION).CHANGED_ICON,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).PANEL,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).PANEL,
                    attributes: {
                        newIcon: emoji.shortName,
                        previousIcon: previousIcon
                    },
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                };
                (0, $dAtrv.withAnalytics)(editorAnalyticsAPI, payload)((0, $c4a15bca763b3f4b$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $dGKc1.PanelType).CUSTOM, {
                    emoji: emoji.shortName,
                    emojiId: emoji.id,
                    emojiText: emoji.fallback
                }, true))(state, dispatch);
                return false;
            };
        const removeEmoji = ()=>(state, dispatch)=>{
                const panelNode = (0, $e0cd121451b09006$export$ddbd7c123a514b96)(state);
                if (activePanelType === (0, $dGKc1.PanelType).CUSTOM && !activePanelIcon) return false;
                if (panelNode === undefined) return false;
                const payload = {
                    action: (0, $d925B.ACTION).REMOVE_ICON,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).PANEL,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).PANEL,
                    attributes: {
                        icon: panelNode.node.attrs.panelIcon
                    },
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                };
                (0, $dAtrv.withAnalytics)(editorAnalyticsAPI, payload)((0, $c4a15bca763b3f4b$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $dGKc1.PanelType).CUSTOM, {
                    emoji: undefined,
                    emojiId: undefined,
                    emojiText: undefined
                }, isCustomPanelEnabled))(state, dispatch);
                return false;
            };
        const panelColor = activePanelType === (0, $dGKc1.PanelType).CUSTOM ? activePanelColor || (0, $DoNsZ.getPanelTypeBackgroundNoTokens)((0, $dGKc1.PanelType).INFO) : (0, $DoNsZ.getPanelTypeBackgroundNoTokens)(activePanelType);
        const defaultPalette = (0, $6f19e76ade7c1b04$export$4c05e6c3475702fb).find((item)=>item.value === panelColor) || {
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            label: 'Custom',
            value: panelColor,
            border: (0, $lhtyR.DEFAULT_BORDER_COLOR)
        };
        if (isCustomPanelEditable) {
            const colorPicker = {
                id: 'editor.panel.colorPicker',
                title: formatMessage((0, $02xUP.panelMessages).backgroundColor),
                isAriaExpanded: true,
                type: 'select',
                selectType: 'color',
                defaultValue: defaultPalette,
                options: (0, $6f19e76ade7c1b04$export$4c05e6c3475702fb),
                onChange: (option)=>changeColor(option.value)
            };
            const emojiPicker = {
                id: 'editor.panel.emojiPicker',
                title: formatMessage((0, $02xUP.panelMessages).emoji),
                type: 'select',
                selectType: 'emoji',
                options: [],
                selected: activePanelType === (0, $dGKc1.PanelType).CUSTOM && !!activePanelIcon,
                onChange: (emoji)=>changeEmoji(emoji)
            };
            const removeEmojiButton = {
                id: 'editor.panel.removeEmoji',
                type: 'button',
                icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2G5zx))), {
                        spacing: 'spacious',
                        label: ''
                    }),
                onClick: removeEmoji(),
                title: formatMessage((0, $61p3e.default).removeEmoji),
                disabled: activePanelIcon ? false : true
            };
            items.push(emojiPicker, removeEmojiButton, {
                type: 'separator'
            }, colorPicker);
        }
    }
    if (areAllNewToolbarFlagsDisabled) {
        if (state) {
            items.push({
                type: 'separator'
            });
            items.push({
                type: 'copy-button',
                items: [
                    {
                        state: state,
                        formatMessage: formatMessage,
                        nodeType: panelNodeType
                    }
                ]
            });
        }
        items.push({
            type: 'separator'
        }, {
            id: 'editor.panel.delete',
            type: 'button',
            appearance: 'danger',
            focusEditoronEnter: true,
            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
                    spacing: 'spacious',
                    label: ''
                }),
            onClick: (0, $c4a15bca763b3f4b$export$8784bcc8bfa6de8d)(editorAnalyticsAPI),
            onMouseEnter: hoverDecoration?.(panelNodeType, true),
            onMouseLeave: hoverDecoration?.(panelNodeType, false),
            onFocus: hoverDecoration?.(panelNodeType, true),
            onBlur: hoverDecoration?.(panelNodeType, false),
            title: formatMessage((0, $61p3e.default).remove),
            tabIndex: null
        });
    } else {
        const hoverDecorationProps = (nodeType, className)=>({
                onMouseEnter: hoverDecoration?.(nodeType, true, className),
                onMouseLeave: hoverDecoration?.(nodeType, false, className),
                onFocus: hoverDecoration?.(nodeType, true, className),
                onBlur: hoverDecoration?.(nodeType, false, className)
            });
        // testId is required to show focus on trigger button on ESC key press
        // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
        const testId = 'panel-overflow-dropdown-trigger';
        const overflowMenuConfig = [
            {
                type: 'separator',
                fullHeight: true
            },
            {
                type: 'overflow-dropdown',
                testId: testId,
                options: [
                    {
                        title: formatMessage((0, $61p3e.default).copyToClipboard),
                        onClick: ()=>{
                            api?.core?.actions.execute(// @ts-ignore
                            api?.floatingToolbar?.commands.copyNode(panelNodeType, (0, $d925B.INPUT_METHOD).FLOATING_TB));
                            return true;
                        },
                        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
                            label: ""
                        }),
                        ...hoverDecorationProps(panelNodeType, (0, $aFUXX.akEditorSelectedNodeClassName))
                    },
                    {
                        title: formatMessage((0, $61p3e.default).delete),
                        onClick: (0, $c4a15bca763b3f4b$export$8784bcc8bfa6de8d)(editorAnalyticsAPI),
                        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
                            label: ""
                        }),
                        ...hoverDecorationProps(panelNodeType)
                    }
                ]
            }
        ];
        items.push(...overflowMenuConfig);
    }
    return items;
};
const $470fc4451c578198$export$86ce8f8241c20a3 = (state, intl, options = {}, providerFactory, api)=>{
    const { formatMessage: formatMessage } = intl;
    const panelObject = (0, $e0cd121451b09006$export$ddbd7c123a514b96)(state);
    if (panelObject) {
        const nodeType = state.schema.nodes.panel;
        const { panelType: panelType, panelColor: panelColor, panelIcon: panelIcon } = panelObject.node.attrs;
        const isStandardPanel = (panelType)=>{
            return panelType !== (0, $dGKc1.PanelType).CUSTOM ? panelType : undefined;
        };
        // force toolbar to be turned on
        const items = $470fc4451c578198$export$b40dbe3b5f798829(formatMessage, nodeType, options.allowCustomPanel || false, options.allowCustomPanel && options.allowCustomPanelEdit || false, providerFactory, api?.decorations?.actions.hoverDecoration, api?.analytics?.actions, panelType, options.allowCustomPanel ? panelColor : undefined, options.allowCustomPanel ? panelIcon || isStandardPanel(panelType) : undefined, state, (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(api?.toolbar)) ? api : undefined);
        const getDomRef = (editorView)=>{
            const domAtPos = editorView.domAtPos.bind(editorView);
            const element = (0, $8m4tT.findDomRefAtPos)(panelObject.pos, domAtPos);
            return element;
        };
        return {
            title: 'Panel floating controls',
            getDomRef: getDomRef,
            nodeType: nodeType,
            items: items,
            scrollable: true,
            groupLabel: formatMessage((0, $02xUP.panelMessages).panelsGroup)
        };
    }
    return;
};


const $e35c1438196cadae$var$panelPlugin = ({ config: options = {}, api: api })=>{
    if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) api?.blockMenu?.actions.registerBlockMenuComponents([
        {
            type: 'block-menu-item',
            key: (0, $btNLq.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $gEb6G.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $btNLq.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]
            },
            component: (0, $3362d16afd56bb0c$export$33a19cd537147781)(api)
        }
    ]);
    return {
        name: 'panel',
        nodes () {
            if ((0, $dh538.fg)('platform_editor_adf_with_localid')) {
                if ((0, $dh538.fg)('platform_editor_ai_generic_prep_for_aifc_2')) return [
                    {
                        name: 'panel',
                        node: {
                            ...(0, $dGKc1.extendedPanelWithLocalId)(!!options.allowCustomPanel),
                            definingAsContext: true
                        }
                    }
                ];
                return [
                    {
                        name: 'panel',
                        node: (0, $dGKc1.extendedPanelWithLocalId)(!!options.allowCustomPanel)
                    }
                ];
            }
            return [
                {
                    name: 'panel',
                    node: (0, $dGKc1.extendedPanel)(!!options.allowCustomPanel)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'panel',
                    plugin: ({ providerFactory: providerFactory, dispatch: dispatch, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(0, $45e5886bb64c7c75$export$ae829ec7b2625219)(dispatch, providerFactory, options, api, nodeViewPortalProviderAPI)
                },
                {
                    name: 'panelKeyMap',
                    plugin: ()=>(0, $902d62fc2eaf77bf$export$2e2bcd8739ae039)()
                }
            ];
        },
        actions: {
            insertPanel (inputMethod) {
                if ((0, $1oCLl.expValEquals)('platform_editor_fix_quick_insert_consistency_exp', 'isEnabled', true)) return function(state, dispatch) {
                    const tr = $e35c1438196cadae$var$createPanelAction({
                        state: state,
                        attributes: {
                            panelType: (0, $dGKc1.PanelType).INFO
                        },
                        api: api,
                        inputMethod: inputMethod
                    });
                    if (!tr) return false;
                    if (dispatch) dispatch(tr);
                    return true;
                };
                else return (0, $c4a15bca763b3f4b$export$2bad565f1cff271f)(inputMethod, api?.analytics?.actions);
            }
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>{
                const quickInsertOptions = [
                    {
                        id: 'infopanel',
                        title: formatMessage((0, $2UWDO.messages).infoPanel),
                        keywords: [
                            'panel'
                        ],
                        description: formatMessage((0, $2UWDO.messages).infoPanelDescription),
                        priority: 800,
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconPanel), {}),
                        action (typeAheadInsert, state) {
                            return $e35c1438196cadae$var$createPanelAction({
                                state: state,
                                attributes: {
                                    panelType: (0, $dGKc1.PanelType).INFO
                                },
                                api: api,
                                typeAheadInsert: typeAheadInsert
                            });
                        }
                    },
                    {
                        id: 'notepanel',
                        title: formatMessage((0, $2UWDO.messages).notePanel),
                        description: formatMessage((0, $2UWDO.messages).notePanelDescription),
                        priority: 1000,
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconPanelNote), {}),
                        action (typeAheadInsert, state) {
                            return $e35c1438196cadae$var$createPanelAction({
                                state: state,
                                attributes: {
                                    panelType: (0, $dGKc1.PanelType).NOTE
                                },
                                api: api,
                                typeAheadInsert: typeAheadInsert
                            });
                        }
                    },
                    {
                        id: 'successpanel',
                        title: formatMessage((0, $2UWDO.messages).successPanel),
                        description: formatMessage((0, $2UWDO.messages).successPanelDescription),
                        keywords: [
                            'tip'
                        ],
                        priority: 1000,
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconPanelSuccess), {}),
                        action (typeAheadInsert, state) {
                            return $e35c1438196cadae$var$createPanelAction({
                                state: state,
                                attributes: {
                                    panelType: (0, $dGKc1.PanelType).SUCCESS
                                },
                                api: api,
                                typeAheadInsert: typeAheadInsert
                            });
                        }
                    },
                    {
                        id: 'warningpanel',
                        title: formatMessage((0, $2UWDO.messages).warningPanel),
                        description: formatMessage((0, $2UWDO.messages).warningPanelDescription),
                        priority: 1000,
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconPanelWarning), {}),
                        action (typeAheadInsert, state) {
                            return $e35c1438196cadae$var$createPanelAction({
                                state: state,
                                attributes: {
                                    panelType: (0, $dGKc1.PanelType).WARNING
                                },
                                api: api,
                                typeAheadInsert: typeAheadInsert
                            });
                        }
                    },
                    {
                        id: 'errorpanel',
                        title: formatMessage((0, $2UWDO.messages).errorPanel),
                        description: formatMessage((0, $2UWDO.messages).errorPanelDescription),
                        priority: 1000,
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconPanelError), {}),
                        action (typeAheadInsert, state) {
                            return $e35c1438196cadae$var$createPanelAction({
                                state: state,
                                attributes: {
                                    panelType: (0, $dGKc1.PanelType).ERROR
                                },
                                api: api,
                                typeAheadInsert: typeAheadInsert
                            });
                        }
                    }
                ];
                if (options.allowCustomPanel && options.allowCustomPanelEdit) quickInsertOptions.push({
                    id: 'custompanel',
                    title: formatMessage((0, $2UWDO.messages).customPanel),
                    description: formatMessage((0, $2UWDO.messages).customPanelDescription),
                    priority: 1000,
                    icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3a491b7898bae957$export$2e2bcd8739ae039), {}),
                    action (typeAheadInsert, state) {
                        return $e35c1438196cadae$var$createPanelAction({
                            state: state,
                            attributes: {
                                panelType: (0, $dGKc1.PanelType).CUSTOM,
                                panelIcon: ':rainbow:',
                                panelIconId: '1f308',
                                panelIconText: "\uD83C\uDF08",
                                // Ignored via go/ees007
                                // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                                // TODO: https://product-fabric.atlassian.net/browse/DSP-7268
                                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
                                panelColor: (0, $6fnsQ.T50)
                            },
                            api: api,
                            typeAheadInsert: typeAheadInsert
                        });
                    }
                });
                return quickInsertOptions;
            },
            floatingToolbar: (state, intl, providerFactory)=>(0, $470fc4451c578198$export$86ce8f8241c20a3)(state, intl, options, providerFactory, api)
        }
    };
};
/**
 * Creates panel action and wrap selection transaction with analytics for the panel insertion.
 *
 * @example
 * const tr = createPanelAction({
 *   state: editorState,
 *   attributes: { panelType: 'info' },
 * });
 * if (tr) {
 *   applyTransaction(tr);
 * }
 */ function $e35c1438196cadae$var$createPanelAction({ state: state, attributes: attributes, api: api, typeAheadInsert: typeAheadInsert, inputMethod: inputMethod = (0, $d925B.INPUT_METHOD).QUICK_INSERT }) {
    const { panel: panel } = state.schema.nodes;
    let tr;
    /*
		During investigation of go/j/ED-26928 I found that the behaviour of this experience was very
		inconsistent. I reached out to Nicole* for a design review, and she confirmed that the desired
		behaviour is to insert the panel on a new line if the selection is empty.
		 *Confluence Editor Lead Product Designer
	 */ if ((0, $1oCLl.expValEquals)('platform_editor_fix_quick_insert_consistency_exp', 'isEnabled', true)) {
        // If the selection is empty, we want to insert the panel on a new line
        if (state.selection.empty) {
            const node = panel.createAndFill({
                ...attributes
            });
            if (!node) return false;
            if (typeAheadInsert !== undefined) // If the type-ahead insert is provided, we should use that to insert the node
            tr = typeAheadInsert(node);
            else // Otherwise we can use insertSelectedItem to insert the node
            tr = (0, $zT4ZO.insertSelectedItem)(node)(state, state.tr, state.selection.head)?.scrollIntoView();
        } else tr = (0, $l9FJJ.createWrapSelectionTransaction)({
            state: state,
            type: panel,
            nodeAttributes: {
                ...attributes
            }
        });
    } else // Panels should wrap content by default when inserted, the quickInsert `insert` method
    // will insert the node on a newline
    if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) tr = state.selection.empty && (0, $l9FJJ.createWrapSelectionTransaction)({
        state: state,
        type: panel,
        nodeAttributes: {
            ...attributes
        }
    });
    else {
        const node = panel.createAndFill({
            ...attributes
        });
        if (!node) return false;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- This is only optional within the experiment, so safe to assume non-null here
        tr = state.selection.empty && typeAheadInsert(node);
    }
    if (tr) api?.analytics?.actions.attachAnalyticsEvent({
        action: (0, $d925B.ACTION).INSERTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).PANEL,
        attributes: {
            inputMethod: inputMethod,
            panelType: attributes.panelType
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    })(tr);
    return tr ?? false;
}
var $e35c1438196cadae$export$2e2bcd8739ae039 = $e35c1438196cadae$var$panelPlugin;
module.exports["default"] = $e35c1438196cadae$export$2e2bcd8739ae039;

});

parcelRegister("jaskt", function(module, exports) {
/* tasksAndDecisionsPlugin.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gClzS = parcelRequire("gClzS");

var $cXZ4C = parcelRequire("cXZ4C");


var $d925B = parcelRequire("d925B");


var $btNLq = parcelRequire("btNLq");

var $gEb6G = parcelRequire("gEb6G");


var $5abq6 = parcelRequire("5abq6");


var $4HWgE = parcelRequire("4HWgE");


var $3pLGZ = parcelRequire("3pLGZ");


var $b3YrF = parcelRequire("b3YrF");


var $8m4tT = parcelRequire("8m4tT");


var $1oCLl = parcelRequire("1oCLl");


var $dZ8uq = parcelRequire("dZ8uq");


var $5elS6 = parcelRequire("5elS6");


var $24P9d = parcelRequire("24P9d");


var $2iuib = parcelRequire("2iuib");


var $7iisy = parcelRequire("7iisy");





var $iu6m9 = parcelRequire("iu6m9");

const $d9e9935026bf8066$export$c0efac86beb21f01 = (node)=>{
    if (node.content.childCount === 0) return true;
    if (node.type.name === 'blockTaskItem') return node.content.childCount === 1 && node.content.firstChild?.type.name === 'paragraph' && node.content.firstChild?.childCount === 0;
    return false;
};


const $13787dd647975a80$export$aa7ccb8f78e9cbdd = ()=>{
    if ((0, $iu6m9.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return 0, $5elS6.taskItem;
    return {
        ...(0, $5elS6.taskItem),
        toDOM: (node)=>$13787dd647975a80$export$61f6ad164c5ca628(node)
    };
};
const $13787dd647975a80$export$526b6659b16d1721 = ()=>{
    if ((0, $iu6m9.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return 0, $5elS6.blockTaskItem;
    return {
        ...(0, $5elS6.blockTaskItem),
        toDOM: (node)=>$13787dd647975a80$export$61f6ad164c5ca628(node)
    };
};
const $13787dd647975a80$var$getCheckBoxId = (localId)=>`task-checkbox-${localId}`;
function $13787dd647975a80$export$640336359e1ccaeb(node, placeholder, intl) {
    const checked = node.attrs.state === 'DONE';
    const checkboxId = $13787dd647975a80$var$getCheckBoxId(node.attrs.localId);
    const inputAttrs = {
        name: checkboxId,
        id: checkboxId,
        type: 'checkbox',
        'aria-label': intl.formatMessage(checked ? (0, $2iuib.tasksAndDecisionsMessages).markTaskAsNotCompleted : (0, $2iuib.tasksAndDecisionsMessages).markTaskAsCompleted)
    };
    if (checked) inputAttrs.checked = 'true';
    const dataAttrs = {
        'data-task-local-id': node.attrs.localId,
        'data-task-state': node.attrs.state,
        'data-prosemirror-node-name': 'taskItem',
        ...node.type.name === 'blockTaskItem' ? {
            'data-task-is-block': 'true'
        } : {}
    };
    let contentDomDataAttrs = node.content.childCount > 0 ? {} : {
        'data-empty': 'true'
    };
    if ((0, $1oCLl.expValEquals)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true)) contentDomDataAttrs = (0, $d9e9935026bf8066$export$c0efac86beb21f01)(node) ? {
        'data-empty': 'true'
    } : {};
    return [
        'div',
        {
            class: `${(0, $7iisy.TaskDecisionSharedCssClassName).TASK_CONTAINER}`,
            ...dataAttrs,
            state: node.attrs.state
        },
        [
            'div',
            {
                'data-component': 'task-item-main'
            },
            [
                'span',
                {
                    contenteditable: 'false',
                    class: `${(0, $7iisy.TaskDecisionSharedCssClassName).TASK_CHECKBOX_CONTAINER}`,
                    'data-component': 'task-item-input-wrap'
                },
                [
                    'input',
                    {
                        ...inputAttrs,
                        'data-input-type': 'task-item',
                        'data-task-input': true,
                        'data-testid': 'task-item-checkbox',
                        'data-component': 'task-item-input',
                        role: 'checkbox'
                    }
                ],
                [
                    'span',
                    {
                        'aria-hidden': true,
                        'data-component': 'checkbox-icon-wrap'
                    },
                    [
                        'http://www.w3.org/2000/svg svg',
                        {
                            viewBox: `0 0 16 16`,
                            width: '16',
                            height: '16',
                            role: 'presentation',
                            fill: 'none',
                            'data-component': 'checkbox-unchecked-icon'
                        },
                        [
                            'http://www.w3.org/2000/svg rect',
                            {
                                width: '12.5',
                                height: '12.5',
                                x: '1.75',
                                y: '1.75',
                                stroke: 'currentcolor',
                                'stroke-width': '1.5',
                                rx: '1.25'
                            }
                        ]
                    ],
                    [
                        'http://www.w3.org/2000/svg svg',
                        {
                            viewBox: `0 0 16 16`,
                            width: '16',
                            height: '16',
                            role: 'presentation',
                            fill: 'none',
                            'data-component': 'checkbox-checked-icon'
                        },
                        [
                            'http://www.w3.org/2000/svg path',
                            {
                                fill: 'currentcolor',
                                'fill-rule': 'evenodd',
                                'clip-rule': 'evenodd',
                                d: 'M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z'
                            }
                        ]
                    ]
                ]
            ],
            [
                'span',
                {
                    class: 'placeholder-node-view',
                    'data-testid': 'task-decision-item-placeholder',
                    'data-component': 'placeholder',
                    contenteditable: 'false'
                },
                placeholder
            ],
            [
                'div',
                {
                    'data-component': 'content'
                },
                [
                    'div',
                    {
                        class: (0, $7iisy.TaskDecisionSharedCssClassName).TASK_ITEM,
                        ...contentDomDataAttrs
                    },
                    0
                ]
            ]
        ]
    ];
}
const $13787dd647975a80$export$61f6ad164c5ca628 = (node)=>{
    const checked = node.attrs.state === 'DONE';
    const inputAttrs = {
        name: node.attrs.localId,
        id: node.attrs.localId,
        type: 'checkbox'
    };
    if (checked) inputAttrs.checked = 'true';
    const dataAttrs = {
        'data-task-local-id': node.attrs.localId,
        'data-task-state': node.attrs.state,
        ...node.type.name === 'blockTaskItem' ? {
            'data-task-is-block': 'true'
        } : {}
    };
    return [
        'div',
        {
            class: (0, $7iisy.TaskDecisionSharedCssClassName).TASK_CONTAINER,
            ...dataAttrs,
            style: (0, $24P9d.convertToInlineCss)({
                listStyleType: 'none',
                lineHeight: '24px',
                minWidth: '48px',
                position: 'relative'
            })
        },
        [
            'div',
            {
                style: (0, $24P9d.convertToInlineCss)({
                    display: 'flex'
                })
            },
            [
                'span',
                {
                    contenteditable: 'false',
                    style: (0, $24P9d.convertToInlineCss)({
                        width: '24px',
                        height: '24px',
                        lineHeight: '24px',
                        display: 'grid',
                        placeContent: 'center center'
                    })
                },
                [
                    'input',
                    {
                        ...inputAttrs,
                        'data-input-type': 'lazy-task-item',
                        style: (0, $24P9d.convertToInlineCss)({
                            width: '13px',
                            height: '13px',
                            margin: '1px 0 0 0',
                            padding: 0,
                            accentColor: "var(--ds-background-selected-bold, #1868DB)"
                        })
                    }
                ]
            ],
            [
                'div',
                {
                    'data-component': 'content'
                },
                [
                    'div',
                    {
                        class: (0, $7iisy.TaskDecisionSharedCssClassName).TASK_ITEM,
                        style: (0, $24P9d.convertToInlineCss)({
                            display: 'block',
                            fontSize: '16px',
                            fontFamily: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                            color: "var(--ds-text, #292A2E)"
                        })
                    },
                    0
                ]
            ]
        ]
    ];
};



var $bpTLT = parcelRequire("bpTLT");







const $2dd6d5f87dea1a71$export$7727308e3d6fe8e9 = ()=>{
    if ((0, $iu6m9.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return 0, $bpTLT.decisionItem;
    return {
        ...(0, $bpTLT.decisionItem),
        toDOM: (node)=>{
            const { localId: localId, state: state } = node.attrs;
            const attrs = {
                'data-decision-local-id': localId || 'local-decision',
                'data-decision-state': state,
                class: 'decisionItemView-content-wrap'
            };
            const showPlaceholder = node.content.size === 0;
            return [
                'li',
                attrs,
                [
                    'div',
                    {
                        'data-decision-wrapper': true,
                        'data-testid': 'elements-decision-item',
                        // Styles to match `packages/elements/task-decision/src/components/styles.ts`
                        style: (0, $24P9d.convertToInlineCss)({
                            background: "var(--ds-background-neutral, #0515240F)",
                            padding: "var(--ds-space-100, 8px)",
                            paddingLeft: "var(--ds-space-150, 12px)",
                            margin: `${"var(--ds-space-100, 8px)"} 0 0 0`,
                            display: 'flex',
                            borderRadius: "var(--ds-radius-small, 3px)"
                        })
                    },
                    [
                        'span',
                        {
                            style: (0, $24P9d.convertToInlineCss)({
                                width: '16px',
                                height: '16px',
                                margin: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"} 0 0`,
                                color: showPlaceholder ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-success, #6A9A23)",
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }),
                            contentEditable: 'false',
                            'data-component': 'icon'
                        },
                        [
                            'span',
                            {
                                role: 'img',
                                'aria-label': 'Decision',
                                style: (0, $24P9d.convertToInlineCss)({
                                    width: '32px',
                                    height: '32px'
                                })
                            },
                            [
                                'http://www.w3.org/2000/svg svg',
                                {
                                    viewBox: `0 0 24 24`,
                                    role: 'presentation',
                                    width: '24',
                                    height: '24',
                                    'data-icon-source': 'legacy',
                                    style: (0, $24P9d.convertToInlineCss)({
                                        width: '32px',
                                        height: '32px'
                                    })
                                },
                                [
                                    'http://www.w3.org/2000/svg path',
                                    {
                                        fill: 'currentcolor',
                                        'fill-rule': 'evenodd',
                                        d: 'm9.414 8 3.293 3.293c.187.187.293.442.293.707v5a1 1 0 0 1-2 0v-4.586l-3-3V10.5a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2zm8.293-1.707a1 1 0 0 1 0 1.414l-2.5 2.5a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l2.5-2.5a1 1 0 0 1 1.414 0'
                                    }
                                ]
                            ]
                        ]
                    ],
                    [
                        'div',
                        {
                            'data-component': 'content'
                        },
                        [
                            'div',
                            {
                                class: 'decision-item'
                            },
                            0
                        ]
                    ]
                ]
            ];
        }
    };
};



var $adhil = parcelRequire("adhil");


var $l9G9n = parcelRequire("l9G9n");

var $irKZA = parcelRequire("irKZA");


var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");


var $aXG5V = parcelRequire("aXG5V");





var $dh538 = parcelRequire("dh538");







const $e74ddcb3d2085778$export$77b371d6becc8882 = new (0, $ks2lK.PluginKey)('tasksAndDecisionsPlugin');


var $c5154c0aaa7029e9$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS[ACTIONS["SET_PROVIDER"] = 0] = "SET_PROVIDER";
    ACTIONS[ACTIONS["FOCUS_BY_LOCALID"] = 1] = "FOCUS_BY_LOCALID";
    ACTIONS[ACTIONS["OPEN_REQUEST_TO_EDIT_POPUP"] = 2] = "OPEN_REQUEST_TO_EDIT_POPUP";
    return ACTIONS;
}({});





function $e1b246d999b63af5$var$isTaskListNode(node) {
    return Boolean(node && node.type && 'taskList' === node.type.name);
}
const $e1b246d999b63af5$var$resolvePositionToStartOfTaskItem = ($pos)=>{
    const fromRange = $pos.blockRange($pos, $e1b246d999b63af5$var$isTaskListNode);
    const fromPosition = fromRange && $pos.textOffset === 0 && fromRange.end - 1 === $pos.pos ? (0, $ks2lK.Selection).near($pos.doc.resolve(fromRange.end + 1), 1).$from : $pos;
    return fromPosition;
};
const $e1b246d999b63af5$var$resolvePositionToEndOfTaskItem = ($pos)=>{
    const toRange = $pos.blockRange($pos, $e1b246d999b63af5$var$isTaskListNode);
    const toPosition = toRange && $pos.textOffset === 0 && toRange.start + 1 === $pos.pos ? (0, $ks2lK.Selection).near($pos.doc.resolve(toRange.start - 1), -1).$to : $pos;
    return toPosition;
};
const $e1b246d999b63af5$export$e590f1ae61640432 = (selection)=>{
    if (selection.empty) return selection;
    const { $from: $from, $to: $to } = selection;
    if (selection instanceof (0, $ks2lK.NodeSelection)) {
        const head = $e1b246d999b63af5$var$resolvePositionToStartOfTaskItem($from);
        return new (0, $ks2lK.TextSelection)(head, head);
    }
    const head = $e1b246d999b63af5$var$resolvePositionToStartOfTaskItem($from);
    const anchor = $e1b246d999b63af5$var$resolvePositionToEndOfTaskItem($to);
    return new (0, $ks2lK.TextSelection)(anchor, head);
};
const $e1b246d999b63af5$export$11f4e85d86397169 = ($from)=>{
    const { blockTaskItem: blockTaskItem, paragraph: paragraph } = $from.doc.type.schema.nodes;
    const firstParent = $from.parent;
    if (firstParent.type === blockTaskItem) return {
        blockTaskItemNode: firstParent,
        hasParagraph: false
    };
    else if (firstParent.type === paragraph) {
        if ($from.depth >= 1) {
            const secondParent = $from.node($from.depth - 1);
            if (secondParent.type === blockTaskItem) return {
                blockTaskItemNode: secondParent,
                hasParagraph: true
            };
            else return false;
        } else return false;
    }
    return false;
};


const $2fc4254aeefcece8$export$c4942fd0ddcad0b = (state)=>{
    const { decisionItem: decisionItem, taskItem: taskItem, blockTaskItem: blockTaskItem } = state.schema.nodes;
    if (blockTaskItem) return Boolean((0, $8m4tT.findParentNodeOfTypeClosestToPos)(state.selection.$from, [
        decisionItem,
        taskItem,
        blockTaskItem
    ]));
    return (0, $8m4tT.hasParentNodeOfType)([
        decisionItem,
        taskItem,
        blockTaskItem
    ])(state.selection);
};
const $2fc4254aeefcece8$export$6f0e2eafb461f634 = (node)=>{
    const { taskList: taskList, decisionList: decisionList } = node.type.schema.nodes;
    return [
        taskList,
        decisionList
    ].indexOf(node.type) > -1;
};
const $2fc4254aeefcece8$export$93c6d1f260b6c095 = (node)=>{
    const { taskItem: taskItem, decisionItem: decisionItem, blockTaskItem: blockTaskItem } = node.type.schema.nodes;
    return [
        taskItem,
        decisionItem,
        blockTaskItem
    ].indexOf(node.type) > -1;
};
const $2fc4254aeefcece8$export$2fad51fb9cb5e2d1 = (state)=>{
    const { taskItem: taskItem, blockTaskItem: blockTaskItem } = state.schema.nodes;
    return (0, $8m4tT.hasParentNodeOfType)([
        taskItem,
        blockTaskItem
    ])(state.selection);
};
const $2fc4254aeefcece8$export$cc187e317961fba = (state)=>{
    const { decisionItem: decisionItem } = state.schema.nodes;
    return (0, $8m4tT.hasParentNodeOfType)([
        decisionItem
    ])(state.selection);
};
const $2fc4254aeefcece8$export$567a2801b8f40ab5 = (node)=>{
    if (!node) return false;
    const { table: table, tableHeader: tableHeader, tableCell: tableCell, tableRow: tableRow } = node.type.schema.nodes;
    return [
        table,
        tableHeader,
        tableCell,
        tableRow
    ].includes(node.type);
};
const $2fc4254aeefcece8$export$f029cbac7e0ab14c = ({ $from: $from, $to: $to })=>{
    const { taskList: taskList, taskItem: taskItem, blockTaskItem: blockTaskItem, paragraph: paragraph } = $from.doc.type.schema.nodes;
    if (blockTaskItem) {
        const result = (0, $e1b246d999b63af5$export$11f4e85d86397169)($from);
        if (result) {
            const { hasParagraph: hasParagraph } = result;
            const blockTaskItemDepth = hasParagraph ? $from.depth - 1 : $from.depth;
            let blockRangeDepth = blockTaskItemDepth - 1;
            // Calculate start position of the block range
            let startPos = $from.start(blockTaskItemDepth) - 1;
            // Calculate end position and get node after the current selection
            const endPos = $to.end();
            let $after = $to.doc.resolve(endPos + 1);
            let afterNode = $after.nodeAfter;
            const lastNode = $to.node($to.depth);
            let endRangePos = $to.start() + lastNode.nodeSize;
            // Make adjustments for paragraph nodes
            if (lastNode.type === paragraph) {
                $after = $to.doc.resolve(endPos + 2);
                afterNode = $after.nodeAfter;
            } else {
                blockRangeDepth--;
                endRangePos--;
            }
            // Extend range if there's a sibling taskList
            if (afterNode && afterNode.type === taskList && $after.depth === blockTaskItemDepth - 1) endRangePos += afterNode.nodeSize;
            // Check if preceded by another taskItem/blockTaskItem
            const $prevNode = $from.doc.resolve(startPos - 1);
            const prevNodeSize = $prevNode.nodeBefore?.nodeSize || 0;
            const $prevNodeParent = $from.doc.resolve($prevNode.pos - prevNodeSize - 1);
            const prevNodeParent = $prevNodeParent.nodeAfter;
            if (prevNodeParent && [
                blockTaskItem,
                taskItem
            ].includes(prevNodeParent.type)) {
                blockRangeDepth = blockTaskItemDepth - 1;
                endRangePos -= 2;
                startPos += 1;
            }
            // Create and return the NodeRange
            return new (0, $5SAOw.NodeRange)($to.doc.resolve(startPos), $to.doc.resolve(endRangePos), blockRangeDepth);
        }
    }
    let end = $to.end();
    const $after = $to.doc.resolve(end + 1);
    const after = $after.nodeAfter;
    // ensure the node after is actually just a sibling
    // $to will be inside the text, so subtract one to get the taskItem it contains in
    if (after && after.type === taskList && $after.depth === $to.depth - 1) // it was! include it in our blockRange
    end += after.nodeSize;
    return $from.blockRange($to.doc.resolve(end));
};
const $2fc4254aeefcece8$export$d75a55aec79aaa5 = (selection)=>{
    const { $from: $from } = selection;
    const { taskList: taskList, blockTaskItem: blockTaskItem } = $from.doc.type.schema.nodes;
    const furthestParent = (0, $l9G9n.findFarthestParentNode)((node)=>node.type === taskList)($from);
    if (!furthestParent) return null;
    if ((0, $8m4tT.hasParentNodeOfType)([
        blockTaskItem
    ])(selection)) {
        const blockTaskItemNode = (0, $l9G9n.findFarthestParentNode)((node)=>node.type === blockTaskItem)($from);
        if (blockTaskItemNode) /**
			 * If we are inside a blockTaskItem, calculate the indent level from the
			 * blockTaskItemNode instead of the selection, in case the selection is
			 * nested inside a blockTaskItem.
			 */ return blockTaskItemNode.depth - furthestParent.depth;
    }
    return $from.depth - furthestParent.depth;
};
const $2fc4254aeefcece8$export$af0098af8462419f = (state)=>{
    const $pos = state.selection.$from;
    const isTaskList = (node)=>node?.type.name === 'taskList';
    const itemAtPos = (0, $8m4tT.findParentNodeClosestToPos)($pos, isTaskList);
    return $pos.index(itemAtPos ? itemAtPos.depth : undefined);
};
const $2fc4254aeefcece8$export$cd30871533411394 = ($startPos)=>{
    let $pos = $startPos;
    // invariant 1: don't walk past the end of the document
    // invariant 2: we haven't walked to the start of *any* node
    //              parentOffset includes textOffset.
    while($pos.pos < $pos.doc.nodeSize - 2 && $pos.parentOffset > 0)$pos = $pos.doc.resolve($pos.pos + 1);
    return $pos;
};
const $2fc4254aeefcece8$export$59958047ba34fe83 = ($from, $to, types)=>{
    const root = (0, $l9G9n.findFarthestParentNode)((node)=>types.indexOf(node.type) > -1)($from);
    if (!root) return -1;
    // get the height between the root and the current position
    const distToParent = $from.depth - root.depth;
    // include any following taskList since nested lists appear
    // as siblings
    //
    // this is unlike regular bullet lists where the orderedList
    // appears as descendent of listItem
    const blockRange = $2fc4254aeefcece8$export$f029cbac7e0ab14c({
        $from: $from,
        $to: $to
    });
    if (!blockRange) return -1;
    // and get the max height from the current position to the
    // deepest leaf node
    let maxChildDepth = $from.depth;
    $from.doc.nodesBetween(blockRange.start, blockRange.end, (descendent, relPos, parent)=>{
        maxChildDepth = Math.max($from.doc.resolve(relPos).depth, maxChildDepth);
        // keep descending down the tree if we can
        if (types.indexOf(descendent.type) > -1) return true;
    });
    return distToParent + (maxChildDepth - $from.depth);
};
const $2fc4254aeefcece8$export$e29ace8e645e5684 = (state)=>{
    const { selection: selection, schema: schema } = state;
    const { paragraph: paragraph, blockTaskItem: blockTaskItem, decisionItem: decisionItem, taskItem: taskItem } = schema.nodes;
    const { $from: $from } = selection;
    const node = $from.node($from.depth);
    const isEmptyTaskOrDecisionItem = node && (node.type === taskItem || node.type === decisionItem) && node.content.size === 0;
    // Block task items must contain a single empty paragraph to be considered empty
    const isInEmptyBlockTaskItem = // If in an empty paragraph that's not at the doc level
    node.content.size === 0 && node.type === paragraph && $from.depth > 0 && // and it's parent is a blockTaskItem with only this paragraph inside it
    $from.node($from.depth - 1).type === blockTaskItem && $from.node($from.depth - 1).childCount === 1 && (0, $dh538.fg)('platform_editor_blocktaskitem_patch_3');
    return isEmptyTaskOrDecisionItem || isInEmptyBlockTaskItem;
};
const $2fc4254aeefcece8$export$b4043a93b6a561c9 = (tr, $from, $to)=>{
    const blockRange = $2fc4254aeefcece8$export$f029cbac7e0ab14c({
        $from: $from,
        $to: $to
    });
    if (!blockRange) return null;
    // ensure we can actually lift
    const target = (0, $aXG5V.liftTarget)(blockRange);
    if (typeof target !== 'number') return null;
    return tr.lift(blockRange, target).scrollIntoView();
};
function $2fc4254aeefcece8$export$bb36b9aa75d84160(view) {
    const { state: state } = view;
    const { selection: selection, schema: schema } = state;
    const { $from: $from } = selection;
    if ((0, $1oCLl.expValEquals)('platform_editor_blocktaskitem_patch_1', 'isEnabled', true)) {
        const { taskItem: taskItem, blockTaskItem: blockTaskItem } = schema.nodes;
        const maybeTask = (0, $8m4tT.findParentNodeOfTypeClosestToPos)($from, [
            taskItem,
            blockTaskItem
        ]);
        // current selection has to be inside taskitem
        if (maybeTask) return {
            pos: maybeTask?.pos,
            localId: maybeTask?.node.attrs.localId
        };
    } else {
        const isInTaskItem = $from.node().type === schema.nodes.taskItem;
        // current selection has to be inside taskitem
        if (isInTaskItem) {
            const taskItemPos = $from.before();
            return {
                pos: taskItemPos,
                localId: $from.node().attrs.localId
            };
        }
    }
}
function $2fc4254aeefcece8$export$fdf2e1015111c7cb(view) {
    const { state: state } = view;
    const { schema: schema } = state;
    const $fromPos = state.selection.$from;
    const isInTaskItem = (0, $1oCLl.expValEquals)('platform_editor_blocktaskitem_patch_1', 'isEnabled', true) ? $2fc4254aeefcece8$export$2fad51fb9cb5e2d1(state) : $fromPos.node().type === schema.nodes.taskItem;
    // if not inside task item then return undefined;
    if (!isInTaskItem) return;
    const { taskList: taskList, taskItem: taskItem, blockTaskItem: blockTaskItem } = schema.nodes;
    const rootTaskListData = (0, $l9G9n.findFarthestParentNode)((node)=>node.type === taskList)($fromPos);
    if (rootTaskListData) {
        const rootTaskList = rootTaskListData.node;
        const rootTaskListStartPos = rootTaskListData.start;
        const allTaskItems = [];
        rootTaskList.descendants((node, pos, parent, index)=>{
            if (node.type === taskItem || (0, $1oCLl.expValEquals)('platform_editor_blocktaskitem_patch_1', 'isEnabled', true) && blockTaskItem && node.type === blockTaskItem) allTaskItems.push({
                node: node,
                pos: pos + rootTaskListStartPos,
                index: index
            });
        });
        return allTaskItems;
    }
}
function $2fc4254aeefcece8$export$34f429092f5d2a8b(view, allTaskItems) {
    const { state: state } = view;
    const { schema: schema } = state;
    const { taskItem: taskItem, blockTaskItem: blockTaskItem } = schema.nodes;
    const $fromPos = state.selection.$from;
    const allTaskItemNodes = allTaskItems.map((nodeData)=>nodeData.node);
    const currentTaskItem = (0, $1oCLl.expValEquals)('platform_editor_blocktaskitem_patch_1', 'isEnabled', true) ? (0, $8m4tT.findParentNodeOfTypeClosestToPos)($fromPos, [
        taskItem,
        blockTaskItem
    ])?.node : $fromPos.node($fromPos.depth);
    if (currentTaskItem) {
        const currentTaskItemIndex = allTaskItemNodes.indexOf(currentTaskItem);
        return currentTaskItemIndex;
    } else return -1;
}
function $2fc4254aeefcece8$export$84c7d27d1433771f(view, direction) {
    const allTaskItems = $2fc4254aeefcece8$export$fdf2e1015111c7cb(view);
    // if not inside task item then allTaskItems will be undefined;
    if (!allTaskItems) return;
    const currentTaskItemIndex = $2fc4254aeefcece8$export$34f429092f5d2a8b(view, allTaskItems);
    if (direction === 'next' ? currentTaskItemIndex === allTaskItems.length - 1 : currentTaskItemIndex === 0) // checkbox of first or last task item is already focused based on direction.
    return;
    const indexOfTaskItemToFocus = direction === 'next' ? currentTaskItemIndex + 1 : currentTaskItemIndex - 1;
    const taskItemToFocus = allTaskItems[indexOfTaskItemToFocus];
    return {
        pos: taskItemToFocus.pos,
        localId: taskItemToFocus.node.attrs.localId
    };
}
function $2fc4254aeefcece8$export$6ddc162ae107856(view, taskItemData) {
    const { state: state, dispatch: dispatch } = view;
    const { tr: tr } = state;
    if (taskItemData) {
        tr.setMeta((0, $e74ddcb3d2085778$export$77b371d6becc8882), {
            action: (0, $c5154c0aaa7029e9$export$92a1a3b7554e9387).FOCUS_BY_LOCALID,
            data: taskItemData.localId
        });
        dispatch(tr);
    }
}
function $2fc4254aeefcece8$export$965155ace97a0424(view, taskItemData) {
    const { pos: pos, localId: localId } = taskItemData;
    const { state: state, dispatch: dispatch } = view;
    const { doc: doc } = state;
    const { schema: schema } = state;
    const { extension: extension } = schema.nodes;
    const tr = state.tr;
    // if there's an extension at this position, we're in a blockTaskItem, set a gapCursor
    if ((0, $1oCLl.expValEquals)('platform_editor_blocktaskitem_patch_1', 'isEnabled', true) && extension && doc.resolve(pos + 1).nodeAfter?.type === extension) tr.setSelection(new (0, $adhil.GapCursorSelection)(doc.resolve(pos + 1)));
    else if ((0, $1oCLl.expValEquals)('platform_editor_blocktaskitem_patch_1', 'isEnabled', true) && doc.resolve(pos + 1).nodeAfter?.isTextblock) tr.setSelection(new (0, $ks2lK.TextSelection)(doc.resolve(pos + 2)));
    else tr.setSelection(new (0, $ks2lK.TextSelection)(doc.resolve(pos + 1)));
    tr.setMeta((0, $e74ddcb3d2085778$export$77b371d6becc8882), {
        action: (0, $c5154c0aaa7029e9$export$92a1a3b7554e9387).FOCUS_BY_LOCALID,
        data: localId
    });
    dispatch(tr);
}
function $2fc4254aeefcece8$export$6d348f0593efe546(view) {
    const { state: state, dispatch: dispatch } = view;
    const { tr: tr } = state;
    view.focus();
    dispatch(tr.setMeta((0, $e74ddcb3d2085778$export$77b371d6becc8882), {
        action: (0, $c5154c0aaa7029e9$export$92a1a3b7554e9387).FOCUS_BY_LOCALID
    }));
}
function $2fc4254aeefcece8$export$ccb659c518fe26ad(view, pos) {
    const { state: state, dispatch: dispatch } = view;
    const { tr: tr } = state;
    dispatch(tr.setMeta((0, $e74ddcb3d2085778$export$77b371d6becc8882), {
        action: (0, $c5154c0aaa7029e9$export$92a1a3b7554e9387).OPEN_REQUEST_TO_EDIT_POPUP,
        data: pos
    }));
}
function $2fc4254aeefcece8$export$6e1436cb7b69383b(view) {
    const { state: state, dispatch: dispatch } = view;
    const { tr: tr } = state;
    dispatch(tr.setMeta((0, $e74ddcb3d2085778$export$77b371d6becc8882), {
        action: (0, $c5154c0aaa7029e9$export$92a1a3b7554e9387).OPEN_REQUEST_TO_EDIT_POPUP,
        data: null
    }));
}
function $2fc4254aeefcece8$export$cd0bf0d386a8d5a7($pos) {
    const currentNode = $pos.doc.nodeAt($pos.pos);
    let listNodePosition = null;
    if ((0, $irKZA.isListNode)(currentNode)) listNodePosition = $pos.pos;
    else {
        const result = (0, $8m4tT.findParentNodeClosestToPos)($pos, (0, $irKZA.isListNode));
        listNodePosition = result && result.pos;
    }
    if (listNodePosition == null) return null;
    const node = $pos.doc.nodeAt(listNodePosition);
    if (!node) return null;
    return {
        node: node,
        pos: listNodePosition
    };
}
const $2fc4254aeefcece8$export$2ca50ccc2f45db88 = (state)=>{
    const { $from: $from } = state.selection;
    const { blockTaskItem: blockTaskItem } = state.schema.nodes;
    return $from.parent.isTextblock && $from.node($from.depth - 1).type === blockTaskItem && $from.index($from.depth - 1) === 0;
};
const $2fc4254aeefcece8$export$bcd44b9b102ed403 = (state)=>{
    const { $from: $from } = state.selection;
    const { blockTaskItem: blockTaskItem } = state.schema.nodes;
    const parentNode = $from.node($from.depth - 1);
    return $from.parent.isTextblock && parentNode.type === blockTaskItem && $from.index($from.depth - 1) === parentNode.childCount - 1;
};






var $1S4f7 = parcelRequire("1S4f7");


var $l03WE = parcelRequire("l03WE");








var $aIMBk = parcelRequire("aIMBk");

var $14sLv = parcelRequire("14sLv");


var $fO7hX = parcelRequire("fO7hX");



var $ba0339a1ea50ea9d$export$f78f4c81bbd3af70 = /*#__PURE__*/ function(USER_CONTEXT) {
    USER_CONTEXT["EDIT"] = "edit";
    USER_CONTEXT["NEW"] = "new";
    return USER_CONTEXT;
}({});
var $ba0339a1ea50ea9d$export$5981355d1002ed79 = /*#__PURE__*/ function(LINK_STATUS) {
    LINK_STATUS["RESOLVED"] = "resolved";
    LINK_STATUS["UNRESOLVED"] = "unresolved";
    return LINK_STATUS;
}({});
var $ba0339a1ea50ea9d$export$6c486891427a9a0 = /*#__PURE__*/ function(LINK_REPRESENTATION) {
    LINK_REPRESENTATION["TEXT"] = "text";
    LINK_REPRESENTATION["INLINE_CARD"] = "inlineCard";
    LINK_REPRESENTATION["BLOCK_CARD"] = "blockCard";
    LINK_REPRESENTATION["EMBED"] = "embed";
    return LINK_REPRESENTATION;
}({});
var $ba0339a1ea50ea9d$export$7c9a0eeb2da3d2de = /*#__PURE__*/ function(LINK_RESOURCE) {
    LINK_RESOURCE["JIRA"] = "jiraIssue";
    LINK_RESOURCE["CONFLUENCE"] = "confluencePage";
    LINK_RESOURCE["BITBUCKET_PR"] = "bitbucketPR";
    LINK_RESOURCE["BITBUCKET_REPO"] = "bitbucketRepo";
    LINK_RESOURCE["TRELLO_CARD"] = "trelloCard";
    LINK_RESOURCE["TRELLO_BOARD"] = "trelloBoard";
    LINK_RESOURCE["STATUS_PAGE"] = "statusPage";
    LINK_RESOURCE["BOX"] = "boxFile";
    LINK_RESOURCE["DROPBOX"] = "dropboxFile";
    LINK_RESOURCE["OFFICE"] = "office";
    LINK_RESOURCE["DRIVE"] = "drive";
    LINK_RESOURCE["YOUTUBE"] = "youtubeVideo";
    LINK_RESOURCE["TWITTER"] = "twitterTweet";
    LINK_RESOURCE["OTHER"] = "other";
    return LINK_RESOURCE;
}({});






var $56SXY = parcelRequire("56SXY");















const $593b7407307544bb$var$getContextData = (contextProvider = {})=>{
    const { objectId: objectId, containerId: containerId } = contextProvider;
    const userContext = objectId ? (0, $ba0339a1ea50ea9d$export$f78f4c81bbd3af70).EDIT : (0, $ba0339a1ea50ea9d$export$f78f4c81bbd3af70).NEW;
    return {
        objectId: objectId,
        containerId: containerId,
        userContext: userContext
    };
};
const $593b7407307544bb$var$generateAnalyticsPayload = (listType, contextData, inputMethod, itemLocalId, listLocalId, itemIdx, listSize)=>{
    let containerId;
    let objectId;
    let userContext;
    if (contextData) ({ containerId: containerId, objectId: objectId, userContext: userContext } = contextData);
    return {
        action: (0, $d925B.ACTION).INSERTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: listType === 'taskList' ? (0, $d925B.ACTION_SUBJECT_ID).ACTION : (0, $d925B.ACTION_SUBJECT_ID).DECISION,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: inputMethod,
            containerAri: containerId,
            objectAri: objectId,
            userContext: userContext,
            localId: itemLocalId,
            listLocalId: listLocalId,
            position: itemIdx,
            listSize: listSize
        }
    };
};
const $593b7407307544bb$export$c8b7fdb74eb8fe5c = (listType, schema)=>{
    const { decisionList: decisionList, decisionItem: decisionItem, taskList: taskList, taskItem: taskItem } = schema.nodes;
    if (listType === 'taskList') return {
        list: taskList,
        item: taskItem
    };
    return {
        list: decisionList,
        item: decisionItem
    };
};
const $593b7407307544bb$export$8c1bb617b1f6f2f1 = (editorAnalyticsAPI, getContextIdentifierProvider)=>(state, listType, inputMethod = (0, $d925B.INPUT_METHOD).TOOLBAR, addItem, listLocalId, itemLocalId, itemAttrs)=>{
        const { schema: schema } = state;
        const addAndCreateList = ({ tr: tr, list: list, item: item, listLocalId: listLocalId, itemLocalId: itemLocalId })=>$593b7407307544bb$export$e38ac211271d1c05(tr, list, item, schema, state, listLocalId, itemLocalId, itemAttrs);
        const addToList = ({ state: state, tr: tr, item: item, itemLocalId: itemLocalId })=>{
            const { $to: $to } = state.selection;
            const endPos = $to.end($to.depth);
            const newItemParagraphPos = endPos + 2;
            return tr.split(endPos, 1, [
                {
                    type: item,
                    attrs: {
                        localId: itemLocalId
                    }
                }
            ]).setSelection(new (0, $ks2lK.TextSelection)(tr.doc.resolve(newItemParagraphPos)));
        };
        const addAndCreateListFn = addItem ?? addAndCreateList;
        const tr = $593b7407307544bb$export$14f75d90d7dffdab(editorAnalyticsAPI, getContextIdentifierProvider)(state, listType, inputMethod, addAndCreateListFn, addToList, listLocalId, itemLocalId, itemAttrs);
        if (!tr) return state.tr;
        (0, $56SXY.autoJoinTr)(tr, [
            'taskList',
            'decisionList'
        ]);
        return tr;
    };
const $593b7407307544bb$export$d1657e7847eaa8d6 = (editorAnalyticsAPI, getContextIdentifierProvider)=>(listType, inputMethod = (0, $d925B.INPUT_METHOD).TOOLBAR, addItem, listLocalId, itemLocalId)=>(state, dispatch)=>{
            const tr = $593b7407307544bb$export$8c1bb617b1f6f2f1(editorAnalyticsAPI, getContextIdentifierProvider)(state, listType, inputMethod, addItem, listLocalId, itemLocalId);
            if (dispatch) dispatch(tr);
            return true;
        };
const $593b7407307544bb$export$14f75d90d7dffdab = (editorAnalyticsAPI, getContextIdentifierProvider)=>(state, listType, inputMethod, addAndCreateList, addToList, listLocalId, itemLocalId, itemAttrs)=>{
        const { schema: schema } = state;
        const { list: list, item: item } = $593b7407307544bb$export$c8b7fdb74eb8fe5c(listType, schema);
        const { tr: tr } = state;
        const { $to: $to } = state.selection;
        const listNode = (0, $8m4tT.findParentNodeOfType)(list)(state.selection);
        const contextIdentifierProvider = getContextIdentifierProvider();
        const contextData = $593b7407307544bb$var$getContextData(contextIdentifierProvider);
        let insertTrCreator;
        let itemIdx;
        let listSize;
        if (!listNode) {
            // Not a list - convert to one.
            itemIdx = 0;
            listSize = 1;
            insertTrCreator = addAndCreateList;
        } else if ($to.node().textContent.length >= 0) {
            listSize = listNode.node.childCount + 1;
            listLocalId = listLocalId || listNode.node.attrs.localId;
            const listItemNode = (0, $8m4tT.findParentNodeOfType)(item)(state.selection); // finds current item in list
            itemIdx = listItemNode ? state.doc.resolve(listItemNode.pos).index() + 1 : 0;
            insertTrCreator = addToList ? addToList : addAndCreateList;
        }
        listLocalId = listLocalId || (0, $fO7hX.uuid).generate();
        itemLocalId = itemLocalId || (0, $fO7hX.uuid).generate();
        if (insertTrCreator) {
            const insertTr = insertTrCreator({
                state: state,
                tr: tr,
                list: list,
                item: item,
                listLocalId: listLocalId,
                itemLocalId: itemLocalId,
                itemAttrs: itemAttrs
            });
            if (insertTr) editorAnalyticsAPI?.attachAnalyticsEvent($593b7407307544bb$var$generateAnalyticsPayload(listType, contextData, inputMethod, itemLocalId, listLocalId, itemIdx || 0, listSize || 0))(insertTr);
            return insertTr;
        }
        return null;
    };
const $593b7407307544bb$export$f71b5a310965503b = (schema, selection)=>{
    const { paragraph: paragraph, blockquote: blockquote, decisionList: decisionList, taskList: taskList, bulletList: bulletList, numberedList: numberedList } = schema.nodes;
    return (0, $8m4tT.hasParentNodeOfType)([
        blockquote,
        paragraph,
        decisionList,
        taskList
    ])(selection) && !(0, $8m4tT.hasParentNodeOfType)([
        bulletList,
        numberedList
    ])(selection);
};
const $593b7407307544bb$export$eb5c8ff5b17fd36b = (before, after)=>after.depth - before.depth;
const $593b7407307544bb$export$e38ac211271d1c05 = (tr, list, item, schema, state, listLocalId = (0, $fO7hX.uuid).generate(), itemLocalId = (0, $fO7hX.uuid).generate(), itemAttrs)=>{
    const { selection: selection } = state;
    const { $from: $from, $to: $to } = selection;
    if ($from.parent !== $to.parent) // ignore selections across multiple nodes
    return null;
    const { paragraph: paragraph, blockquote: blockquote, decisionList: decisionList, taskList: taskList, decisionItem: decisionItem, taskItem: taskItem, mediaGroup: mediaGroup } = schema.nodes;
    if ($from.parent.type === mediaGroup) return null;
    const emptyList = list.create({
        localId: listLocalId
    }, [
        item.create({
            localId: itemLocalId,
            ...itemAttrs
        })
    ]);
    // we don't take the content of a block node next to the gap cursor and always create an empty task
    if (selection instanceof (0, $adhil.GapCursorSelection)) return (0, $8m4tT.safeInsert)(emptyList)(tr);
    // try to replace when selection is in nodes which support it
    if ($593b7407307544bb$export$f71b5a310965503b(schema, selection)) {
        const { type: nodeType, childCount: childCount } = selection.$from.node();
        const newListNode = list.create({
            localId: (0, $fO7hX.uuid).generate()
        }, [
            item.create({
                localId: (0, $fO7hX.uuid).generate()
            }, $from.node($from.depth).content)
        ]);
        const hasBlockquoteParent = (0, $8m4tT.findParentNodeOfType)(blockquote)(selection);
        if (hasBlockquoteParent) {
            const liftedDepth = $from.depth - 1;
            const range = new (0, $5SAOw.NodeRange)($from, $to, liftedDepth);
            tr.lift(range, (0, $aXG5V.liftTarget)(range));
        }
        const listParent = (0, $8m4tT.findParentNodeOfType)(taskList)(selection) || (0, $8m4tT.findParentNodeOfType)(decisionList)(selection);
        const listItem = (0, $8m4tT.findParentNodeOfType)(taskItem)(selection) || (0, $8m4tT.findParentNodeOfType)(decisionItem)(selection);
        // For a selection inside a task/decision list, we can't just simply replace the
        // node type as it will mess up lists with > 1 item
        if (listParent && listItem) {
            let start;
            let end;
            let selectionPos = selection.from;
            // if selection is in first item in list, we need to delete extra so that
            // this list isn't split
            if (listParent.node.firstChild === listItem.node) {
                start = listParent.start - 1;
                end = listItem.start + listItem.node.nodeSize;
                if (listParent.node.childCount === 1) end = listParent.start + listParent.node.nodeSize - 1;
            } else {
                start = listItem.start - 1;
                end = listItem.start + listItem.node.nodeSize;
                selectionPos += 2; // as we have added the new list node
            }
            tr.replaceWith(start, end, newListNode);
            tr = (0, $8m4tT.setTextSelection)(selectionPos)(tr);
            return tr;
        }
        // For a selection inside one of these node types we can just convert the node type
        const nodeTypesToReplace = [
            blockquote
        ];
        if (nodeType === paragraph && childCount > 0 || hasBlockquoteParent) // Only convert paragraphs containing content.
        // Empty paragraphs use the default flow.
        // This distinction ensures the text selection remains in the correct location.
        // We also want to replace the paragraph type when we are inside a blockQuote
        // to avoid inserting an extra taskList whilst keeping the paragraph
        nodeTypesToReplace.push(paragraph);
        let newTr = tr;
        newTr = (0, $8m4tT.replaceParentNodeOfType)(nodeTypesToReplace, newListNode)(tr);
        // Adjust depth for new selection, if it has changed (e.g. paragraph to list (ol > li))
        const depthAdjustment = $593b7407307544bb$export$eb5c8ff5b17fd36b($to, newTr.selection.$to);
        tr = tr.setSelection(new (0, $ks2lK.TextSelection)(tr.doc.resolve($to.pos + depthAdjustment)));
        // replacing successful
        if (newTr !== tr) return tr;
    }
    return (0, $8m4tT.safeInsert)(emptyList)(tr);
};
const $593b7407307544bb$export$1572b3eade6662f9 = (provider)=>(tr)=>{
        return tr.setMeta((0, $e74ddcb3d2085778$export$77b371d6becc8882), {
            action: (0, $c5154c0aaa7029e9$export$92a1a3b7554e9387).SET_PROVIDER,
            data: provider
        });
    };


const $ac4bed0eb4b2d5b6$var$createListRule = (editorAnalyticsAPI, getContextIdentifierProvider)=>(regex, listType, itemAttrs)=>{
        return (0, $l03WE.createRule)(regex, (state, _match, start, end)=>{
            const { paragraph: paragraph } = state.schema.nodes;
            const { list: list } = (0, $593b7407307544bb$export$c8b7fdb74eb8fe5c)(listType, state.schema);
            const $end = state.doc.resolve(end);
            const $endOfParent = state.doc.resolve($end.after());
            // Only allow creating list in nodes that support them.
            // Parent must be a paragraph as we don't want this applying to headings
            if ($end.parent.type !== paragraph || !(0, $8m4tT.canInsert)($endOfParent, list.createAndFill())) return null;
            const insertTr = (0, $593b7407307544bb$export$8c1bb617b1f6f2f1)(editorAnalyticsAPI, getContextIdentifierProvider)(state, listType, (0, $d925B.INPUT_METHOD).FORMATTING, $ac4bed0eb4b2d5b6$var$addItem(start, end), undefined, undefined, itemAttrs);
            return insertTr;
        });
    };
const $ac4bed0eb4b2d5b6$var$isCursorInsideList = ($pos)=>{
    return $pos.node($pos.depth - 1)?.type.name === 'listItem';
};
const $ac4bed0eb4b2d5b6$var$processShortcutForNestedTask = (content, $from, tr, list, item, listLocalId, itemLocalId, itemAttrs)=>{
    //Extracting the content into the 'contentWithoutShortcut' from 'content' after removing the keyboard shortcut text, i.e., '[] '.
    const contentWithoutShortcut = content.cut($from.pos - $from.start(), content.size);
    tr.insert($from.after(), list.create({
        localId: listLocalId
    }, [
        item.create({
            localId: itemLocalId,
            ...itemAttrs
        }, contentWithoutShortcut)
    ])).setSelection(new (0, $ks2lK.TextSelection)(tr.doc.resolve($from.after()))).delete($from.start(), $from.end());
};
const $ac4bed0eb4b2d5b6$var$addItem = (start, end)=>({ tr: tr, state: state, list: list, item: item, listLocalId: listLocalId, itemLocalId: itemLocalId, itemAttrs: itemAttrs })=>{
        const { selection: { $from: $from }, schema: schema } = state;
        const { hardBreak: hardBreak } = schema.nodes;
        const content = $from.node($from.depth).content;
        let shouldBreakNode = false;
        content.forEach((node, offset)=>{
            if (node.type === hardBreak && offset < start) shouldBreakNode = true;
        });
        if (!shouldBreakNode) {
            if ($ac4bed0eb4b2d5b6$var$isCursorInsideList($from)) {
                $ac4bed0eb4b2d5b6$var$processShortcutForNestedTask(content, $from, tr, list, item, listLocalId, itemLocalId, itemAttrs);
                return tr;
            }
            tr.replaceRangeWith($from.before(), $from.after(), list.create({
                localId: listLocalId
            }, [
                item.create({
                    localId: itemLocalId,
                    ...itemAttrs
                }, content)
            ])).delete(start + 1, end + 1).setSelection(new (0, $ks2lK.TextSelection)(tr.doc.resolve(start + 1)));
            return tr;
        }
        const depthAdjustment = (0, $593b7407307544bb$export$eb5c8ff5b17fd36b)($from, tr.selection.$from);
        tr.split($from.pos).setSelection(new (0, $ks2lK.NodeSelection)(tr.doc.resolve($from.pos + 1))).replaceSelectionWith(list.create({
            localId: listLocalId
        }, [
            item.create({
                localId: itemLocalId,
                ...itemAttrs
            }, tr.doc.nodeAt($from.pos + 1).content)
        ])).setSelection(new (0, $ks2lK.TextSelection)(tr.doc.resolve($from.pos + depthAdjustment))).delete(start, end + 1);
        return tr;
    };
const $ac4bed0eb4b2d5b6$export$568a7ed6897c4817 = (editorAnalyticsAPI, getContextIdentifierProvider)=>(schema, featureFlags)=>{
        const rules = [];
        const { decisionList: decisionList, decisionItem: decisionItem, taskList: taskList, taskItem: taskItem } = schema.nodes;
        if (decisionList && decisionItem) rules.push($ac4bed0eb4b2d5b6$var$createListRule(editorAnalyticsAPI, getContextIdentifierProvider)(// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        new RegExp(`(^|${(0, $14sLv.leafNodeReplacementCharacter)})\\<\\>\\s$`), 'decisionList'));
        if (taskList && taskItem) {
            rules.push($ac4bed0eb4b2d5b6$var$createListRule(editorAnalyticsAPI, getContextIdentifierProvider)(// Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            new RegExp(`(^|${(0, $14sLv.leafNodeReplacementCharacter)})\\[\\]\\s$`), 'taskList'));
            rules.push($ac4bed0eb4b2d5b6$var$createListRule(editorAnalyticsAPI, getContextIdentifierProvider)(// Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            new RegExp(`(^|${(0, $14sLv.leafNodeReplacementCharacter)})\\[x\\]\\s$`), 'taskList', {
                state: 'DONE'
            }));
        }
        return new (0, $1S4f7.SafePlugin)((0, $aIMBk.createPlugin)('tasks-and-decisions', rules, {
            isBlockNodeRule: true
        }));
    };
var $ac4bed0eb4b2d5b6$export$2e2bcd8739ae039 = $ac4bed0eb4b2d5b6$export$568a7ed6897c4817;







var $9YoeD = parcelRequire("9YoeD");




var $aU3dp = parcelRequire("aU3dp");


var $dAtrv = parcelRequire("dAtrv");


var $hgeg8 = parcelRequire("hgeg8");





var $e7tBw = parcelRequire("e7tBw");


var $astHL = parcelRequire("astHL");


var $dus6D = parcelRequire("dus6D");

















var $dhoHU = parcelRequire("dhoHU");






const $8a662c092cc6e62e$export$2837bcd4021a2a47 = (state, dispatch)=>{
    const normalizedSelection = (0, $e1b246d999b63af5$export$e590f1ae61640432)(state.selection);
    const { $from: $from, $to: $to } = normalizedSelection;
    const tr = (0, $2fc4254aeefcece8$export$b4043a93b6a561c9)(state.tr, $from, $to);
    if (dispatch && tr) dispatch(tr);
    return !!tr;
};
const $8a662c092cc6e62e$export$b9f50dd5ccd0f20 = (state, dispatch)=>{
    const { $from: $from, $to: $to } = (0, $e1b246d999b63af5$export$e590f1ae61640432)(state.selection);
    // limit ui indentation to 6 levels
    const { taskList: taskList, taskItem: taskItem, blockTaskItem: blockTaskItem } = state.schema.nodes;
    let maxDepth = (0, $2fc4254aeefcece8$export$59958047ba34fe83)($from, $to, [
        taskList,
        taskItem
    ]);
    if (blockTaskItem) {
        const resultOfFindBlockTaskItem = (0, $e1b246d999b63af5$export$11f4e85d86397169)($from);
        if (resultOfFindBlockTaskItem) {
            const { hasParagraph: hasParagraph } = resultOfFindBlockTaskItem;
            // If the selection is inside a nested node inside the blockTaskItem
            // Remove the difference in depth between the selection and the blockTaskItemNode
            if (hasParagraph) maxDepth = (0, $2fc4254aeefcece8$export$59958047ba34fe83)($from, $to, [
                taskList,
                blockTaskItem
            ]) - 1;
            else maxDepth = (0, $2fc4254aeefcece8$export$59958047ba34fe83)($from, $to, [
                taskList,
                blockTaskItem
            ]);
        }
    }
    if (maxDepth >= 6) return true;
    const blockRange = (0, $2fc4254aeefcece8$export$f029cbac7e0ab14c)({
        $from: $from,
        $to: $to
    });
    if (!blockRange) return true;
    const wrapping = (0, $aXG5V.findWrapping)(blockRange, state.schema.nodes.taskList);
    if (!wrapping) return true;
    if (dispatch) dispatch(state.tr.wrap(blockRange, wrapping).scrollIntoView());
    return true;
};
const $8a662c092cc6e62e$export$3553eb36282f092b = ($pos)=>(state, dispatch)=>{
        const $cut = (0, $dhoHU.findCutBefore)($pos);
        const { blockTaskItem: blockTaskItem } = state.schema.nodes;
        if (!$cut) return false;
        const { paragraph: paragraph } = $cut.doc.type.schema.nodes;
        // find the boundary between the taskList and paragraph
        if ($cut.nodeBefore && (0, $2fc4254aeefcece8$export$6f0e2eafb461f634)($cut.nodeBefore) && $cut.nodeAfter && $cut.nodeAfter.type === paragraph) {
            // we'll find the boundary of a taskList
            // so resolve -1 to find the inside end of the last taskItem
            let $lastNode = $cut.doc.resolve($cut.pos - 1);
            // might have deeply nested taskList, keep trying to find it
            while(!(0, $2fc4254aeefcece8$export$93c6d1f260b6c095)($lastNode.parent))$lastNode = state.doc.resolve($lastNode.pos - 1);
            // grab the structure between the taskItem and the paragraph
            // note: structure = true in ReplaceAroundStep
            let slice = state.tr.doc.slice($lastNode.pos, $cut.pos);
            let from = $lastNode.pos;
            const to = $cut.pos + $cut.nodeAfter.nodeSize;
            let gapFrom = $cut.pos + 1;
            let gapTo = $cut.pos + $cut.nodeAfter.nodeSize - 1;
            const insert = 0;
            if (blockTaskItem) {
                if ($lastNode.parent.type === blockTaskItem) {
                    const childOfLastNode = state.doc.resolve($lastNode.pos - 1);
                    if (childOfLastNode.parent.type === paragraph) {
                        // Recalculate the slice to include the full blockTaskItem structure
                        slice = state.tr.doc.slice(childOfLastNode.pos, $cut.pos);
                        // Need to move one pos in to get to the text node of the paragraph
                        from = $lastNode.pos - 1;
                    } else {
                        // If the blockTaskItem last node is not a paragraph
                        // Expand the gap to include the paragraph being merged
                        gapFrom = $cut.pos; // To get the actual paragraph node
                        gapTo = $cut.pos + $cut.nodeAfter.nodeSize - 1;
                    }
                }
            }
            // collapse the range between end of last taskItem and after the paragraph
            // with the gap being the paragraph's content (i.e. take that content)
            //
            // we pass the structure we found earlier to join the p and taskItem nodes
            //
            // see https://prosemirror.net/docs/ref/#transform.ReplaceStep.constructor
            // see https://prosemirror.net/docs/ref/#transform.ReplaceAroundStep.constructor
            const tr = state.tr.step(new (0, $aXG5V.ReplaceAroundStep)(from, to, gapFrom, gapTo, slice, insert, true));
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };








var $4FFjp = parcelRequire("4FFjp");

var $iD5M5 = parcelRequire("iD5M5");










const $2b7d7c8d49850f96$export$2e48e3ea1c210731 = (targetType = 'paragraph')=>({ tr: tr })=>{
        const { nodes: nodes } = tr.doc.type.schema;
        const { selection: selection } = tr;
        // Handle empty selection: insert a new task item
        if ((0, $dh538.fg)('platform_editor_toolbar_aifc_ga_blockers')) {
            const { $from: $from } = selection;
            const isEmpty = $from.parent.content.size === 0;
            if (isEmpty && nodes.taskList && nodes.taskItem) {
                // Create an empty task list with one empty task item
                const listLocalId = (0, $fO7hX.uuid).generate();
                const itemLocalId = (0, $fO7hX.uuid).generate();
                const emptyList = nodes.taskList.create({
                    localId: listLocalId
                }, [
                    nodes.taskItem.create({
                        localId: itemLocalId
                    })
                ]);
                // Insert the empty list at the current selection
                const insertTr = (0, $8m4tT.safeInsert)(emptyList)(tr);
                if (insertTr !== tr) {
                    // Set cursor inside the new task item
                    const insertPos = insertTr.selection.$from.pos;
                    return insertTr.setSelection((0, $ks2lK.TextSelection).near(insertTr.doc.resolve(insertPos)));
                }
            }
        }
        const { node: node, pos: pos } = (0, $4FFjp.getFormattedNode)(tr);
        if (node !== null && pos !== null) {
            if ((0, $iD5M5.isBulletOrOrderedList)(node.type)) {
                const context = {
                    sourceNode: node,
                    sourcePos: pos,
                    targetNodeType: nodes.taskList,
                    tr: tr
                };
                return (0, $4FFjp.transformBetweenListTypes)(context);
            }
            if ((0, $iD5M5.isTaskList)(node.type)) {
                const context = {
                    sourceNode: node,
                    sourcePos: pos,
                    targetNodeType: nodes[targetType],
                    tr: tr
                };
                return targetType === 'paragraph' ? (0, $4FFjp.transformTaskListToBlockNodes)(context) : (0, $4FFjp.transformBetweenListTypes)(context);
            }
            const { $from: $from, $to: $to } = selection;
            const range = $from.blockRange($to);
            if (range) return (0, $4FFjp.transformToTaskList)(tr, range, nodes.taskList, undefined, nodes);
        }
        return tr;
    };



const $2da1bf346dcac0f3$var$indentationAnalytics = (curIndentLevel, direction, inputMethod)=>({
        action: (0, $d925B.ACTION).FORMATTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_INDENT,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: inputMethod,
            previousIndentationLevel: curIndentLevel,
            newIndentLevel: direction === (0, $aU3dp.INDENT_DIRECTION).OUTDENT ? curIndentLevel - 1 : curIndentLevel + 1,
            direction: direction,
            indentType: (0, $aU3dp.INDENT_TYPE).TASK_LIST
        }
    });
const $2da1bf346dcac0f3$var$nodeAfter = ($pos)=>$pos.doc.resolve($pos.end()).nodeAfter;
const $2da1bf346dcac0f3$var$actionDecisionFollowsOrNothing = ($pos)=>{
    const after = $2da1bf346dcac0f3$var$nodeAfter($pos);
    return !after || (0, $2fc4254aeefcece8$export$93c6d1f260b6c095)(after);
};
const $2da1bf346dcac0f3$var$joinTaskDecisionFollowing = (state, dispatch)=>{
    // only run if selection is at end of text, and inside a task or decision item
    if (!(0, $e7tBw.isEmptySelectionAtEnd)(state) || !(0, $2fc4254aeefcece8$export$c4942fd0ddcad0b)(state) || !dispatch) return false;
    // look for the node after this current one
    const $next = (0, $2fc4254aeefcece8$export$cd30871533411394)(state.selection.$from);
    // if there's no taskItem or taskList following, then
    // we just do the normal behaviour
    const { taskList: taskList, taskItem: taskItem, decisionList: decisionList, decisionItem: decisionItem, paragraph: paragraph, bulletList: bulletList, orderedList: orderedList, listItem: listItem } = state.schema.nodes;
    const parentList = (0, $8m4tT.findParentNodeOfTypeClosestToPos)($next, [
        taskList,
        taskItem,
        decisionList,
        decisionItem
    ]);
    if (!parentList) {
        if ($next.parent.type === paragraph) // try to join paragraph and taskList when backspacing
        return (0, $8a662c092cc6e62e$export$3553eb36282f092b)($next.doc.resolve($next.pos))(state, dispatch);
        // If the item we are joining is a list
        if ($next.parent.type === bulletList || $next.parent.type === orderedList) // If the list has an item
        {
            if ($next.parent.firstChild && $next.parent.firstChild.type === listItem) {
                // Place the cursor at the first listItem
                const resolvedStartPos = state.doc.resolve($next.pos + 1);
                // Unindent the first listItem.
                // As if placing your cursor just after the first dot of the list (before the text)
                // and pressing Shift-Tab.
                const tr = (0, $2fc4254aeefcece8$export$b4043a93b6a561c9)(state.tr, resolvedStartPos, resolvedStartPos);
                // If autoJoin not used, two ul/ol elements appear rather than one with multiple li elements
                return (0, $astHL.autoJoin)((state, dispatch)=>{
                    if (tr) {
                        if (dispatch) dispatch(tr);
                        return true;
                    }
                    return false;
                }, [
                    'bulletList',
                    'orderedList'
                ])(state, dispatch);
            }
        }
    }
    return false;
};
const $2da1bf346dcac0f3$export$d5d1010fad3453fa = (editorAnalyticsAPI)=>(inputMethod = (0, $d925B.INPUT_METHOD).KEYBOARD)=>(0, $e7tBw.filterCommand)((0, $2fc4254aeefcece8$export$2fad51fb9cb5e2d1), (state, dispatch)=>{
            const normalizedSelection = (0, $e1b246d999b63af5$export$e590f1ae61640432)(state.selection);
            const curIndentLevel = (0, $2fc4254aeefcece8$export$d75a55aec79aaa5)(normalizedSelection);
            if (!curIndentLevel || curIndentLevel === 1) return false;
            return (0, $dAtrv.withAnalytics)(editorAnalyticsAPI, $2da1bf346dcac0f3$var$indentationAnalytics(curIndentLevel, (0, $aU3dp.INDENT_DIRECTION).OUTDENT, inputMethod))((0, $astHL.autoJoin)((0, $8a662c092cc6e62e$export$2837bcd4021a2a47), [
                'taskList'
            ]))(state, dispatch);
        });
// if selection is decision item or first action item in table cell
// then dont consume the Tab, as table-keymap should tab to the next cell
const $2da1bf346dcac0f3$var$shouldLetTabThroughInTable = (state)=>{
    const curIndentLevel = (0, $2fc4254aeefcece8$export$d75a55aec79aaa5)(state.selection);
    const curIndex = (0, $2fc4254aeefcece8$export$af0098af8462419f)(state);
    const { tableCell: tableCell, tableHeader: tableHeader } = state.schema.nodes;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const cell = (0, $8m4tT.findParentNodeOfType)([
        tableCell,
        tableHeader
    ])(state.selection);
    if ((curIndentLevel === 1 && curIndex === 0 || (0, $2fc4254aeefcece8$export$cc187e317961fba)(state)) && cell) return true;
    return false;
};
const $2da1bf346dcac0f3$export$b294289254b8cdac = (editorAnalyticsAPI)=>(inputMethod = (0, $d925B.INPUT_METHOD).KEYBOARD)=>(0, $e7tBw.filterCommand)((0, $2fc4254aeefcece8$export$2fad51fb9cb5e2d1), (state, dispatch)=>{
            const normalizedSelection = (0, $e1b246d999b63af5$export$e590f1ae61640432)(state.selection);
            const curIndentLevel = (0, $2fc4254aeefcece8$export$d75a55aec79aaa5)(normalizedSelection);
            if (!curIndentLevel || curIndentLevel >= 6) return true;
            return (0, $dAtrv.withAnalytics)(editorAnalyticsAPI, $2da1bf346dcac0f3$var$indentationAnalytics(curIndentLevel, (0, $aU3dp.INDENT_DIRECTION).INDENT, inputMethod))((0, $astHL.autoJoin)((0, $8a662c092cc6e62e$export$b9f50dd5ccd0f20), [
                'taskList'
            ]))(state, dispatch);
        });
const $2da1bf346dcac0f3$var$backspaceFrom = (editorAnalyticsAPI)=>($from)=>(state, dispatch)=>{
            const { taskList: taskList, blockTaskItem: blockTaskItem, paragraph: paragraph } = state.schema.nodes;
            if ((0, $1oCLl.expValEquals)('editor_refactor_backspace_task_and_decisions', 'isEnabled', true)) {
                // Check if selection is inside a blockTaskItem paragraph
                const resultOfFindBlockTaskItem = (0, $e1b246d999b63af5$export$11f4e85d86397169)($from);
                const isInBlockTaskItemParagraph = resultOfFindBlockTaskItem && resultOfFindBlockTaskItem?.hasParagraph;
                // Get the node before the current position
                const beforePos = isInBlockTaskItemParagraph ? $from.before() - 1 : $from.before();
                const nodeBefore = $from.doc.resolve(beforePos).nodeBefore;
                // Check if the node before is an empty task item
                const isEmptyActionOrDecisionItem = nodeBefore && (0, $2fc4254aeefcece8$export$93c6d1f260b6c095)(nodeBefore) && nodeBefore.content.size === 0;
                const isEmptyBlockTaskItem = blockTaskItem && nodeBefore?.type === blockTaskItem && nodeBefore?.firstChild?.type === paragraph && nodeBefore?.firstChild?.content?.size === 0;
                // previous was empty, just delete backwards
                if (isEmptyActionOrDecisionItem || isEmptyBlockTaskItem) return false;
                // If nested in a taskList, unindent
                const depthFromSelectionToBlockTaskItem = isInBlockTaskItemParagraph ? 2 : 1;
                const depthFromSelectionToNestedTaskList = depthFromSelectionToBlockTaskItem + 1;
                const parentDepth = $from.depth - depthFromSelectionToNestedTaskList;
                if ($from.node(parentDepth).type === taskList) return $2da1bf346dcac0f3$export$d5d1010fad3453fa(editorAnalyticsAPI)()(state, dispatch);
                // If at the end of an item, unwrap contents into a paragraph
                // we achieve this by slicing the content out, and replacing
                if ($2da1bf346dcac0f3$var$actionDecisionFollowsOrNothing($from)) {
                    if (dispatch) {
                        // If we are in a blockTaskItem paragraph, we need to get the content of the whole blockTaskItem
                        // So we reduce the depth by 1 to get to the blockTaskItem node content
                        const taskContent = isInBlockTaskItemParagraph ? state.doc.slice($from.start($from.depth - 1), $from.end($from.depth - 1)).content : state.doc.slice($from.start(), $from.end()).content;
                        let slice;
                        try {
                            slice = taskContent.size ? paragraph.createChecked(undefined, taskContent) : paragraph.createChecked();
                            // might be end of document after
                            const tr = $2da1bf346dcac0f3$var$splitListItemWith(state.tr, slice, $from, true);
                            dispatch(tr);
                            return true;
                        } catch (error) {
                            // If there's an error creating a paragraph, check if we are in a blockTaskItem
                            // Block task item's can have non-text content that cannot be wrapped in a paragraph
                            // So if the selection is in a blockTaskItem, just pass the content as is
                            if (resultOfFindBlockTaskItem && resultOfFindBlockTaskItem.blockTaskItemNode) {
                                // Create an array from the fragment to pass into splitListItemWith, as the `content` property is readonly
                                slice = Array.from(taskContent.content);
                                const tr = $2da1bf346dcac0f3$var$splitListItemWith(state.tr, slice, $from, true);
                                dispatch(tr);
                                return true;
                            }
                        }
                    }
                }
            } else {
                // previous was empty, just delete backwards
                const taskBefore = $from.doc.resolve($from.before());
                if (taskBefore.nodeBefore && (0, $2fc4254aeefcece8$export$93c6d1f260b6c095)(taskBefore.nodeBefore) && taskBefore.nodeBefore.nodeSize === 2) return false;
                // if nested, just unindent
                if ($from.node($from.depth - 2).type === taskList) return $2da1bf346dcac0f3$export$d5d1010fad3453fa(editorAnalyticsAPI)()(state, dispatch);
                // If at the end of an item, unwrap contents into a paragraph
                // we achieve this by slicing the content out, and replacing
                if ($2da1bf346dcac0f3$var$actionDecisionFollowsOrNothing($from)) {
                    if (dispatch) {
                        const taskContent = state.doc.slice($from.start(), $from.end()).content;
                        let slice;
                        try {
                            slice = taskContent.size ? paragraph.createChecked(undefined, taskContent) : paragraph.createChecked();
                            // might be end of document after
                            const tr = $2da1bf346dcac0f3$var$splitListItemWith(state.tr, slice, $from, true);
                            dispatch(tr);
                            return true;
                        } catch (error) {
                            // If there's an error creating a paragraph, then just pass the content as is
                            // Block task item's can have non-text content that cannot be wrapped in a paragraph
                            if (blockTaskItem) {
                                // Create an array from the fragment to pass into splitListItemWith, as the `content` property is readonly
                                slice = Array.from(taskContent.content);
                                const tr = $2da1bf346dcac0f3$var$splitListItemWith(state.tr, slice, $from, true);
                                dispatch(tr);
                                return true;
                            }
                        }
                    }
                }
            }
            return false;
        };
const $2da1bf346dcac0f3$var$backspace = (editorAnalyticsAPI)=>(0, $e7tBw.filterCommand)((0, $e7tBw.isEmptySelectionAtStart), (0, $astHL.autoJoin)((0, $astHL.chainCommands)((state, dispatch)=>(0, $8a662c092cc6e62e$export$3553eb36282f092b)(state.selection.$from)(state, dispatch), (0, $e7tBw.filterCommand)((0, $2fc4254aeefcece8$export$c4942fd0ddcad0b), (state, dispatch)=>$2da1bf346dcac0f3$var$backspaceFrom(editorAnalyticsAPI)(state.selection.$from)(state, dispatch))), [
        'taskList',
        'decisionList'
    ]));
const $2da1bf346dcac0f3$var$unindentTaskOrUnwrapTaskDecisionFollowing = (state, dispatch)=>{
    const { selection: { $from: $from }, schema: { nodes: { taskList: taskList, doc: doc, paragraph: paragraph, blockTaskItem: blockTaskItem, taskItem: taskItem } }, tr: tr } = state;
    if ((0, $dh538.fg)('platform_editor_blocktaskitem_patch_3')) {
        // only run if cursor is at the end of the node
        if (!(0, $e7tBw.isEmptySelectionAtEnd)(state) || !dispatch) return false;
        // look for the node after this current one
        const $next = (0, $2fc4254aeefcece8$export$cd30871533411394)($from);
        // this is a top-level node it wont have $next.before()
        if (!$next.parent || $next.parent.type === doc) return false;
        // get resolved position of parent
        const $parentPos = $from.doc.resolve($from.start($from.depth - 1));
        const currentNode = $from.node();
        const parentNode = $parentPos.node();
        // if current position isn't an action or decision item, return false
        if (!(0, $2fc4254aeefcece8$export$93c6d1f260b6c095)(currentNode) && !(0, $2fc4254aeefcece8$export$93c6d1f260b6c095)(parentNode)) return false;
        const resultOfCurrentFindBlockTaskItem = (0, $e1b246d999b63af5$export$11f4e85d86397169)($next);
        let isCurrentEmptyBlockTaskItem = false;
        if (resultOfCurrentFindBlockTaskItem) {
            const { blockTaskItemNode: blockTaskItemNode } = resultOfCurrentFindBlockTaskItem;
            isCurrentEmptyBlockTaskItem = blockTaskItem && blockTaskItemNode && blockTaskItemNode.childCount === 1 && blockTaskItemNode.firstChild?.type === paragraph && blockTaskItemNode.firstChild.childCount === 0;
        }
        const isEmptyActionOrDecisionItem = currentNode && (0, $2fc4254aeefcece8$export$93c6d1f260b6c095)(currentNode) && currentNode.childCount === 0;
        // If empty item, use default handler
        if (isEmptyActionOrDecisionItem || isCurrentEmptyBlockTaskItem) return false;
        // Check if next node is a blockTaskItem paragraph
        const resultOfNextFindBlockTaskItem = (0, $e1b246d999b63af5$export$11f4e85d86397169)($next);
        const isNextInBlockTaskItemParagraph = resultOfNextFindBlockTaskItem && resultOfNextFindBlockTaskItem?.hasParagraph;
        // if nested, just unindent
        if ($next.node($next.depth - 2).type === taskList || // this is for the case when we are on a non-nested item and next one is nested
        $next.node($next.depth - 1).type === taskList && $next.parent.type === taskList) {
            (0, $2fc4254aeefcece8$export$b4043a93b6a561c9)(tr, $next, $next);
            dispatch(tr);
            return true;
        }
        const isNextCompatibleWithBlockTaskItem = blockTaskItem && ($next?.node()?.type === taskItem && $from?.node()?.type === blockTaskItem || $next?.node()?.type === blockTaskItem && $from?.node()?.type === taskItem || [
            taskItem,
            blockTaskItem
        ].includes($next?.node()?.type) && resultOfCurrentFindBlockTaskItem && resultOfCurrentFindBlockTaskItem.blockTaskItemNode);
        // if next node is of same type or compatible type, remove the node wrapping and create paragraph
        if (!(0, $2fc4254aeefcece8$export$567a2801b8f40ab5)($next.nodeAfter) && (0, $2fc4254aeefcece8$export$93c6d1f260b6c095)($from.parent) || resultOfCurrentFindBlockTaskItem && resultOfCurrentFindBlockTaskItem.blockTaskItemNode && $2da1bf346dcac0f3$var$actionDecisionFollowsOrNothing($from) && // only forward delete if the node is same type or compatible
        ($next.node().type.name === $from.node().type.name || isNextCompatibleWithBlockTaskItem)) {
            if (dispatch) {
                // If next node is in a blockTaskItem paragraph, we need to get the content of the whole blockTaskItem
                // So we reduce the depth by 1 to get to the blockTaskItem node content
                const taskContent = isNextInBlockTaskItemParagraph ? state.doc.slice($next.start($next.depth - 1), $next.end($next.depth - 1)).content : state.doc.slice($next.start(), $next.end()).content;
                let slice;
                try {
                    slice = taskContent.size ? paragraph.createChecked(undefined, taskContent) : paragraph.createChecked();
                    // might be end of document after
                    const tr = $2da1bf346dcac0f3$var$splitListItemWith(state.tr, slice, $next, false);
                    dispatch(tr);
                    return true;
                } catch (error) {
                    // If there's an error creating a paragraph, check if we are in a blockTaskItem
                    // Block task item's can have non-text content that cannot be wrapped in a paragraph
                    // So if the selection is in a blockTaskItem, just pass the content as is
                    if (resultOfNextFindBlockTaskItem && resultOfNextFindBlockTaskItem.blockTaskItemNode) {
                        // Create an array from the fragment to pass into splitListItemWith, as the `content` property is readonly
                        slice = Array.from(taskContent.content);
                        let $splitPos = $next;
                        if ($next.node().firstChild?.isTextblock) // set $next to the resolved position of inside the textblock
                        $splitPos = $next.doc.resolve($next.pos + 1);
                        const tr = $2da1bf346dcac0f3$var$splitListItemWith(state.tr, slice, $splitPos, false);
                        dispatch(tr);
                        return true;
                    }
                }
            }
        }
    } else {
        // only run if cursor is at the end of the node
        if (!(0, $e7tBw.isEmptySelectionAtEnd)(state) || !dispatch) return false;
        // look for the node after this current one
        const $next = (0, $2fc4254aeefcece8$export$cd30871533411394)($from);
        // this is a top-level node it wont have $next.before()
        if (!$next.parent || $next.parent.type === doc) return false;
        // if nested, just unindent
        if ($next.node($next.depth - 2).type === taskList || // this is for the case when we are on a non-nested item and next one is nested
        $next.node($next.depth - 1).type === taskList && $next.parent.type === taskList) {
            (0, $2fc4254aeefcece8$export$b4043a93b6a561c9)(tr, $next, $next);
            dispatch(tr);
            return true;
        }
        // if next node is of same type, remove the node wrapping and create paragraph
        if (!(0, $2fc4254aeefcece8$export$567a2801b8f40ab5)($next.nodeAfter) && (0, $2fc4254aeefcece8$export$93c6d1f260b6c095)($from.parent) && $2da1bf346dcac0f3$var$actionDecisionFollowsOrNothing($from) && // only forward delete if the node is same type
        $next.node().type.name === $from.node().type.name) {
            const taskContent = state.doc.slice($next.start(), $next.end()).content;
            // might be end of document after
            const slice = taskContent.size ? paragraph.createChecked(undefined, taskContent) : [];
            dispatch($2da1bf346dcac0f3$var$splitListItemWith(tr, slice, $next, false));
            return true;
        }
    }
    return false;
};
const $2da1bf346dcac0f3$var$deleteForwards = (0, $astHL.autoJoin)((0, $astHL.chainCommands)((0, $e7tBw.deleteEmptyParagraphAndMoveBlockUp)((0, $2fc4254aeefcece8$export$6f0e2eafb461f634)), $2da1bf346dcac0f3$var$joinTaskDecisionFollowing, $2da1bf346dcac0f3$var$unindentTaskOrUnwrapTaskDecisionFollowing), [
    'taskList',
    'decisionList'
]);
const $2da1bf346dcac0f3$var$deleteExtraListItem = (tr, $from)=>{
    /*
    After we replace actionItem with empty list item if there's the anomaly of extra empty list item
    the cursor moves inside the first taskItem of splitted taskList
    so the extra list item present above the list item containing taskList & cursor
  */ const $currentFrom = tr.selection.$from;
    const listItemContainingActionList = tr.doc.resolve($currentFrom.start($currentFrom.depth - 2));
    const emptyListItem = tr.doc.resolve(listItemContainingActionList.before() - 1);
    tr.delete(emptyListItem.start(), listItemContainingActionList.pos);
};
const $2da1bf346dcac0f3$var$processNestedActionItem = (tr, $from, previousListItemPos)=>{
    const parentListNode = (0, $2fc4254aeefcece8$export$cd0bf0d386a8d5a7)($from);
    const previousChildCountOfList = parentListNode?.node.childCount;
    const currentParentListNode = (0, $2fc4254aeefcece8$export$cd0bf0d386a8d5a7)(tr.doc.resolve(tr.mapping.map($from.pos)));
    const currentChildCountOfList = currentParentListNode?.node.childCount;
    /*
    While replacing range with empty list item an extra list item gets created in some of the scenarios
    After splitting only one extra listItem should be created else an extra listItem is created
  */ if (previousChildCountOfList && currentChildCountOfList && previousChildCountOfList + 1 !== currentChildCountOfList) $2da1bf346dcac0f3$var$deleteExtraListItem(tr, $from);
    // Set custom selection for nested action inside lists using previosuly calculated previousListItem position
    const stableResolvedPos = tr.doc.resolve(previousListItemPos);
    tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, stableResolvedPos.after() + 2));
};
const $2da1bf346dcac0f3$var$splitListItemWith = (tr, content, $from, setSelection)=>{
    const origDoc = tr.doc;
    const { blockTaskItem: blockTaskItem, taskList: taskList } = tr.doc.type.schema.nodes;
    let baseDepth = $from.depth;
    let $oldAfter = origDoc.resolve($from.after());
    let textSelectionModifier = 0;
    let replaceFromModifier = 0;
    let deleteBlockModifier = 0;
    let shouldSplitBlockTaskItem = true;
    let isGapCursorSelection = false;
    let hasBlockTaskItem = false;
    if (blockTaskItem) {
        const result = (0, $e1b246d999b63af5$export$11f4e85d86397169)($from);
        if (result) {
            const { blockTaskItemNode: blockTaskItemNode, hasParagraph: hasParagraph } = result;
            hasBlockTaskItem = (0, $dh538.fg)('platform_editor_blocktaskitem_patch_3') && !!blockTaskItemNode;
            if (blockTaskItemNode) {
                // If the case there is a paragraph in the block task item we need to
                // adjust some calculations
                if (hasParagraph) {
                    baseDepth = $from.depth - 1;
                    $oldAfter = origDoc.resolve($from.after(baseDepth));
                    // When we're removing the extra empty task item we need to reduce the range a bit
                    deleteBlockModifier = 1;
                } else {
                    textSelectionModifier = 1;
                    isGapCursorSelection = true;
                }
                textSelectionModifier = 1;
                const hasSiblingTaskList = $oldAfter.nodeAfter?.type === taskList;
                if (hasSiblingTaskList) // Don't use the split command if there is a sibling taskList
                shouldSplitBlockTaskItem = false;
                const posPreviousSibling = $from.start(hasParagraph ? $from.depth - 1 : $from.depth) - 1;
                const $posPreviousSibling = tr.doc.resolve(posPreviousSibling);
                const hasPreviousTaskItem = $posPreviousSibling.nodeBefore?.type === blockTaskItem;
                if (hasPreviousTaskItem && hasParagraph) replaceFromModifier = 1;
            }
        }
    }
    // split just before the current item
    // we can only split if there was a list item before us
    const container = $from.node(baseDepth - 2);
    const posInList = $from.index(baseDepth - 1);
    const shouldSplit = !(!(0, $2fc4254aeefcece8$export$6f0e2eafb461f634)(container) && posInList === 0) && shouldSplitBlockTaskItem;
    const frag = (0, $5SAOw.Fragment).from(content);
    const isNestedActionInsideLists = frag.childCount === 1 && frag.firstChild?.type.name === 'listItem';
    /*
	 * We don't split the list item if it's nested inside lists
	 * to have consistent behaviour and their resolution.
	 */ if (shouldSplit && !isNestedActionInsideLists) // this only splits a node to delete it, so we probably don't need a random uuid
    // but generate one anyway for correctness
    tr = tr.split($from.pos, // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $dh538.fg)('platform_editor_blocktaskitem_patch_3') && hasBlockTaskItem ? 0 : 1, [
        {
            type: $from.parent.type,
            attrs: {
                localId: (0, $fO7hX.uuid).generate()
            }
        }
    ]);
    /*
	 * In case of nested action inside lists we explicitly set the cursor
	 * We need to insert it relatively to previous doc structure
	 * So we calculate the position of previous list item and save that position
	 * (The cursor can be placed easily next to list item)
	 */ const previousListItemPos = isNestedActionInsideLists ? $from.start(baseDepth - 2) : 0;
    tr = tr.replace(tr.mapping.map($from.start(baseDepth) - 2 + replaceFromModifier), tr.mapping.map($from.end(baseDepth) + 2), frag.size ? new (0, $5SAOw.Slice)(frag, 0, 0) : (0, $5SAOw.Slice).empty);
    if (setSelection && !isNestedActionInsideLists) {
        const newPos = $from.pos + 1 - ((shouldSplit ? 0 : 2) + textSelectionModifier);
        if (isGapCursorSelection) tr = tr.setSelection(new (0, $adhil.GapCursorSelection)(tr.doc.resolve(newPos), (0, $adhil.Side).LEFT));
        else tr = tr.setSelection(new (0, $ks2lK.TextSelection)(tr.doc.resolve(newPos)));
    }
    // if different levels then we shouldn't lift
    if ($oldAfter.depth === baseDepth - 1) {
        if ($oldAfter.nodeAfter && (0, $2fc4254aeefcece8$export$6f0e2eafb461f634)($oldAfter.nodeAfter)) {
            // getBlockRange expects to be inside the taskItem
            const pos = tr.mapping.map($oldAfter.pos + 2);
            const $after = tr.doc.resolve(pos);
            const blockRange = (0, $2fc4254aeefcece8$export$f029cbac7e0ab14c)({
                $from: $after,
                $to: tr.doc.resolve($after.after($after.depth - 1) - 1)
            });
            if (blockRange) tr = tr.lift(blockRange, blockRange.depth - 1).scrollIntoView();
            // After replacing the range there is an empty task item that
            // we need to remove.
            // We delete 1 past the range of the empty taskItem
            // otherwise we hit a bug in prosemirror-transform:
            // Cannot read property 'content' of undefined
            // If this operation was done on a blockTaskItem we
            // have a modifier for the position
            tr = tr.deleteRange(pos - 3 - deleteBlockModifier, pos - 1 - deleteBlockModifier);
        }
    }
    if (isNestedActionInsideLists) $2da1bf346dcac0f3$var$processNestedActionItem(tr, $from, previousListItemPos);
    return tr;
};
const $2da1bf346dcac0f3$var$creatParentListItemFragement = (state)=>{
    return state.schema.nodes.listItem.create({}, state.schema.nodes.paragraph.create());
};
const $2da1bf346dcac0f3$var$splitListItem = (state, dispatch)=>{
    const { tr: tr, selection: { $from: $from } } = state;
    const { listItem: listItem, blockTaskItem: blockTaskItem, taskItem: taskItem, paragraph: paragraph } = state.schema.nodes;
    if ($2da1bf346dcac0f3$var$actionDecisionFollowsOrNothing($from)) {
        if (dispatch) {
            if ((0, $dh538.fg)('platform_editor_blocktaskitem_patch_3')) {
                // If previous node is a blockTaskItem we just want to delete the existing node and replace it with a paragraph
                const nodeBefore = state.doc.resolve($from.pos - 1).nodeBefore;
                if (blockTaskItem && nodeBefore?.type === blockTaskItem) {
                    if ($from.parent.type === taskItem) {
                        const nodeSize = $from.parent.nodeSize;
                        tr.delete($from.pos - Math.floor(nodeSize / 2), $from.pos + Math.ceil(nodeSize / 2));
                        tr.insert($from.pos, paragraph.createChecked());
                        dispatch(tr);
                        return true;
                    }
                }
            }
            if ((0, $8m4tT.hasParentNodeOfType)(listItem)(tr.selection)) {
                // if we're inside a list item, then we pass in a fragment containing a new list item not a paragraph
                dispatch($2da1bf346dcac0f3$var$splitListItemWith(tr, $2da1bf346dcac0f3$var$creatParentListItemFragement(state), $from, true));
                return true;
            }
            dispatch($2da1bf346dcac0f3$var$splitListItemWith(tr, paragraph.createChecked(), $from, true));
        }
        return true;
    }
    return false;
};
const $2da1bf346dcac0f3$var$enter = (editorAnalyticsAPI, getContextIdentifier)=>(0, $e7tBw.filterCommand)((0, $2fc4254aeefcece8$export$c4942fd0ddcad0b), (0, $astHL.chainCommands)((0, $e7tBw.filterCommand)((0, $2fc4254aeefcece8$export$e29ace8e645e5684), (0, $astHL.chainCommands)($2da1bf346dcac0f3$export$d5d1010fad3453fa(editorAnalyticsAPI)(), $2da1bf346dcac0f3$var$splitListItem)), (state, dispatch)=>{
        const { selection: selection, schema: schema } = state;
        const { decisionItem: decisionItem, taskItem: taskItem, blockTaskItem: blockTaskItem } = schema.nodes;
        const { $from: $from, $to: $to } = selection;
        const node = $from.node($from.depth);
        let nodeType = node && node.type;
        // Get the parent node type if the current node type is not one of the task or decision items
        // This is required to handle blockTaskItem
        if (![
            decisionItem,
            taskItem,
            blockTaskItem
        ].includes(nodeType)) {
            const possibleNodeType = (0, $8m4tT.findParentNodeOfType)([
                decisionItem,
                taskItem,
                blockTaskItem
            ])(selection)?.node?.type;
            if (possibleNodeType) nodeType = possibleNodeType;
        }
        const listType = [
            taskItem,
            blockTaskItem
        ].includes(nodeType) ? 'taskList' : 'decisionList';
        const addItem = ({ tr: tr, itemLocalId: itemLocalId })=>{
            // ED-8932: When cursor is at the beginning of a task item, instead of split, we insert above.
            if ($from.pos === $to.pos && $from.parentOffset === 0 && ((0, $dh538.fg)('platform_editor_blocktaskitem_patch_2') ? !$from.parent.isTextblock || (0, $2fc4254aeefcece8$export$2ca50ccc2f45db88)(state) : true)) {
                const newTask = nodeType.createAndFill({
                    localId: itemLocalId
                });
                if (newTask) {
                    if (nodeType === blockTaskItem) {
                        const blockTaskItemNode = (0, $8m4tT.findParentNodeOfType)([
                            blockTaskItem
                        ])(selection);
                        // New task items for blockTaskItem should be taskItem
                        // We want to prevent creating new blockTaskItems as much as possible
                        const newTaskItem = taskItem.createAndFill({
                            localId: itemLocalId
                        });
                        if (!blockTaskItemNode || !newTaskItem) return tr;
                        return tr.insert(blockTaskItemNode.pos, newTaskItem);
                    }
                    // Current position will point to text node, but we want to insert above the taskItem node
                    return tr.insert($from.pos - 1, newTask);
                }
            }
            /**
					 * For blockTaskItem, must handle it differently because it can have a different depth
					 */ if (nodeType === blockTaskItem) {
                const blockTaskItemNode = (0, $8m4tT.findParentNodeOfType)([
                    blockTaskItem
                ])(selection);
                if (!blockTaskItemNode) return tr;
                // If the selection is a gap cursor at the end of the blockTaskItem,
                // we should insert a new taskItem.
                if (((0, $dh538.fg)('platform_editor_blocktaskitem_patch_2') ? !$from.parent.isTextblock || (0, $2fc4254aeefcece8$export$bcd44b9b102ed403)(state) : true) && $from.parentOffset === $from.parent.nodeSize - 2) {
                    const newTaskItem = taskItem.createAndFill({
                        localId: itemLocalId
                    });
                    if (newTaskItem) {
                        tr.insert(blockTaskItemNode.pos + blockTaskItemNode.node.nodeSize, newTaskItem);
                        // Move the cursor to the end of the newly inserted blockTaskItem
                        tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, blockTaskItemNode.pos + blockTaskItemNode.node.nodeSize + 1));
                        return tr;
                    }
                }
                // Split near the depth of the current selection
                return tr.split($from.pos, (0, $dh538.fg)('platform_editor_blocktaskitem_patch_2') ? $from?.parent?.isTextblock ? 2 : 1 : $from.depth - 1, [
                    {
                        type: blockTaskItem,
                        attrs: {
                            localId: itemLocalId
                        }
                    }
                ]);
            }
            return tr.split($from.pos, 1, [
                {
                    type: nodeType,
                    attrs: {
                        localId: itemLocalId
                    }
                }
            ]);
        };
        const insertTr = (0, $593b7407307544bb$export$14f75d90d7dffdab)(editorAnalyticsAPI, getContextIdentifier)(state, listType, (0, $d925B.INPUT_METHOD).KEYBOARD, addItem);
        if (insertTr && dispatch) {
            insertTr.scrollIntoView();
            dispatch(insertTr);
        }
        return true;
    }));
const $2da1bf346dcac0f3$var$cmdOptEnter = (0, $e7tBw.filterCommand)((0, $2fc4254aeefcece8$export$c4942fd0ddcad0b), (state, dispatch)=>{
    const { selection: selection, schema: schema } = state;
    const { taskItem: taskItem } = schema.nodes;
    const { $from: $from } = selection;
    const node = $from.node($from.depth);
    const nodeType = node && node.type;
    const nodePos = $from.before($from.depth);
    if (nodeType === taskItem) {
        const tr = state.tr;
        tr.step(new (0, $9YoeD.SetAttrsStep)(nodePos, {
            state: node.attrs.state === 'TODO' ? 'DONE' : 'TODO',
            localId: node.attrs.localId
        }));
        if (tr && dispatch) dispatch(tr);
    }
    return true;
});
function $2da1bf346dcac0f3$export$e832373cff8dec22(schema, api, allowNestedTasks, consumeTabs) {
    const getContextIdentifier = ()=>api?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider;
    const indentHandlers = {
        'Shift-Tab': (0, $e7tBw.filterCommand)([
            (0, $2fc4254aeefcece8$export$c4942fd0ddcad0b),
            (state)=>!$2da1bf346dcac0f3$var$shouldLetTabThroughInTable(state)
        ], (state, dispatch)=>$2da1bf346dcac0f3$export$d5d1010fad3453fa(api?.analytics?.actions)((0, $d925B.INPUT_METHOD).KEYBOARD)(state, dispatch) || !!consumeTabs),
        Tab: (0, $e7tBw.filterCommand)([
            (0, $2fc4254aeefcece8$export$c4942fd0ddcad0b),
            (state)=>!$2da1bf346dcac0f3$var$shouldLetTabThroughInTable(state)
        ], (state, dispatch)=>$2da1bf346dcac0f3$export$b294289254b8cdac(api?.analytics?.actions)((0, $d925B.INPUT_METHOD).KEYBOARD)(state, dispatch) || !!consumeTabs)
    };
    const defaultHandlers = consumeTabs ? {
        'Shift-Tab': (0, $2fc4254aeefcece8$export$c4942fd0ddcad0b),
        Tab: (0, $2fc4254aeefcece8$export$c4942fd0ddcad0b)
    } : {};
    const toggleTaskListShortcut = (state, dispatch)=>{
        if (!(0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true)) return false;
        if (!state.schema.nodes.taskItem) return false;
        if (dispatch) {
            const command = (0, $2b7d7c8d49850f96$export$2e48e3ea1c210731)();
            const tr = command({
                tr: state.tr
            });
            if (tr) {
                dispatch(tr);
                return true;
            }
        }
        return false;
    };
    const keymaps = {
        Backspace: $2da1bf346dcac0f3$var$backspace(api?.analytics?.actions),
        Delete: $2da1bf346dcac0f3$var$deleteForwards,
        'Ctrl-d': $2da1bf346dcac0f3$var$deleteForwards,
        Enter: $2da1bf346dcac0f3$var$enter(api?.analytics?.actions, getContextIdentifier),
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        [(0, $hgeg8.toggleTaskItemCheckbox).common]: $2da1bf346dcac0f3$var$cmdOptEnter,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        [(0, $hgeg8.toggleTaskList).common]: toggleTaskListShortcut,
        ...allowNestedTasks ? indentHandlers : defaultHandlers
    };
    return (0, $dus6D.keymap)(keymaps);
}
var $2da1bf346dcac0f3$export$2e2bcd8739ae039 = $2da1bf346dcac0f3$export$e832373cff8dec22;












var $3tffm = parcelRequire("3tffm");




var $2pjJ5 = parcelRequire("2pjJ5");





var $ftzrq = parcelRequire("ftzrq");













// This value can be a fixed constant as it doesn't depend on runtime values or arguments.
const $02f4886b88fe9752$var$iconDOM = [
    'span',
    {
        contentEditable: false,
        'data-component': 'icon'
    },
    [
        'span',
        {
            role: 'img',
            'aria-label': 'Decision'
        },
        [
            'http://www.w3.org/2000/svg svg',
            {
                viewBox: `0 0 24 24`,
                role: 'presentation',
                width: '24',
                height: '24',
                'data-icon-source': 'legacy'
            },
            [
                'http://www.w3.org/2000/svg path',
                {
                    fill: 'currentcolor',
                    'fill-rule': 'evenodd',
                    d: 'm9.414 8 3.293 3.293c.187.187.293.442.293.707v5a1 1 0 0 1-2 0v-4.586l-3-3V10.5a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2zm8.293-1.707a1 1 0 0 1 0 1.414l-2.5 2.5a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l2.5-2.5a1 1 0 0 1 1.414 0'
                }
            ]
        ],
        [
            'http://www.w3.org/2000/svg svg',
            {
                viewBox: `-4 -4 24 24`,
                fill: 'none',
                role: 'presentation',
                width: '24',
                height: '24',
                'data-icon-source': 'refreshed'
            },
            [
                'http://www.w3.org/2000/svg path',
                {
                    fill: 'currentcolor',
                    'fill-rule': 'evenodd',
                    d: 'm13.97.97-4.5 4.5 1.06 1.06 4.5-4.5zM3.56 2.5H8V1H1.75a.75.75 0 0 0-.75.75V8h1.5V3.56l4.604 4.604a.5.5 0 0 1 .146.354V15h1.5V8.518a2 2 0 0 0-.586-1.414z'
                }
            ]
        ]
    ]
];
const $02f4886b88fe9752$export$e9f11508261835be = (node, intl)=>{
    const contentDomDataAttrs = node.childCount > 0 ? {} : {
        'data-empty': 'true'
    };
    return [
        'li',
        {
            'data-decision-local-id': node.attrs.localId || 'local-decision',
            'data-decision-state': node.attrs.state,
            'data-prosemirror-node-name': 'decisionItem',
            class: 'decisionItemView-content-wrap'
        },
        [
            'div',
            {
                'data-testid': 'elements-decision-item',
                'data-decision-wrapper': true
            },
            $02f4886b88fe9752$var$iconDOM,
            // renderPlaceholder
            [
                'span',
                {
                    'data-testid': 'task-decision-item-placeholder',
                    'data-component': 'placeholder',
                    contentEditable: false
                },
                intl.formatMessage((0, $2iuib.tasksAndDecisionsMessages).decisionPlaceholder)
            ],
            [
                'div',
                {
                    'data-component': 'content'
                },
                [
                    'div',
                    {
                        class: 'decision-item',
                        ...contentDomDataAttrs
                    },
                    0
                ]
            ]
        ]
    ];
};


class $2e866c54e15eb318$export$a190d28468c64715 {
    /**
   * Updates the hasChildren state based on the node's child count by setting the `data-empty` attribute on the contentDOM.
   * @param node - The ProseMirror node to check for children.
   * @private
   */ updateHasChildren(node) {
        const currentlyHasChildren = node.childCount > 0;
        if (currentlyHasChildren !== this.hasChildren) {
            this.hasChildren = currentlyHasChildren;
            this.contentDOM?.toggleAttribute('data-empty', !currentlyHasChildren);
        }
        return this.hasChildren;
    }
    /**
   * Updates the node view when the ProseMirror node changes.
   * @import type {PMNode} from '@atlaskit/editor-prosemirror/model';
   * @param {PMNode} node - The ProseMirror node to update the view with.
   * @example
   * decisionItemNodeView.update(node);
   * @returns {boolean} - Returns true if the view was updated successfully.
   */ update(node) {
        this.updateHasChildren(node);
        return true;
    }
    /**
   * Determines whether a mutation should be ignored by ProseMirror.
   * This prevents unnecessary node view destruction during DOM changes that don't affect our content.
   * @param mutation - The DOM mutation record or selection change
   * @returns true if the mutation should be ignored, false if it should be processed
   * @example
   * // Mutation outside contentDOM will be ignored
   * const shouldIgnore = decisionItemNodeView.ignoreMutation(mutationRecord);
   */ ignoreMutation(mutation) {
        // This was discovered while implementing the platform_editor_debounce_portal_provider experiment
        // And there will only be an issue if the experiment is enabled.
        // As such, this fix is behind this experiment.
        if (!(0, $1oCLl.expValEquals)('platform_editor_debounce_portal_provider', 'isEnabled', true, false)) return false; // Let ProseMirror handle all mutations when experiment is disabled
        if (!this.contentDOM) return true;
        // Ignore mutations that don't target our contentDOM and aren't selection changes
        return !this.contentDOM.contains(mutation.target) && mutation.type !== 'selection';
    }
    /**
   * Creates a new DecisionItemNodeView.
   * @import type {PMNode} from '@atlaskit/editor-prosemirror/model';
   * @import type {IntlShape} from 'react-intl-next';
   * @param {PMNode} node - The ProseMirror node representing the decision item.
   * @param {IntlShape} intl - The IntlShape for internationalization, used to format the placeholder text.
   * @example
   * const decisionItemNodeView = new DecisionItemNodeView(node, getIntl());
   */ constructor(node, intl){
        this.dom = void 0;
        this.contentDOM = void 0;
        this.hasChildren = undefined;
        const spec = (0, $02f4886b88fe9752$export$e9f11508261835be)(node, intl);
        const { dom: dom, contentDOM: contentDOM } = (0, $5SAOw.DOMSerializer).renderSpec(document, spec);
        this.dom = dom;
        this.contentDOM = contentDOM;
    }
}



var $fFa3V = parcelRequire("fFa3V");
















class $7906c8f910b83ab0$export$8e651bc5e6600399 {
    getContextIdentifierProvider() {
        return this.api?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider;
    }
    getObjectAri() {
        const provider = this.getContextIdentifierProvider();
        if (provider) return provider.objectId;
        return undefined;
    }
    isContentEmpty(node) {
        return node.content.childCount === 0;
    }
    // Update the placeholder visibility based on content
    updatePlaceholder(node) {
        let currentIsContentEmpty = this.isContentEmpty(node);
        if ((0, $1oCLl.expValEquals)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true)) currentIsContentEmpty = (0, $d9e9935026bf8066$export$c0efac86beb21f01)(node);
        if (currentIsContentEmpty !== this.emptyContent) {
            this.emptyContent = currentIsContentEmpty;
            this.contentDOM?.toggleAttribute('data-empty', currentIsContentEmpty);
        }
    }
    update(node) {
        if (!(0, $1oCLl.expValEquals)('platform_editor_prevent_taskitem_remount', 'isEnabled', true)) {
            const isValidUpdate = node.type === this.node.type && !!(node.attrs.state === this.node.attrs.state);
            if (!isValidUpdate) return false;
        }
        // Only return false if this is a completely different task
        if (this.node.attrs.localId !== node.attrs.localId) return false;
        if ((0, $1oCLl.expValEquals)('platform_editor_prevent_taskitem_remount', 'isEnabled', true)) {
            if (node.type !== this.node.type) return false;
            const stateChanged = node.type === this.node.type && !!(node.attrs.state !== this.node.attrs.state);
            // Update task checkbox state to match document state.
            // It's possible the state may have changed from a collab edit and not from a checkbox click
            // so we need to update the checkbox to match.
            if (stateChanged && this.input) this.input.checked = node.attrs.state === 'DONE';
        }
        this.updatePlaceholder(node);
        if (this.domElement && !node.sameMarkup(this.node)) {
            this.domElement.setAttribute('data-task-state', node.attrs.state);
            this.domElement.setAttribute('data-task-local-id', node.attrs.localId);
            this.domElement.setAttribute('state', node.attrs.state);
        }
        this.node = node;
        return true;
    }
    ignoreMutation(mutation) {
        if (!this.contentDOM) return true;
        return !this.contentDOM.contains(mutation.target) && mutation.type !== 'selection';
    }
    destroy() {
        if (this.unbindInputDom) this.unbindInputDom();
        this.contentDOM = undefined;
        this.input = undefined;
        this.emptyContent = undefined;
        this.api = undefined;
    }
    constructor(node, view, getPos, { api: api, placeholder: placeholder, intl: intl }){
        this.dom = void 0;
        this.domElement = void 0;
        this.contentDOM = void 0;
        this.node = void 0;
        this.view = void 0;
        this.getPos = void 0;
        this.api = void 0;
        this.intl = void 0;
        this.unbindInputDom = void 0;
        this.emptyContent = void 0;
        this.input = void 0;
        this.handleOnClick = (event)=>{
            if (!this.api?.taskDecision?.sharedState.currentState()?.hasEditPermission) {
                event.stopImmediatePropagation();
                event.preventDefault();
                const pos = this.getPos();
                if (typeof pos === 'number') (0, $2fc4254aeefcece8$export$ccb659c518fe26ad)(this.view, pos);
                return;
            }
        };
        this.handleOnChange = ()=>{
            const { tr: tr } = this.view.state;
            const nodePos = this.getPos();
            if (typeof nodePos !== 'number') return;
            const { localId: localId, state: state } = this.node.attrs;
            const isDone = state === 'DONE';
            const nextState = isDone ? 'TODO' : 'DONE';
            const currentTaskDecisionState = this.api?.taskDecision.sharedState.currentState();
            // logic is inspired from packages/elements/task-decision/src/components/ResourcedTaskItem.tsx
            const objectAri = this.getObjectAri();
            if (currentTaskDecisionState?.taskDecisionProvider && objectAri) currentTaskDecisionState.taskDecisionProvider.toggleTask({
                localId: localId,
                objectAri: objectAri
            }, nextState);
            // SetAttrsStep should be used to prevent task updates from being dropped when mapping task ticks
            // from a previous version of the document, such as a published page.
            tr.step(new (0, $9YoeD.SetAttrsStep)(nodePos, {
                state: nextState,
                localId: localId
            }));
            tr.setMeta('scrollIntoView', false);
            const taskItemInfoMeta = {
                checkState: nextState,
                from: nodePos,
                to: nodePos + this.node.nodeSize
            };
            tr.setMeta('taskItemInfo', taskItemInfoMeta);
            this.view.dispatch(tr);
        };
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.intl = intl;
        this.api = api;
        this.view = view;
        const domPlaceholder = placeholder ?? this.intl.formatMessage((0, $2iuib.tasksAndDecisionsMessages).taskPlaceholder);
        const { dom: dom, contentDOM: contentDOM } = (0, $5SAOw.DOMSerializer).renderSpec(document, (0, $13787dd647975a80$export$640336359e1ccaeb)(node, domPlaceholder, intl));
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.domElement = this.dom instanceof HTMLElement ? this.dom : undefined;
        if (this.domElement) {
            this.input = this.domElement.querySelector('input[type="checkbox"]');
            this.unbindInputDom = (0, $fFa3V.bindAll)(this.input, [
                {
                    type: 'click',
                    listener: this.handleOnClick
                },
                {
                    type: 'change',
                    listener: this.handleOnChange
                }
            ]);
        }
    }
}


const $ea01580a5a6127d1$export$da2f2be53bb82f44 = (api, intl, placeholder)=>{
    return (node, view, getPos)=>{
        return new (0, $7906c8f910b83ab0$export$8e651bc5e6600399)(node, view, getPos, {
            placeholder: placeholder,
            api: api,
            intl: intl
        });
    };
};


const $06de0f51abda899d$export$9af39543e75ed75a = (state, action)=>{
    return {
        ...state,
        focusedTaskItemLocalId: action.data
    };
};
const $06de0f51abda899d$export$1572b3eade6662f9 = (state, action)=>{
    return {
        ...state,
        taskDecisionProvider: action.data
    };
};
const $06de0f51abda899d$export$571ff0891839feec = (state, action)=>{
    return {
        ...state,
        openRequestToEditPopupAt: action.data
    };
};




function $34bba4e4e015a378$export$4f9e52c150984a8a(view, event) {
    const { target: target } = event;
    if (!target || !(target instanceof HTMLInputElement) || target.type !== 'checkbox' || target.getAttribute('data-input-type') !== 'lazy-task-item') return;
    const pos = view.posAtDOM(target, 0);
    // Resolve the position in the current document
    const resolvedPos = view.state.doc.resolve(pos);
    // Access the parent node
    const parentNode = resolvedPos?.parent;
    if (parentNode?.type?.name !== 'taskItem') return;
    const parentPos = resolvedPos.before(resolvedPos.depth);
    const tr = view.state.tr.setNodeMarkup(parentPos, null, {
        ...parentNode.attrs,
        state: target.checked ? 'DONE' : 'TODO'
    });
    view.dispatch(tr);
}









const $1c1225914357e914$export$7e04b173e2b79898 = (slice, view)=>{
    const { schema: schema } = view.state;
    const { taskItem: taskItem, blockTaskItem: blockTaskItem, paragraph: paragraph } = schema.nodes;
    // Check if we're pasting into a taskItem
    const { $from: $from } = view.state.selection;
    const isInTaskItem = $from.node().type === taskItem;
    if (isInTaskItem && blockTaskItem) {
        // Transform the slice to replace blockTaskItems with taskItems
        const transformedContent = [];
        slice.content.forEach((node)=>{
            if (node.type === blockTaskItem) {
                // Check if blockTaskItem only contains paragraphs
                let allChildrenAreParagraphs = true;
                node.content.forEach((child)=>{
                    if (child.type !== paragraph) allChildrenAreParagraphs = false;
                });
                if (allChildrenAreParagraphs && node.childCount > 0) // Convert each paragraph to a taskItem
                node.content.forEach((paragraphNode)=>{
                    const newTaskItem = taskItem.create({
                        localId: (0, $fO7hX.uuid).generate(),
                        state: node.attrs.state || 'TODO'
                    }, paragraphNode.content);
                    transformedContent.push(newTaskItem);
                });
                else // Keep the blockTaskItem as is if it doesn't only contain paragraphs
                transformedContent.push(node);
            } else // Keep other nodes as is
            transformedContent.push(node);
        });
        // Create new slice with transformed content
        if (transformedContent.length !== slice.content.childCount || transformedContent.some((node, idx)=>node !== slice.content.child(idx))) {
            const newFragment = (0, $5SAOw.Fragment).from(transformedContent);
            return new (0, $5SAOw.Slice)(newFragment, slice.openStart, slice.openEnd);
        }
    }
    return slice;
};


function $bc3faaa8c98786d9$var$nodesBetweenChanged(tr, f, startPos) {
    const stepRange = (0, $2pjJ5.getStepRange)(tr);
    if (!stepRange) return;
    tr.doc.nodesBetween(stepRange.from, stepRange.to, f, startPos);
}
function $bc3faaa8c98786d9$export$ae829ec7b2625219(portalProviderAPI, eventDispatcher, dispatch, api, getIntl, useLongPressSelection = false, hasEditPermission, hasRequestedEditPermission, requestToEditContent, taskPlaceholder) {
    return new (0, $1S4f7.SafePlugin)({
        props: {
            nodeViews: {
                taskItem: (0, $ea01580a5a6127d1$export$da2f2be53bb82f44)(api, getIntl(), taskPlaceholder),
                decisionItem: (node)=>{
                    return new (0, $2e866c54e15eb318$export$a190d28468c64715)(node, getIntl());
                },
                ...(0, $1oCLl.expValEquals)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true) ? {
                    blockTaskItem: (0, $ea01580a5a6127d1$export$da2f2be53bb82f44)(api, getIntl(), taskPlaceholder)
                } : {}
            },
            decorations (state) {
                const pluginState = (0, $e74ddcb3d2085778$export$77b371d6becc8882).getState(state);
                if (pluginState?.decorations) return pluginState.decorations;
                return (0, $ftzrq.DecorationSet).empty;
            },
            handleTextInput (view, from, to, text) {
                // When a decision item is selected and the user starts typing, the entire node
                // should be replaced with what was just typed. This custom text input handler
                // is needed to implement that behaviour.
                const { state: state, dispatch: dispatch } = view;
                const { tr: tr } = state;
                if (state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node.type === view.state.schema.nodes.decisionItem) {
                    state.selection.replace(tr);
                    tr.insertText(text);
                    if (dispatch) dispatch(tr);
                    return true;
                }
                return false;
            },
            handleClickOn: (0, $3tffm.createSelectionClickHandler)([
                'decisionItem',
                'taskItem'
            ], (target)=>target.hasAttribute('data-decision-wrapper') || target.getAttribute('aria-label') === 'Decision', {
                useLongPressSelection: useLongPressSelection
            }),
            handleDOMEvents: {
                // When the page is lazy loaded and task item is not yet available this allows
                // our toDOM implementation to toggle the node state
                change: (0, $34bba4e4e015a378$export$4f9e52c150984a8a)
            },
            handleKeyDown: (view, event)=>{
                const { state: state } = view;
                const { selection: selection, schema: schema } = state;
                const { $from: $from, $to: $to } = selection;
                const parentOffset = $from.parentOffset;
                const isInTaskItem = (0, $1oCLl.expValEquals)('platform_editor_blocktaskitem_patch_1', 'isEnabled', true) ? (0, $2fc4254aeefcece8$export$2fad51fb9cb5e2d1)(state) : $from.node().type === schema.nodes.taskItem;
                const focusedTaskItemLocalId = (0, $e74ddcb3d2085778$export$77b371d6becc8882).getState(state).focusedTaskItemLocalId;
                const currentTaskItemData = (0, $2fc4254aeefcece8$export$bb36b9aa75d84160)(view);
                const currentTaskItemFocused = focusedTaskItemLocalId === currentTaskItemData?.localId;
                // if task item checkbox not focused and arrow key is not pressed
                //  then we don't want to handle event.
                if (![
                    'ArrowUp',
                    'ArrowDown',
                    'ArrowRight',
                    'ArrowLeft'
                ].includes(event.key)) return false;
                // We want to handle arrow up, down and left key only
                //  when selection is inside task item and no text is selected.
                if ([
                    'ArrowUp',
                    'ArrowDown',
                    'ArrowLeft'
                ].includes(event.key) && (!isInTaskItem || $from.pos !== $to.pos)) return false;
                // Arrow keys are pressed and shift, ctrl or meta is pressed as well.
                //  along with arrow keys and task item checkbox is focused
                //  then first move focus to view and proceed with default event handling.
                if (event.shiftKey || event.ctrlKey || event.metaKey) {
                    currentTaskItemFocused && (0, $2fc4254aeefcece8$export$6d348f0593efe546)(view);
                    return false;
                }
                // task item checkbox is already focused
                if (focusedTaskItemLocalId) {
                    if (event.key === 'ArrowLeft') {
                        // Move focus to view and proceed with default keyboard handler.
                        // Which will move cursor to previous position.
                        (0, $2fc4254aeefcece8$export$6d348f0593efe546)(view);
                        return false;
                    }
                    if (event.key === 'ArrowRight') {
                        // Move focus to view and DON'T proceed with default handler.
                        // We have assumed that selection is already before first character of task item.
                        (0, $2fc4254aeefcece8$export$6d348f0593efe546)(view);
                        return true;
                    }
                    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                        const taskItemData = (0, $2fc4254aeefcece8$export$84c7d27d1433771f)(view, event.key === 'ArrowUp' ? 'previous' : 'next');
                        if (taskItemData) {
                            (0, $2fc4254aeefcece8$export$965155ace97a0424)(view, taskItemData);
                            return true;
                        } else {
                            // If any how checkbox input not found, then move focus to view
                            //  and proceed with default keyboard handler.
                            (0, $2fc4254aeefcece8$export$6d348f0593efe546)(view);
                            return false;
                        }
                    }
                }
                // If left arrow key is pressed and cursor is at first position in task-item
                //  then focus checkbox and DON'T proceed with default keyboard handler
                if (event.key === 'ArrowLeft' && parentOffset === 0) {
                    // here we are not using focusCheckboxAndUpdateSelection() method
                    // because it is working incorretly when we are placing is inside the nested items
                    (0, $2fc4254aeefcece8$export$6ddc162ae107856)(view, currentTaskItemData);
                    return true;
                }
                if (event.key === 'ArrowRight') {
                    // If gap cursor is just before task list then focus first task item in list.
                    if (selection instanceof (0, $adhil.GapCursorSelection) && selection.side === 'left' && $from.nodeAfter?.type === schema.nodes.taskList) {
                        const taskList = $from.nodeAfter;
                        const firstTaskItemNode = taskList.child(0);
                        const taskItemPos = $from.pos + 1;
                        (0, $2fc4254aeefcece8$export$965155ace97a0424)(view, {
                            pos: taskItemPos,
                            localId: firstTaskItemNode.attrs.localId
                        });
                        return true;
                    } else if (isInTaskItem && $from.node().content.size === parentOffset) {
                        const nextTaskItemData = (0, $2fc4254aeefcece8$export$84c7d27d1433771f)(view, 'next');
                        if (nextTaskItemData) {
                            (0, $2fc4254aeefcece8$export$965155ace97a0424)(view, nextTaskItemData);
                            return true;
                        }
                    } else return false;
                }
            },
            transformPasted: (slice, view)=>{
                if (Boolean(view?.state?.schema?.nodes?.blockTaskItem)) slice = (0, $1c1225914357e914$export$7e04b173e2b79898)(slice, view);
                return slice;
            }
        },
        state: {
            init () {
                return {
                    insideTaskDecisionItem: false,
                    hasEditPermission: hasEditPermission,
                    hasRequestedEditPermission: hasRequestedEditPermission,
                    requestToEditContent: requestToEditContent,
                    focusedTaskItemLocalId: null,
                    taskDecisionProvider: undefined,
                    decorations: (0, $ftzrq.DecorationSet).empty
                };
            },
            apply (tr, pluginState) {
                const metaData = tr.getMeta((0, $e74ddcb3d2085778$export$77b371d6becc8882));
                const { action: action, data: data } = metaData ?? {
                    action: null,
                    data: null
                };
                let newPluginState = pluginState;
                // Actions
                switch(action){
                    case (0, $c5154c0aaa7029e9$export$92a1a3b7554e9387).FOCUS_BY_LOCALID:
                        newPluginState = (0, $06de0f51abda899d$export$9af39543e75ed75a)(newPluginState, {
                            action: (0, $c5154c0aaa7029e9$export$92a1a3b7554e9387).FOCUS_BY_LOCALID,
                            data: data
                        });
                        break;
                    case (0, $c5154c0aaa7029e9$export$92a1a3b7554e9387).SET_PROVIDER:
                        newPluginState = (0, $06de0f51abda899d$export$1572b3eade6662f9)(newPluginState, {
                            action: (0, $c5154c0aaa7029e9$export$92a1a3b7554e9387).SET_PROVIDER,
                            data: data
                        });
                        break;
                    case (0, $c5154c0aaa7029e9$export$92a1a3b7554e9387).OPEN_REQUEST_TO_EDIT_POPUP:
                        newPluginState = (0, $06de0f51abda899d$export$571ff0891839feec)(newPluginState, {
                            action: (0, $c5154c0aaa7029e9$export$92a1a3b7554e9387).OPEN_REQUEST_TO_EDIT_POPUP,
                            data: data
                        });
                        break;
                }
                // Commands
                if (metaData && 'hasEditPermission' in metaData) newPluginState = {
                    ...newPluginState,
                    hasEditPermission: metaData.hasEditPermission
                };
                if (metaData && 'hasRequestedEditPermission' in metaData) newPluginState = {
                    ...newPluginState,
                    hasRequestedEditPermission: metaData.hasRequestedEditPermission
                };
                const taskItemInfo = tr.getMeta('taskItemInfo');
                let decorations = (0, $ftzrq.DecorationSet).empty;
                if (taskItemInfo) decorations = (0, $ftzrq.DecorationSet).create(tr.doc, [
                    (0, $ftzrq.Decoration).inline(taskItemInfo.from, taskItemInfo.to, {}, {
                        dataTaskNodeCheckState: taskItemInfo.checkState
                    })
                ]);
                else decorations = newPluginState.decorations?.map(tr.mapping, tr.doc);
                const newState = {
                    ...newPluginState,
                    decorations: decorations
                };
                dispatch((0, $e74ddcb3d2085778$export$77b371d6becc8882), newState);
                return newState;
            }
        },
        key: (0, $e74ddcb3d2085778$export$77b371d6becc8882),
        /*
     * After each transaction, we search through the document for any decisionList/Item & taskList/Item nodes
     * that do not have the localId attribute set and generate a random UUID to use. This is to replace a previous
     * Prosemirror capability where node attributes could be generated dynamically.
     * See https://discuss.prosemirror.net/t/release-0-23-0-possibly-to-be-1-0-0/959/17 for a discussion of this approach.
     *
     * Note: we currently do not handle the edge case where two nodes may have the same localId
     */ appendTransaction: (transactions, _oldState, newState)=>{
            const tr = newState.tr;
            let modified = false;
            transactions.forEach((transaction)=>{
                if (!transaction.docChanged) return;
                // Adds a unique id to a node
                $bc3faaa8c98786d9$var$nodesBetweenChanged(transaction, (node, pos)=>{
                    const { decisionList: decisionList, decisionItem: decisionItem, taskList: taskList, taskItem: taskItem, blockTaskItem: blockTaskItem } = newState.schema.nodes;
                    if (!!node.type && (node.type === decisionList || node.type === decisionItem || node.type === taskList || node.type === taskItem || blockTaskItem && node.type === blockTaskItem)) {
                        const { localId: localId, ...rest } = node.attrs;
                        if (localId === undefined || localId === null || localId === '') {
                            tr.step(new (0, $9YoeD.SetAttrsStep)(pos, {
                                localId: (0, $fO7hX.uuid).generate(),
                                ...rest
                            }));
                            modified = true;
                        }
                    }
                });
            });
            if (modified) return tr.setMeta('addToHistory', false);
            return;
        },
        view: ()=>{
            return {
                update: (view, prevState)=>{
                    const pluginState = (0, $e74ddcb3d2085778$export$77b371d6becc8882).getState(view.state);
                    const prevPluginState = (0, $e74ddcb3d2085778$export$77b371d6becc8882).getState(prevState);
                    if (pluginState.focusedTaskItemLocalId === prevPluginState.focusedTaskItemLocalId) return;
                    const taskItem = (0, $2fc4254aeefcece8$export$bb36b9aa75d84160)(view);
                    if (!taskItem) return;
                    if (pluginState.focusedTaskItemLocalId === taskItem.localId) {
                        const taskElement = view.nodeDOM(taskItem.pos);
                        if (taskElement instanceof HTMLElement) taskElement?.querySelector('input')?.focus();
                    }
                }
            };
        }
    });
}








var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");





var $eiA8Z = parcelRequire("eiA8Z");


var $eKkkY = parcelRequire("eKkkY");


var $2GVu1 = parcelRequire("2GVu1");


var $ejBUP = parcelRequire("ejBUP");

const $f7fe21105709aaf2$export$77edd8d99970778c = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const selection = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'selection'
    ], (states)=>states.selectionState?.selection);
    const isSelected = (0, $42omo.useMemo)(()=>{
        return selection && selection.$from.parent.type.name === 'decisionItem';
    }, [
        selection
    ]);
    const onClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $d925B.INPUT_METHOD).KEYBOARD : (0, $d925B.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $d925B.INPUT_METHOD).BLOCK_MENU;
        api?.core.actions.execute(({ tr: tr })=>{
            const command = api?.blockMenu?.commands.transformNode(tr.doc.type.schema.nodes.decisionList, {
                inputMethod: inputMethod,
                triggeredFrom: triggeredFrom,
                targetTypeName: 'decisionList'
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
        isSelected: isSelected,
        onClick: onClick,
        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ejBUP))), {
            label: ""
        }),
        children: formatMessage((0, $eKkkY.messages).decisionList)
    });
};


/* RequestToEditPopup.tsx generated by @compiled/babel-plugin v0.36.1 */ // import Popup from '@atlaskit/popup';















var $e2wMq = parcelRequire("e2wMq");





var $jwWgu = parcelRequire("jwWgu");


var $efG2U = parcelRequire("efG2U");





var $aFUXX = parcelRequire("aFUXX");


var $7hXDW = parcelRequire("7hXDW");


var $cvXh8 = parcelRequire("cvXh8");


var $gdv5Z = parcelRequire("gdv5Z");

var $fVUfS = parcelRequire("fVUfS");

var $eyWa4 = parcelRequire("eyWa4");

const $3825fe6825229574$var$PopupWithListeners = (0, $efG2U.default)((0, $jwWgu.default));
const $3825fe6825229574$var$TRYING_REQUEST_TIMEOUT = 3000;
const $3825fe6825229574$var$popupContentWrapper = null;
const $3825fe6825229574$var$wrapperStyles = null;
const $3825fe6825229574$var$wrapperBoxStyles = null;
const $3825fe6825229574$var$dotStyles = null;
const $3825fe6825229574$var$dotStylesUnbounded = null;
const $3825fe6825229574$var$pressableStyles = {
    pressable: "_ca0qze3t _n3tdze3t _19bvze3t _u5f3ze3t _1wybdlk8 _syaz1oa5 _bfhksm61 _9oik1r31 _1bnx8stv _jf4cnqa1 _9h8h12zz"
};
const $3825fe6825229574$var$anaylyticsEventPayload = (action)=>{
    return {
        action: action,
        actionSubject: (0, $d925B.ACTION_SUBJECT).REQUEST_TO_EDIT_POP_UP,
        eventType: (0, $d925B.EVENT_TYPE).UI,
        attributes: {
            platform: (0, $e2wMq.PLATFORMS).WEB,
            mode: (0, $e2wMq.MODE).EDITOR
        }
    };
};
const $3825fe6825229574$var$RequestedMessage = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            formatMessage((0, $2iuib.tasksAndDecisionsMessages).requestToEdit),
            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
                label: "requested-to-edit",
                color: "var(--ds-icon-disabled, #080F214A)"
            })
        ]
    });
};
const $3825fe6825229574$var$RequestToEditButton = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
            onClick: onClick,
            xcss: $3825fe6825229574$var$pressableStyles.pressable,
            testId: "request-to-edit-popup-request-btn",
            children: formatMessage((0, $2iuib.tasksAndDecisionsMessages).requestToEdit)
        })
    });
};
const $3825fe6825229574$export$2dae066a4c27dc7a = ({ element: element, api: api, editorView: editorView, onClose: onClose, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement })=>{
    const hasRequestedEditPermission = (0, $b3YrF.useSharedPluginStateSelector)(api, 'taskDecision.hasRequestedEditPermission');
    const openRequestToEditPopupAt = (0, $b3YrF.useSharedPluginStateSelector)(api, 'taskDecision.openRequestToEditPopupAt');
    const [isOpen, setIsOpen] = (0, $42omo.useState)(!!openRequestToEditPopupAt);
    const [requested, setRequested] = (0, $42omo.useState)(hasRequestedEditPermission);
    const [tryingRequest, setTryingRequest] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    (0, $42omo.useEffect)(()=>{
        setRequested(hasRequestedEditPermission);
    }, [
        hasRequestedEditPermission
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!tryingRequest) {
            const timout = setTimeout(()=>{
                setTryingRequest(false);
            }, $3825fe6825229574$var$TRYING_REQUEST_TIMEOUT);
            return ()=>clearTimeout(timout);
        }
    }, [
        tryingRequest
    ]);
    const onHandleEdit = (event)=>{
        event.stopPropagation();
        const viewMode = api?.editorViewMode?.sharedState.currentState()?.mode;
        if (viewMode !== 'view') return;
        const editorAnalyticsAPI = api?.analytics?.actions;
        setTryingRequest(true);
        const { tr: tr } = editorView.state;
        tr.setMeta('scrollIntoView', false);
        if (!api?.taskDecision?.sharedState.currentState()?.hasEditPermission) {
            const requestToEdit = api?.taskDecision?.sharedState.currentState()?.requestToEditContent;
            if (requestToEdit) requestToEdit();
        }
        editorAnalyticsAPI?.attachAnalyticsEvent($3825fe6825229574$var$anaylyticsEventPayload((0, $d925B.ACTION).REQUEST_TO_EDIT))(tr);
        editorView.dispatch(tr);
    };
    const onHandleDismiss = (editorAnalyticsAPI)=>{
        editorAnalyticsAPI?.fireAnalyticsEvent($3825fe6825229574$var$anaylyticsEventPayload((0, $d925B.ACTION).DISMISSED));
        setIsOpen(false);
        onClose();
    };
    const onHandleCancel = (event)=>{
        // Check if the click is on task item checkbox, if so, do not close the popup
        const target = event.target;
        if (target && (element.contains(target) || element === target)) return;
        setIsOpen(false);
        onClose();
    };
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)($3825fe6825229574$var$PopupWithListeners // Ignored via go/ees005
    , {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        target: element,
        fitHeight: 148,
        handleClickOutside: onHandleCancel,
        handleEscapeKeydown: onHandleCancel,
        zIndex: (0, $aFUXX.akEditorFloatingDialogZIndex),
        mountTo: mountTo,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        ariaLabel: null,
        preventOverflow: true,
        focusTrap: true,
        captureClick: true,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $efG2U.OutsideClickTargetRefContext).Consumer, {
            children: (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                    ref: setOutsideClickTargetRef,
                    className: (0, $gMc0m.default)([
                        "_2rkofajl _ca0qv77o _n3tdv77o _19bvv77o _u5f3v77o _16qs130s _bfhk1bhr"
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            "_1e0c1txw _2lx21bp4 _p12f1qwj _ca0qpxbi _u5f31ejb _n3tdpxbi _19bv1ejb"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                            space: "space.150",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                                    size: "xsmall",
                                    children: formatMessage((0, $2iuib.tasksAndDecisionsMessages).editAccessTitle)
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                    children: formatMessage((0, $2iuib.tasksAndDecisionsMessages).requestToEditDescription)
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                                    className: (0, $gMc0m.default)([
                                        "_zulp1b66 _1e0c1txw _4cvr1h6o _syaz1gmx"
                                    ]),
                                    children: [
                                        tryingRequest || requested ? /*#__PURE__*/ (0, $l998X.jsx)($3825fe6825229574$var$RequestedMessage, {}) : /*#__PURE__*/ (0, $l998X.jsx)($3825fe6825229574$var$RequestToEditButton, {
                                            onClick: onHandleEdit
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                            className: (0, $gMc0m.default)([
                                                "_19pku2gc _otyru2gc _18u0u2gc _2hwxu2gc _1e0c1o8l _1bsbyh40 _4t3iyh40 _bfhk16e3",
                                                "_2rko1rr0"
                                            ])
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                                                onClick: ()=>onHandleDismiss(api?.analytics?.actions),
                                                xcss: $3825fe6825229574$var$pressableStyles.pressable,
                                                testId: "request-to-edit-popup-cancel-btn",
                                                children: formatMessage((0, $2iuib.tasksAndDecisionsMessages).dismiss)
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
        })
    });
};
























var $dmbve = parcelRequire("dmbve");

const $fef31ad80b5dd689$export$de5198967b780ae = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const selection = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'selection'
    ], (states)=>states.selectionState?.selection);
    const isSelected = (0, $42omo.useMemo)(()=>{
        return selection && selection.$from.parent.type.name === 'taskItem';
    }, [
        selection
    ]);
    const onClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $d925B.INPUT_METHOD).KEYBOARD : (0, $d925B.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $d925B.INPUT_METHOD).BLOCK_MENU;
        api?.core.actions.execute(({ tr: tr })=>{
            const command = api?.blockMenu?.commands.transformNode(tr.doc.type.schema.nodes.taskList, {
                inputMethod: inputMethod,
                triggeredFrom: triggeredFrom,
                targetTypeName: 'taskList'
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
        isSelected: isSelected,
        onClick: onClick,
        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dmbve))), {
            label: ""
        }),
        children: formatMessage((0, $2iuib.tasksAndDecisionsMessages).taskList)
    });
};





parcelRequire("42omo");


var $cPCP8 = parcelRequire("cPCP8");

var $4Chin = parcelRequire("4Chin");







parcelRequire("42omo");


















var $jbmmV = parcelRequire("jbmmV");

const $619e6ad826b1d0bb$export$a78d1842153dea18 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { isInsideTask: isInsideTask } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'taskDecision'
    ], (states)=>({
            isInsideTask: states.taskDecisionState?.isInsideTask
        }));
    const handleClick = ()=>{
        api?.core.actions.execute(api?.taskDecision?.commands.toggleTaskList());
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dmbve))), {
            size: "small",
            label: ""
        }),
        elemAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, $jbmmV.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $hgeg8.formatShortcut)((0, $hgeg8.toggleTaskList))
        }),
        isSelected: isInsideTask,
        isDisabled: false,
        onClick: handleClick,
        ariaKeyshortcuts: (0, $hgeg8.formatShortcut)((0, $hgeg8.toggleTaskList)),
        children: formatMessage((0, $2iuib.tasksAndDecisionsMessages).taskList)
    });
};


const $9346d09a2f438667$export$f1884d013db554cc = ({ api: api })=>{
    if (!(0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true)) return [];
    return [
        {
            type: (0, $cPCP8.TASK_LIST_MENU_ITEM).type,
            key: (0, $cPCP8.TASK_LIST_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $cPCP8.LISTS_INDENTATION_MENU_SECTION).type,
                    key: (0, $cPCP8.LISTS_INDENTATION_MENU_SECTION).key,
                    rank: (0, $4Chin.LISTS_INDENTATION_MENU_SECTION_RANK)[(0, $cPCP8.TASK_LIST_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $619e6ad826b1d0bb$export$a78d1842153dea18), {
                    api: api,
                    parents: parents
                })
        }
    ];
};





parcelRequire("42omo");


var $gmMgo = parcelRequire("gmMgo");





var $8TW6I = parcelRequire("8TW6I");

var $a4eZN = parcelRequire("a4eZN");





const $ed8ed537ed67ff6e$var$ToolbarDecision = ({ isDisabled: isDisabled, isReducedSpacing: isReducedSpacing, intl: { formatMessage: formatMessage }, editorView: editorView, editorAPI: editorAPI })=>{
    const label = formatMessage((0, $4HWgE.toolbarInsertBlockMessages).decision);
    const handleInsertDecision = ()=>{
        if (!editorView) return false;
        const getContextIdentifier = ()=>editorAPI?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider;
        (0, $593b7407307544bb$export$d1657e7847eaa8d6)(editorAPI?.analytics?.actions, getContextIdentifier)('decisionList')(editorView.state, editorView.dispatch);
        return true;
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a4eZN.default), {
        buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).DECISION_LIST,
        onClick: handleInsertDecision,
        disabled: isDisabled,
        spacing: isReducedSpacing ? 'none' : 'default',
        title: `${label} <>`,
        "aria-keyshortcuts": "Shift+, Shift+. space",
        iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ejBUP))), {
            label: label
        })
    });
};
var $ed8ed537ed67ff6e$export$2e2bcd8739ae039 = (0, $gmMgo.default)($ed8ed537ed67ff6e$var$ToolbarDecision);





parcelRequire("42omo");













var $7FcUt = parcelRequire("7FcUt");


const $50c6c5eb0364220d$var$ToolbarTask = ({ isDisabled: isDisabled, isReducedSpacing: isReducedSpacing, intl: { formatMessage: formatMessage }, editorAPI: editorAPI, editorView: editorView })=>{
    const label = formatMessage((0, $4HWgE.toolbarInsertBlockMessages).action);
    const handleInsertTask = ()=>{
        if (!editorView) return false;
        const getContextIdentifier = ()=>editorAPI?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider;
        (0, $593b7407307544bb$export$d1657e7847eaa8d6)(editorAPI?.analytics?.actions, getContextIdentifier)('taskList')(editorView.state, editorView.dispatch);
        return true;
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a4eZN.default), {
        buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).TASK_LIST,
        onClick: handleInsertTask,
        disabled: isDisabled,
        spacing: isReducedSpacing ? 'none' : 'default',
        title: `${label} []`,
        iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7FcUt))), {
            label: label
        })
    });
};
var $50c6c5eb0364220d$export$2e2bcd8739ae039 = (0, $gmMgo.default)($50c6c5eb0364220d$var$ToolbarTask);


const $715bf2373cc9aad1$var$taskDecisionToolbarGroupStyles = null;
const $715bf2373cc9aad1$var$addItem = (insert, listType, schema)=>({ listLocalId: listLocalId, itemLocalId: itemLocalId })=>{
        const { list: list, item: item } = (0, $593b7407307544bb$export$c8b7fdb74eb8fe5c)(listType, schema);
        return insert(list.createChecked({
            localId: listLocalId
        }, item.createChecked({
            localId: itemLocalId
        })));
    };
function $715bf2373cc9aad1$var$ContentComponent({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, dependencyApi: dependencyApi }) {
    const openRequestToEditPopupAt = (0, $b3YrF.useSharedPluginStateSelector)(dependencyApi, 'taskDecision.openRequestToEditPopupAt');
    const hasEditPermission = (0, $b3YrF.useSharedPluginStateSelector)(dependencyApi, 'taskDecision.hasEditPermission');
    if ((0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) && !editorView) return null;
    if (hasEditPermission || !openRequestToEditPopupAt) return null;
    const domAtPos = editorView.domAtPos.bind(editorView); // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const element = (0, $8m4tT.findDomRefAtPos)(openRequestToEditPopupAt, domAtPos);
    const handleOnClose = ()=>{
        (0, $2fc4254aeefcece8$export$6e1436cb7b69383b)(editorView);
        editorView.focus();
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3825fe6825229574$export$2dae066a4c27dc7a), {
        api: dependencyApi,
        editorView: editorView,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        element: element,
        onClose: handleOnClose
    }, openRequestToEditPopupAt);
}
const $715bf2373cc9aad1$export$582323d9689d93fc = ({ config: { allowNestedTasks: allowNestedTasks, consumeTabs: consumeTabs, useLongPressSelection: useLongPressSelection, hasEditPermission: hasEditPermission = true, hasRequestedEditPermission: hasRequestedEditPermission, quickInsertActionDescription: quickInsertActionDescription, requestToEditContent: requestToEditContent, taskDecisionProvider: taskDecisionProvider, taskPlaceholder: taskPlaceholder, allowBlockTaskItem: allowBlockTaskItem } = {}, api: api })=>{
    const getIdentifierProvider = ()=>api?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider;
    let previousTaskAndDecisionProvider;
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    if (isToolbarAIFCEnabled && (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true)) api?.toolbar?.actions.registerComponents((0, $9346d09a2f438667$export$f1884d013db554cc)({
        api: api
    }));
    if (taskDecisionProvider) taskDecisionProvider.then((provider)=>{
        api?.core.actions.execute(({ tr: tr })=>(0, $593b7407307544bb$export$1572b3eade6662f9)(provider)(tr));
    });
    if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) api?.blockMenu?.actions.registerBlockMenuComponents([
        {
            type: 'block-menu-item',
            key: (0, $btNLq.TRANSFORM_STRUCTURE_TASK_LIST_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $gEb6G.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $btNLq.TRANSFORM_STRUCTURE_TASK_LIST_MENU_ITEM).key]
            },
            component: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fef31ad80b5dd689$export$de5198967b780ae), {
                    api: api
                })
        },
        {
            type: 'block-menu-item',
            key: (0, $btNLq.TRANSFORM_STRUCTURE_DECISION_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $gEb6G.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $btNLq.TRANSFORM_STRUCTURE_DECISION_MENU_ITEM).key]
            },
            component: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $f7fe21105709aaf2$export$77edd8d99970778c), {
                    api: api
                })
        }
    ]);
    return {
        name: 'taskDecision',
        nodes () {
            return [
                {
                    name: 'decisionList',
                    node: (0, $gClzS.decisionList)
                },
                {
                    name: 'decisionItem',
                    node: (0, $2dd6d5f87dea1a71$export$7727308e3d6fe8e9)()
                },
                {
                    name: 'taskList',
                    node: (0, $cXZ4C.taskList)
                },
                {
                    name: 'taskItem',
                    node: (0, $13787dd647975a80$export$aa7ccb8f78e9cbdd)()
                },
                ...(0, $1oCLl.expValEquals)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true) && allowBlockTaskItem ? [
                    {
                        name: 'blockTaskItem',
                        node: (0, $13787dd647975a80$export$526b6659b16d1721)()
                    }
                ] : []
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $e74ddcb3d2085778$export$77b371d6becc8882).getState(editorState);
            const indentLevel = (0, $2fc4254aeefcece8$export$d75a55aec79aaa5)(editorState.selection) || 0;
            const itemIndex = (0, $2fc4254aeefcece8$export$af0098af8462419f)(editorState);
            return {
                focusedTaskItemLocalId: pluginState?.focusedTaskItemLocalId || null,
                isInsideTask: (0, $2fc4254aeefcece8$export$2fad51fb9cb5e2d1)(editorState),
                indentDisabled: itemIndex === 0 || indentLevel >= (0, $5abq6.MAX_INDENTATION_LEVEL),
                outdentDisabled: indentLevel <= 1,
                // hasEditPermission is assumed to be true if pluginState.hasEditPermission is undefined
                // this allows the default plugin state to initialise as true if the extra configuration is not provided
                hasEditPermission: pluginState?.hasEditPermission !== undefined ? pluginState?.hasEditPermission : true,
                requestToEditContent: pluginState?.requestToEditContent,
                hasRequestedEditPermission: pluginState?.hasRequestedEditPermission,
                taskDecisionProvider: pluginState?.taskDecisionProvider,
                openRequestToEditPopupAt: pluginState?.openRequestToEditPopupAt
            };
        },
        commands: {
            toggleTaskList: $2b7d7c8d49850f96$export$2e48e3ea1c210731,
            updateEditPermission: (hasEditPermission)=>({ tr: tr })=>tr.setMeta((0, $e74ddcb3d2085778$export$77b371d6becc8882), {
                        hasEditPermission: hasEditPermission
                    }),
            updateHasRequestedEditPermission: (hasRequestedEditPermission)=>({ tr: tr })=>tr.setMeta((0, $e74ddcb3d2085778$export$77b371d6becc8882), {
                        hasRequestedEditPermission: hasRequestedEditPermission
                    })
        },
        actions: {
            insertTaskDecision: (0, $593b7407307544bb$export$d1657e7847eaa8d6)(api?.analytics?.actions, getIdentifierProvider),
            indentTaskList: (0, $2da1bf346dcac0f3$export$b294289254b8cdac)(api?.analytics?.actions),
            outdentTaskList: (0, $2da1bf346dcac0f3$export$d5d1010fad3453fa)(api?.analytics?.actions),
            setProvider: async (providerPromise)=>{
                const provider = await providerPromise; // Prevent someone trying to set the exact same provider twice for performance reasons+
                if (previousTaskAndDecisionProvider === provider || taskDecisionProvider === providerPromise) return false;
                previousTaskAndDecisionProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>(0, $593b7407307544bb$export$1572b3eade6662f9)(provider)(tr)) ?? false;
            }
        },
        pmPlugins () {
            return [
                {
                    name: 'tasksAndDecisions',
                    plugin: ({ portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, dispatch: dispatch, getIntl: getIntl })=>{
                        return (0, $bc3faaa8c98786d9$export$ae829ec7b2625219)(portalProviderAPI, eventDispatcher, dispatch, api, getIntl, useLongPressSelection, hasEditPermission, hasRequestedEditPermission, requestToEditContent, taskPlaceholder);
                    }
                },
                {
                    name: 'tasksAndDecisionsInputRule',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $ac4bed0eb4b2d5b6$export$2e2bcd8739ae039)(api?.analytics?.actions, getIdentifierProvider)(schema, featureFlags)
                },
                {
                    name: 'tasksAndDecisionsKeyMap',
                    plugin: ({ schema: schema })=>(0, $2da1bf346dcac0f3$export$2e2bcd8739ae039)(schema, api, allowNestedTasks, consumeTabs)
                } // Needs to be after "save-on-enter"
            ];
        },
        secondaryToolbarComponent ({ editorView: editorView, disabled: disabled }) {
            return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                className: (0, $gMc0m.default)([
                    "_1e0c1txw"
                ]),
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ed8ed537ed67ff6e$export$2e2bcd8739ae039), {
                        editorView: editorView,
                        isDisabled: disabled,
                        isReducedSpacing: true,
                        editorAPI: api
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $50c6c5eb0364220d$export$2e2bcd8739ae039), {
                        editorView: editorView,
                        isDisabled: disabled,
                        isReducedSpacing: true,
                        editorAPI: api
                    })
                ]
            });
        },
        contentComponent ({ editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $l998X.jsx)($715bf2373cc9aad1$var$ContentComponent, {
                dependencyApi: api,
                editorView: editorView,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement
            });
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'action',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).action),
                        description: quickInsertActionDescription ?? formatMessage((0, $4HWgE.toolbarInsertBlockMessages).actionDescription),
                        priority: 100,
                        keywords: [
                            'checkbox',
                            'task',
                            'todo'
                        ],
                        keyshortcut: '[]',
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconAction), {}),
                        action (insert, state) {
                            return (0, $593b7407307544bb$export$8c1bb617b1f6f2f1)(api?.analytics?.actions, getIdentifierProvider)(state, 'taskList', (0, $d925B.INPUT_METHOD).QUICK_INSERT, $715bf2373cc9aad1$var$addItem(insert, 'taskList', state.schema));
                        }
                    },
                    {
                        id: 'decision',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).decision),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).decisionDescription),
                        priority: 900,
                        keyshortcut: '<>',
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconDecision), {}),
                        action (insert, state) {
                            return (0, $593b7407307544bb$export$8c1bb617b1f6f2f1)(api?.analytics?.actions, getIdentifierProvider)(state, 'decisionList', (0, $d925B.INPUT_METHOD).QUICK_INSERT, $715bf2373cc9aad1$var$addItem(insert, 'decisionList', state.schema));
                        }
                    }
                ]
        }
    };
};
module.exports["tasksAndDecisionsPlugin"] = $715bf2373cc9aad1$export$582323d9689d93fc;

});

parcelRegister("4FFjp", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $8m4tT = parcelRequire("8m4tT");


var $iD5M5 = parcelRequire("iD5M5");

const $40ae9645382f099a$var$getContentSupportChecker = (targetNodeType)=>{
    return (node)=>{
        try {
            return targetNodeType.validContent((0, $5SAOw.Fragment).from(node));
        } catch  {
            return false;
        }
    };
};
const $40ae9645382f099a$export$95df50ae6315ead6 = (props, onhandleUnsupportedContent)=>{
    const transformedItems = [];
    const { listNode: listNode, isSourceBulletOrOrdered: isSourceBulletOrOrdered, isTargetBulletOrOrdered: isTargetBulletOrOrdered, isSourceTask: isSourceTask, isTargetTask: isTargetTask, supportedListTypes: supportedListTypes, schema: schema, targetNodeType: targetNodeType } = props;
    const { taskList: taskList, listItem: listItem, taskItem: taskItem, paragraph: paragraph } = schema.nodes;
    listNode.forEach((child)=>{
        if (isSourceBulletOrOrdered && isTargetTask) // Convert bullet/ordered => task
        {
            if (child.type === listItem) {
                const inlineContent = [];
                const nestedTaskLists = [];
                child.forEach((grandChild)=>{
                    if (supportedListTypes.has(grandChild.type) && grandChild.type !== taskList) nestedTaskLists.push($40ae9645382f099a$export$95df50ae6315ead6({
                        ...props,
                        listNode: grandChild
                    }, onhandleUnsupportedContent));
                    else if (!$40ae9645382f099a$var$getContentSupportChecker(taskItem)(grandChild) && !grandChild.isTextblock) onhandleUnsupportedContent?.(grandChild);
                    else inlineContent.push(...(0, $iD5M5.convertBlockToInlineContent)(grandChild, schema));
                });
                transformedItems.push(taskItem.create(null, inlineContent.length > 0 ? inlineContent : null));
                transformedItems.push(...nestedTaskLists);
            }
        } else if (isSourceTask && isTargetBulletOrOrdered) {
            // Convert task => bullet/ordered
            if (child.type === taskItem) {
                const inlineContent = [
                    ...child.content.content
                ];
                const paragraphNode = paragraph.create(null, inlineContent.length > 0 ? inlineContent : null);
                transformedItems.push(listItem.create(null, [
                    paragraphNode
                ]));
            } else if (child.type === taskList) {
                const transformedNestedList = $40ae9645382f099a$export$95df50ae6315ead6({
                    ...props,
                    listNode: child
                }, onhandleUnsupportedContent);
                const lastItem = transformedItems[transformedItems.length - 1];
                if (lastItem?.type === listItem) {
                    // Attach nested list to previous item
                    const updatedContent = [
                        ...lastItem.content.content,
                        transformedNestedList
                    ];
                    transformedItems[transformedItems.length - 1] = listItem.create(lastItem.attrs, updatedContent);
                } else // No previous item, flatten nested items
                transformedItems.push(...transformedNestedList.content.content);
            }
        } else if (isSourceBulletOrOrdered && isTargetBulletOrOrdered) {
            if (child.type === listItem) {
                const convertedNestedLists = [];
                child.forEach((grandChild)=>{
                    if (supportedListTypes.has(grandChild.type) && grandChild.type !== targetNodeType) {
                        const convertedNode = $40ae9645382f099a$export$95df50ae6315ead6({
                            ...props,
                            listNode: grandChild
                        }, onhandleUnsupportedContent);
                        convertedNestedLists.push(convertedNode);
                    } else convertedNestedLists.push(grandChild);
                });
                transformedItems.push(listItem.create(null, convertedNestedLists));
            }
        }
    });
    return targetNodeType.create(null, transformedItems);
};
const $40ae9645382f099a$export$f6e356fc6d93cbb1 = (context)=>{
    const { tr: tr, sourceNode: sourceNode, sourcePos: sourcePos, targetNodeType: targetNodeType } = context;
    const nodes = tr.doc.type.schema.nodes;
    const unsupportedContent = [];
    const onhandleUnsupportedContent = (content)=>{
        unsupportedContent.push(content);
    };
    try {
        const listNode = {
            node: sourceNode,
            pos: sourcePos
        };
        const { node: sourceList, pos: listPos } = listNode;
        // const { taskList, listItem, taskItem, paragraph } = nodes;
        const isSourceBulletOrOrdered = (0, $iD5M5.isBulletOrOrderedList)(sourceList.type);
        const isTargetTask = (0, $iD5M5.isTaskList)(targetNodeType);
        const isSourceTask = (0, $iD5M5.isTaskList)(sourceList.type);
        const isTargetBulletOrOrdered = (0, $iD5M5.isBulletOrOrderedList)(targetNodeType);
        const supportedListTypes = (0, $iD5M5.getSupportedListTypesSet)(nodes);
        const newList = $40ae9645382f099a$export$95df50ae6315ead6({
            isSourceBulletOrOrdered: isSourceBulletOrOrdered,
            isSourceTask: isSourceTask,
            isTargetBulletOrOrdered: isTargetBulletOrOrdered,
            isTargetTask: isTargetTask,
            listNode: sourceList,
            schema: tr.doc.type.schema,
            supportedListTypes: supportedListTypes,
            targetNodeType: targetNodeType
        }, onhandleUnsupportedContent);
        tr.replaceWith(listPos, listPos + sourceList.nodeSize, [
            newList,
            ...unsupportedContent
        ]);
        return tr;
    } catch  {
        return tr;
    }
};
const $40ae9645382f099a$export$2f7df9065a975ace = (context)=>{
    const { tr: tr, sourceNode: sourceNode, sourcePos: sourcePos, targetNodeType: targetNodeType } = context;
    const { nodes: nodes } = tr.doc.type.schema;
    const sourceListType = sourceNode.type;
    const isSourceBulletOrOrdered = (0, $iD5M5.isBulletOrOrderedList)(sourceListType);
    const isTargetTask = (0, $iD5M5.isTaskList)(targetNodeType);
    const isSourceTask = (0, $iD5M5.isTaskList)(sourceListType);
    const isTargetBulletOrOrdered = (0, $iD5M5.isBulletOrOrderedList)(targetNodeType);
    // Check if we need structure transformation
    const needsStructureTransform = isSourceBulletOrOrdered && isTargetTask || isSourceTask && isTargetBulletOrOrdered;
    try {
        if (!needsStructureTransform) {
            // Simple type change for same structure lists (bullet <-> ordered)
            // Apply to the main list
            tr.setNodeMarkup(sourcePos, targetNodeType);
            // Apply to nested lists
            const listStart = sourcePos;
            const listEnd = sourcePos + sourceNode.nodeSize;
            const supportedListTypesSet = (0, $iD5M5.getSupportedListTypesSet)(nodes);
            tr.doc.nodesBetween(listStart, listEnd, (node, pos, parent)=>{
                // Only process nested lists (not the root list we already handled)
                if (supportedListTypesSet.has(node.type) && pos !== sourcePos) {
                    const isNestedList = parent && (supportedListTypesSet.has(parent.type) || parent.type === nodes.listItem);
                    if (isNestedList) {
                        const shouldTransformNode = node.type === sourceListType || (0, $iD5M5.isBulletOrOrderedList)(node.type) && isTargetBulletOrOrdered;
                        if (shouldTransformNode) tr.setNodeMarkup(pos, targetNodeType);
                    }
                }
                return true; // Continue traversing
            });
            return tr;
        } else return $40ae9645382f099a$export$f6e356fc6d93cbb1(context);
    } catch  {
        return null;
    }
};
const $40ae9645382f099a$export$201fb3474673bbf3 = (tr, range, targetNodeType, targetAttrs, nodes)=>{
    try {
        const { taskItem: taskItem } = nodes;
        const listItems = [];
        // Process each block in the range
        tr.doc.nodesBetween(range.start, range.end, (node)=>{
            if (node.isBlock) {
                // For block nodes like paragraphs, directly use their inline content
                const inlineContent = [
                    ...node.content.content
                ];
                if (inlineContent.length > 0) {
                    // Create task item with inline content directly
                    const listItem = taskItem.create(targetAttrs, inlineContent);
                    listItems.push(listItem);
                }
            }
            return false; // Don't traverse into children
        });
        if (listItems.length === 0) return null;
        // Create the new task list
        const newList = targetNodeType.create(targetAttrs, listItems);
        // Replace the range with the new list
        tr.replaceWith(range.start, range.end, newList);
        return tr;
    } catch  {
        return null;
    }
};
const $40ae9645382f099a$export$d9cdacbed7444a4a = (context)=>{
    const { tr: tr, targetNodeType: targetNodeType, targetAttrs: targetAttrs, sourceNode: sourceNode, sourcePos: sourcePos } = context;
    const { selection: selection } = tr;
    const schema = selection.$from.doc.type.schema;
    const taskItemsResult = (0, $8m4tT.findChildrenByType)(sourceNode, schema.nodes.taskItem);
    const taskItems = taskItemsResult.map((item)=>item.node);
    const taskItemFragments = taskItems.map((taskItem)=>taskItem.content);
    let targetNodes = [];
    // Convert fragments to headings if target is heading
    if (targetNodeType === schema.nodes.heading && targetAttrs) {
        // convert the fragments to headings
        const targetHeadingLevel = targetAttrs.level;
        targetNodes = taskItemFragments.map((fragment)=>schema.nodes.heading.createChecked({
                level: targetHeadingLevel
            }, fragment.content));
    }
    // Convert fragments to paragraphs if target is paragraphs
    if (targetNodeType === schema.nodes.paragraph) // convert the fragments to paragraphs
    targetNodes = taskItemFragments.map((fragment)=>schema.nodes.paragraph.createChecked({}, fragment.content));
    // Convert fragments to code block if target is code block
    if (targetNodeType === schema.nodes.codeBlock) {
        // convert the fragments to one code block
        const codeBlockContent = taskItemFragments.map((fragment)=>fragment.textBetween(0, fragment.size, '\n')).join('\n');
        targetNodes = [
            schema.nodes.codeBlock.createChecked({}, schema.text(codeBlockContent))
        ];
    }
    // Replace the task list node with the new content in the transaction
    const slice = new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).fromArray(targetNodes), 0, 0);
    const rangeStart = sourcePos !== null ? sourcePos : selection.from;
    tr.replaceRange(rangeStart, rangeStart + sourceNode.nodeSize, slice);
    return tr;
};
const $40ae9645382f099a$export$c0b9021b626ac150 = (tr)=>{
    const { selection: selection } = tr;
    const { nodes: nodes } = tr.doc.type.schema;
    // Find the node to format from the current selection
    let nodeToFormat;
    let nodePos = selection.from;
    // Try to find the current node from selection
    const selectedNode = (0, $8m4tT.findSelectedNodeOfType)([
        nodes.paragraph,
        nodes.heading,
        nodes.blockquote,
        nodes.panel,
        nodes.expand,
        nodes.codeBlock,
        nodes.bulletList,
        nodes.orderedList,
        nodes.taskList,
        nodes.layoutSection
    ])(selection);
    if (selectedNode) {
        nodeToFormat = selectedNode.node;
        nodePos = selectedNode.pos;
    } else {
        // Try to find parent node (including list parents)
        const parentNode = (0, $8m4tT.findParentNodeOfType)([
            nodes.blockquote,
            nodes.panel,
            nodes.expand,
            nodes.codeBlock,
            nodes.listItem,
            nodes.taskItem,
            nodes.layoutSection
        ])(selection);
        if (parentNode) {
            nodeToFormat = parentNode.node;
            nodePos = parentNode.pos;
            const paragraphOrHeadingNode = (0, $8m4tT.findParentNodeOfType)([
                nodes.paragraph,
                nodes.heading
            ])(selection);
            // Special case: if we found a listItem, check if we need the parent list instead
            if (parentNode.node.type === nodes.listItem || parentNode.node.type === nodes.taskItem) {
                const listParent = (0, $8m4tT.findParentNodeOfType)([
                    nodes.bulletList,
                    nodes.orderedList,
                    nodes.taskList
                ])(selection);
                if (listParent) {
                    // For list transformations, we want the list parent, not the listItem
                    nodeToFormat = listParent.node;
                    nodePos = listParent.pos;
                }
            } else if (parentNode.node.type !== nodes.blockquote && paragraphOrHeadingNode) {
                nodeToFormat = paragraphOrHeadingNode.node;
                nodePos = paragraphOrHeadingNode.pos;
            }
        }
    }
    if (!nodeToFormat) {
        nodeToFormat = selection.$from.node();
        nodePos = selection.$from.pos;
    }
    return {
        node: nodeToFormat,
        pos: nodePos
    };
};
module.exports["transformListRecursively"] = $40ae9645382f099a$export$95df50ae6315ead6;
module.exports["transformBetweenListTypes"] = $40ae9645382f099a$export$2f7df9065a975ace;
module.exports["transformToTaskList"] = $40ae9645382f099a$export$201fb3474673bbf3;
module.exports["transformTaskListToBlockNodes"] = $40ae9645382f099a$export$d9cdacbed7444a4a;
module.exports["getFormattedNode"] = $40ae9645382f099a$export$c0b9021b626ac150;

});

parcelRegister("iD5M5", function(module, exports) {
const $0af71c7c009df6fc$export$1d7e7dcd2590e9c6 = (nodeType)=>{
    return nodeType.name === 'bulletList' || nodeType.name === 'orderedList';
};
const $0af71c7c009df6fc$export$adef7a5f125e0514 = (nodeType)=>{
    return nodeType.name === 'taskList';
};
const $0af71c7c009df6fc$export$98148b07df5ff68c = (nodes)=>{
    return [
        nodes.bulletList,
        nodes.orderedList,
        nodes.taskList
    ].filter(Boolean);
};
const $0af71c7c009df6fc$export$3fd351b2ea86488c = (nodes)=>{
    return new Set($0af71c7c009df6fc$export$98148b07df5ff68c(nodes));
};
const $0af71c7c009df6fc$export$3b2ae917fa66948c = (node, schema)=>{
    const { paragraph: paragraph, hardBreak: hardBreak } = schema.nodes;
    if (node.type === paragraph) return [
        ...node.content.content
    ];
    if (node.isBlock) {
        const textContent = node.textContent;
        const lines = textContent.split('\n');
        const newText = [];
        lines.forEach((line, index)=>{
            if (line !== '') newText.push(line ? schema.text(line) : schema.text(' '));
            if (lines.length > 1 && index !== lines.length - 1) newText.push(hardBreak.create());
        });
        return newText;
    }
    return [
        node
    ];
};
module.exports["isBulletOrOrderedList"] = $0af71c7c009df6fc$export$1d7e7dcd2590e9c6;
module.exports["isTaskList"] = $0af71c7c009df6fc$export$adef7a5f125e0514;
module.exports["getSupportedListTypesSet"] = $0af71c7c009df6fc$export$3fd351b2ea86488c;
module.exports["convertBlockToInlineContent"] = $0af71c7c009df6fc$export$3b2ae917fa66948c;

});

parcelRegister("3ihIB", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eiA8Z = parcelRequire("eiA8Z");


var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $6F6hl = parcelRequire("6F6hl");

const $1916947757a3ce4a$var$accessibilityUtilsPluginKey = new (0, $ks2lK.PluginKey)('accessibilityUtilsPlugin');
const $1916947757a3ce4a$export$8bab9b7a6db7fbeb = ({ api: api })=>{
    let editorView;
    const setEditorView = (newEditorView)=>{
        editorView = newEditorView;
    };
    return {
        name: 'accessibilityUtils',
        actions: {
            ariaNotify: (message, ariaLiveElementAttributes)=>{
                if (!editorView) // at time of writing, this should never happen
                return;
                const tr = editorView.state.tr;
                tr.setMeta($1916947757a3ce4a$var$accessibilityUtilsPluginKey, {
                    message: message,
                    ariaLiveElementAttributes: ariaLiveElementAttributes,
                    key: Date.now().toString()
                });
                editorView.dispatch(tr);
                return;
            }
        },
        contentComponent: ()=>{
            return /*#__PURE__*/ (0, $l998X.jsx)($1916947757a3ce4a$var$ContentComponent, {
                api: api
            });
        },
        getSharedState (editorState) {
            if (!editorState) return null;
            return $1916947757a3ce4a$var$accessibilityUtilsPluginKey.getState(editorState);
        },
        pmPlugins () {
            return [
                {
                    name: 'get-editor-view',
                    plugin: ()=>{
                        return new (0, $1S4f7.SafePlugin)({
                            key: $1916947757a3ce4a$var$accessibilityUtilsPluginKey,
                            state: {
                                init: ()=>({
                                        message: '',
                                        ariaLiveElementAttributes: {}
                                    }),
                                apply: (tr, prevState)=>{
                                    const meta = tr.getMeta($1916947757a3ce4a$var$accessibilityUtilsPluginKey);
                                    if (meta) return {
                                        ...prevState,
                                        ...meta
                                    };
                                    return prevState;
                                }
                            },
                            view (editorView) {
                                setEditorView(editorView);
                                return {};
                            }
                        });
                    }
                }
            ];
        }
    };
};
function $1916947757a3ce4a$var$ContentComponent({ api: api }) {
    const { ariaLiveElementAttributes: ariaLiveElementAttributes, key: key, message: message } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'accessibilityUtils'
    ], (states)=>{
        return {
            ariaLiveElementAttributes: states.accessibilityUtilsState?.ariaLiveElementAttributes,
            key: states.accessibilityUtilsState?.key,
            message: states.accessibilityUtilsState?.message
        };
    });
    const role = ariaLiveElementAttributes?.priority === 'important' ? 'alert' : 'status';
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
        testId: 'accessibility-message-wrapper',
        role: role,
        ...role === 'alert' && {
            key: key
        },
        children: message
    });
}
module.exports["accessibilityUtilsPlugin"] = $1916947757a3ce4a$export$8bab9b7a6db7fbeb;

});

parcelRegister("PJ00O", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $8C5kA = parcelRequire("8C5kA");


var $d925B = parcelRequire("d925B");


var $c5kBY = parcelRequire("c5kBY");




parcelRequire("42omo");


var $gmMgo = parcelRequire("gmMgo");


var $eiA8Z = parcelRequire("eiA8Z");


var $61p3e = parcelRequire("61p3e");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $2Pg7f = parcelRequire("2Pg7f");





var $ks2lK = parcelRequire("ks2lK");

/* eslint-disable @repo/internal/styles/no-exported-styles, @atlaskit/design-system/no-nested-styles */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $aFUXX = parcelRequire("aFUXX");


var $6fnsQ = parcelRequire("6fnsQ");

function $849d8d04cecde05d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $849d8d04cecde05d$export$2755d6ea511694ef = /*#__PURE__*/ (0, $9K4OG.css)({
    background: `var(--ds-background-neutral, ${(0, $6fnsQ.N20)})`,
    borderRadius: "var(--ds-radius-full, 9999px)",
    minWidth: "var(--ds-space-400, 32px)",
    marginLeft: "var(--ds-space-negative-050, -4px)"
});
const $849d8d04cecde05d$export$84e713f68a1110f7 = {
    name: "1g5siac",
    styles: "margin-right:var(--ds-space-100, 8px);display:flex;align-items:center;&& > ul{list-style-type:none;}div:last-child button.invite-to-edit{border-radius:var(--ds-radius-full, 9999px);height:32px;width:32px;padding:var(--ds-space-025, 2px);}"
};
const $849d8d04cecde05d$export$4aebd143f31d0c0d = (backgroundColor, textColor)=>/*#__PURE__*/ (0, $9K4OG.css)({
        display: 'block',
        position: 'absolute',
        right: "var(--ds-space-025, 2px)",
        bottom: "var(--ds-space-025, 2px)",
        width: "var(--ds-space-150, 12px)",
        height: "var(--ds-space-150, 12px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $aFUXX.akEditorSmallZIndex),
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
        borderRadius: "var(--ds-radius-small, 3px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: backgroundColor,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: textColor,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: (0, $aFUXX.relativeFontSizeToBase16)(9),
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        paddingTop: "var(--ds-space-075, 6px)",
        textAlign: 'center',
        boxShadow: `0 0 1px ${"var(--ds-border-inverse, #fff)"}`,
        boxSizing: 'border-box'
    });





parcelRequire("42omo");


var $2XqLN = parcelRequire("2XqLN");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766







const $73c72dde0e84c83e$export$1a8ce77350a239fa = (props)=>{
    const participantColor = props.api?.collabEdit?.actions?.getAvatarColor(props.presenceId ?? props.sessionId) ?? {
        backgroundColor: `var(--ds-background-accent-red-subtle, ${0, $6fnsQ.R100})`,
        textColor: `var(--ds-text-accent-gray-bolder, ${0, $6fnsQ.N900})`
    };
    const avatar = props.name.substr(0, 1).toUpperCase();
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $849d8d04cecde05d$export$4aebd143f31d0c0d)(participantColor?.backgroundColor, participantColor?.textColor),
        "data-testid": "editor-collab-badge"
    }, avatar);
};


const $aea62b1d5b248950$var$toAvatar = (participant, api)=>({
        name: participant.name,
        src: participant.avatar,
        size: 'medium',
        presence: /*#__PURE__*/ (0, $l998X.jsx)((0, $73c72dde0e84c83e$export$1a8ce77350a239fa), {
            api: api,
            name: participant.name,
            sessionId: participant.sessionId,
            presenceId: participant.presenceId
        })
    });
var $aea62b1d5b248950$export$2e2bcd8739ae039 = (0, $2XqLN.default)($aea62b1d5b248950$var$toAvatar, function participantEquals([a], [b]) {
    return a.name === b.name && a.avatar === b.avatar && a.sessionId === b.sessionId;
});


const $711e821894e7e93e$var$scrollToCollabCursor = (editorAPI, participants, sessionId, index, editorAnalyticsAPI)=>{
    const selectedUser = participants[index];
    const cursorPos = selectedUser.cursorPos;
    if (selectedUser && cursorPos !== undefined && selectedUser.sessionId !== sessionId) {
        const analyticsPayload = {
            action: (0, $d925B.ACTION).MATCHED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).SELECTION,
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        };
        editorAPI?.core?.actions?.execute(({ tr: tr })=>{
            tr.setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(cursorPos)));
            editorAnalyticsAPI?.attachAnalyticsEvent(analyticsPayload)(tr);
            tr.scrollIntoView();
            return tr;
        });
        editorAPI?.core?.actions?.focus();
    }
};
const $711e821894e7e93e$export$8232a93d94178362 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    const { sessionId: sessionId, featureFlags: featureFlags, editorAPI: editorAPI } = props;
    // .slice() turns ReadonlyArray<CollabParticipant> into a mutable CollabParticipant[]
    const participants = props.participants?.toArray()?.slice();
    if (!participants) return null;
    const avatars = participants.sort((p)=>p.sessionId === sessionId ? -1 : 1).map((participant)=>(0, $aea62b1d5b248950$export$2e2bcd8739ae039)(participant, editorAPI));
    if (!avatars.length) return null;
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $849d8d04cecde05d$export$84e713f68a1110f7)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $2Pg7f.default), {
        appearance: "stack",
        size: "medium",
        data: avatars,
        maxCount: 3,
        onAvatarClick: (_event, _analytics, index)=>{
            const allowCollabAvatarScroll = featureFlags?.collabAvatarScroll;
            // user does not need to scroll to their own position (index 0)
            if (allowCollabAvatarScroll && index > 0) $711e821894e7e93e$var$scrollToCollabCursor(editorAPI, participants, props.sessionId, index, props.editorAnalyticsAPI);
        }
    }), props.children));
});


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $a4eZN = parcelRequire("a4eZN");


var $g5gZt = parcelRequire("g5gZt");


const $f0562110382ae1dd$var$ID = (props)=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, props.children);
const $f0562110382ae1dd$export$c166df103ee37df9 = (props)=>{
    const { Component: Component, onClick: onClick, selected: selected, title: title } = props;
    const iconBefore = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
            label: title
        }), [
        title
    ]);
    if (!Component && !onClick) return null;
    const Wrapper = Component ? Component : $f0562110382ae1dd$var$ID;
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $849d8d04cecde05d$export$2755d6ea511694ef)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)(Wrapper, null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a4eZN.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "invite-to-edit",
        onClick: onClick,
        selected: selected,
        title: title,
        titlePosition: "bottom",
        iconBefore: iconBefore
    }))));
};


const $239a6f15acd3f564$var$AvatarsWithPluginState = (props)=>{
    const title = props.intl.formatMessage((0, $61p3e.default).inviteToEditButtonTitle);
    const { isInviteToEditButtonSelected: selected, inviteToEditHandler: onClick, inviteToEditComponent: Component, editorView: editorView, featureFlags: featureFlags, editorAnalyticsAPI: editorAnalyticsAPI, editorAPI: editorAPI } = props;
    const { sessionId: sessionId, activeParticipants: activeParticipants, initialised: initialised } = (0, $eiA8Z.useSharedPluginStateWithSelector)(editorAPI, [
        'collabEdit'
    ], (states)=>({
            sessionId: states.collabEditState?.sessionId,
            activeParticipants: states.collabEditState?.activeParticipants,
            initialised: states.collabEditState?.initialised
        }));
    if (!initialised) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $711e821894e7e93e$export$8232a93d94178362), {
        sessionId: sessionId,
        participants: activeParticipants,
        editorView: editorView,
        featureFlags: featureFlags,
        editorAnalyticsAPI: editorAnalyticsAPI,
        editorAPI: editorAPI,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $f0562110382ae1dd$export$c166df103ee37df9), {
            title: title,
            selected: selected,
            onClick: onClick,
            Component: Component
        })
    });
};
var $239a6f15acd3f564$export$2e2bcd8739ae039 = (0, $gmMgo.default)($239a6f15acd3f564$var$AvatarsWithPluginState);


function $04f8d7f6355f625f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $04f8d7f6355f625f$var$toolbarButtonWrapper = {
    name: "gzuwk4",
    styles: "display:flex;justify-content:flex-end;flex-grow:0;align-items:center;& > div{margin-right:0;}"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $04f8d7f6355f625f$var$toolbarButtonWrapperFullWidth = /*#__PURE__*/ (0, $9K4OG.css)($04f8d7f6355f625f$var$toolbarButtonWrapper, "flex-grow:1;");
const $04f8d7f6355f625f$var$AvatarGroupPluginWrapper = (props)=>{
    const { dispatchAnalyticsEvent: dispatchAnalyticsEvent, featureFlags: featureFlags } = props;
    const intl = (0, $8C5kA.default)();
    (0, $42omo.useEffect)(()=>{
        if (!dispatchAnalyticsEvent) return;
        dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).VIEWED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).AVATAR_GROUP_PLUGIN,
            eventType: (0, $d925B.EVENT_TYPE).UI
        });
    }, [
        dispatchAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "aria-label": intl.formatMessage((0, $c5kBY.avatarGroupMessages).editors),
        "data-testid": 'avatar-group-in-plugin',
        css: props.takeFullWidth ? $04f8d7f6355f625f$var$toolbarButtonWrapperFullWidth : $04f8d7f6355f625f$var$toolbarButtonWrapper
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $239a6f15acd3f564$export$2e2bcd8739ae039), {
        editorView: props.editorView,
        eventDispatcher: props.eventDispatcher,
        inviteToEditComponent: props.collabEdit && props.collabEdit.inviteToEditComponent,
        inviteToEditHandler: props.collabEdit && props.collabEdit.inviteToEditHandler,
        isInviteToEditButtonSelected: props.collabEdit && props.collabEdit.isInviteToEditButtonSelected,
        featureFlags: featureFlags,
        editorAnalyticsAPI: props.editorAnalyticsAPI,
        editorAPI: props.editorAPI
    }));
};
var $04f8d7f6355f625f$export$2e2bcd8739ae039 = $04f8d7f6355f625f$var$AvatarGroupPluginWrapper;



const $0a1fd9c7a1f16ff9$export$56985cb4934eb626 = ({ config: props, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const primaryToolbarComponent = ({ editorView: editorView, eventDispatcher: eventDispatcher, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $04f8d7f6355f625f$export$2e2bcd8739ae039), {
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            editorView: editorView,
            eventDispatcher: eventDispatcher,
            collabEdit: props?.collabEdit,
            takeFullWidth: props?.takeFullWidth,
            featureFlags: featureFlags,
            editorAnalyticsAPI: api?.analytics?.actions,
            editorAPI: api
        });
    };
    if (props.showAvatarGroup) api?.primaryToolbar?.actions.registerComponent({
        name: 'avatarGroup',
        component: primaryToolbarComponent
    });
    return {
        name: 'avatarGroup',
        primaryToolbarComponent: !api?.primaryToolbar && props.showAvatarGroup ? primaryToolbarComponent : undefined,
        actions: {
            getToolbarItem: ({ inviteToEditHandler: inviteToEditHandler, isInviteToEditButtonSelected: isInviteToEditButtonSelected, inviteToEditComponent: inviteToEditComponent })=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $239a6f15acd3f564$export$2e2bcd8739ae039), {
                    featureFlags: api?.featureFlags?.sharedState.currentState() ?? {},
                    editorAnalyticsAPI: api?.analytics?.actions,
                    editorAPI: api,
                    inviteToEditHandler: inviteToEditHandler,
                    isInviteToEditButtonSelected: isInviteToEditButtonSelected,
                    inviteToEditComponent: inviteToEditComponent
                });
            }
        }
    };
};
module.exports["avatarGroupPlugin"] = $0a1fd9c7a1f16ff9$export$56985cb4934eb626;

});

parcelRegister("fPXRH", function(module, exports) {

var $7Mtx3 = parcelRequire("7Mtx3");

var $9YoeD = parcelRequire("9YoeD");


var $aXG5V = parcelRequire("aXG5V");

const $87a97b02b68ffbeb$export$1ccab2571cac8f23 = (step)=>{
    if (step instanceof (0, $9YoeD.SetAttrsStep)) return {
        position: step.pos,
        attrs: step.attrs
    };
    return {
        position: step.pos,
        attrs: {
            [step.attr]: step.value
        }
    };
};
const $87a97b02b68ffbeb$export$2d36bf32f2dffb3e = (steps)=>{
    const mappedData = steps.reduce((acc, step)=>{
        const parsedStep = $87a97b02b68ffbeb$export$1ccab2571cac8f23(step);
        const previousAttributes = acc.get(parsedStep.position) || {};
        acc.set(parsedStep.position, {
            ...previousAttributes,
            ...parsedStep.attrs
        });
        return acc;
    }, new Map());
    return Array.from(mappedData, ([position, attrs])=>({
            position: position,
            attrs: attrs
        }));
};
const $87a97b02b68ffbeb$var$isValidSteps = (steps)=>{
    const hasInvalidSteps = steps.some((step)=>{
        const isSetAttrsStep = step instanceof (0, $9YoeD.SetAttrsStep);
        const isAttrStep = step instanceof (0, $aXG5V.AttrStep);
        const isValidStep = isSetAttrsStep || isAttrStep;
        return !isValidStep;
    });
    return !hasInvalidSteps;
};
const $87a97b02b68ffbeb$export$383250d570a1fb48 = ({ doc: doc, steps: maybeAttrSteps })=>{
    if (!$87a97b02b68ffbeb$var$isValidSteps(maybeAttrSteps)) // This is important to avoid any bad usage to ending up with data loss
    throw new Error('BatchAttrsSteps error: Invalid BatchStep usage - non attribute step used');
    const positionsAndAttributesData = $87a97b02b68ffbeb$export$2d36bf32f2dffb3e(maybeAttrSteps);
    const data = positionsAndAttributesData.map(({ position: position, attrs: attrs })=>{
        const maybeNode = doc.nodeAt(position);
        if (!maybeNode) throw new Error(`BatchAttrsSteps error: Node does not exist at the position ${position}.`);
        const nodeType = maybeNode.type.name;
        return {
            position: position,
            attrs: attrs,
            nodeType: nodeType
        };
    });
    return new (0, $7Mtx3.BatchAttrsStep)(data);
};


const $109ba4bfab5ff805$export$5af772f765987c49 = ()=>{
    return {
        name: 'batchAttributeUpdates',
        actions: {
            batchSteps: $87a97b02b68ffbeb$export$383250d570a1fb48
        }
    };
};
module.exports["batchAttributeUpdatesPlugin"] = $109ba4bfab5ff805$export$5af772f765987c49;

});

parcelRegister("hSJYu", function(module, exports) {

var $eINDz = parcelRequire("eINDz");

const $bb41ee0a2501fba2$export$39349c329288443f = ()=>({
        name: 'border',
        marks () {
            return [
                {
                    name: 'border',
                    mark: (0, $eINDz.border)
                }
            ];
        }
    });
module.exports["borderPlugin"] = $bb41ee0a2501fba2$export$39349c329288443f;

});

parcelRegister("01uqX", function(module, exports) {

var $7Rcde = parcelRequire("7Rcde");


var $1S4f7 = parcelRequire("1S4f7");


var $ftzrq = parcelRequire("ftzrq");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $ks2lK = parcelRequire("ks2lK");

const $03134e7b83656df3$export$bdb7e84dad6ef3a = new (0, $ks2lK.PluginKey)('codeBidiWarningPlugin');



var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cUcZ5 = parcelRequire("cUcZ5");


var $g7Pc3 = parcelRequire("g7Pc3");


var $03WRT = parcelRequire("03WRT");


var $lkJUe = parcelRequire("lkJUe");

var $kTbzR = parcelRequire("kTbzR");





var $defaa468a0f3b2b9$export$2e2bcd8739ae039 = (pluginState, action)=>{
    return pluginState;
};


const $23228c277756d7fb$export$a4805b2c1b031d72 = (nodeViewPortalProviderAPI)=>(0, $lkJUe.pluginFactory)((0, $03134e7b83656df3$export$bdb7e84dad6ef3a), (0, $defaa468a0f3b2b9$export$2e2bcd8739ae039), {
        onDocChanged: (tr, pluginState)=>{
            if (!tr.steps.find((0, $kTbzR.stepHasSlice))) return pluginState;
            const newBidiWarningsDecorationSet = $23228c277756d7fb$export$f1e73511389847e5({
                doc: tr.doc,
                codeBidiWarningLabel: pluginState.codeBidiWarningLabel,
                tooltipEnabled: pluginState.tooltipEnabled,
                nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
            });
            return {
                ...pluginState,
                decorationSet: newBidiWarningsDecorationSet
            };
        }
    });
function $23228c277756d7fb$export$f1e73511389847e5({ doc: doc, codeBidiWarningLabel: codeBidiWarningLabel, tooltipEnabled: tooltipEnabled, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }) {
    const bidiCharactersAndTheirPositions = [];
    doc.descendants((node, pos)=>{
        const isTextWithCodeMark = node.type.name === 'text' && node.marks && node.marks.some((mark)=>mark.type.name === 'code');
        if (isTextWithCodeMark) {
            (0, $03WRT.default)(node.textContent, ({ bidiCharacter: bidiCharacter, index: index })=>{
                bidiCharactersAndTheirPositions.push({
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    position: pos + index,
                    bidiCharacter: bidiCharacter
                });
            });
            return false;
        }
        const isCodeBlock = node.type.name === 'codeBlock';
        if (isCodeBlock) (0, $03WRT.default)(node.textContent, ({ bidiCharacter: bidiCharacter, index: index })=>{
            bidiCharactersAndTheirPositions.push({
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                position: pos + index + 1,
                bidiCharacter: bidiCharacter
            });
        });
    });
    // Bidi characters are not expected to commonly appear in code snippets, so recreating the decoration set
    // for documents rather than reusing existing decorations seems a reasonable performance/complexity tradeoff.
    if (bidiCharactersAndTheirPositions.length === 0) return (0, $ftzrq.DecorationSet).empty;
    const newBidiWarningsDecorationSet = (0, $ftzrq.DecorationSet).create(doc, bidiCharactersAndTheirPositions.map(({ position: position, bidiCharacter: bidiCharacter })=>{
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const renderKey = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
        return (0, $ftzrq.Decoration).widget(position, (el)=>$23228c277756d7fb$var$renderDOM({
                bidiCharacter: bidiCharacter,
                codeBidiWarningLabel: codeBidiWarningLabel,
                tooltipEnabled: tooltipEnabled,
                nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                renderKey: renderKey
            }), {
            destroy: (el)=>{
            // removing portalprovider clean up due to a rendering bug
            // with this plugin under React 18. This matches the previous
            // React 16 behaviour which never cleaned up rendering.
            //
            // This will mean CodeBidi instances are not cleaned up, but
            // this is expected to be minimal due to the low frequency of
            // bidi characters in code blocks.
            //
            // We will fix this in a follow up ticket to rewrite the plugin
            // to use pure toDOM -> ED-26540
            // nodeViewPortalProviderAPI.remove(renderKey);
            }
        });
    }));
    return newBidiWarningsDecorationSet;
}
function $23228c277756d7fb$var$renderDOM({ bidiCharacter: bidiCharacter, codeBidiWarningLabel: codeBidiWarningLabel, tooltipEnabled: tooltipEnabled, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, renderKey: renderKey }) {
    const element = document.createElement('span');
    nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $g7Pc3.default), {
            bidiCharacter: bidiCharacter,
            skipChildren: true,
            label: codeBidiWarningLabel,
            tooltipEnabled: tooltipEnabled
        }), element, renderKey);
    return element;
}











var $5SAOw = parcelRequire("5SAOw");




function $f49bdad54933e9dd$export$44a184e2acd6f193(bidiCharacter, codeBidiWarningLabel, tooltipEnabled) {
    const bidiCharacterCode = `U+${bidiCharacter.codePointAt(0)?.toString(16)?.toUpperCase()}`;
    return [
        'span',
        {
            'data-prosemirror-node-name': 'code-bidi-warning',
            dir: 'ltr'
        },
        // Code Bidi Warning Decorator
        [
            'span',
            {
                'data-bidi-component': 'code-bidi-warning-decorator',
                'data-testid': 'code-bidi-warning-decorator',
                'data-bidi-character-code': bidiCharacterCode,
                role: 'mark'
            },
            // Mark the < and > characters as visually hidden for screen readers
            [
                'span',
                {
                    'aria-hidden': 'true'
                },
                '<'
            ],
            bidiCharacterCode,
            [
                'span',
                {
                    'aria-hidden': 'true'
                },
                '>'
            ]
        ],
        // Code Bidi Warning Tooltip
        ...tooltipEnabled ? [
            [
                'span',
                {
                    'data-bidi-component': 'code-bidi-warning-tooltip',
                    role: 'tooltip'
                },
                codeBidiWarningLabel
            ]
        ] : []
    ];
}




const $fd1e2b014c518a11$export$a4805b2c1b031d72 = ()=>(0, $lkJUe.pluginFactory)((0, $03134e7b83656df3$export$bdb7e84dad6ef3a), (0, $defaa468a0f3b2b9$export$2e2bcd8739ae039), {
        onDocChanged: (tr, pluginState)=>{
            if (!tr.steps.find((0, $kTbzR.stepHasSlice))) return pluginState;
            const newBidiWarningsDecorationSet = $fd1e2b014c518a11$export$f1e73511389847e5({
                doc: tr.doc,
                codeBidiWarningLabel: pluginState.codeBidiWarningLabel,
                tooltipEnabled: pluginState.tooltipEnabled
            });
            return {
                ...pluginState,
                decorationSet: newBidiWarningsDecorationSet
            };
        }
    });
function $fd1e2b014c518a11$var$assertIsElement(node) {
    // Using 1 instead of Node.ELEMENT_NODE just in case Node is not defined in some environments
    if (node.nodeType !== 1) throw new Error('Code Bidi Warning DOM spec did not return an Element node');
}
function $fd1e2b014c518a11$export$f1e73511389847e5({ doc: doc, codeBidiWarningLabel: codeBidiWarningLabel, tooltipEnabled: tooltipEnabled }) {
    const bidiCharactersAndTheirPositions = [];
    doc.descendants((node, pos)=>{
        const isTextWithCodeMark = node.type.name === 'text' && node.marks && node.marks.some((mark)=>mark.type.name === 'code');
        if (isTextWithCodeMark) {
            (0, $03WRT.default)(node.textContent, ({ bidiCharacter: bidiCharacter, index: index })=>{
                bidiCharactersAndTheirPositions.push({
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    position: pos + index,
                    bidiCharacter: bidiCharacter
                });
            });
            return false;
        }
        const isCodeBlock = node.type.name === 'codeBlock';
        if (isCodeBlock) (0, $03WRT.default)(node.textContent, ({ bidiCharacter: bidiCharacter, index: index })=>{
            bidiCharactersAndTheirPositions.push({
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                position: pos + index + 1,
                bidiCharacter: bidiCharacter
            });
        });
    });
    // Bidi characters are not expected to commonly appear in code snippets, so recreating the decoration set
    // for documents rather than reusing existing decorations seems a reasonable performance/complexity tradeoff.
    if (bidiCharactersAndTheirPositions.length === 0) return (0, $ftzrq.DecorationSet).empty;
    return (0, $ftzrq.DecorationSet).create(doc, bidiCharactersAndTheirPositions.map(({ position: position, bidiCharacter: bidiCharacter })=>{
        return (0, $ftzrq.Decoration).widget(position, ()=>$fd1e2b014c518a11$var$renderDOM(bidiCharacter, codeBidiWarningLabel, tooltipEnabled), {
            destroy: (node)=>{
                $fd1e2b014c518a11$var$assertIsElement(node);
                node.remove();
            }
        });
    }));
}
function $fd1e2b014c518a11$var$renderDOM(bidiCharacter, codeBidiWarningLabel, tooltipEnabled) {
    const spec = (0, $f49bdad54933e9dd$export$44a184e2acd6f193)(bidiCharacter, codeBidiWarningLabel, tooltipEnabled);
    const { dom: dom } = (0, $5SAOw.DOMSerializer).renderSpec(document, spec);
    // In SSR or non-browser DOM implementations, HTMLElement may not be present or cross-realm.
    // Accept any Element node (nodeType === Node.ELEMENT_NODE) instead of relying on instanceof checks.
    $fd1e2b014c518a11$var$assertIsElement(dom);
    return dom;
}


const $23b3865760ba2e9b$export$ae829ec7b2625219 = (api, { dispatch: dispatch, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }, { appearance: appearance })=>{
    const intl = getIntl();
    const codeBidiWarningLabel = intl.formatMessage((0, $7Rcde.codeBidiWarningMessages).label);
    const { createPluginState: createPluginState, getPluginState: getPluginState } = (0, $dh538.fg)('platform_editor_vanilla_codebidi_warning') ? (0, $fd1e2b014c518a11$export$a4805b2c1b031d72)() : (0, $23228c277756d7fb$export$a4805b2c1b031d72)(nodeViewPortalProviderAPI);
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $03134e7b83656df3$export$bdb7e84dad6ef3a),
        state: createPluginState(dispatch, (state)=>{
            if ((0, $1oCLl.expValEquals)('platform_editor_remove_bidi_char_warning', 'isEnabled', true)) return {
                decorationSet: (0, $ftzrq.DecorationSet).empty,
                codeBidiWarningLabel: '',
                tooltipEnabled: false
            };
            if (api?.limitedMode?.sharedState.currentState()?.enabled) return {
                decorationSet: (0, $ftzrq.DecorationSet).empty,
                codeBidiWarningLabel: '',
                tooltipEnabled: false
            };
            return {
                decorationSet: (0, $dh538.fg)('platform_editor_vanilla_codebidi_warning') ? (0, $fd1e2b014c518a11$export$f1e73511389847e5)({
                    doc: state.doc,
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    tooltipEnabled: true
                }) : (0, $23228c277756d7fb$export$f1e73511389847e5)({
                    doc: state.doc,
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    tooltipEnabled: true,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                }),
                codeBidiWarningLabel: codeBidiWarningLabel,
                tooltipEnabled: true
            };
        }),
        props: {
            decorations: (state)=>{
                if ((0, $1oCLl.expValEquals)('platform_editor_remove_bidi_char_warning', 'isEnabled', true)) return (0, $ftzrq.DecorationSet).empty;
                const { decorationSet: decorationSet } = getPluginState(state);
                return decorationSet;
            }
        }
    });
};


const $ee52efc8a78efe34$export$d7bb9295cdf61833 = ({ config: config, api: api })=>({
        name: 'codeBidiWarning',
        pmPlugins () {
            return [
                {
                    name: 'codeBidiWarning',
                    plugin: (options)=>{
                        return (0, $23b3865760ba2e9b$export$ae829ec7b2625219)(api, options, config ?? {});
                    }
                }
            ];
        }
    });
module.exports["codeBidiWarningPlugin"] = $ee52efc8a78efe34$export$d7bb9295cdf61833;

});

parcelRegister("bS1lJ", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $dus6D = parcelRequire("dus6D");


var $6tl2G = parcelRequire("6tl2G");


var $ke2AI = parcelRequire("ke2AI");


var $ks2lK = parcelRequire("ks2lK");

const $131d10f93817f2cc$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('customAutoformatPlugin');
const $131d10f93817f2cc$export$f05434c51e3762e = (editorState)=>$131d10f93817f2cc$export$18d4026d1ea86bb1.getState(editorState);
const $131d10f93817f2cc$export$c921af6adf4fd3e2 = (tr, action)=>{
    return tr.setMeta($131d10f93817f2cc$export$18d4026d1ea86bb1, action);
};


const $f1668ed15bca155e$export$c95e7d405e6ed1df = (_regex, handler)=>{
    return async (view, match, start, end)=>{
        const replacementPromise = handler(match.slice(1, match.length - 1));
        // queue the position and match pair so that we can remap across transactions
        // while we wait for the replacmentPromise to resolve
        view.dispatch((0, $131d10f93817f2cc$export$c921af6adf4fd3e2)(view.state.tr, {
            action: 'matched',
            match: match,
            start: start,
            end: end
        }));
        // ask the provider to give us an ADF node to replace the text with
        const replacementData = await replacementPromise;
        const replacementNode = (0, $6tl2G.processRawValue)(view.state.schema, replacementData);
        view.dispatch((0, $131d10f93817f2cc$export$c921af6adf4fd3e2)(view.state.tr, {
            action: 'resolved',
            matchString: match[0],
            replacement: replacementNode
        }));
        return replacementData;
    };
};
const $f1668ed15bca155e$export$44515d004ac96c3b = (docText, match)=>{
    const REPLACEMENT_CHARACTER = '\ufffc';
    const docTextStartChar = docText[0];
    const docTextEndSlice = docText.slice(1);
    const matchStartChar = match[0][0];
    const matchEndSlice = match[0].slice(1);
    const slicesMatch = docTextEndSlice === matchEndSlice;
    const isAlternator = docTextStartChar === '|';
    const isObjReplaceChar = matchStartChar === REPLACEMENT_CHARACTER;
    return slicesMatch && isAlternator && isObjReplaceChar;
};
const $f1668ed15bca155e$export$e9a01ad76956fe83 = (view, state)=>{
    const { inlineCard: inlineCard } = view.state.schema.nodes;
    state.matches.forEach((completedMatch)=>{
        const matchingRequests = state.resolving.filter((candidate)=>candidate.match[0] === completedMatch.matchString);
        let tr = view.state.tr;
        matchingRequests.forEach((request)=>{
            const { match: match, start: start, end: end } = request;
            const { replacement: replacement } = completedMatch;
            const prefix = match[1];
            const suffix = match[match.length - 1];
            const matchEndPos = end + suffix.length;
            // only permit inlineCard as replacement target for now
            if (!replacement || replacement.type !== inlineCard && !replacement.isText) return;
            // get the current document text, adding # or | if we cross node boundaries
            const docText = view.state.doc.textBetween(start, matchEndPos, '#', '|');
            const canAutoformatAfterSoftbreak = $f1668ed15bca155e$export$44515d004ac96c3b(docText, match);
            // only replace if text still remains the same as when typed at the start
            if (docText === match[0] || canAutoformatAfterSoftbreak) tr = tr.replaceWith(tr.mapping.map(start + prefix.length), tr.mapping.map(end, -1), replacement);
        });
        // clear this match from plugin state now that we've processed it
        tr = (0, $131d10f93817f2cc$export$c921af6adf4fd3e2)(tr, {
            action: 'finish',
            matchString: completedMatch.matchString
        });
        // and dispatch the replacement, closing history for cmd+z to allow undo separately
        view.dispatch((0, $ke2AI.closeHistory)(tr));
    });
};


const $b8aef149b15efe55$var$MAX_MATCH = 500;
const $b8aef149b15efe55$export$2b7343a2464fe84e = (view, rules, from, to, text)=>{
    const { state: state } = view;
    const $from = state.doc.resolve(from);
    if ($from.parent.type.spec.code) return false;
    const textBefore = $from.parent.textBetween(Math.max(0, $from.parentOffset - $b8aef149b15efe55$var$MAX_MATCH), $from.parentOffset, undefined, '\ufffc') + text;
    // loop through rules trying to find one that matches
    for(let i = 0; i < rules.length; i++){
        let match;
        if (text.length) match = rules[i].matchTyping.exec(textBefore);
        else match = rules[i].matchEnter.exec(textBefore);
        if (match) {
            // kick off the handler
            const pos = from - (match[0].length - text.length);
            rules[i].handler(view, match, pos, to);
            return true;
        }
    }
    return false;
};


const $6d3dbd7d7860c54d$export$b373f08cf72033a1 = (state, action)=>({
        ...state,
        resolving: [
            ...state.resolving,
            {
                start: action.start,
                end: action.end,
                match: action.match
            }
        ]
    });
const $6d3dbd7d7860c54d$export$d06d16b20ced9190 = (state, action)=>({
        ...state,
        matches: [
            ...state.matches,
            {
                replacement: action.replacement,
                matchString: action.matchString
            }
        ]
    });
const $6d3dbd7d7860c54d$export$5953b28951b32649 = (state, action)=>{
    return {
        ...state,
        resolving: state.resolving.filter((resolving)=>resolving.match[0] !== action.matchString),
        matches: state.matches.filter((matching)=>matching.matchString !== action.matchString)
    };
};
const $6d3dbd7d7860c54d$export$1572b3eade6662f9 = (state, action)=>{
    return {
        ...state,
        autoformattingProvider: action.provider
    };
};


const $a0456d233170b8b0$var$reduce = (state, action)=>{
    switch(action.action){
        case 'matched':
            return (0, $6d3dbd7d7860c54d$export$b373f08cf72033a1)(state, action);
        case 'resolved':
            return (0, $6d3dbd7d7860c54d$export$d06d16b20ced9190)(state, action);
        case 'finish':
            return (0, $6d3dbd7d7860c54d$export$5953b28951b32649)(state, action);
        case 'setProvider':
            return (0, $6d3dbd7d7860c54d$export$1572b3eade6662f9)(state, action);
        default:
            return state;
    }
};
var $a0456d233170b8b0$export$2e2bcd8739ae039 = $a0456d233170b8b0$var$reduce;



const $38455a59ff85d29b$export$ad324b5166a7fb7 = ({ providerFactory: providerFactory }, options, api)=>{
    const rules = [];
    return new (0, $1S4f7.SafePlugin)({
        state: {
            init () {
                return {
                    resolving: [],
                    matches: [],
                    autoformattingProvider: undefined
                };
            },
            apply (tr, prevPluginState) {
                if (!prevPluginState) return prevPluginState;
                // remap positions
                const remappedPluginState = {
                    ...prevPluginState,
                    resolving: prevPluginState.resolving.map((candidate)=>({
                            ...candidate,
                            start: tr.mapping.map(candidate.start),
                            end: tr.mapping.map(candidate.end, -1)
                        }))
                };
                const meta = tr.getMeta((0, $131d10f93817f2cc$export$18d4026d1ea86bb1));
                if (!meta) return remappedPluginState;
                return (0, $a0456d233170b8b0$export$2e2bcd8739ae039)(remappedPluginState, meta);
            }
        },
        props: {
            handleTextInput (view, from, to, text) {
                (0, $b8aef149b15efe55$export$2b7343a2464fe84e)(view, rules, from, to, text);
                return false;
            },
            handleKeyDown: (0, $dus6D.keydownHandler)({
                Enter: (_state, _dispatch, view)=>{
                    if (view) (0, $b8aef149b15efe55$export$2b7343a2464fe84e)(view, rules, view.state.selection.from, view.state.selection.to, '');
                    return false;
                }
            })
        },
        view () {
            const handleProvider = (name, provider)=>{
                if (name !== 'autoformattingProvider' || !provider) return;
                provider.then(async (autoformattingProvider)=>{
                    const ruleset = await autoformattingProvider.getRules();
                    Object.keys(ruleset).forEach((rule)=>{
                        const inputRule = {
                            /**
							 * On Shift + Enter, after the first word an Object Replacement Character (/ufffc) is added.
							 * We still want to match strings that start with an Object Replacement Character.
							 */ // Ignored via go/ees005
                            // eslint-disable-next-line require-unicode-regexp
                            matchTyping: new RegExp('(\\s+|^|\\ufffc)' + rule + '(\\s|,|\\.)$'),
                            // Ignored via go/ees005
                            // eslint-disable-next-line require-unicode-regexp
                            matchEnter: new RegExp('(\\s+|^)' + rule + '()$'),
                            handler: (0, $f1668ed15bca155e$export$c95e7d405e6ed1df)(rule, ruleset[rule])
                        };
                        rules.push(inputRule);
                    });
                });
            };
            if (options?.autoformattingProvider) handleProvider('autoformattingProvider', options.autoformattingProvider);
            return {
                update (view) {
                    const currentState = (0, $131d10f93817f2cc$export$f05434c51e3762e)(view.state);
                    if (!currentState) return;
                    // make replacements in document for finished autoformats
                    if (currentState.matches) (0, $f1668ed15bca155e$export$e9a01ad76956fe83)(view, currentState);
                }
            };
        },
        key: (0, $131d10f93817f2cc$export$18d4026d1ea86bb1)
    });
};
const $38455a59ff85d29b$export$1572b3eade6662f9 = (provider)=>(tr)=>{
        return (0, $131d10f93817f2cc$export$c921af6adf4fd3e2)(tr, {
            action: 'setProvider',
            provider: provider
        });
    };
const $38455a59ff85d29b$export$aa4fc86248a63de6 = ({ api: api, config: options })=>{
    let previousProvider;
    if (options?.autoformattingProvider) options.autoformattingProvider.then((provider)=>{
        api?.core.actions.execute(({ tr: tr })=>$38455a59ff85d29b$export$1572b3eade6662f9(provider)(tr));
    });
    return {
        name: 'customAutoformat',
        pmPlugins () {
            return [
                {
                    name: 'customAutoformat',
                    plugin: (pmPluginFactoryParams)=>{
                        return $38455a59ff85d29b$export$ad324b5166a7fb7(pmPluginFactoryParams, options, api);
                    }
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return;
            const { autoformattingProvider: autoformattingProvider } = (0, $131d10f93817f2cc$export$f05434c51e3762e)(editorState) ?? {};
            return {
                autoformattingProvider: autoformattingProvider
            };
        },
        actions: {
            setProvider: async (providerPromise)=>{
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons+
                if (previousProvider === provider || options?.autoformattingProvider === providerPromise) return false;
                previousProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>$38455a59ff85d29b$export$1572b3eade6662f9(provider)(tr)) ?? false;
            }
        }
    };
};
module.exports["customAutoformatPlugin"] = $38455a59ff85d29b$export$aa4fc86248a63de6;

});

parcelRegister("2nH2Y", function(module, exports) {

var $4dOgb = parcelRequire("4dOgb");

const $e8dc27017aa97706$export$1dc90efb79c37811 = ()=>({
        name: 'dataConsumer',
        marks () {
            return [
                {
                    name: 'dataConsumer',
                    mark: (0, $4dOgb.dataConsumer)
                }
            ];
        }
    });
module.exports["dataConsumerPlugin"] = $e8dc27017aa97706$export$1dc90efb79c37811;

});

parcelRegister("1GAIu", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $aXG5V = parcelRequire("aXG5V");


var $14sLv = parcelRequire("14sLv");

const $66ec9ab0f200151b$export$a86035451b36e0f9 = new (0, $ks2lK.PluginKey)('scrollIntoViewPlugin');
/**
 * Determines if a transaction contains changes that should trigger scrolling into view.
 * This includes:
 * - Specific step types (Replace, ReplaceAround)
 */ const $66ec9ab0f200151b$var$hasRelevantChanges = (tr)=>{
    // Check if there are any steps that modified the document
    if (!tr.docChanged) return false;
    // Look for specific types of steps that should trigger scrolling
    const hasRelevantStep = tr.steps.some((step)=>step instanceof (0, $aXG5V.ReplaceStep) || step instanceof (0, $aXG5V.ReplaceAroundStep));
    return hasRelevantStep;
};
const $66ec9ab0f200151b$var$createPlugin = ()=>new (0, $1S4f7.SafePlugin)({
        key: $66ec9ab0f200151b$export$a86035451b36e0f9,
        appendTransaction: (transactions, _oldState, newState)=>{
            if (!transactions.length) return;
            const tr = transactions[0];
            if (($66ec9ab0f200151b$var$hasRelevantChanges(tr) || tr.storedMarksSet) && !tr.scrolledIntoView && tr.getMeta('scrollIntoView') !== false && // ignore anything we would not want to undo
            // this covers things like autofixing layouts, hovering table rows/cols
            tr.getMeta('addToHistory') !== false && // ignore collab changes from another user
            !tr.getMeta('isRemote') && // ignore any transaction coming from the input text rule plugin
            !tr.getMeta((0, $14sLv.TEXT_INPUT_RULE_TRANSACTION_KEY)) && // ignore appended transactions as they should be treated as side effects
            tr.getMeta('appendedTransaction') === undefined) return newState.tr.scrollIntoView();
        }
    });
const $66ec9ab0f200151b$export$750392944713b1a5 = ()=>({
        name: 'scrollIntoView',
        pmPlugins () {
            return [
                {
                    name: 'scrollIntoView',
                    plugin: ()=>$66ec9ab0f200151b$var$createPlugin()
                }
            ];
        }
    });
module.exports["scrollIntoViewPlugin"] = $66ec9ab0f200151b$export$750392944713b1a5;

});

parcelRegister("59fTa", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eiA8Z = parcelRequire("eiA8Z");


var $d925B = parcelRequire("d925B");

var $aSgIe = parcelRequire("aSgIe");


var $dAtrv = parcelRequire("dAtrv");

var $1342a56b1febaadc$export$ad3c0356f902fd97 = /*#__PURE__*/ function(PastePluginActionTypes) {
    PastePluginActionTypes["START_TRACKING_PASTED_MACRO_POSITIONS"] = "START_TRACKING_PASTED_MACRO_POSITIONS";
    PastePluginActionTypes["STOP_TRACKING_PASTED_MACRO_POSITIONS"] = "STOP_TRACKING_PASTED_MACRO_POSITIONS";
    PastePluginActionTypes["SHOW_PASTE_OPTIONS"] = "SHOW_PASTE_OPTIONS";
    PastePluginActionTypes["HIDE_PASTE_OPTIONS"] = "HIDE_PASTE_OPTIONS";
    PastePluginActionTypes["HIGHLIGHT_CONTENT"] = "HIGHLIGHT_CONTENT";
    PastePluginActionTypes["CHANGE_FORMAT"] = "CHANGE_FORMAT";
    return PastePluginActionTypes;
}({});



var $lkJUe = parcelRequire("lkJUe");



var $ks2lK = parcelRequire("ks2lK");

const $605b26f4929db737$export$2b71482310d8c520 = new (0, $ks2lK.PluginKey)('paste-options');
var $605b26f4929db737$export$ec4e67a10e59fca = /*#__PURE__*/ function(ToolbarDropdownOption) {
    ToolbarDropdownOption[ToolbarDropdownOption["Markdown"] = 0] = "Markdown";
    ToolbarDropdownOption[ToolbarDropdownOption["RichText"] = 1] = "RichText";
    ToolbarDropdownOption[ToolbarDropdownOption["PlainText"] = 2] = "PlainText";
    ToolbarDropdownOption[ToolbarDropdownOption["None"] = 3] = "None";
    return ToolbarDropdownOption;
}({});


const $1f78ff91b043d5f4$export$164821e1c3d789fd = 'ak-editor-paste-toolbar';
const $1f78ff91b043d5f4$export$81e541fc7755f475 = 'ak-editor-paste-toolbar-item-dropdownList';
const $1f78ff91b043d5f4$export$78dda1ebb9a1ea84 = 'text-highlight';
const $1f78ff91b043d5f4$export$d829547aa567b0f1 = 'paste-highlight-decoration-key';
const $1f78ff91b043d5f4$export$af443436fa5992cb = 'ak-editor-paste-toolbar-item';
const $1f78ff91b043d5f4$export$220f0307408bc0c = 'akEditor';
const $1f78ff91b043d5f4$export$299d35c5583816ad = 'paste-options-testid';
const $1f78ff91b043d5f4$export$d1234a98f427930 = 'paste-options$';



const $c58e58996beaa411$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case (0, $1342a56b1febaadc$export$ad3c0356f902fd97).SHOW_PASTE_OPTIONS:
            return {
                ...state,
                showToolbar: true,
                highlightContent: false,
                isPlainText: action.data.isPlainText,
                plaintext: action.data.plaintext,
                selectedOption: action.data.selectedOption,
                richTextSlice: action.data.richTextSlice,
                pasteStartPos: action.data.pasteStartPos,
                pasteEndPos: action.data.pasteEndPos
            };
        case (0, $1342a56b1febaadc$export$ad3c0356f902fd97).HIDE_PASTE_OPTIONS:
            return {
                ...state,
                highlightContent: false,
                showToolbar: false
            };
        case (0, $1342a56b1febaadc$export$ad3c0356f902fd97).HIGHLIGHT_CONTENT:
            return {
                ...state,
                highlightContent: true
            };
        case (0, $1342a56b1febaadc$export$ad3c0356f902fd97).CHANGE_FORMAT:
            return {
                ...state,
                highlightContent: true,
                selectedOption: action.data.selectedOption
            };
        default:
            return state;
    }
};


const { createPluginState: $e07496a754522791$export$656c7661095efe2e, createCommand: $e07496a754522791$export$8d4021544bdece00, getPluginState: $e07496a754522791$export$f05434c51e3762e } = (0, $lkJUe.pluginFactory)((0, $605b26f4929db737$export$2b71482310d8c520), (0, $c58e58996beaa411$export$1650419e431d3ba3), {
    mapping: (tr, pluginState)=>{
        if (!tr.docChanged || !pluginState.showToolbar) return pluginState;
        const oldPasteStartPos = pluginState.pasteStartPos;
        const oldPasteEndPos = pluginState.pasteEndPos;
        const newPasteStartPos = tr.mapping.map(oldPasteStartPos);
        const newPasteEndPos = tr.mapping.map(oldPasteEndPos);
        //this is true when user changes format from the toolbar.
        //only change pasteEndPos in this case
        if ($e07496a754522791$var$changedFormatFromToolbar(tr)) return {
            ...pluginState,
            pasteEndPos: newPasteEndPos
        };
        if (oldPasteStartPos === newPasteStartPos && oldPasteEndPos === newPasteEndPos) return pluginState;
        return {
            ...pluginState,
            pasteStartPos: newPasteStartPos,
            pasteEndPos: newPasteEndPos
        };
    },
    onSelectionChanged: (tr, pluginState)=>{
        // Detect click outside the editor
        if (tr.getMeta('outsideProsemirrorEditorClicked')) return {
            ...pluginState,
            showToolbar: false,
            highlightContent: false
        };
        return pluginState;
    }
});
const $e07496a754522791$var$changedFormatFromToolbar = (tr)=>{
    const meta = tr.getMeta((0, $1f78ff91b043d5f4$export$d1234a98f427930));
    if (meta && meta.type === (0, $1342a56b1febaadc$export$ad3c0356f902fd97).CHANGE_FORMAT) return true;
    return false;
};



var $hWRJP = parcelRequire("hWRJP");


var $jvA0K = parcelRequire("jvA0K");


var $aRZzN = parcelRequire("aRZzN");


var $5SAOw = parcelRequire("5SAOw");





var $aXG5V = parcelRequire("aXG5V");

function $59655049ca4ee713$export$6c3620a9f018c4e(pastedFrom) {
    return pastedFrom === 'fabric-editor';
}
function $59655049ca4ee713$export$8acd10161c5f8b07(text) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return text.replace(/(\[([^\]]+)\]\()?((https?|ftp|jamfselfservice):\/\/[^\s"'>]+)/g, (str)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return str.match(/^(https?|ftp|jamfselfservice):\/\/[^\s"'>]+$/) ? `<${str}>` : str;
    });
}
const $59655049ca4ee713$export$e7b0e22080760bf0 = (slice)=>{
    if (!slice) return false;
    let hasMedia = false;
    slice.content.descendants((node)=>{
        if ([
            'media',
            'mediaInline',
            'mediaGroup',
            'mediaSingle'
        ].includes(node.type.name)) {
            hasMedia = true;
            return false;
        }
        return true;
    });
    return hasMedia;
};
const $59655049ca4ee713$export$ec154944314bb7c = (slice, schema)=>{
    let hasRuleNode = false;
    slice.content.nodesBetween(0, slice.content.size, (node, start)=>{
        if (node.type === schema.nodes.rule) hasRuleNode = true;
    });
    return hasRuleNode;
};
const $59655049ca4ee713$export$2d7feffd198c797d = (slice)=>{
    let hasLinkMark = false;
    slice.content.descendants((node)=>{
        const marks = node.marks?.map((mark)=>mark.type.name);
        hasLinkMark = marks?.includes('link');
        if (hasLinkMark) //break out of loop
        return false;
    });
    return hasLinkMark;
};


const $1227962d9e59dddd$export$f9baf8679201c53f = (tr, pluginState)=>{
    let pasteStartPos = pluginState.pasteStartPos;
    const pasteEndPos = pluginState.pasteEndPos;
    const plaintext = pluginState.plaintext;
    if (pasteStartPos < 0) return tr;
    const resolvedPasteStartPos = tr.doc.resolve(pasteStartPos);
    const parentOffset = resolvedPasteStartPos.parentOffset;
    if (parentOffset === 0 && resolvedPasteStartPos.depth > 0) pasteStartPos = resolvedPasteStartPos.before();
    const markdownSlice = $1227962d9e59dddd$export$3f1f93abf0f3a57(plaintext, tr.doc.type.schema, tr.selection);
    if (!markdownSlice) return tr;
    $1227962d9e59dddd$var$pasteSliceIntoTransactionWithSelectionAdjust({
        tr: tr,
        pasteStartPos: pasteStartPos,
        pasteEndPos: pasteEndPos,
        slice: markdownSlice
    });
    return tr;
};
const $1227962d9e59dddd$export$da9c2ff7c79a9eab = (tr, pluginState)=>{
    let pasteStartPos = pluginState.pasteStartPos;
    const pasteEndPos = pluginState.pasteEndPos;
    const richTextSlice = pluginState.richTextSlice;
    if (pasteStartPos < 0) return tr;
    if (richTextSlice.content.size === 0) return tr;
    const resolvedPasteStartPos = tr.doc.resolve(pasteStartPos);
    const parentOffset = resolvedPasteStartPos.parentOffset;
    if (parentOffset === 0 && resolvedPasteStartPos.depth > 0) pasteStartPos = resolvedPasteStartPos.before();
    $1227962d9e59dddd$var$richTextSliceTransactionWithSelectionAdjust({
        tr: tr,
        pasteStartPos: pasteStartPos,
        pasteEndPos: pasteEndPos,
        slice: richTextSlice
    });
    return tr;
};
const $1227962d9e59dddd$export$60ca0c8603a51ef1 = (tr, pluginState)=>{
    let pasteStartPos = pluginState.pasteStartPos;
    const pasteEndPos = pluginState.pasteEndPos;
    const plaintext = pluginState.plaintext;
    //not possible to create plain text slice with empty string
    if (pasteStartPos < 0 || plaintext === '') return tr;
    const resolvedPasteStartPos = tr.doc.resolve(pasteStartPos);
    const parentOffset = resolvedPasteStartPos.parentOffset;
    if (parentOffset === 0 && resolvedPasteStartPos.depth > 0) pasteStartPos = resolvedPasteStartPos.before();
    const schema = tr.doc.type.schema;
    const plainTextNode = schema.text(plaintext);
    const plainTextFragment = (0, $5SAOw.Fragment).from(schema.nodes.paragraph.createAndFill(null, plainTextNode));
    const plainTextSlice = new (0, $5SAOw.Slice)(plainTextFragment, resolvedPasteStartPos.depth, resolvedPasteStartPos.depth);
    $1227962d9e59dddd$var$pasteSliceIntoTransactionWithSelectionAdjust({
        tr: tr,
        pasteStartPos: pasteStartPos,
        pasteEndPos: pasteEndPos,
        slice: plainTextSlice
    });
    return tr;
};
function $1227962d9e59dddd$var$pasteSliceIntoTransactionWithSelectionAdjust({ tr: tr, pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos, slice: slice }) {
    tr.replaceRange(pasteStartPos, pasteEndPos, slice);
    // ProseMirror doesn't give a proper way to tell us where something was inserted.
    // However, we can know "how" it inserted something.
    //
    // So, instead of weird depth calculations, we can use the step produced by the transform.
    // For instance:
    //    The `replaceStep.to and replaceStep.from`, tell us the real position
    //    where the content will be insert.
    //    Then, we can use the `tr.mapping.map` to the updated position after the replace operation
    const replaceStep = tr.steps[0];
    if (!(replaceStep instanceof (0, $aXG5V.ReplaceStep))) return tr;
    const lastInsertNode = replaceStep.slice.content.lastChild;
    const emptyNodeReference = lastInsertNode?.type.createAndFill();
    const isLastNodeEmpty = emptyNodeReference?.nodeSize === lastInsertNode?.nodeSize;
    const isStepSplitingTarget = !lastInsertNode?.isLeaf && isLastNodeEmpty;
    const $nextHead = tr.doc.resolve(tr.mapping.map(replaceStep.to));
    const $nextPosition = isStepSplitingTarget && $nextHead.depth > 0 ? tr.doc.resolve($nextHead.before()) : $nextHead;
    // The findFrom will make search for both: TextSelection and NodeSelections.
    const nextSelection = (0, $ks2lK.Selection).findFrom($nextPosition, -1);
    if (nextSelection) tr.setSelection(nextSelection);
}
function $1227962d9e59dddd$var$richTextSliceTransactionWithSelectionAdjust({ tr: tr, pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos, slice: slice }) {
    tr.replaceRange(pasteStartPos, pasteEndPos, slice);
    // ProseMirror doesn't give a proper way to tell us where something was inserted.
    // However, we can know "how" it inserted something.
    //
    // So, instead of weird depth calculations, we can use the step produced by the transform.
    // For instance:
    //    The `replaceStep.to and replaceStep.from`, tell us the real position
    //    where the content will be insert.
    //    Then, we can use the `tr.mapping.map` to the updated position after the replace operation
    const replaceStep = tr.steps[0];
    if (!(replaceStep instanceof (0, $aXG5V.ReplaceStep))) return tr;
    const nextPosition = tr.mapping.map(replaceStep.to);
    // The findFrom will make search for both: TextSelection and NodeSelections.
    const nextSelection = (0, $ks2lK.Selection).findFrom(tr.doc.resolve(Math.min(nextPosition, tr.doc.content.size)), -1);
    if (nextSelection) tr.setSelection(nextSelection);
}
function $1227962d9e59dddd$export$3f1f93abf0f3a57(text, schema, selection) {
    const targetOpenStartNode = selection.$from.parent;
    const targetOpenEndNode = selection.$to.parent;
    try {
        let textInput = text;
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const textSplitByCodeBlock = textInput.split(/```/);
        for(let i = 0; i < textSplitByCodeBlock.length; i++)if (i % 2 === 0) // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        textSplitByCodeBlock[i] = textSplitByCodeBlock[i].replace(/\\/g, '\\\\');
        textInput = textSplitByCodeBlock.join('```');
        const atlassianMarkDownParser = new (0, $aRZzN.MarkdownTransformer)(schema, (0, $jvA0K.md));
        const doc = atlassianMarkDownParser.parse((0, $59655049ca4ee713$export$8acd10161c5f8b07)(textInput));
        if (!doc || !doc.content) return;
        const canMergeOpenStart = targetOpenStartNode.type === doc.content.firstChild?.type;
        const canMergeOpenEnd = targetOpenEndNode.type === doc.content.lastChild?.type;
        const $start = (0, $ks2lK.Selection).atStart(doc).$from;
        const $end = (0, $ks2lK.Selection).atEnd(doc).$from;
        const openStart = canMergeOpenStart ? $start.depth : 0;
        const openEnd = canMergeOpenEnd ? $end.depth : 0;
        return new (0, $5SAOw.Slice)(doc.content, openStart, openEnd);
    } catch (error) {
        (0, $hWRJP.logException)(error, {
            location: 'editor-plugin-paste-options-toolbar/util'
        });
        return;
    }
}



const $666b1f40c60bb978$export$1ad95a504fba561e = (lastContentPasted, selectedOption)=>{
    const commandAction = (editorState)=>{
        return {
            type: (0, $1342a56b1febaadc$export$ad3c0356f902fd97).SHOW_PASTE_OPTIONS,
            data: {
                selectedOption: selectedOption,
                plaintext: lastContentPasted.text ?? '',
                isPlainText: lastContentPasted.isPlainText,
                richTextSlice: lastContentPasted.pastedSlice,
                pasteStartPos: lastContentPasted.pasteStartPos,
                pasteEndPos: lastContentPasted.pasteEndPos
            }
        };
    };
    return (0, $e07496a754522791$export$8d4021544bdece00)(commandAction);
};
const $666b1f40c60bb978$export$ff80cd8c68a7a6ad = ()=>{
    const plaintextTransformer = (tr, state)=>{
        const pluginState = (0, $605b26f4929db737$export$2b71482310d8c520).getState(state);
        if (pluginState.selectedOption === (0, $605b26f4929db737$export$ec4e67a10e59fca).PlainText) return tr;
        return (0, $1227962d9e59dddd$export$60ca0c8603a51ef1)(tr, pluginState);
    };
    const commandAction = (editorState)=>{
        return {
            type: (0, $1342a56b1febaadc$export$ad3c0356f902fd97).CHANGE_FORMAT,
            data: {
                selectedOption: (0, $605b26f4929db737$export$ec4e67a10e59fca).PlainText
            }
        };
    };
    return (0, $e07496a754522791$export$8d4021544bdece00)(commandAction, plaintextTransformer);
};
const $666b1f40c60bb978$export$c833704cd36ac295 = (editorAnalyticsAPI, sliceSize)=>()=>{
        return (0, $dAtrv.withAnalytics)(editorAnalyticsAPI, {
            action: (0, $d925B.ACTION).PASTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, $d925B.INPUT_METHOD).TOOLBAR,
                type: (0, $aSgIe.PasteTypes).plain,
                content: (0, $aSgIe.PasteContents).text,
                pasteSize: sliceSize
            }
        })($666b1f40c60bb978$export$ff80cd8c68a7a6ad());
    };
const $666b1f40c60bb978$export$405f0689dadde83d = ()=>{
    return $666b1f40c60bb978$export$3367fb592cb1ac64();
};
const $666b1f40c60bb978$export$50a682c7628ffa4e = ()=>{
    const transformer = (tr, state)=>{
        const pluginState = (0, $605b26f4929db737$export$2b71482310d8c520).getState(state);
        if (pluginState.selectedOption === (0, $605b26f4929db737$export$ec4e67a10e59fca).RichText) return tr;
        return (0, $1227962d9e59dddd$export$da9c2ff7c79a9eab)(tr, pluginState);
    };
    const commandAction = (editorState)=>{
        return {
            type: (0, $1342a56b1febaadc$export$ad3c0356f902fd97).CHANGE_FORMAT,
            data: {
                selectedOption: (0, $605b26f4929db737$export$ec4e67a10e59fca).RichText
            }
        };
    };
    return (0, $e07496a754522791$export$8d4021544bdece00)(commandAction, transformer);
};
const $666b1f40c60bb978$export$849d50d444ed50f8 = (editorAnalyticsAPI)=>()=>{
        const payloadCallback = (state)=>{
            const pastePluginState = (0, $605b26f4929db737$export$2b71482310d8c520).getState(state);
            return {
                action: (0, $d925B.ACTION).PASTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: (0, $d925B.INPUT_METHOD).TOOLBAR,
                    type: (0, $aSgIe.PasteTypes).richText,
                    content: (0, $aSgIe.PasteContents).text,
                    pasteSize: pastePluginState.richTextSlice?.size || 0
                }
            };
        };
        return (0, $dAtrv.withAnalytics)(editorAnalyticsAPI, payloadCallback)($666b1f40c60bb978$export$50a682c7628ffa4e());
    };
const $666b1f40c60bb978$export$f22e171f994ad9d1 = ()=>{
    const markdownTransformer = (tr, state)=>{
        const pluginState = (0, $605b26f4929db737$export$2b71482310d8c520).getState(state);
        if (pluginState.selectedOption === (0, $605b26f4929db737$export$ec4e67a10e59fca).Markdown) return tr;
        return (0, $1227962d9e59dddd$export$f9baf8679201c53f)(tr, pluginState);
    };
    const commandAction = (editorState)=>{
        return {
            type: (0, $1342a56b1febaadc$export$ad3c0356f902fd97).CHANGE_FORMAT,
            data: {
                selectedOption: (0, $605b26f4929db737$export$ec4e67a10e59fca).Markdown
            }
        };
    };
    return (0, $e07496a754522791$export$8d4021544bdece00)(commandAction, markdownTransformer);
};
const $666b1f40c60bb978$export$a1a13c805bf0cea1 = (editorAnalyticsAPI, sliceSize)=>()=>{
        return (0, $dAtrv.withAnalytics)(editorAnalyticsAPI, {
            action: (0, $d925B.ACTION).PASTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, $d925B.INPUT_METHOD).TOOLBAR,
                type: (0, $aSgIe.PasteTypes).markdown,
                content: (0, $aSgIe.PasteContents).text,
                pasteSize: sliceSize
            }
        })($666b1f40c60bb978$export$f22e171f994ad9d1());
    };
const $666b1f40c60bb978$export$3367fb592cb1ac64 = ()=>{
    const commandAction = (editorState)=>{
        return {
            type: (0, $1342a56b1febaadc$export$ad3c0356f902fd97).HIGHLIGHT_CONTENT
        };
    };
    return (0, $e07496a754522791$export$8d4021544bdece00)(commandAction);
};
const $666b1f40c60bb978$export$70777665aad0464c = ()=>{
    const commandAction = (editorState)=>{
        return {
            type: (0, $1342a56b1febaadc$export$ad3c0356f902fd97).HIDE_PASTE_OPTIONS
        };
    };
    return (0, $e07496a754522791$export$8d4021544bdece00)(commandAction);
};
const $666b1f40c60bb978$export$8b65e7aad6163588 = (view)=>{
    const pluginState = (0, $605b26f4929db737$export$2b71482310d8c520).getState(view.state);
    if (pluginState.showToolbar) $666b1f40c60bb978$export$70777665aad0464c()(view.state, view.dispatch);
};



var $1S4f7 = parcelRequire("1S4f7");





var $ftzrq = parcelRequire("ftzrq");





function $c2cc415fa3636815$export$ae829ec7b2625219(dispatch) {
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $605b26f4929db737$export$2b71482310d8c520),
        state: (0, $e07496a754522791$export$656c7661095efe2e)(dispatch, {
            showToolbar: false,
            pasteStartPos: 0,
            pasteEndPos: 0,
            plaintext: '',
            isPlainText: false,
            highlightContent: false,
            highlightDecorationSet: (0, $ftzrq.DecorationSet).empty,
            richTextSlice: (0, $5SAOw.Slice).empty,
            selectedOption: (0, $605b26f4929db737$export$ec4e67a10e59fca).None
        }),
        view (editorView) {
            return {
                update (view, prevState) {
                    return prevState;
                }
            };
        },
        props: {
            handleDOMEvents: {
                // Hide toolbar when clicked outside the editor
                blur: (0, $666b1f40c60bb978$export$8b65e7aad6163588),
                // Hide toolbar when clicked anywhere within the editor, tr.getMeta('pointer') does not work if clicked on the same line after pasting so relying on mousedown event
                mousedown: (0, $666b1f40c60bb978$export$8b65e7aad6163588)
            },
            handleKeyDown: (view)=>{
                (0, $666b1f40c60bb978$export$8b65e7aad6163588)(view);
                return false;
            },
            decorations: (state)=>{
                const { highlightContent: highlightContent, pasteStartPos: pasteStartPos } = (0, $605b26f4929db737$export$2b71482310d8c520).getState(state) || {};
                const decorationSet = (0, $605b26f4929db737$export$2b71482310d8c520).getState(state)?.highlightDecorationSet ?? (0, $ftzrq.DecorationSet).empty;
                if (!highlightContent) return decorationSet;
                const { selection: selection } = state.tr;
                const pasteEndPos = selection.$anchor.pos;
                const highlightDecoration = (0, $ftzrq.Decoration).inline(pasteStartPos, pasteEndPos, {
                    class: (0, $1f78ff91b043d5f4$export$78dda1ebb9a1ea84)
                }, {
                    key: (0, $1f78ff91b043d5f4$export$d829547aa567b0f1)
                });
                return decorationSet.add(state.doc, [
                    highlightDecoration
                ]);
            }
        }
    });
}




var $fHFVT = parcelRequire("fHFVT");


var $aFUXX = parcelRequire("aFUXX");






var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $iV0NL = parcelRequire("iV0NL");

// Ignored via go/ees005
// eslint-disable-next-line react/jsx-props-no-spreading
const $1d8936e5d970124c$var$EditorPasteIcon = (props)=>{
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iV0NL))), {
        ...props
    });
};
$1d8936e5d970124c$var$EditorPasteIcon.displayName = 'EditorPasteIcon';
var $1d8936e5d970124c$export$2e2bcd8739ae039 = $1d8936e5d970124c$var$EditorPasteIcon;


const $fb8dc68c754fae4d$export$208ad7410c805534 = (state, lastContentPasted)=>{
    /**
   * Conditions for not showing the toolbar:
   * 1. Pasting link, media or text containing media(note: markdown link and images are allowed)
   * 2. Content is pasted in a nested node(i.e. inside a table, panel etc.).
   *    (grandParent node should be root doc for showing up the toolbar)
   * 3. Cursor is inside the codeblock.
   */ const $from = state.selection.$from;
    if ((0, $59655049ca4ee713$export$ec154944314bb7c)(lastContentPasted.pastedSlice, state.schema)) return false;
    const parentNodeType = $from.parent?.type;
    const grandParentNodeType = $from.node($from.depth - 1)?.type;
    if (grandParentNodeType && grandParentNodeType.name === state.schema.nodes.doc.name && parentNodeType.name !== state.schema.nodes.codeBlock?.name && !(0, $59655049ca4ee713$export$6c3620a9f018c4e)(lastContentPasted.pasteSource) && !(0, $59655049ca4ee713$export$2d7feffd198c797d)(lastContentPasted.pastedSlice) && !(0, $59655049ca4ee713$export$e7b0e22080760bf0)(lastContentPasted.pastedSlice)) return true;
    return false;
};
const $fb8dc68c754fae4d$export$aea1bbb5471be38f = (pluginState, intl, editorAnalyticsAPI)=>{
    const options = [
        {
            id: 'editor.paste.richText',
            title: intl.formatMessage((0, $fHFVT.pasteOptionsToolbarMessages).richText),
            selected: pluginState.selectedOption === (0, $605b26f4929db737$export$ec4e67a10e59fca).RichText,
            hidden: pluginState.isPlainText,
            onClick: (0, $666b1f40c60bb978$export$849d50d444ed50f8)(editorAnalyticsAPI)()
        },
        {
            id: 'editor.paste.markdown',
            title: intl.formatMessage((0, $fHFVT.pasteOptionsToolbarMessages).markdown),
            selected: pluginState.selectedOption === (0, $605b26f4929db737$export$ec4e67a10e59fca).Markdown,
            onClick: (0, $666b1f40c60bb978$export$a1a13c805bf0cea1)(editorAnalyticsAPI, pluginState.plaintext.length)()
        },
        {
            id: 'editor.paste.plainText',
            title: intl.formatMessage((0, $fHFVT.pasteOptionsToolbarMessages).plainText),
            selected: pluginState.selectedOption === (0, $605b26f4929db737$export$ec4e67a10e59fca).PlainText,
            onClick: (0, $666b1f40c60bb978$export$c833704cd36ac295)(editorAnalyticsAPI, pluginState.plaintext.length)()
        }
    ];
    return {
        id: (0, $1f78ff91b043d5f4$export$af443436fa5992cb),
        icon: (0, $1d8936e5d970124c$export$2e2bcd8739ae039),
        type: 'dropdown',
        testId: (0, $1f78ff91b043d5f4$export$299d35c5583816ad),
        title: intl.formatMessage((0, $fHFVT.pasteOptionsToolbarMessages).pasteOptions),
        options: options,
        onToggle: $fb8dc68c754fae4d$var$onToggleHandler
    };
};
const $fb8dc68c754fae4d$var$onToggleHandler = (state, dispatch)=>{
    return (0, $666b1f40c60bb978$export$405f0689dadde83d)()(state, dispatch);
};
const $fb8dc68c754fae4d$export$6dd6ab35df8f7f86 = (state, intl, editorAnalyticsAPI)=>{
    const { schema: schema } = state;
    const validNodes = Object.values(schema.nodes);
    const pluginState = (0, $605b26f4929db737$export$2b71482310d8c520).getState(state);
    const menu = $fb8dc68c754fae4d$export$aea1bbb5471be38f(pluginState, intl, editorAnalyticsAPI);
    return {
        title: intl.formatMessage((0, $fHFVT.pasteOptionsToolbarMessages).pasteOptions),
        nodeType: validNodes,
        zIndex: (0, $aFUXX.akEditorFloatingPanelZIndex),
        className: (0, $1f78ff91b043d5f4$export$164821e1c3d789fd),
        items: [
            menu
        ],
        align: 'right',
        onPositionCalculated: $fb8dc68c754fae4d$var$onPositionCalculated
    };
};
const $fb8dc68c754fae4d$var$onPositionCalculated = (editorView, nextPos)=>{
    const { from: from } = editorView.state.selection;
    const fromCoords = editorView.coordsAtPos(from);
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const toolbar = document.querySelector(`div[aria-label="${(0, $fHFVT.pasteOptionsToolbarMessages).pasteOptions.defaultMessage}"]`);
    const offsetParent = toolbar?.offsetParent || editorView.dom;
    const offsetParentRect = offsetParent?.getBoundingClientRect();
    const offsetTop = offsetParentRect?.top || 0;
    const offsetLeft = offsetParentRect?.left || 0;
    const offsetScrollTop = offsetParent?.scrollTop || 0;
    const cursorHeight = $fb8dc68c754fae4d$var$getCursorHeight(editorView, from);
    return {
        top: fromCoords.top - offsetTop + offsetScrollTop + cursorHeight,
        left: fromCoords.left - offsetLeft
    };
};
const $fb8dc68c754fae4d$var$getCursorHeight = (editorView, from)=>{
    const nodeAtFrom = editorView.domAtPos(from).node;
    const nearestNonTextNode = nodeAtFrom?.nodeType === Node.TEXT_NODE ? // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    nodeAtFrom.parentNode : // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    nodeAtFrom;
    return parseFloat(window.getComputedStyle(nearestNonTextNode, undefined).lineHeight || '');
};


const $d3b480babb517bc1$export$2eabbda136e01363 = ({ config: config, api: api })=>{
    const editorAnalyticsAPI = api?.analytics?.actions;
    return {
        name: 'pasteOptionsToolbarPlugin',
        pmPlugins () {
            return [
                {
                    name: 'pasteOptionsToolbarPlugin',
                    plugin: ({ dispatch: dispatch })=>(0, $c2cc415fa3636815$export$ae829ec7b2625219)(dispatch)
                }
            ];
        },
        pluginsOptions: {
            floatingToolbar (state, intl) {
                const pastePluginState = (0, $605b26f4929db737$export$2b71482310d8c520).getState(state);
                if (pastePluginState.showToolbar) return (0, $fb8dc68c754fae4d$export$6dd6ab35df8f7f86)(state, intl, editorAnalyticsAPI);
                return;
            }
        },
        usePluginHook ({ editorView: editorView }) {
            const { lastContentPasted: lastContentPasted } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
                'paste'
            ], (states)=>({
                    lastContentPasted: states.pasteState?.lastContentPasted
                }));
            (0, $42omo.useEffect)(()=>{
                if (!lastContentPasted) {
                    (0, $666b1f40c60bb978$export$70777665aad0464c)()(editorView.state, editorView.dispatch);
                    return;
                }
                let selectedOption = (0, $605b26f4929db737$export$ec4e67a10e59fca).None;
                if (!lastContentPasted.isPlainText) selectedOption = (0, $605b26f4929db737$export$ec4e67a10e59fca).RichText;
                else if (lastContentPasted.isShiftPressed) selectedOption = (0, $605b26f4929db737$export$ec4e67a10e59fca).PlainText;
                else selectedOption = (0, $605b26f4929db737$export$ec4e67a10e59fca).Markdown;
                if (!(0, $fb8dc68c754fae4d$export$208ad7410c805534)(editorView.state, lastContentPasted)) return;
                (0, $666b1f40c60bb978$export$1ad95a504fba561e)(lastContentPasted, selectedOption)(editorView.state, editorView.dispatch);
            }, [
                lastContentPasted,
                editorView
            ]);
        }
    };
};
module.exports["pasteOptionsToolbarPlugin"] = $d3b480babb517bc1$export$2eabbda136e01363;

});

parcelRegister("bz4KD", function(module, exports) {

var $kyRHQ = parcelRequire("kyRHQ");

const $3074fcc4b1d6f955$export$e137bce9a5077ae5 = ()=>({
        name: 'ufo',
        pmPlugins () {
            const isSSR = Boolean($kyRHQ?.env?.REACT_SSR);
            if (isSSR) // This plugin is not needed in SSR environments - and uses apis which are not available in SSR internally
            return [];
            // This Plugin is not currently used as it leads to too high a level of abortions (due to the current TTAI timing being long, and users starting click before TTAI completes).
            // This can be reconsidered if we meaningfully reduce our TTAI (ie. <7 seconds)
            return [];
        // return [
        // 	{
        // 		name: 'traceUFOInteractionOnFirstInteraction',
        // 		plugin: traceUFOInteractionOnFirstInteraction,
        // 	},
        // ];
        }
    });
module.exports["ufoPlugin"] = $3074fcc4b1d6f955$export$e137bce9a5077ae5;

});

parcelRegister("hr8mu", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $anbEX = parcelRequire("anbEX");


var $dh538 = parcelRequire("dh538");


var $iu6m9 = parcelRequire("iu6m9");


var $d925B = parcelRequire("d925B");


var $hgeg8 = parcelRequire("hgeg8");

var $60bKU = parcelRequire("60bKU");





var $dhoHU = parcelRequire("dhoHU");


var $dAtrv = parcelRequire("dAtrv");


var $ks2lK = parcelRequire("ks2lK");

/**
 * Iterates over the commands one after the other,
 * passes the tr through and dispatches the cumulated transaction
 */ function $ce6a26a2978f2920$var$cascadeCommands(cmds) {
    return (state, dispatch)=>{
        const { tr: baseTr } = state;
        let shouldDispatch = false;
        const onDispatchAction = (tr)=>{
            const selectionJSON = tr.selection.toJSON();
            baseTr.setSelection((0, $ks2lK.Selection).fromJSON(baseTr.doc, selectionJSON));
            tr.steps.forEach((st)=>{
                baseTr.step(st);
            });
            shouldDispatch = true;
        };
        cmds.forEach((cmd)=>cmd(state, onDispatchAction));
        if (dispatch && shouldDispatch) {
            dispatch(baseTr);
            return true;
        }
        return false;
    };
}
const $ce6a26a2978f2920$export$f3f99b2459c4a09f = (align)=>(state, dispatch)=>{
        const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = state.schema;
        return (0, $dhoHU.toggleBlockMark)(alignment, ()=>!align ? undefined : align === 'start' ? false : {
                align: align
            }, [
            paragraph,
            heading
        ])(state, dispatch);
    };
const $ce6a26a2978f2920$var$changeBlockAlignmentWithAnalytics = (editorAnalyticsApi, align, inputMethod)=>(state, dispatch)=>{
        const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = state.schema;
        return (0, $dAtrv.withAnalytics)(editorAnalyticsApi, {
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            actionSubject: (0, $d925B.ACTION_SUBJECT).ALIGNMENT,
            action: (0, $d925B.ACTION).UPDATED,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).TEXT,
            attributes: {
                alignmentType: align,
                inputMethod: inputMethod
            }
        })((0, $dhoHU.toggleBlockMark)(alignment, ()=>!align ? undefined : align === 'start' ? false : {
                align: align
            }, [
            paragraph,
            heading
        ]))(state, dispatch);
    };
const $ce6a26a2978f2920$var$changeBlockAlignmentWithAnalyticsTr = (api, align, inputMethod)=>({ tr: tr })=>{
        const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = tr.doc.type.schema;
        const alignmentApplied = (0, $dhoHU.toggleBlockMarkNext)(alignment, ()=>!align ? undefined : align === 'start' ? false : {
                align: align
            }, [
            paragraph,
            heading
        ])(tr);
        if (alignmentApplied) api?.analytics?.actions.attachAnalyticsEvent({
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            actionSubject: (0, $d925B.ACTION_SUBJECT).ALIGNMENT,
            action: (0, $d925B.ACTION).UPDATED,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).TEXT,
            attributes: {
                alignmentType: align,
                inputMethod: inputMethod
            }
        })(tr);
        return tr;
    };
const $ce6a26a2978f2920$var$changeImageAlignmentWithAnalytics = (editorAnalyticsApi, align, inputMethod)=>(state, dispatch)=>{
        return (0, $dAtrv.withAnalytics)(editorAnalyticsApi, {
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            actionSubject: (0, $d925B.ACTION_SUBJECT).ALIGNMENT,
            action: (0, $d925B.ACTION).UPDATED,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).MEDIA_SINGLE,
            attributes: {
                alignmentType: align,
                inputMethod: inputMethod
            }
        })((0, $dhoHU.changeImageAlignment)(align))(state, dispatch);
    };
const $ce6a26a2978f2920$var$changeImageAlignmentWithAnalyticsTr = (api, align, inputMethod)=>({ tr: tr })=>{
        const alignmentApplied = (0, $dhoHU.changeImageAlignmentNext)(align)(tr);
        if (alignmentApplied) api?.analytics?.actions.attachAnalyticsEvent({
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            actionSubject: (0, $d925B.ACTION_SUBJECT).ALIGNMENT,
            action: (0, $d925B.ACTION).UPDATED,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).MEDIA_SINGLE,
            attributes: {
                alignmentType: align,
                inputMethod: inputMethod
            }
        })(tr);
        return tr;
    };
const $ce6a26a2978f2920$export$7364e99daa3bbf34 = (align, api, inputMethod)=>(state, dispatch)=>{
        return $ce6a26a2978f2920$var$cascadeCommands([
            $ce6a26a2978f2920$var$changeImageAlignmentWithAnalytics(api?.analytics?.actions, align, inputMethod),
            $ce6a26a2978f2920$var$changeBlockAlignmentWithAnalytics(api?.analytics?.actions, align, inputMethod)
        ])(state, dispatch);
    };
const $ce6a26a2978f2920$export$69636f7bd4c47a65 = (api, align, inputMethod)=>({ tr: tr })=>{
        $ce6a26a2978f2920$var$changeBlockAlignmentWithAnalyticsTr(api, align, inputMethod)({
            tr: tr
        });
        $ce6a26a2978f2920$var$changeImageAlignmentWithAnalyticsTr(api, align, inputMethod)({
            tr: tr
        });
        return tr;
    };


function $1d83767db168a60d$export$e832373cff8dec22(api) {
    const list = {};
    // Ignored via go/ees005
    (0, $hgeg8.bindKeymapWithCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.alignLeft).common, (0, $ce6a26a2978f2920$export$7364e99daa3bbf34)('start', api, (0, $d925B.INPUT_METHOD).SHORTCUT), list);
    // Ignored via go/ees005
    (0, $hgeg8.bindKeymapWithCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.alignCenter).common, (0, $ce6a26a2978f2920$export$7364e99daa3bbf34)('center', api, (0, $d925B.INPUT_METHOD).SHORTCUT), list);
    // Ignored via go/ees005
    (0, $hgeg8.bindKeymapWithCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.alignRight).common, (0, $ce6a26a2978f2920$export$7364e99daa3bbf34)('end', api, (0, $d925B.INPUT_METHOD).SHORTCUT), list);
    return (0, $60bKU.keymap)(list);
}



var $1S4f7 = parcelRequire("1S4f7");






var $8m4tT = parcelRequire("8m4tT");


var $7XFGZ = parcelRequire("7XFGZ");

const $e1909cf6b30b9ea2$export$fcb629559422d129 = (state)=>{
    if (state.selection instanceof (0, $7XFGZ.CellSelection)) {
        const marks = [];
        state.selection.forEachCell((cell)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const mark = cell.firstChild.marks.filter((mark)=>mark.type === state.schema.marks.alignment)[0];
            marks.push(mark ? mark.attrs.align : 'start');
        });
        return marks.every((mark)=>mark === marks[0]) ? marks[0] : 'start';
    }
    const node = (0, $8m4tT.findParentNodeOfType)([
        state.schema.nodes.paragraph,
        state.schema.nodes.heading
    ])(state.selection);
    const getMark = node && node.node.marks.filter((mark)=>mark.type === state.schema.marks.alignment)[0];
    return getMark && getMark.attrs.align || 'start';
};


function $e5b264df70ce239d$var$createInitialPluginState(editorState, pluginConfig) {
    return {
        align: (0, $e1909cf6b30b9ea2$export$fcb629559422d129)(editorState) || pluginConfig.align,
        isEnabled: true
    };
}
const $e5b264df70ce239d$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('alignmentPlugin');
function $e5b264df70ce239d$export$ae829ec7b2625219(dispatch, pluginConfig) {
    return new (0, $1S4f7.SafePlugin)({
        key: $e5b264df70ce239d$export$18d4026d1ea86bb1,
        state: {
            init (_, editorState) {
                return $e5b264df70ce239d$var$createInitialPluginState(editorState, pluginConfig);
            },
            apply (_tr, state, _prevState, nextState) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const nextPluginState = (0, $e1909cf6b30b9ea2$export$fcb629559422d129)(nextState);
                const isEnabled = (0, $ce6a26a2978f2920$export$f3f99b2459c4a09f)(nextPluginState)(nextState);
                const newState = {
                    ...state,
                    align: nextPluginState,
                    isEnabled: isEnabled
                };
                if (nextPluginState !== state.align || isEnabled !== state.isEnabled) dispatch($e5b264df70ce239d$export$18d4026d1ea86bb1, newState);
                return newState;
            }
        }
    });
}






var $42omo = parcelRequire("42omo");





var $eiA8Z = parcelRequire("eiA8Z");





var $806bba3ad7232b9a$export$a5d11b3163e4b1a5 = /*#__PURE__*/ function(ToolbarType) {
    ToolbarType["PRIMARY"] = "primaryToolbar";
    ToolbarType["FLOATING"] = "floatingToolbar";
    return ToolbarType;
}({});


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gmMgo = parcelRequire("gmMgo");





var $hkTaH = parcelRequire("hkTaH");


var $807Mc = parcelRequire("807Mc");

var $7k7Bn = parcelRequire("7k7Bn");

var $8mBDG = parcelRequire("8mBDG");

var $l1m3U = parcelRequire("l1m3U");

var $jN96M = parcelRequire("jN96M");


var $5v8Ta = parcelRequire("5v8Ta");

var $2dkHo = parcelRequire("2dkHo");

var $h4TOP = parcelRequire("h4TOP");

var $a4eZN = parcelRequire("a4eZN");


var $kiZiu = parcelRequire("kiZiu");


var $6bJyJ = parcelRequire("6bJyJ");


var $cOZT3 = parcelRequire("cOZT3");





/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");













parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");













const $9077f92b6f7c0540$var$iconAndMessageMap = {
    start: {
        Component: (0, (/*@__PURE__*/$parcel$interopDefault($6bJyJ))),
        label: (0, $hkTaH.alignmentMessages).alignLeft
    },
    end: {
        Component: (0, (/*@__PURE__*/$parcel$interopDefault($cOZT3))),
        label: (0, $hkTaH.alignmentMessages).alignRight
    },
    center: {
        Component: (0, (/*@__PURE__*/$parcel$interopDefault($kiZiu))),
        label: (0, $hkTaH.alignmentMessages).alignCenter
    }
};
const $9077f92b6f7c0540$export$e75cf43d5d0a9444 = (props)=>{
    const { Component: Component, label: label } = $9077f92b6f7c0540$var$iconAndMessageMap[props.alignment];
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        label: intl.formatMessage(label),
        color: "currentColor",
        spacing: "spacious"
    });
};





parcelRequire("42omo");







function $8f58ec37c0df463c$var$AlignmentButton({ label: label, isSelected: isSelected, content: content, shortcut: shortcut, onClick: onClick, value: value }) {
    const onClickCallback = (e)=>{
        // detect if the click event comes from keyboard where screenX and screenY are 0
        const isMouseEvent = e instanceof MouseEvent;
        e.preventDefault();
        onClick(value, isMouseEvent);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a4eZN.default), {
        disabled: false,
        selected: isSelected,
        title: /*#__PURE__*/ (0, $l998X.jsx)((0, $hgeg8.ToolTipContent), {
            description: label,
            keymap: shortcut
        }),
        "aria-label": shortcut ? (0, $hgeg8.tooltip)(shortcut, label) : label,
        "aria-pressed": isSelected,
        "aria-keyshortcuts": (0, $hgeg8.getAriaKeyshortcuts)(shortcut),
        onClick: onClickCallback,
        iconBefore: content,
        titlePosition: 'bottom'
    });
}
var $8f58ec37c0df463c$export$2e2bcd8739ae039 = $8f58ec37c0df463c$var$AlignmentButton;


const $5be52fb152fadf6d$var$alignmentWrapper = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- This rule thinks this isn't a `css()` call due to the name mapping
const $5be52fb152fadf6d$var$alignmentWrapperStylesUnbounded = null;
const $5be52fb152fadf6d$var$alignCenterKeyboardShortcut = (0, $hgeg8.alignCenter);
const $5be52fb152fadf6d$var$alignRightKeyboardShortcut = (0, $hgeg8.alignRight);
const $5be52fb152fadf6d$var$alignmentOptions = [
    {
        title: (0, $hkTaH.alignmentMessages).alignLeft,
        shortcut: (0, $hgeg8.alignLeft),
        value: 'start'
    },
    {
        title: (0, $hkTaH.alignmentMessages).alignCenter,
        shortcut: $5be52fb152fadf6d$var$alignCenterKeyboardShortcut,
        value: 'center'
    },
    {
        title: (0, $hkTaH.alignmentMessages).alignRight,
        shortcut: $5be52fb152fadf6d$var$alignRightKeyboardShortcut,
        value: 'end'
    }
];
function $5be52fb152fadf6d$var$Alignment({ onClick: onClick, selectedAlignment: selectedAlignment, className: className, intl: intl }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": "alignment-buttons" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        ,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $gMc0m.default)([
            "_1e0c1txw _ca0qze3t _n3tdze3t _19bvu2gc _u5f3u2gc _p12f53f4 _gy1pv77o",
            "_1fvdglyw",
            className
        ]),
        children: $5be52fb152fadf6d$var$alignmentOptions.map((alignment)=>{
            const { value: value, title: title, shortcut: shortcut } = alignment;
            const message = intl.formatMessage(title);
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $8f58ec37c0df463c$export$2e2bcd8739ae039), {
                content: /*#__PURE__*/ (0, $l998X.jsx)((0, $9077f92b6f7c0540$export$e75cf43d5d0a9444), {
                    alignment: value
                }),
                value: value,
                label: message,
                shortcut: shortcut,
                onClick: onClick,
                isSelected: value === selectedAlignment
            }, value);
        })
    });
}
var $5be52fb152fadf6d$export$2e2bcd8739ae039 = (0, $gmMgo.default)($5be52fb152fadf6d$var$Alignment);



function $26b4ba5a10aa334a$var$_defineProperty(e, r, t) {
    return (r = $26b4ba5a10aa334a$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $26b4ba5a10aa334a$var$_toPropertyKey(t) {
    var i = $26b4ba5a10aa334a$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $26b4ba5a10aa334a$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $26b4ba5a10aa334a$var$AlignmentToolbar extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { isOpen: isOpen } = this.state;
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isReducedSpacing: isReducedSpacing, align: align, disabled: disabled, intl: intl, api: api } = this.props;
        const alignment = align ?? 'start';
        const title = intl.formatMessage((0, $hkTaH.alignmentMessages).alignment);
        const reducedSpacing = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
            exposure: true
        }) ? 'compact' : 'none';
        const items = [
            {
                key: 'alignmentLeft',
                content: intl.formatMessage((0, $hkTaH.alignmentMessages).alignLeft),
                value: {
                    name: 'start'
                },
                isActive: align === 'start',
                elemAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, $807Mc.Shortcut), {
                    children: (0, $hgeg8.tooltip)((0, $hgeg8.alignLeft))
                }),
                elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6bJyJ))), {
                    label: ""
                })
            },
            {
                key: 'alignmentCenter',
                content: intl.formatMessage((0, $hkTaH.alignmentMessages).alignCenter),
                value: {
                    name: 'center'
                },
                isActive: align === 'center',
                elemAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, $807Mc.Shortcut), {
                    children: (0, $hgeg8.tooltip)((0, $hgeg8.alignCenter))
                }),
                elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kiZiu))), {
                    label: ""
                })
            },
            {
                key: 'alignmentRight',
                content: intl.formatMessage((0, $hkTaH.alignmentMessages).alignRight),
                value: {
                    name: 'end'
                },
                isActive: align === 'end',
                elemAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, $807Mc.Shortcut), {
                    children: (0, $hgeg8.tooltip)((0, $hgeg8.alignRight))
                }),
                elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cOZT3))), {
                    label: ""
                })
            }
        ];
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $8mBDG.ToolbarDropdownWrapper), {
            children: [
                (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $h4TOP.DropdownMenuWithKeyboardNavigation), {
                    arrowKeyNavigationProviderOptions: {
                        type: (0, $5v8Ta.ArrowKeyNavigationType).MENU
                    },
                    items: [
                        {
                            items: items
                        }
                    ],
                    isOpen: isOpen,
                    onItemActivated: this.handleOnItemActivated,
                    onOpenChange: (attrs)=>this.setState({
                            isOpen: attrs?.isOpen
                        }),
                    mountTo: popupsMountPoint,
                    boundariesElement: popupsBoundariesElement,
                    scrollableElement: popupsScrollableElement,
                    fitWidth: 200,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a4eZN.default), {
                        spacing: isReducedSpacing ? reducedSpacing : 'default',
                        disabled: disabled,
                        selected: isOpen,
                        title: title,
                        "aria-label": title,
                        "aria-expanded": isOpen,
                        "aria-haspopup": true,
                        onClick: this.toggleOpen,
                        onKeyDown: this.toggleOpenByKeyboard,
                        iconBefore: /*#__PURE__*/ (0, $l998X.jsxs)((0, $7k7Bn.ToolbarDropdownTriggerWrapper), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $9077f92b6f7c0540$export$e75cf43d5d0a9444), {
                                    alignment: alignment
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $l1m3U.ToolbarExpandIcon), {})
                            ]
                        })
                    })
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $2dkHo.DropdownContainer), {
                    mountTo: popupsMountPoint,
                    boundariesElement: popupsBoundariesElement,
                    scrollableElement: popupsScrollableElement,
                    isOpen: isOpen,
                    handleClickOutside: (event)=>{
                        if (event instanceof MouseEvent) this.hide({
                            isOpen: false,
                            event: event
                        });
                    },
                    handleEscapeKeydown: this.hideOnEscape,
                    arrowKeyNavigationProviderOptions: {
                        type: (0, $5v8Ta.ArrowKeyNavigationType).MENU
                    },
                    fitWidth: 112,
                    fitHeight: 80,
                    closeOnTab: true,
                    trigger: /*#__PURE__*/ (0, $l998X.jsx)((0, $a4eZN.default), {
                        spacing: isReducedSpacing ? reducedSpacing : 'default',
                        disabled: disabled,
                        selected: isOpen,
                        title: title,
                        className: "align-btn",
                        "aria-label": title,
                        "aria-expanded": isOpen,
                        "aria-haspopup": true,
                        onClick: this.toggleOpen,
                        onKeyDown: this.toggleOpenByKeyboard,
                        iconBefore: /*#__PURE__*/ (0, $l998X.jsxs)((0, $7k7Bn.ToolbarDropdownTriggerWrapper), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $9077f92b6f7c0540$export$e75cf43d5d0a9444), {
                                    alignment: alignment
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $l1m3U.ToolbarExpandIcon), {})
                            ]
                        }),
                        ref: this.toolbarItemRef
                    }),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5be52fb152fadf6d$export$2e2bcd8739ae039), {
                        onClick: (align)=>this.changeAlignment(align, false),
                        selectedAlignment: alignment
                    })
                }),
                !api?.primaryToolbar && /*#__PURE__*/ (0, $l998X.jsx)((0, $jN96M.ToolbarSeparator), {})
            ]
        });
    }
    componentDidUpdate(prevProps) {
        if (this.props.toolbarType !== (0, $806bba3ad7232b9a$export$a5d11b3163e4b1a5).FLOATING && this.state.isOpen) // by triggering the keyboard event with a setTimeout, we ensure that the tooltip
        // associated with the alignment button doesn't render until the next render cycle
        // where the popup will be correctly positioned and the relative position of the tooltip
        // will not overlap with the button.
        setTimeout(()=>{
            const keyboardEvent = new KeyboardEvent('keydown', {
                bubbles: true,
                key: 'ArrowDown'
            });
            this.toolbarItemRef.current?.dispatchEvent(keyboardEvent);
        }, 0);
    }
    constructor(...args){
        super(...args);
        $26b4ba5a10aa334a$var$_defineProperty(this, "toolbarItemRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef());
        $26b4ba5a10aa334a$var$_defineProperty(this, "state", {
            isOpen: false
        });
        $26b4ba5a10aa334a$var$_defineProperty(this, "changeAlignment", (align, togglePopup)=>{
            if (togglePopup) this.toggleOpen();
            return this.props.changeAlignment(align);
        });
        $26b4ba5a10aa334a$var$_defineProperty(this, "toggleOpen", ()=>{
            this.setState({
                isOpen: !this.state.isOpen
            });
        });
        $26b4ba5a10aa334a$var$_defineProperty(this, "toggleOpenByKeyboard", (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.setState({
                    isOpen: !this.state.isOpen
                });
            }
        });
        $26b4ba5a10aa334a$var$_defineProperty(this, "handleOnItemActivated", ({ item: item, shouldCloseMenu: shouldCloseMenu = true })=>this.changeAlignment(item.value.name, shouldCloseMenu));
        $26b4ba5a10aa334a$var$_defineProperty(this, "hide", (attrs)=>{
            if (this.state.isOpen) {
                this.setState({
                    isOpen: false
                });
                if (attrs?.event instanceof KeyboardEvent && attrs.event.key === 'Escape') this.toolbarItemRef?.current?.focus();
            }
        });
        $26b4ba5a10aa334a$var$_defineProperty(this, "hideOnEscape", ()=>{
            this.hide();
            this.toolbarItemRef?.current?.focus();
        });
    }
}
$26b4ba5a10aa334a$var$_defineProperty($26b4ba5a10aa334a$var$AlignmentToolbar, "displayName", 'AlignmentToolbar');
var $26b4ba5a10aa334a$export$2e2bcd8739ae039 = (0, $gmMgo.default)($26b4ba5a10aa334a$var$AlignmentToolbar);


const $43cfda29e24b9fdf$var$FloatingToolbarSettings = {
    disabled: false,
    isToolbarReducedSpacing: true
};
function $43cfda29e24b9fdf$export$b15abb95157a91c7({ api: api, editorView: editorView }) {
    const { align: align, isEnabled: isEnabled } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'alignment'
    ], (states)=>{
        return {
            align: states.alignmentState?.align,
            isEnabled: states.alignmentState?.isEnabled
        };
    });
    const changeAlignmentCallback = (0, $42omo.useCallback)((align)=>{
        return (0, $ce6a26a2978f2920$export$7364e99daa3bbf34)(align, api, (0, $d925B.INPUT_METHOD).FLOATING_TB)(editorView.state, editorView.dispatch);
    }, [
        editorView,
        api
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $26b4ba5a10aa334a$export$2e2bcd8739ae039), {
        align: align,
        isReducedSpacing: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? false : $43cfda29e24b9fdf$var$FloatingToolbarSettings.isToolbarReducedSpacing,
        changeAlignment: changeAlignmentCallback,
        disabled: $43cfda29e24b9fdf$var$FloatingToolbarSettings.disabled || !isEnabled,
        toolbarType: (0, $806bba3ad7232b9a$export$a5d11b3163e4b1a5).FLOATING,
        api: api
    });
}

















function $78654db6b6a6a165$export$94516d5cccf573e3({ api: api, editorView: editorView, disabled: disabled, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing }) {
    const { align: align, isEnabled: isEnabled } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'alignment'
    ], (states)=>{
        return {
            align: states.alignmentState?.align,
            isEnabled: states.alignmentState?.isEnabled
        };
    });
    const changeAlignmentCallback = (0, $42omo.useCallback)((align)=>(0, $ce6a26a2978f2920$export$7364e99daa3bbf34)(align, api, (0, $d925B.INPUT_METHOD).TOOLBAR)(editorView.state, editorView.dispatch), [
        editorView,
        api
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $26b4ba5a10aa334a$export$2e2bcd8739ae039), {
        align: align,
        isReducedSpacing: isToolbarReducedSpacing,
        changeAlignment: changeAlignmentCallback,
        disabled: disabled || !isEnabled,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        api: api,
        toolbarType: (0, $806bba3ad7232b9a$export$a5d11b3163e4b1a5).PRIMARY
    });
}





parcelRequire("42omo");


var $cPCP8 = parcelRequire("cPCP8");

var $4Chin = parcelRequire("4Chin");


var $1oCLl = parcelRequire("1oCLl");




parcelRequire("42omo");











var $bTiiT = parcelRequire("bTiiT");

var $iIVVb = parcelRequire("iIVVb");



















const $02889ce465edde7a$export$8a5a39b03f4aaab = ()=>({
        start: {
            key: (0, $cPCP8.ALIGN_LEFT_MENU_ITEM).key,
            type: (0, $cPCP8.ALIGN_LEFT_MENU_ITEM).type,
            rank: (0, $4Chin.ALIGNMENT_MENU_SECTION_RANK)[(0, $cPCP8.ALIGN_LEFT_MENU_ITEM).key],
            label: (0, $hkTaH.alignmentMessages).alignLeft,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6bJyJ))),
            keymap: (0, $hgeg8.alignLeft)
        },
        center: {
            key: (0, $cPCP8.ALIGN_CENTER_MENU_ITEM).key,
            type: (0, $cPCP8.ALIGN_CENTER_MENU_ITEM).type,
            rank: (0, $4Chin.ALIGNMENT_MENU_SECTION_RANK)[(0, $cPCP8.ALIGN_CENTER_MENU_ITEM).key],
            label: (0, $hkTaH.alignmentMessages).alignCenter,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kiZiu))),
            keymap: (0, $hgeg8.alignCenter)
        },
        end: {
            key: (0, $cPCP8.ALIGN_RIGHT_MENU_ITEM).key,
            type: (0, $cPCP8.ALIGN_RIGHT_MENU_ITEM).type,
            rank: (0, $4Chin.ALIGNMENT_MENU_SECTION_RANK)[(0, $cPCP8.ALIGN_RIGHT_MENU_ITEM).key],
            label: (0, $hkTaH.alignmentMessages).alignRight,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cOZT3))),
            keymap: (0, $hgeg8.alignRight)
        }
    });


const $41509ad770a558ab$export$4301fcd45f99f8a5 = ({ children: children, api: api })=>{
    const { align: align = 'start', isEnabled: isEnabled } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'alignment'
    ], (states)=>{
        return {
            align: states.alignmentState?.align,
            isEnabled: states.alignmentState?.isEnabled
        };
    });
    const { icon: Icon } = (0, $02889ce465edde7a$export$8a5a39b03f4aaab)()[align];
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const title = formatMessage((0, $hkTaH.alignmentMessages).alignment);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iIVVb.ToolbarTooltip), {
        content: title,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bTiiT.ToolbarDropdownMenu), {
            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                label: "",
                size: "small"
            }),
            isDisabled: !isEnabled,
            testId: "text-alignment-menu",
            label: title,
            children: children
        })
    });
};





parcelRequire("42omo");











var $4Dsx2 = parcelRequire("4Dsx2");


var $2GVu1 = parcelRequire("2GVu1");

var $jbmmV = parcelRequire("jbmmV");


const $235527fa0af4c687$export$ff21a61af4a241d = ({ option: { label: label, icon: Icon, keymap: keymap }, api: api, alignment: alignment, parents: parents })=>{
    const { align: align } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'alignment'
    ], (states)=>{
        return {
            align: states.alignmentState?.align
        };
    });
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const shortcut = (0, $hgeg8.tooltip)(keymap);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
        isSelected: align === alignment,
        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            size: "small",
            label: ""
        }),
        elemAfter: shortcut && /*#__PURE__*/ (0, $l998X.jsx)((0, $jbmmV.ToolbarKeyboardShortcutHint), {
            shortcut: shortcut
        }),
        ariaKeyshortcuts: (0, $hgeg8.getAriaKeyshortcuts)(keymap),
        onClick: ()=>{
            api?.core.actions.execute((0, $ce6a26a2978f2920$export$69636f7bd4c47a65)(api, alignment, (0, $4Dsx2.getInputMethodFromParentKeys)(parents)));
        },
        children: formatMessage(label)
    });
};





parcelRequire("42omo");





var $6UWPx = parcelRequire("6UWPx");

const $ad2ecd4529c8501c$export$4b1545b4f2016d26 = ({ children: children, title: title, parents: parents })=>{
    const hasSeparator = parents.some((parent)=>parent.key === (0, $cPCP8.TEXT_COLLAPSED_MENU).key);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6UWPx.ToolbarDropdownItemSection), {
        hasSeparator: hasSeparator,
        title: title,
        children: children
    });
};



const $5f64fe0bd2a0a4c4$var$getAlignmentMenuItems = (api)=>{
    return Object.entries((0, $02889ce465edde7a$export$8a5a39b03f4aaab)()).map(([alignment, item])=>{
        const { key: key, type: type, rank: rank } = item;
        return {
            type: type,
            key: key,
            parents: [
                {
                    type: (0, $cPCP8.ALIGNMENT_MENU_SECTION).type,
                    key: (0, $cPCP8.ALIGNMENT_MENU_SECTION).key,
                    rank: rank
                }
            ],
            component: ({ parents: parents })=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $235527fa0af4c687$export$ff21a61af4a241d), {
                    api: api,
                    option: item,
                    alignment: alignment,
                    parents: parents
                });
            }
        };
    });
};
const $5f64fe0bd2a0a4c4$export$a758406ca53b86a5 = (api)=>{
    return [
        {
            type: (0, $cPCP8.ALIGNMENT_GROUP).type,
            key: (0, $cPCP8.ALIGNMENT_GROUP).key,
            parents: [
                {
                    type: (0, $cPCP8.TEXT_SECTION).type,
                    key: (0, $cPCP8.TEXT_SECTION).key,
                    rank: (0, $4Chin.TEXT_SECTION_RANK)[(0, $cPCP8.ALIGNMENT_GROUP).key]
                },
                {
                    type: (0, $cPCP8.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $cPCP8.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $4Chin.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $cPCP8.ALIGNMENT_GROUP).key]
                }
            ]
        },
        {
            type: (0, $cPCP8.ALIGNMENT_MENU).type,
            key: (0, $cPCP8.ALIGNMENT_MENU).key,
            parents: [
                {
                    type: (0, $cPCP8.ALIGNMENT_GROUP).type,
                    key: (0, $cPCP8.ALIGNMENT_GROUP).key,
                    rank: (0, $4Chin.ALIGNMENT_GROUP_RANK)[(0, $cPCP8.ALIGNMENT_MENU).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $41509ad770a558ab$export$4301fcd45f99f8a5), {
                    api: api,
                    children: children
                });
            }
        },
        {
            type: (0, $cPCP8.ALIGNMENT_MENU_SECTION).type,
            key: (0, $cPCP8.ALIGNMENT_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $cPCP8.ALIGNMENT_MENU).type,
                    key: (0, $cPCP8.ALIGNMENT_MENU).key,
                    rank: (0, $4Chin.ALIGNMENT_MENU_RANK)[(0, $cPCP8.ALIGNMENT_MENU_SECTION).key]
                },
                ...(0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_responsive', 'isEnabled', true) ? [
                    {
                        type: (0, $cPCP8.TEXT_COLLAPSED_MENU).type,
                        key: (0, $cPCP8.TEXT_COLLAPSED_MENU).key,
                        rank: (0, $4Chin.TEXT_COLLAPSED_MENU_RANK)[(0, $cPCP8.ALIGNMENT_MENU_SECTION).key]
                    }
                ] : []
            ],
            component: (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_responsive', 'isEnabled', true) ? (0, $ad2ecd4529c8501c$export$4b1545b4f2016d26) : undefined
        },
        ...$5f64fe0bd2a0a4c4$var$getAlignmentMenuItems(api)
    ];
};


const $e91e4386e86c6360$var$defaultConfig = {
    align: 'start'
};
const $e91e4386e86c6360$export$48e8beb2d4cfb048 = ({ api: api })=>{
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const primaryToolbarComponent = ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $78654db6b6a6a165$export$94516d5cccf573e3), {
            api: api,
            editorView: editorView,
            disabled: disabled,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            isToolbarReducedSpacing: isToolbarReducedSpacing
        });
    };
    if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $5f64fe0bd2a0a4c4$export$a758406ca53b86a5)(api));
    else api?.primaryToolbar?.actions.registerComponent({
        name: 'alignment',
        component: primaryToolbarComponent
    });
    return {
        name: 'alignment',
        marks () {
            return [
                {
                    name: 'alignment',
                    mark: (0, $anbEX.alignment)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $e5b264df70ce239d$export$18d4026d1ea86bb1).getState(editorState);
            return pluginState ? {
                align: pluginState.align,
                isEnabled: pluginState.isEnabled
            } : undefined;
        },
        pmPlugins () {
            return [
                {
                    name: 'alignmentPlugin',
                    plugin: ({ dispatch: dispatch })=>(0, $e5b264df70ce239d$export$ae829ec7b2625219)(dispatch, $e91e4386e86c6360$var$defaultConfig)
                },
                {
                    name: 'annotationKeymap',
                    plugin: ()=>(0, $1d83767db168a60d$export$e832373cff8dec22)(api)
                }
            ];
        },
        pluginsOptions: {
            selectionToolbar: isToolbarAIFCEnabled ? undefined : ()=>{
                const toolbarDocking = (0, $dh538.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition : api?.selectionToolbar?.sharedState?.currentState()?.toolbarDocking;
                if (toolbarDocking === 'none' && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
                    exposure: true
                })) {
                    const toolbarCustom = {
                        type: 'custom',
                        render: (view)=>{
                            if (!view) return;
                            return /*#__PURE__*/ (0, $l998X.jsx)((0, $43cfda29e24b9fdf$export$b15abb95157a91c7), {
                                api: api,
                                editorView: view
                            });
                        },
                        fallback: []
                    };
                    return {
                        isToolbarAbove: true,
                        items: [
                            toolbarCustom
                        ],
                        rank: 4,
                        pluginName: 'alignment'
                    };
                } else return undefined;
            }
        },
        primaryToolbarComponent: !api?.primaryToolbar && !isToolbarAIFCEnabled ? primaryToolbarComponent : undefined
    };
};
module.exports["alignmentPlugin"] = $e91e4386e86c6360$export$48e8beb2d4cfb048;

});

parcelRegister("cpn0f", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eTj7Y = parcelRequire("eTj7Y");


var $eiA8Z = parcelRequire("eiA8Z");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $cUycv = parcelRequire("cUycv");


var $d925B = parcelRequire("d925B");

var $55QXP = parcelRequire("55QXP");


var $ks2lK = parcelRequire("ks2lK");


var $lkJUe = parcelRequire("lkJUe");





var $ftzrq = parcelRequire("ftzrq");








var $dh538 = parcelRequire("dh538");

var $d39172ac82b8477b$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS[ACTIONS["UPDATE_INLINE_COMMENT_STATE"] = 0] = "UPDATE_INLINE_COMMENT_STATE";
    ACTIONS[ACTIONS["SET_INLINE_COMMENT_DRAFT_STATE"] = 1] = "SET_INLINE_COMMENT_DRAFT_STATE";
    ACTIONS[ACTIONS["INLINE_COMMENT_UPDATE_MOUSE_STATE"] = 2] = "INLINE_COMMENT_UPDATE_MOUSE_STATE";
    ACTIONS[ACTIONS["INLINE_COMMENT_CLEAR_DIRTY_MARK"] = 3] = "INLINE_COMMENT_CLEAR_DIRTY_MARK";
    ACTIONS[ACTIONS["ADD_INLINE_COMMENT"] = 4] = "ADD_INLINE_COMMENT";
    ACTIONS[ACTIONS["INLINE_COMMENT_SET_VISIBLE"] = 5] = "INLINE_COMMENT_SET_VISIBLE";
    ACTIONS[ACTIONS["CLOSE_COMPONENT"] = 6] = "CLOSE_COMPONENT";
    ACTIONS[ACTIONS["SET_SELECTED_ANNOTATION"] = 7] = "SET_SELECTED_ANNOTATION";
    ACTIONS[ACTIONS["SET_HOVERED_ANNOTATION"] = 8] = "SET_HOVERED_ANNOTATION";
    ACTIONS[ACTIONS["FLUSH_PENDING_SELECTIONS"] = 9] = "FLUSH_PENDING_SELECTIONS";
    ACTIONS[ACTIONS["SET_PENDING_SELECTIONS"] = 10] = "SET_PENDING_SELECTIONS";
    ACTIONS[ACTIONS["SET_INLINE_COMMENTS_FETCHED"] = 11] = "SET_INLINE_COMMENTS_FETCHED";
    return ACTIONS;
}({});









var $kfJSC = parcelRequire("kfJSC");


var $6ESsx = parcelRequire("6ESsx");


var $bYZ53 = parcelRequire("bYZ53");

var $7iE7T = parcelRequire("7iE7T");










var $6ec66a5f4782e56b$export$ad08e20e7e22e394 = /*#__PURE__*/ function(AnnotationSelectionType) {
    AnnotationSelectionType["INVALID"] = "invalid";
    AnnotationSelectionType["DISABLED"] = "disabled";
    AnnotationSelectionType["VALID"] = "valid";
    return AnnotationSelectionType;
}({});
const $6ec66a5f4782e56b$var$prefix = 'ak-editor-annotation';
const $6ec66a5f4782e56b$export$711f43d01b7e0019 = {
    prefix: $6ec66a5f4782e56b$var$prefix,
    floatingComponent: `${$6ec66a5f4782e56b$var$prefix}-floating-component`,
    floatingToolbarCreateButton: `${$6ec66a5f4782e56b$var$prefix}-toolbar-create-button`,
    componentSave: `${$6ec66a5f4782e56b$var$prefix}-dummy-save-button`,
    componentClose: `${$6ec66a5f4782e56b$var$prefix}-dummy-close-button`
};


function $1c6cc12c1e03ecad$var$sum(arr, f) {
    return arr.reduce((val, x)=>val + f(x), 0);
}
const $1c6cc12c1e03ecad$export$c023470e9a462982 = ($pos)=>{
    const { nodeBefore: nodeBefore, nodeAfter: nodeAfter } = $pos;
    const markNodeBefore = nodeBefore && $pos.doc.nodeAt(Math.max(0, $pos.pos - nodeBefore.nodeSize - 1));
    const markNodeAfter = nodeAfter && $pos.doc.nodeAt($pos.pos + nodeAfter.nodeSize);
    return [
        markNodeBefore && markNodeBefore.marks || [],
        markNodeAfter && markNodeAfter.marks || []
    ];
};
/**
 * Finds annotation marks, and returns their IDs.
 * @param marks Array of marks to search in
 */ const $1c6cc12c1e03ecad$var$filterAnnotationIds = (marks)=>{
    if (!marks.length) return [];
    const { annotation: annotation } = marks[0].type.schema.marks;
    return marks.filter((mark)=>mark.type === annotation).map((mark)=>mark.attrs.id);
};
/**
 * Re-orders the annotation array based on the order in the document.
 *
 * This places the marks that do not appear in the surrounding nodes
 * higher in the list. That is, the inner-most one appears first.
 *
 * Undo, for example, can re-order annotation marks in the document.
 * @param annotations annotation metadata
 * @param $from location to look around (usually the selection)
 */ const $1c6cc12c1e03ecad$var$reorderAnnotations = (annotations, $from)=>{
    const idSet = $1c6cc12c1e03ecad$export$c023470e9a462982($from).map($1c6cc12c1e03ecad$var$filterAnnotationIds);
    annotations.sort((a, b)=>$1c6cc12c1e03ecad$var$sum(idSet, (ids)=>ids.indexOf(a.id)) - $1c6cc12c1e03ecad$var$sum(idSet, (ids)=>ids.indexOf(b.id)));
};
const $1c6cc12c1e03ecad$export$2ecc008effaefd6e = (doc)=>{
    const allAnnotationIds = new Set();
    doc.descendants((node)=>{
        node.marks.filter((mark)=>mark.type.name === 'annotation')// filter out annotations with invalid attributes as they cause errors when interacting with them
        .filter($1c6cc12c1e03ecad$var$validateAnnotationMark).forEach((m)=>allAnnotationIds.add(m.attrs.id));
        return true;
    });
    return Array.from(allAnnotationIds);
};
/*
 * verifies if annotation mark contains valid attributes
 */ const $1c6cc12c1e03ecad$var$validateAnnotationMark = (annotationMark)=>{
    const { id: id, annotationType: annotationType } = annotationMark.attrs;
    return validateAnnotationId(id) && validateAnnotationType(annotationType);
    function validateAnnotationId(id) {
        if (!id || typeof id !== 'string') return false;
        const invalidIds = [
            'null',
            'undefined'
        ];
        return !invalidIds.includes(id.toLowerCase());
    }
    function validateAnnotationType(type) {
        if (!type || typeof type !== 'string') return false;
        const allowedTypes = Object.values((0, $cUycv.AnnotationTypes));
        return allowedTypes.includes(type);
    }
};
const $1c6cc12c1e03ecad$export$824a8ce0be7d4e38 = {
    block: 'blockCommentDecoration',
    inline: 'inlineCommentDecoration'
};
const $1c6cc12c1e03ecad$export$b3b680ab7872fa4c = (start, end, targetType = 'inline')=>{
    if (targetType === 'block') return (0, $ftzrq.Decoration).node(start, end, {
        class: `${(0, $6ESsx.BlockAnnotationSharedClassNames).draft}`
    }, {
        key: $1c6cc12c1e03ecad$export$824a8ce0be7d4e38.block
    });
    return (0, $ftzrq.Decoration).inline(start, end, {
        class: `${(0, $6ESsx.AnnotationSharedClassNames).draft}`
    }, {
        key: $1c6cc12c1e03ecad$export$824a8ce0be7d4e38.inline
    });
};
const $1c6cc12c1e03ecad$export$1832a9899106877a = (annotations)=>{
    const keys = annotations.map((mark)=>mark.id).join('_');
    return `view-annotation-wrapper_${keys}`;
};
const $1c6cc12c1e03ecad$export$3bf994b39b13856a = (selection, doc)=>{
    const { empty: empty, $anchor: $anchor, anchor: anchor } = selection;
    // Only detect annotations on caret selection
    if (!empty || !doc) {
        if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
            if (selection instanceof (0, $ks2lK.NodeSelection) && [
                'inlineCard',
                'emoji',
                'date',
                'mention',
                'status'
            ].includes(selection.node.type.name)) ;
            else return [];
        } else return [];
    }
    const node = doc.nodeAt(anchor);
    const nodeBefore = $anchor.nodeBefore;
    if (!node && !nodeBefore) return [];
    // Inline comment on mediaInline is not supported as part of comments on media project
    // Hence, we ignore annotations associated with the node when the cursor is right after/before the node
    if ([
        nodeBefore,
        node
    ].some((node)=>node?.type.name === 'mediaInline')) return [];
    const annotationMark = doc.type.schema.marks.annotation;
    const anchorAnnotationMarks = node?.marks || [];
    let marks = [];
    if (annotationMark.isInSet(anchorAnnotationMarks)) marks = anchorAnnotationMarks;
    if (nodeBefore && annotationMark.isInSet(nodeBefore.marks)) {
        const existingMarkIds = marks.map((m)=>m.attrs.id);
        marks = marks.concat(...nodeBefore.marks.filter((m)=>!existingMarkIds.includes(m.attrs.id)));
    }
    const annotations = marks.filter((mark)=>mark.type.name === 'annotation').map((mark)=>({
            id: mark.attrs.id,
            type: mark.attrs.annotationType
        }));
    $1c6cc12c1e03ecad$var$reorderAnnotations(annotations, $anchor);
    return annotations;
};
const $1c6cc12c1e03ecad$export$196f73a7cbac5e80 = (editorState, bookmark, supportedBlockNodes = [])=>{
    const { doc: doc } = editorState;
    const resolvedBookmark = bookmark ? bookmark.resolve(doc) : editorState.selection;
    const { from: from, to: to, head: head } = resolvedBookmark;
    let draftBookmark = {
        from: from,
        to: to,
        head: head,
        isBlockNode: false
    };
    if (resolvedBookmark instanceof (0, $ks2lK.NodeSelection)) {
        // It's possible that annotation is only allowed in child node instead parent (e.g. mediaSingle vs media),
        // thus, we traverse the node to find the first node that supports annotation and return its position
        let nodeFound = false;
        doc.nodesBetween(from, to, (node, pos)=>{
            // if we find the node, breakout the traversal to make sure we always record the first supported node
            if (nodeFound) return false;
            const nodeEndsAt = pos + node.nodeSize;
            if (supportedBlockNodes.includes(node.type.name)) {
                draftBookmark = {
                    from: pos,
                    to: nodeEndsAt,
                    head: nodeEndsAt,
                    isBlockNode: node.isBlock
                };
                nodeFound = true;
                return false;
            }
        });
    }
    return draftBookmark;
};
function $1c6cc12c1e03ecad$export$31c5af77b755d41f(editorState, bookmark) {
    // get positions via saved bookmark if it is available
    // this is to make comments box positioned relative to temporary highlight rather then current selection
    if (bookmark) return bookmark.resolve(editorState.doc);
    return editorState.selection;
}
const $1c6cc12c1e03ecad$export$544b399faf6001b7 = new (0, $ks2lK.PluginKey)('inlineCommentPluginKey');
const $1c6cc12c1e03ecad$export$f05434c51e3762e = (state)=>{
    return $1c6cc12c1e03ecad$export$544b399faf6001b7.getState(state);
};
/**
 * get number of unique annotations within current selection
 */ const $1c6cc12c1e03ecad$var$getAnnotationsInSelectionCount = (state)=>{
    const { from: from, to: to } = state.selection;
    const annotations = (0, $bYZ53.getAnnotationIdsFromRange)({
        from: from,
        to: to
    }, state.doc, state.schema);
    return annotations.length;
};
const $1c6cc12c1e03ecad$export$a28639698c912d2c = (drafting, inputMethod)=>{
    const payload = (state)=>{
        let attributes = {};
        if (drafting) attributes = {
            inputMethod: inputMethod,
            overlap: $1c6cc12c1e03ecad$var$getAnnotationsInSelectionCount(state)
        };
        if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
            const { bookmark: bookmark } = $1c6cc12c1e03ecad$export$f05434c51e3762e(state) || {};
            attributes.inlineNodeNames = (0, $bYZ53.getRangeInlineNodeNames)({
                doc: state.doc,
                pos: $1c6cc12c1e03ecad$export$196f73a7cbac5e80(state, bookmark)
            });
        }
        return {
            action: drafting ? (0, $d925B.ACTION).OPENED : (0, $d925B.ACTION).CLOSED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: attributes
        };
    };
    return payload;
};
const $1c6cc12c1e03ecad$export$af7e6fc08350a63d = (state, _supportedNodes = [])=>{
    const { selection: selection } = state;
    const { disallowOnWhitespace: disallowOnWhitespace } = $1c6cc12c1e03ecad$export$f05434c51e3762e(state) || {};
    const allowedInlineNodes = [
        'emoji',
        'status',
        'date',
        'mention',
        'inlineCard'
    ];
    const isSelectionEmpty = selection.empty;
    const isTextOrAllSelection = selection instanceof (0, $ks2lK.TextSelection) || selection instanceof (0, $ks2lK.AllSelection);
    const isValidNodeSelection = selection instanceof (0, $ks2lK.NodeSelection) && allowedInlineNodes.includes(selection.node.type.name);
    const isValidSelection = isTextOrAllSelection || isValidNodeSelection;
    // Allow media so that it can enter draft mode
    if ((0, $kfJSC.currentMediaNodeWithPos)(state)?.node) return (0, $6ec66a5f4782e56b$export$ad08e20e7e22e394).VALID;
    if (isSelectionEmpty || !isValidSelection) return (0, $6ec66a5f4782e56b$export$ad08e20e7e22e394).INVALID;
    const containsInvalidNodes = $1c6cc12c1e03ecad$export$d454546510357a0(state);
    // A selection that only covers 1 pos, and is an invalid node
    // e.g. a text selection over a mention
    if (containsInvalidNodes && selection.to - selection.from === 1) return (0, $6ec66a5f4782e56b$export$ad08e20e7e22e394).INVALID;
    if (containsInvalidNodes) return (0, $6ec66a5f4782e56b$export$ad08e20e7e22e394).DISABLED;
    if (disallowOnWhitespace && $1c6cc12c1e03ecad$export$6d32268ea00f42b0(selection, state.schema)) return (0, $6ec66a5f4782e56b$export$ad08e20e7e22e394).INVALID;
    if (!(selection instanceof (0, $ks2lK.NodeSelection)) && (0, $bYZ53.isEmptyTextSelection)(selection, state.schema)) return (0, $6ec66a5f4782e56b$export$ad08e20e7e22e394).INVALID;
    return (0, $6ec66a5f4782e56b$export$ad08e20e7e22e394).VALID;
};
const $1c6cc12c1e03ecad$export$d454546510357a0 = (state)=>{
    const { selection: selection, doc: doc, schema: schema } = state;
    return !(0, $bYZ53.canApplyAnnotationOnRange)({
        from: selection.from,
        to: selection.to
    }, doc, schema);
};
const $1c6cc12c1e03ecad$export$bb7c9ea7da92cd01 = (node, supportedBlockNodes = [])=>{
    return supportedBlockNodes.indexOf(node.type.name) >= 0 || node.type.name === 'mediaSingle' && supportedBlockNodes.indexOf('media') >= 0;
};
function $1c6cc12c1e03ecad$export$6d32268ea00f42b0(selection, schema) {
    let foundInvalidWhitespace = false;
    const content = selection.content().content;
    let hasCommentableInlineNodeDescendants = false;
    let hasCommentableTextNodeDescendants = false;
    content.descendants((node)=>{
        if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
            const isAllowedInlineNode = [
                'emoji',
                'status',
                'date',
                'mention',
                'inlineCard'
            ].includes(node.type.name);
            if (isAllowedInlineNode) {
                hasCommentableInlineNodeDescendants = true;
                return false;
            }
        }
        if (node.type === schema.nodes.inlineCard && (0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) return false;
        if ((0, $7iE7T.isText)(node, schema)) {
            if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
                if (node.textContent.trim() !== '') hasCommentableTextNodeDescendants = true;
            }
            return false;
        }
        if (!(0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
            if (node.textContent.trim() === '') {
                // Trailing new lines do not result in the annotation spanning into
                // the trailing new line so can be ignored when looking for invalid
                // whitespace nodes.
                const nodeIsTrailingNewLine = // it is the final node
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                node.eq(content.lastChild) && // and there are multiple nodes
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                !node.eq(content.firstChild) && // and it is a paragraph node
                (0, $7iE7T.isParagraph)(node, schema);
                if (!nodeIsTrailingNewLine) foundInvalidWhitespace = true;
            }
        }
        return !foundInvalidWhitespace;
    });
    if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
        if (hasCommentableInlineNodeDescendants) return false;
        return !hasCommentableTextNodeDescendants;
    }
    return foundInvalidWhitespace;
}
function $1c6cc12c1e03ecad$export$5a8abbb22a9cfbef(annotationId, state) {
    const commentsPluginState = $1c6cc12c1e03ecad$export$f05434c51e3762e(state);
    return !!commentsPluginState?.annotations && Object.keys(commentsPluginState.annotations).includes(annotationId);
}
function $1c6cc12c1e03ecad$export$ca9ec32b395faf65(slice, state) {
    if (!slice.content.size) return false;
    slice.content.forEach((node)=>{
        $1c6cc12c1e03ecad$var$stripNonExistingAnnotationsFromNode(node, state);
        node.content.descendants((node)=>{
            $1c6cc12c1e03ecad$var$stripNonExistingAnnotationsFromNode(node, state);
            return true;
        });
    });
}
/*
 * remove annotations that dont exsist in plugin state
 * from node
 */ function $1c6cc12c1e03ecad$var$stripNonExistingAnnotationsFromNode(node, state) {
    if ((0, $bYZ53.hasAnnotationMark)(node, state)) node.marks = node.marks.filter((mark)=>{
        if (mark.type.name === 'annotation') return $1c6cc12c1e03ecad$export$5a8abbb22a9cfbef(mark.attrs.id, state);
        return true;
    });
    return node;
}
function $1c6cc12c1e03ecad$export$a411569b9111c88e(oldSelectedAnnotations, newSelectedAnnotations) {
    return newSelectedAnnotations.length !== oldSelectedAnnotations.length || // assuming annotations have unique id's for simplicity
    newSelectedAnnotations.some((annotation)=>!oldSelectedAnnotations.find((pluginStateAnnotation)=>annotation.id === pluginStateAnnotation.id && annotation.type === pluginStateAnnotation.type));
}
const $1c6cc12c1e03ecad$export$e171deb7d9f0a865 = (selection, selectedAnnotations = [])=>{
    if (selectedAnnotations.length && selection instanceof (0, $ks2lK.NodeSelection)) {
        const node = selection.node.type.name === 'mediaSingle' ? selection.node.firstChild : selection.node;
        const annotationMarks = node?.marks.filter((mark)=>mark.type.name === 'annotation').map((mark)=>({
                id: mark.attrs.id,
                type: mark.attrs.annotationType
            })) || [];
        return !selectedAnnotations.some((annotation)=>!annotationMarks.find((existingAnnotation)=>existingAnnotation.id === annotation.id && existingAnnotation.type === annotation.type));
    }
    return false;
};
const $1c6cc12c1e03ecad$export$98b0a2a6ba343064 = (state)=>{
    const annotations = $1c6cc12c1e03ecad$export$f05434c51e3762e(state)?.annotations;
    if (annotations) {
        /**
     * annotations type is { [key: string]: boolean };
     * Here, key represents mark.attr.id and it is used to find where annotation to be presented in the document.
     * When value is false, it means it is unresolved annotation.
     *
     * But sometimes annotation map has entry with key undefined somehow.
     * And it is not valid mark attribute id, so it won't be presented anywhere in the document.
     */ const unresolvedAnnotationKeys = Object.keys(annotations).filter((key)=>key !== 'undefined' && annotations[key] === false);
        return unresolvedAnnotationKeys.length > 0;
    }
    return false;
};


var $a74378346bd8522b$export$2e2bcd8739ae039 = (pluginState, action)=>{
    switch(action.type){
        case (0, $d39172ac82b8477b$export$92a1a3b7554e9387).SET_INLINE_COMMENTS_FETCHED:
            return {
                ...pluginState,
                annotationsLoaded: true
            };
        case (0, $d39172ac82b8477b$export$92a1a3b7554e9387).UPDATE_INLINE_COMMENT_STATE:
            return {
                ...pluginState,
                annotationsLoaded: true,
                annotations: {
                    ...pluginState.annotations,
                    ...action.data
                }
            };
        case (0, $d39172ac82b8477b$export$92a1a3b7554e9387).INLINE_COMMENT_UPDATE_MOUSE_STATE:
            const mouseData = Object.assign({}, pluginState.mouseData, action.data.mouseData);
            return {
                ...pluginState,
                mouseData: mouseData
            };
        case (0, $d39172ac82b8477b$export$92a1a3b7554e9387).SET_INLINE_COMMENT_DRAFT_STATE:
            return $a74378346bd8522b$var$getNewDraftState(pluginState, action.data.drafting, action.data.editorState, action.data.targetType, action.data.supportedBlockNodes, action.data.targetNodeId, action.data.isOpeningMediaCommentFromToolbar);
        case (0, $d39172ac82b8477b$export$92a1a3b7554e9387).INLINE_COMMENT_CLEAR_DIRTY_MARK:
            return {
                ...pluginState,
                dirtyAnnotations: false,
                annotations: {}
            };
        case (0, $d39172ac82b8477b$export$92a1a3b7554e9387).CLOSE_COMPONENT:
            return {
                ...pluginState,
                isInlineCommentViewClosed: true,
                isDrafting: false,
                isOpeningMediaCommentFromToolbar: false,
                ...(0, $dh538.fg)('platform_editor_annotation_selected_annotation') && {
                    selectedAnnotations: []
                },
                ...pluginState.isAnnotationManagerEnabled && {
                    selectedAnnotations: []
                }
            };
        case (0, $d39172ac82b8477b$export$92a1a3b7554e9387).ADD_INLINE_COMMENT:
            const updatedPluginState = $a74378346bd8522b$var$getNewDraftState(pluginState, action.data.drafting, action.data.editorState);
            return {
                ...updatedPluginState,
                selectedAnnotations: [
                    ...updatedPluginState.selectedAnnotations,
                    ...action.data.selectedAnnotations
                ],
                annotations: {
                    ...pluginState.annotations,
                    ...action.data.inlineComments
                },
                isInlineCommentViewClosed: false,
                selectAnnotationMethod: undefined,
                ...pluginState.isAnnotationManagerEnabled && {
                    skipSelectionHandling: true
                }
            };
        case (0, $d39172ac82b8477b$export$92a1a3b7554e9387).INLINE_COMMENT_SET_VISIBLE:
            const { isVisible: isVisible } = action.data;
            if (isVisible === pluginState.isVisible) return pluginState;
            return {
                ...isVisible ? pluginState : $a74378346bd8522b$var$getNewDraftState(pluginState, false),
                isVisible: isVisible
            };
        case (0, $d39172ac82b8477b$export$92a1a3b7554e9387).SET_SELECTED_ANNOTATION:
            return {
                ...pluginState,
                selectedAnnotations: [
                    ...action.data.selectedAnnotations
                ],
                selectAnnotationMethod: action.data.selectAnnotationMethod,
                skipSelectionHandling: true,
                isInlineCommentViewClosed: false,
                isOpeningMediaCommentFromToolbar: action.data.isOpeningMediaCommentFromToolbar
            };
        case (0, $d39172ac82b8477b$export$92a1a3b7554e9387).SET_HOVERED_ANNOTATION:
            return {
                ...pluginState,
                hoveredAnnotations: [
                    ...action.data.hoveredAnnotations
                ],
                skipSelectionHandling: true,
                isInlineCommentViewClosed: false
            };
        case (0, $d39172ac82b8477b$export$92a1a3b7554e9387).FLUSH_PENDING_SELECTIONS:
            return {
                ...pluginState,
                selectedAnnotations: action.data.canSetAsSelectedAnnotations ? [
                    ...pluginState.pendingSelectedAnnotations
                ] : pluginState.selectedAnnotations,
                pendingSelectedAnnotations: [],
                isInlineCommentViewClosed: false
            };
        case (0, $d39172ac82b8477b$export$92a1a3b7554e9387).SET_PENDING_SELECTIONS:
            return {
                ...pluginState,
                pendingSelectedAnnotations: [
                    ...action.data.selectedAnnotations
                ],
                pendingSelectedAnnotationsUpdateCount: pluginState.pendingSelectedAnnotationsUpdateCount + 1,
                skipSelectionHandling: true,
                isInlineCommentViewClosed: false
            };
        default:
            return pluginState;
    }
};
function $a74378346bd8522b$var$getNewDraftState(pluginState, drafting, editorState, targetType, supportedBlockNodes, targetNodeId, isOpeningMediaCommentFromToolbar) {
    let { draftDecorationSet: draftDecorationSet } = pluginState;
    if (!draftDecorationSet || !drafting) draftDecorationSet = (0, $ftzrq.DecorationSet).empty;
    const newState = {
        ...pluginState,
        draftDecorationSet: draftDecorationSet,
        isDrafting: drafting,
        targetNodeId: targetNodeId
    };
    newState.bookmark = undefined;
    if (drafting && editorState) {
        newState.bookmark = editorState.selection.getBookmark();
        const { from: from, to: to } = (0, $1c6cc12c1e03ecad$export$196f73a7cbac5e80)(editorState, newState.bookmark, supportedBlockNodes);
        const draftDecoration = (0, $1c6cc12c1e03ecad$export$b3b680ab7872fa4c)(from, to, targetType);
        newState.draftDecorationSet = draftDecorationSet.add(editorState.doc, [
            draftDecoration
        ]);
    }
    newState.isOpeningMediaCommentFromToolbar = isOpeningMediaCommentFromToolbar;
    return newState;
}



const $5bbbca891262e1f8$var$handleDocChanged = (tr, prevPluginState)=>{
    if (!tr.getMeta('replaceDocument')) return $5bbbca891262e1f8$var$getSelectionChangedHandler(false)(tr, prevPluginState);
    return {
        ...prevPluginState,
        dirtyAnnotations: true
    };
};
/**
 * Creates a handleDocChanged function with its own deleted annotations cache.
 * This ensures each editor instance has its own cache, avoiding cross-contamination.
 */ const $5bbbca891262e1f8$var$createHandleDocChanged = ()=>{
    // Cache for preserving deleted annotation resolved states through delete/undo cycles
    // This lives in closure scope per editor instance to avoid serialization and reduce state size
    const deletedAnnotationsCache = {};
    return (tr, prevPluginState)=>{
        if (tr.getMeta('replaceDocument')) return {
            ...prevPluginState,
            dirtyAnnotations: true
        };
        const updatedState = $5bbbca891262e1f8$var$getSelectionChangedHandler(false)(tr, prevPluginState);
        // Collect annotation IDs currently in the document
        const annotationIdsInDocument = new Set();
        tr.doc.descendants((node)=>{
            node.marks.forEach((mark)=>{
                if (mark.type.name === 'annotation') annotationIdsInDocument.add(mark.attrs.id);
            });
        });
        const annotationIdsInState = Object.keys(prevPluginState.annotations);
        // Early return if annotations haven't changed
        const annotationsHaveChanged = annotationIdsInDocument.size !== annotationIdsInState.length || annotationIdsInState.some((id)=>!annotationIdsInDocument.has(id));
        if (!annotationsHaveChanged) return updatedState;
        // Cache deleted annotations to be able to restore their resolved states on undo
        const updatedAnnotations = {};
        annotationIdsInState.forEach((id)=>{
            if (!annotationIdsInDocument.has(id)) deletedAnnotationsCache[id] = prevPluginState.annotations[id];
        });
        // Update annotations to match document state, preserving resolved states through delete/undo
        annotationIdsInDocument.forEach((id)=>{
            updatedAnnotations[id] = prevPluginState.annotations[id] ?? deletedAnnotationsCache[id] ?? false;
        });
        return {
            ...updatedState,
            annotations: updatedAnnotations
        };
    };
};
const $5bbbca891262e1f8$export$58d7bae3d6fd3076 = (tr, editorState, bookmark)=>{
    if (editorState.selection.empty || !bookmark) return true;
    else if (editorState.selection instanceof (0, $ks2lK.NodeSelection)) {
        const bookmarkSelection = bookmark?.resolve(tr.doc);
        if (bookmarkSelection instanceof (0, $ks2lK.NodeSelection)) {
            const selectionNode = editorState.selection.node;
            const bookmarkNode = bookmarkSelection.node;
            /**
			 * Currently, after updating the alt text of a mediaSingle node,
			 * the selection moves to the media node.
			 * (then will append a transaction to its parent node)
			 */ if (selectionNode.type.name === 'media' && bookmarkNode.type.name === 'mediaSingle') return !bookmarkNode.firstChild?.eq(selectionNode);
            else return !bookmarkNode.eq(selectionNode);
        }
    }
    // by default we discard bookmark
    return true;
};
const $5bbbca891262e1f8$var$getSelectionChangeHandlerOld = (reopenCommentView)=>(tr, pluginState)=>{
        if (pluginState.skipSelectionHandling) return {
            ...pluginState,
            skipSelectionHandling: false,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            }
        };
        if (// If pluginState.selectedAnnotations is annotations of block node, i.e. when a new comment is created,
        // we keep it as it is so that we can show comment view component with the newly created comment
        (0, $1c6cc12c1e03ecad$export$e171deb7d9f0a865)(tr.selection, pluginState.selectedAnnotations)) return {
            ...pluginState,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            }
        };
        const selectedAnnotations = (0, $1c6cc12c1e03ecad$export$3bf994b39b13856a)(tr.selection, tr.doc);
        if (selectedAnnotations.length === 0) return {
            ...pluginState,
            selectedAnnotations: selectedAnnotations,
            isInlineCommentViewClosed: true,
            selectAnnotationMethod: undefined
        };
        if ((0, $1c6cc12c1e03ecad$export$a411569b9111c88e)(selectedAnnotations, pluginState.selectedAnnotations)) return {
            ...pluginState,
            selectedAnnotations: selectedAnnotations,
            selectAnnotationMethod: undefined,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            }
        };
        return {
            ...pluginState,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            },
            selectAnnotationMethod: undefined
        };
    };
const $5bbbca891262e1f8$var$getSelectionChangeHandlerNew = (reopenCommentView)=>(tr, pluginState)=>{
        if (pluginState.skipSelectionHandling) return {
            ...pluginState,
            skipSelectionHandling: false,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            }
        };
        const selectedAnnotations = (0, $1c6cc12c1e03ecad$export$3bf994b39b13856a)(tr.selection, tr.doc);
        // NOTE: I've left this commented code here as a reference that the previous old code would reset the selected annotations
        // if the selection is empty. If this is no longer needed, we can remove this code.
        // if (selectedAnnotations.length === 0) {
        // 	return {
        // 		...pluginState,
        // 		pendingSelectedAnnotations: selectedAnnotations,
        // 		pendingSelectedAnnotationsUpdateCount:
        // 			pluginState.pendingSelectedAnnotationsUpdateCount + 1,
        // 		isInlineCommentViewClosed: true,
        // 		selectAnnotationMethod: undefined,
        // 	};
        // }
        if ((0, $1c6cc12c1e03ecad$export$a411569b9111c88e)(selectedAnnotations, pluginState.pendingSelectedAnnotations)) return {
            ...pluginState,
            pendingSelectedAnnotations: selectedAnnotations,
            pendingSelectedAnnotationsUpdateCount: pluginState.pendingSelectedAnnotationsUpdateCount + 1,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            }
        };
        return {
            ...pluginState,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            },
            selectAnnotationMethod: undefined
        };
    };
const $5bbbca891262e1f8$var$getSelectionChangedHandler = (reopenCommentView)=>(tr, pluginState)=>pluginState.isAnnotationManagerEnabled ? $5bbbca891262e1f8$var$getSelectionChangeHandlerNew(reopenCommentView)(tr, pluginState) : $5bbbca891262e1f8$var$getSelectionChangeHandlerOld(reopenCommentView)(tr, pluginState);
// Create the handler with cache once at module level
const $5bbbca891262e1f8$var$handleDocChangedWithSync = $5bbbca891262e1f8$var$createHandleDocChanged();
const $5bbbca891262e1f8$var$getDocChangedHandler = (tr, prevPluginState)=>{
    // Check feature flag at runtime to support test variants
    if ((0, $1oCLl.expValEquals)('platform_editor_annotations_sync_on_docchange', 'isEnabled', true)) return $5bbbca891262e1f8$var$handleDocChangedWithSync(tr, prevPluginState);
    return $5bbbca891262e1f8$var$handleDocChanged(tr, prevPluginState);
};
const { createPluginState: $5bbbca891262e1f8$export$656c7661095efe2e, createCommand: $5bbbca891262e1f8$export$8d4021544bdece00 } = (0, $lkJUe.pluginFactory)((0, $1c6cc12c1e03ecad$export$544b399faf6001b7), (0, $a74378346bd8522b$export$2e2bcd8739ae039), {
    onSelectionChanged: $5bbbca891262e1f8$var$getSelectionChangedHandler(true),
    onDocChanged: $5bbbca891262e1f8$var$getDocChangedHandler,
    mapping: (tr, pluginState, editorState)=>{
        const { draftDecorationSet: draftDecorationSet, bookmark: bookmark } = pluginState;
        let mappedDecorationSet = (0, $ftzrq.DecorationSet).empty, mappedBookmark;
        let hasMappedDecorations = false;
        if (draftDecorationSet) mappedDecorationSet = draftDecorationSet.map(tr.mapping, tr.doc);
        hasMappedDecorations = mappedDecorationSet.find(undefined, undefined, (spec)=>Object.values((0, $1c6cc12c1e03ecad$export$824a8ce0be7d4e38)).includes(spec.key)).length > 0;
        // When changes to decoration target make decoration invalid (e.g. delete text, add mark to node),
        // we need to reset bookmark to hide create component and to avoid invalid draft being published
        // We only perform this change when document selection has changed.
        if (!hasMappedDecorations && $5bbbca891262e1f8$export$58d7bae3d6fd3076(tr, editorState, bookmark)) return {
            ...pluginState,
            draftDecorationSet: mappedDecorationSet,
            bookmark: undefined
        };
        if (bookmark) mappedBookmark = bookmark.map(tr.mapping);
        // return same pluginState if mappings did not change
        if (mappedBookmark === bookmark && mappedDecorationSet === draftDecorationSet) return pluginState;
        return {
            ...pluginState,
            draftDecorationSet: mappedDecorationSet,
            bookmark: mappedBookmark
        };
    }
});












var $b167b = parcelRequire("b167b");








var $aXG5V = parcelRequire("aXG5V");





const $525475292fc461c8$var$isAnnotationStep = (step)=>step instanceof (0, $aXG5V.AddMarkStep) && step.mark.type.name === 'annotation';
const $525475292fc461c8$var$addAnnotationMark = (id, supportedBlockNodes)=>(transaction, state)=>{
        const inlineCommentState = (0, $1c6cc12c1e03ecad$export$f05434c51e3762e)(state);
        const { bookmark: bookmark } = inlineCommentState || {};
        const annotationMark = state.schema.marks.annotation.create({
            id: id,
            type: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
        });
        const { from: from, to: to, head: head, isBlockNode: isBlockNode } = (0, $1c6cc12c1e03ecad$export$196f73a7cbac5e80)(state, bookmark, supportedBlockNodes);
        let tr = transaction;
        if (isBlockNode) {
            tr = tr.addNodeMark(from, annotationMark);
            // Set selection on the node so that we can display view component
            tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, from));
        } else {
            // Apply the mark only to text node in the range.
            const tr = (0, $b167b.applyMarkOnRange)(from, to, false, annotationMark, transaction);
            // The mark may not be applied to the current "head" of the bookmark so determine what was applied
            // above and use that instead
            const annotationMarkStep = tr.steps.reverse().find($525475292fc461c8$var$isAnnotationStep);
            const headBasedOnMark = from === head ? annotationMarkStep?.from : annotationMarkStep?.to;
            tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, headBasedOnMark ?? head));
        }
        return tr;
    };
const $525475292fc461c8$var$addInlineComment = (editorAnalyticsAPI, editorAPI)=>(id, supportedBlockNodes)=>(transaction, state)=>{
            let tr = $525475292fc461c8$var$addAnnotationMark(id, supportedBlockNodes)(transaction, state);
            editorAPI?.editorViewModeEffects?.actions.applyViewModeStepAt(tr);
            // add insert analytics step to transaction
            tr = $525475292fc461c8$var$addInsertAnalytics(editorAnalyticsAPI)(tr, state);
            // add close analytics step to transaction
            tr = $525475292fc461c8$var$addOpenCloseAnalytics(editorAnalyticsAPI)(false, (0, $d925B.INPUT_METHOD).TOOLBAR)(tr, state);
            const pluginState = (0, $1c6cc12c1e03ecad$export$f05434c51e3762e)(state);
            const isAutoScrollBugFixEnabled = pluginState?.featureFlagsPluginState?.commentsOnMediaAutoscrollInEditor;
            if (isAutoScrollBugFixEnabled) // Explicitly disable scrollIntoView as scrolling is handled by CommentSidebar
            tr.setMeta('scrollIntoView', false);
            return tr;
        };
const $525475292fc461c8$var$addOpenCloseAnalytics = (editorAnalyticsAPI)=>(drafting, method = (0, $d925B.INPUT_METHOD).TOOLBAR)=>(transaction, state)=>{
            const draftingPayload = (0, $1c6cc12c1e03ecad$export$a28639698c912d2c)(drafting, method)(state);
            editorAnalyticsAPI?.attachAnalyticsEvent(draftingPayload)(transaction);
            return transaction;
        };
const $525475292fc461c8$var$handleDraftState = (editorAnalyticsAPI)=>(drafting, method = (0, $d925B.INPUT_METHOD).TOOLBAR)=>(transaction, state)=>{
            const tr = $525475292fc461c8$var$addOpenCloseAnalytics(editorAnalyticsAPI)(drafting, method)(transaction, state);
            const pluginState = (0, $1c6cc12c1e03ecad$export$f05434c51e3762e)(state);
            const isAutoScrollBugFixEnabled = pluginState?.featureFlagsPluginState?.commentsOnMediaAutoscrollInEditor;
            if (isAutoScrollBugFixEnabled) // Explicitly disable scrollIntoView as scrolling is handled by CommentSidebar
            tr.setMeta('scrollIntoView', false);
            return tr;
        };
const $525475292fc461c8$var$addInsertAnalytics = (editorAnalyticsAPI)=>(transaction, state)=>{
        const analyticsEvent = {
            action: (0, $d925B.ACTION).INSERTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {}
        };
        if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
            const { bookmark: bookmark } = (0, $1c6cc12c1e03ecad$export$f05434c51e3762e)(state) || {};
            // When this FF is removed we can move the analytics event creation inside of the
            // attachAnalyticsEvent and get type inference for the attributes.
            // @ts-ignore
            analyticsEvent.attributes.inlineNodeNames = (0, $bYZ53.getRangeInlineNodeNames)({
                doc: state.doc,
                pos: (0, $1c6cc12c1e03ecad$export$196f73a7cbac5e80)(state, bookmark)
            });
        }
        editorAnalyticsAPI?.attachAnalyticsEvent(analyticsEvent)(transaction);
        return transaction;
    };
const $525475292fc461c8$var$addResolveAnalytics = (editorAnalyticsAPI)=>(method)=>(transaction, state)=>{
            const resolvedPayload = {
                action: (0, $d925B.ACTION).RESOLVED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    method: method
                }
            };
            editorAnalyticsAPI?.attachAnalyticsEvent(resolvedPayload)(transaction);
            return transaction;
        };
const $525475292fc461c8$var$addPreemptiveGateErrorAnalytics = (editorAnalyticsAPI)=>(errorReason)=>(transaction, state)=>{
            const analyticsEvent = {
                action: (0, $d925B.ACTION).ERROR,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorReason: errorReason
                }
            };
            editorAnalyticsAPI?.attachAnalyticsEvent(analyticsEvent)(transaction);
            return transaction;
        };
const $525475292fc461c8$var$addDeleteAnalytics = (editorAnalyticsAPI)=>(transaction, state)=>{
        const analyticsEvent = {
            action: (0, $d925B.ACTION).DELETED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {}
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(analyticsEvent)(transaction);
        return transaction;
    };
var $525475292fc461c8$export$2e2bcd8739ae039 = {
    addAnnotationMark: $525475292fc461c8$var$addAnnotationMark,
    addInlineComment: $525475292fc461c8$var$addInlineComment,
    handleDraftState: $525475292fc461c8$var$handleDraftState,
    addOpenCloseAnalytics: $525475292fc461c8$var$addOpenCloseAnalytics,
    addInsertAnalytics: $525475292fc461c8$var$addInsertAnalytics,
    addResolveAnalytics: $525475292fc461c8$var$addResolveAnalytics,
    addPreemptiveGateErrorAnalytics: $525475292fc461c8$var$addPreemptiveGateErrorAnalytics,
    addDeleteAnalytics: $525475292fc461c8$var$addDeleteAnalytics
};


const $20ee3e44c93eaa25$export$2c4e3be4c627582b = (api, tr)=>{
    return api?.userIntent?.commands?.setCurrentUserIntent('commenting')({
        tr: tr
    });
};
const $20ee3e44c93eaa25$export$dc07a25f8edf98a5 = (api, tr)=>{
    return api?.userIntent?.commands?.setCurrentUserIntent('default')({
        tr: tr
    });
};


const $0f9c6d7837321f71$export$4d8462ca3c146d0e = (editorAnalyticsAPI)=>(partialNewState, resolveMethod)=>{
        const command = {
            type: (0, $d39172ac82b8477b$export$92a1a3b7554e9387).UPDATE_INLINE_COMMENT_STATE,
            data: partialNewState
        };
        const allResolved = Object.values(partialNewState).every((state)=>state);
        // TODO: EDF-716 - This is nuking the scroll into view which occurs
        // when a comment is resolved. The problem is this is called when either a collab user or the current user resolves a comment.
        // and the problem is since cc is just dispatching an event through the provider to resolve the comment and this
        // is not comming via NCS, we have not way to know if this is a local or remote transaction.
        // To quickly fix this problem to unblock live pages this will just stop the transaction causing a scroll when the
        // resolve method is set.
        const transformer = (tr, state)=>resolveMethod === (0, $55QXP.RESOLVE_METHOD).CONSUMER ? tr.setMeta('scrollIntoView', false) : tr;
        if (resolveMethod && allResolved) return (0, $5bbbca891262e1f8$export$8d4021544bdece00)(command, (tr, state)=>transformer((0, $525475292fc461c8$export$2e2bcd8739ae039).addResolveAnalytics(editorAnalyticsAPI)(resolveMethod)(tr, state), state));
        return (0, $5bbbca891262e1f8$export$8d4021544bdece00)(command, transformer);
    };
const $0f9c6d7837321f71$export$da26c8d097933b72 = ()=>(0, $5bbbca891262e1f8$export$8d4021544bdece00)({
        type: (0, $d39172ac82b8477b$export$92a1a3b7554e9387).CLOSE_COMPONENT
    });
const $0f9c6d7837321f71$export$ffa869a92c2481c3 = ()=>(0, $5bbbca891262e1f8$export$8d4021544bdece00)({
        type: (0, $d39172ac82b8477b$export$92a1a3b7554e9387).INLINE_COMMENT_CLEAR_DIRTY_MARK
    });
const $0f9c6d7837321f71$export$a3833f7fc842f6da = ()=>(0, $5bbbca891262e1f8$export$8d4021544bdece00)({
        type: (0, $d39172ac82b8477b$export$92a1a3b7554e9387).SET_INLINE_COMMENTS_FETCHED
    });
const $0f9c6d7837321f71$export$940b79a08b19cea6 = (editorAnalyticsAPI)=>(canSetAsSelectedAnnotations, errorReason)=>{
        const command = {
            type: (0, $d39172ac82b8477b$export$92a1a3b7554e9387).FLUSH_PENDING_SELECTIONS,
            data: {
                canSetAsSelectedAnnotations: canSetAsSelectedAnnotations
            }
        };
        if (!!errorReason) return (0, $5bbbca891262e1f8$export$8d4021544bdece00)(command, (tr, state)=>(0, $525475292fc461c8$export$2e2bcd8739ae039).addPreemptiveGateErrorAnalytics(editorAnalyticsAPI)(errorReason)(tr, state));
        return (0, $5bbbca891262e1f8$export$8d4021544bdece00)(command);
    };
const $0f9c6d7837321f71$export$a99e2fe25edc1abd = (id)=>(0, $5bbbca891262e1f8$export$8d4021544bdece00)({
        type: (0, $d39172ac82b8477b$export$92a1a3b7554e9387).SET_PENDING_SELECTIONS,
        data: {
            selectedAnnotations: [
                {
                    id: id,
                    type: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
                }
            ]
        }
    });
const $0f9c6d7837321f71$var$removeInlineCommentFromNode = (id, supportedBlockNodes = [], state, dispatch)=>{
    const { tr: tr, selection: selection } = state;
    if (selection instanceof (0, $ks2lK.NodeSelection) && (0, $1c6cc12c1e03ecad$export$bb7c9ea7da92cd01)(selection.node, supportedBlockNodes)) {
        const { $from: $from } = selection;
        let currNode = selection.node;
        let from = $from.start();
        // for media annotation, the selection is on media Single
        if (currNode.type === state.schema.nodes.mediaSingle && currNode.firstChild) {
            currNode = currNode.firstChild;
            from = from + 1;
        }
        const { annotation: annotationMarkType } = state.schema.marks;
        const hasAnnotation = currNode.marks.some((mark)=>mark.type === annotationMarkType);
        if (!hasAnnotation) return false;
        tr.removeNodeMark(from, annotationMarkType.create({
            id: id,
            type: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
        }));
        if (dispatch) dispatch(tr);
        return true;
    }
    return false;
};
const $0f9c6d7837321f71$export$75bee4cee90040 = (id, supportedNodes = [])=>(state, dispatch)=>{
        const { tr: tr, selection: { $from: $from } } = state;
        if ($0f9c6d7837321f71$var$removeInlineCommentFromNode(id, supportedNodes, state, dispatch)) return true;
        const { annotation: annotationMarkType } = state.schema.marks;
        const hasAnnotation = $from.marks().some((mark)=>mark.type === annotationMarkType);
        if (!hasAnnotation) return false;
        // just remove entire mark from around the node
        tr.removeMark($from.start(), $from.end(), annotationMarkType.create({
            id: id,
            type: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
        }));
        if (dispatch) dispatch(tr);
        return true;
    };
const $0f9c6d7837321f71$export$d087dc0f7213ba13 = (editorAnalyticsAPI)=>(id, supportedNodes = [])=>(state, dispatch)=>{
            const { tr: tr } = state;
            state.doc.descendants((node, pos)=>{
                // Inline comment on mediaInline is not supported as part of comments on media project
                // Thus, we skip the decoration for mediaInline node
                if (node.type.name === 'mediaInline') return false;
                const isSupportedBlockNode = node.isBlock && supportedNodes?.includes(node.type.name);
                node.marks.filter((mark)=>mark.type === state.schema.marks.annotation && mark.attrs.id === id).forEach((mark)=>{
                    if (isSupportedBlockNode) tr.removeNodeMark(pos, mark);
                    else tr.removeMark(pos, pos + node.nodeSize, mark);
                });
            });
            if (dispatch) {
                dispatch((0, $525475292fc461c8$export$2e2bcd8739ae039).addDeleteAnalytics(editorAnalyticsAPI)(tr, state));
                return true;
            }
            return false;
        };
const $0f9c6d7837321f71$var$getDraftCommandAction = (drafting, targetType, targetNodeId, supportedBlockNodes, isOpeningMediaCommentFromToolbar)=>{
    return (editorState)=>{
        // validate selection only when entering draft mode
        if (drafting && (0, $1c6cc12c1e03ecad$export$af7e6fc08350a63d)(editorState) !== (0, $6ec66a5f4782e56b$export$ad08e20e7e22e394).VALID) return false;
        return {
            type: (0, $d39172ac82b8477b$export$92a1a3b7554e9387).SET_INLINE_COMMENT_DRAFT_STATE,
            data: {
                drafting: drafting,
                editorState: editorState,
                targetType: targetType,
                supportedBlockNodes: supportedBlockNodes,
                targetNodeId: targetNodeId,
                isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar
            }
        };
    };
};
const $0f9c6d7837321f71$export$d80af6562490622d = (supportedBlockNodes = [])=>(node, viewMethod, isOpeningMediaCommentFromToolbar)=>(state, dispatch)=>{
            const pluginState = (0, $1c6cc12c1e03ecad$export$f05434c51e3762e)(state);
            const { annotation: annotation } = state.schema.marks;
            if (node && node.isBlock && supportedBlockNodes.includes(node.type.name)) {
                const unresolvedAnnotationMarks = (node?.marks || []).filter((mark)=>mark.type === annotation && !pluginState?.annotations[mark.attrs.id]).map((mark)=>({
                        id: mark.attrs.id,
                        type: mark.attrs.annotationType
                    }));
                if (unresolvedAnnotationMarks.length) {
                    if (dispatch) {
                        // bypass createCommand with setMeta
                        // so that external plugins can be aware of if there are active(unresolved) comments associated with the node
                        // i.e. media plugin can use the return result (true/false) to show toggle create comment component
                        dispatch(state.tr.setMeta((0, $1c6cc12c1e03ecad$export$544b399faf6001b7), {
                            type: (0, $d39172ac82b8477b$export$92a1a3b7554e9387).SET_SELECTED_ANNOTATION,
                            data: {
                                selectedAnnotations: unresolvedAnnotationMarks,
                                selectAnnotationMethod: viewMethod,
                                isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar
                            }
                        }));
                        return true;
                    }
                }
            }
            return false;
        };
const $0f9c6d7837321f71$export$2a7aec6fc438fa0b = (editorAnalyticsAPI, supportedBlockNodes = [], api)=>(drafting, inputMethod = (0, $d925B.INPUT_METHOD).TOOLBAR, targetType = 'inline', targetNodeId, isOpeningMediaCommentFromToolbar)=>{
        const commandAction = $0f9c6d7837321f71$var$getDraftCommandAction(drafting, targetType, targetNodeId, supportedBlockNodes, isOpeningMediaCommentFromToolbar);
        if (Boolean(api?.toolbar)) return (state, dispatch)=>{
            const tr = (0, $525475292fc461c8$export$2e2bcd8739ae039).handleDraftState(editorAnalyticsAPI)(drafting, inputMethod)(state.tr, state);
            const newPluginState = commandAction(state);
            if (tr && newPluginState) {
                tr.setMeta((0, $1c6cc12c1e03ecad$export$544b399faf6001b7), newPluginState);
                if (drafting) (0, $20ee3e44c93eaa25$export$2c4e3be4c627582b)(api, tr);
                else (0, $20ee3e44c93eaa25$export$dc07a25f8edf98a5)(api, tr);
                if (dispatch) dispatch(tr);
            } else return false;
            return true;
        };
        else return (0, $5bbbca891262e1f8$export$8d4021544bdece00)(commandAction, (0, $525475292fc461c8$export$2e2bcd8739ae039).handleDraftState(editorAnalyticsAPI)(drafting, inputMethod));
    };
const $0f9c6d7837321f71$export$fd78ad47ea0892f4 = (editorAnalyticsAPI, editorAPI)=>(id, supportedBlockNodes)=>{
        const commandAction = (editorState)=>({
                type: (0, $d39172ac82b8477b$export$92a1a3b7554e9387).ADD_INLINE_COMMENT,
                data: {
                    drafting: false,
                    inlineComments: {
                        [id]: false
                    },
                    // Auto make the newly inserted comment selected.
                    // We move the selection to the head of the comment selection.
                    selectedAnnotations: [
                        {
                            id: id,
                            type: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
                        }
                    ],
                    editorState: editorState
                }
            });
        if (Boolean(editorAPI?.toolbar)) return (state, dispatch)=>{
            const tr = (0, $525475292fc461c8$export$2e2bcd8739ae039).addInlineComment(editorAnalyticsAPI, editorAPI)(id, supportedBlockNodes)(state.tr, state);
            tr.setMeta((0, $1c6cc12c1e03ecad$export$544b399faf6001b7), commandAction(state));
            (0, $20ee3e44c93eaa25$export$dc07a25f8edf98a5)(editorAPI, tr);
            if (dispatch) {
                dispatch(tr);
                return true;
            }
            return false;
        };
        else return (0, $5bbbca891262e1f8$export$8d4021544bdece00)(commandAction, (0, $525475292fc461c8$export$2e2bcd8739ae039).addInlineComment(editorAnalyticsAPI, editorAPI)(id, supportedBlockNodes));
    };
const $0f9c6d7837321f71$export$ef4c42f03863dce9 = (mouseData)=>(0, $5bbbca891262e1f8$export$8d4021544bdece00)({
        type: (0, $d39172ac82b8477b$export$92a1a3b7554e9387).INLINE_COMMENT_UPDATE_MOUSE_STATE,
        data: {
            mouseData: mouseData
        }
    });
const $0f9c6d7837321f71$export$1e715f68ff6f5a2f = (id)=>(0, $5bbbca891262e1f8$export$8d4021544bdece00)({
        type: (0, $d39172ac82b8477b$export$92a1a3b7554e9387).SET_SELECTED_ANNOTATION,
        data: {
            selectedAnnotations: [
                {
                    id: id,
                    type: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
                }
            ]
        }
    });
const $0f9c6d7837321f71$export$c1805eee6fd0cf44 = (id)=>(0, $5bbbca891262e1f8$export$8d4021544bdece00)({
        type: (0, $d39172ac82b8477b$export$92a1a3b7554e9387).SET_HOVERED_ANNOTATION,
        data: {
            hoveredAnnotations: [
                {
                    id: id,
                    type: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
                }
            ]
        }
    });
const $0f9c6d7837321f71$export$51eda81011da4982 = (editorAnalyticsAPI, editorAPI)=>(id, annotationType = (0, $cUycv.AnnotationTypes).INLINE_COMMENT, supportedBlockNodes)=>(state, dispatch)=>{
            // don't try to add if there are is no temp highlight bookmarked
            const { bookmark: bookmark } = (0, $1c6cc12c1e03ecad$export$f05434c51e3762e)(state) || {};
            if (!bookmark || !dispatch) return false;
            if (annotationType === (0, $cUycv.AnnotationTypes).INLINE_COMMENT) return $0f9c6d7837321f71$export$fd78ad47ea0892f4(editorAnalyticsAPI, editorAPI)(id, supportedBlockNodes)(state, dispatch);
            return false;
        };
const $0f9c6d7837321f71$export$c6dc86fb1ced7a07 = (isVisible)=>{
    return (0, $5bbbca891262e1f8$export$8d4021544bdece00)({
        type: (0, $d39172ac82b8477b$export$92a1a3b7554e9387).INLINE_COMMENT_SET_VISIBLE,
        data: {
            isVisible: isVisible
        }
    });
};





const $f7a893223e5c2354$export$802ec1d716a6bb1 = {
    ...(0, $cUycv.annotation),
    toDOM: (node)=>{
        return [
            'span',
            {
                // Needs id as a reference point
                id: node.attrs.id,
                // Used to determine if the annotation is active
                annotationType: node.attrs.annotationType,
                // Below are used for prosemirror (ie. copy/paste behaviour)
                'data-mark-type': 'annotation',
                'data-mark-annotation-type': node.attrs.annotationType,
                'data-id': node.attrs.id
            },
            0
        ];
    }
};









var $1S4f7 = parcelRequire("1S4f7");















const $e1a7a5099c215209$export$b3ab33741101ad90 = (isUnresolved, hasFocus, isHovered)=>{
    if (!isUnresolved) return;
    if (hasFocus) return (0, $6ESsx.AnnotationSharedClassNames).focus;
    if (isHovered) return (0, $6ESsx.AnnotationSharedClassNames).hover;
    return (0, $6ESsx.AnnotationSharedClassNames).blur;
};
const $e1a7a5099c215209$export$bb73203a2b3a63e2 = (isUnresolved, hasFocus)=>{
    if (!isUnresolved) return;
    return hasFocus ? (0, $6ESsx.BlockAnnotationSharedClassNames).focus : (0, $6ESsx.BlockAnnotationSharedClassNames).blur;
};









var $8m4tT = parcelRequire("8m4tT");




const $21fc40f8bb03ab3c$var$ERROR_REASON_DRAFT_NOT_STARTED = 'draft-not-started';
const $21fc40f8bb03ab3c$var$ERROR_REASON_DRAFT_IN_PROGRESS = 'draft-in-progress';
const $21fc40f8bb03ab3c$var$ERROR_REASON_RANGE_MISSING = 'range-no-longer-exists';
const $21fc40f8bb03ab3c$var$ERROR_REASON_RANGE_INVALID = 'invalid-range';
const $21fc40f8bb03ab3c$var$ERROR_REASON_ID_INVALID = 'id-not-valid';
const $21fc40f8bb03ab3c$var$domRefFromPos = (view, position)=>{
    let dom;
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        dom = (0, $8m4tT.findDomRefAtPos)(position, view.domAtPos.bind(view));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(error);
        return undefined;
    }
    return dom;
};
const $21fc40f8bb03ab3c$export$86f3258f283eb796 = (editorView, options)=>()=>{
        const { isDrafting: isDrafting, draftDecorationSet: draftDecorationSet } = (0, $1c6cc12c1e03ecad$export$544b399faf6001b7).getState(editorView.state) || {};
        if (isDrafting) return false;
        const decoration = draftDecorationSet?.find();
        // If a draft decoration exists then we should block the user from creating a new one.
        if (!!decoration?.length) return false;
        return (0, $1c6cc12c1e03ecad$export$af7e6fc08350a63d)(editorView.state) === (0, $6ec66a5f4782e56b$export$ad08e20e7e22e394).VALID;
    };
const $21fc40f8bb03ab3c$export$768048043e8d2bcd = (editorView, options)=>()=>{
        const { isDrafting: isDrafting, selectedAnnotations: selectedAnnotations } = (0, $1c6cc12c1e03ecad$export$544b399faf6001b7).getState(editorView.state) || {};
        if (isDrafting) return {
            success: false,
            reason: $21fc40f8bb03ab3c$var$ERROR_REASON_DRAFT_IN_PROGRESS
        };
        if (!!selectedAnnotations?.length) {
            // if there are selected annotations when starting a draft, we need to clear the selected annotations
            // before we start the draft.
            (0, $0f9c6d7837321f71$export$da26c8d097933b72)()(editorView.state, editorView.dispatch);
            // not only that but we need to also deselect any other annotations that are currently selected.
            selectedAnnotations?.forEach((annotation)=>{
                options.annotationManager?.emit({
                    name: 'annotationSelectionChanged',
                    data: {
                        annotationId: annotation.id,
                        isSelected: false,
                        inlineNodeTypes: (0, $bYZ53.getAnnotationInlineNodeTypes)(editorView.state, annotation.id) ?? []
                    }
                });
            });
        }
        (0, $0f9c6d7837321f71$export$2a7aec6fc438fa0b)(options.editorAnalyticsAPI, undefined, options.api)(true)(editorView.state, editorView.dispatch);
        const { draftDecorationSet: draftDecorationSet } = (0, $1c6cc12c1e03ecad$export$544b399faf6001b7).getState(editorView.state) || {};
        const decorations = draftDecorationSet?.find();
        // If the matching decorations is not found containing the id, it means something went wrong with the draft.
        if (!decorations?.length) return {
            success: false,
            reason: $21fc40f8bb03ab3c$var$ERROR_REASON_RANGE_INVALID
        };
        const from = decorations[0].from;
        const targetElement = $21fc40f8bb03ab3c$var$domRefFromPos(editorView, from);
        const inlineNodeTypes = (0, $bYZ53.getRangeInlineNodeNames)({
            doc: editorView.state.doc,
            pos: {
                from: from,
                to: decorations[decorations.length - 1].to
            }
        }) ?? [];
        options.annotationManager?.emit({
            name: 'draftAnnotationStarted',
            data: {
                targetElement: targetElement,
                actionResult: undefined,
                inlineNodeTypes: inlineNodeTypes
            }
        });
        return {
            success: true,
            targetElement: targetElement,
            // In Editor the action result is undefined, because the editor will perform the transaction on the document.
            actionResult: undefined,
            inlineNodeTypes: inlineNodeTypes
        };
    };
const $21fc40f8bb03ab3c$export$eeeb486534738631 = (editorView, options)=>()=>{
        const { isDrafting: isDrafting, draftDecorationSet: draftDecorationSet } = (0, $1c6cc12c1e03ecad$export$544b399faf6001b7).getState(editorView.state) || {};
        if (!isDrafting) return {
            success: false,
            reason: $21fc40f8bb03ab3c$var$ERROR_REASON_DRAFT_NOT_STARTED
        };
        const decorations = draftDecorationSet?.find();
        if (!decorations?.length) return {
            success: false,
            reason: $21fc40f8bb03ab3c$var$ERROR_REASON_DRAFT_NOT_STARTED
        };
        (0, $0f9c6d7837321f71$export$2a7aec6fc438fa0b)(options.editorAnalyticsAPI, undefined, options.api)(false)(editorView.state, editorView.dispatch);
        !editorView.hasFocus() && editorView.focus();
        return {
            success: true
        };
    };
const $21fc40f8bb03ab3c$export$8bc7b93e04771bda = (editorView, options)=>(id)=>{
        const { isDrafting: isDrafting, draftDecorationSet: draftDecorationSet, bookmark: bookmark } = (0, $1c6cc12c1e03ecad$export$544b399faf6001b7).getState(editorView.state) || {};
        if (!isDrafting) return {
            success: false,
            reason: $21fc40f8bb03ab3c$var$ERROR_REASON_DRAFT_NOT_STARTED
        };
        const decorations = draftDecorationSet?.find();
        if (!decorations?.length || !bookmark) return {
            success: false,
            reason: $21fc40f8bb03ab3c$var$ERROR_REASON_RANGE_MISSING
        };
        const from = decorations[0].from;
        (0, $0f9c6d7837321f71$export$51eda81011da4982)(options.editorAnalyticsAPI, options.api)(id, (0, $cUycv.AnnotationTypes).INLINE_COMMENT, options.provider.supportedBlockNodes)(editorView.state, editorView.dispatch);
        !editorView.hasFocus() && editorView.focus();
        // Using the original decoration from position we should be able to locate the new target element.
        // This is because the new annotation will be created at the same position as the draft decoration.
        const targetElement = $21fc40f8bb03ab3c$var$domRefFromPos(editorView, from);
        // When a draft is applied it is automatically selected, so we need to set the selected annotation.
        // emit the event for the selected annotation.
        options.annotationManager?.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: id,
                isSelected: true,
                inlineNodeTypes: (0, $bYZ53.getAnnotationInlineNodeTypes)(editorView.state, id) ?? []
            }
        });
        return {
            success: true,
            targetElement: // Get the dom element from the newly created annotation and return it here.
            targetElement,
            // In Editor this is undefined, because the editor will update the document.
            actionResult: undefined
        };
    };
const $21fc40f8bb03ab3c$export$1a473231c51c1d5b = (editorView, options)=>()=>{
        const { isDrafting: isDrafting, draftDecorationSet: draftDecorationSet } = (0, $1c6cc12c1e03ecad$export$544b399faf6001b7).getState(editorView.state) || {};
        if (!isDrafting) return {
            success: false,
            reason: $21fc40f8bb03ab3c$var$ERROR_REASON_DRAFT_NOT_STARTED
        };
        const decorations = draftDecorationSet?.find();
        if (!decorations?.length) return {
            success: false,
            reason: $21fc40f8bb03ab3c$var$ERROR_REASON_DRAFT_NOT_STARTED
        };
        const from = decorations[0].from;
        const targetElement = $21fc40f8bb03ab3c$var$domRefFromPos(editorView, from);
        const inlineNodeTypes = (0, $bYZ53.getRangeInlineNodeNames)({
            doc: editorView.state.doc,
            pos: {
                from: from,
                to: decorations[decorations.length - 1].to
            }
        }) ?? [];
        return {
            success: true,
            inlineNodeTypes: inlineNodeTypes,
            targetElement: targetElement,
            actionResult: undefined
        };
    };
const $21fc40f8bb03ab3c$export$b8ac6bdd928e737c = (editorView, options)=>(id, isSelected)=>{
        const { annotations: annotations, isDrafting: isDrafting, selectedAnnotations: selectedAnnotations } = (0, $1c6cc12c1e03ecad$export$544b399faf6001b7).getState(editorView.state) || {};
        if (isDrafting) return {
            success: false,
            reason: $21fc40f8bb03ab3c$var$ERROR_REASON_DRAFT_IN_PROGRESS
        };
        // If there is no annotation state with this id then we can assume the annotation is invalid.
        if (!annotations?.hasOwnProperty(id)) return {
            success: false,
            reason: $21fc40f8bb03ab3c$var$ERROR_REASON_ID_INVALID
        };
        const isCurrentlySelectedIndex = selectedAnnotations?.findIndex((annotation)=>annotation.id === id) ?? -1;
        const isCurrentlySelected = isCurrentlySelectedIndex !== -1;
        if (isSelected !== isCurrentlySelected) {
            // the annotation is selection is changing.
            if (isCurrentlySelected && !isSelected) {
                // the selected annotaion is being unselected, so we need to close the view.
                (0, $0f9c6d7837321f71$export$da26c8d097933b72)()(editorView.state, editorView.dispatch);
                options.annotationManager?.emit({
                    name: 'annotationSelectionChanged',
                    data: {
                        annotationId: id,
                        isSelected: false,
                        inlineNodeTypes: (0, $bYZ53.getAnnotationInlineNodeTypes)(editorView.state, id) ?? []
                    }
                });
            } else if (!isCurrentlySelected && isSelected) {
                // the annotation is currently not selected and is being selected, so we need to open the view.
                (0, $0f9c6d7837321f71$export$1e715f68ff6f5a2f)(id)(editorView.state, editorView.dispatch);
                // the current annotations are going to be unselected. So we need to notify listeners of this change also.
                selectedAnnotations?.forEach((annotation)=>{
                    if (annotation.id !== id) options.annotationManager?.emit({
                        name: 'annotationSelectionChanged',
                        data: {
                            annotationId: annotation.id,
                            isSelected: false,
                            inlineNodeTypes: (0, $bYZ53.getAnnotationInlineNodeTypes)(editorView.state, annotation.id) ?? []
                        }
                    });
                });
                // Lastly we need to emit the event for the selected annotation.
                options.annotationManager?.emit({
                    name: 'annotationSelectionChanged',
                    data: {
                        annotationId: id,
                        isSelected: true,
                        inlineNodeTypes: (0, $bYZ53.getAnnotationInlineNodeTypes)(editorView.state, id) ?? []
                    }
                });
            }
        }
        return {
            success: true,
            isSelected: isSelected
        };
    };
const $21fc40f8bb03ab3c$export$5ada3da2e2f0701f = (editorView, options)=>(id, isHovered)=>{
        const { annotations: annotations, hoveredAnnotations: hoveredAnnotations } = (0, $1c6cc12c1e03ecad$export$544b399faf6001b7).getState(editorView.state) || {};
        // If there is no annotation state with this id then we can assume the annotation is invalid.
        if (!annotations?.hasOwnProperty(id)) return {
            success: false,
            reason: $21fc40f8bb03ab3c$var$ERROR_REASON_ID_INVALID
        };
        const isCurrentlyHoveredIndex = hoveredAnnotations?.findIndex((annotation)=>annotation.id === id) ?? -1;
        const isCurrentlyHovered = isCurrentlyHoveredIndex !== -1;
        if (isHovered !== isCurrentlyHovered) {
            // the annotation in hovered is changing.
            if (isCurrentlyHovered && !isHovered) // the hovered annotaion is being unhovered, so we should remove the hover state.
            (0, $0f9c6d7837321f71$export$c1805eee6fd0cf44)('')(editorView.state, editorView.dispatch);
            else if (!isCurrentlyHovered && isHovered) // the annotation is currently not hovered and is being hovered.
            (0, $0f9c6d7837321f71$export$c1805eee6fd0cf44)(id)(editorView.state, editorView.dispatch);
        }
        return {
            success: true,
            isHovered: isHovered
        };
    };
const $21fc40f8bb03ab3c$export$6baae9b3f0f9bdce = (editorView, options)=>(id)=>{
        const { annotations: annotations } = (0, $1c6cc12c1e03ecad$export$544b399faf6001b7).getState(editorView.state) || {};
        // If there is no annotation state with this id then we can assume the annotation is invalid.
        if (!annotations?.hasOwnProperty(id)) return {
            success: false,
            reason: $21fc40f8bb03ab3c$var$ERROR_REASON_ID_INVALID
        };
        (0, $0f9c6d7837321f71$export$d087dc0f7213ba13)(options.editorAnalyticsAPI)(id, options.provider.supportedBlockNodes)(editorView.state, editorView.dispatch);
        return {
            success: true,
            actionResult: undefined
        };
    };






parcelRequire("42omo");




var $e2wMq = parcelRequire("e2wMq");


var $hgeg8 = parcelRequire("hgeg8");





var $ahUGI = parcelRequire("ahUGI");


var $lNDSG = parcelRequire("lNDSG");




var $1yB28 = parcelRequire("1yB28");










const $9b6a63f7e792d6b0$var$getValidNodes = (state)=>{
    const { schema: schema } = state;
    const { annotation: annotation } = schema.marks;
    return Object.keys(schema.nodes).reduce((acc, current)=>{
        const type = schema.nodes[current];
        if (type.allowsMarkType(annotation)) acc.push(type);
        return acc;
    }, []);
};
const $9b6a63f7e792d6b0$export$8921e02ce71849ce = ({ state: state, bookmark: bookmark })=>{
    if (!bookmark) return false;
    const { tr: tr } = state;
    const resolvedBookmark = bookmark.resolve(tr.doc);
    const isSelectionMatchingBookmark = resolvedBookmark.to === tr.selection.to && resolvedBookmark.from === tr.selection.from;
    return isSelectionMatchingBookmark;
};
const $9b6a63f7e792d6b0$export$4f0bdd9681380033 = (state, api)=>{
    const userIntentEnabled = Boolean(api?.userIntent && (0, $1oCLl.expValEquals)('platform_editor_lovability_user_intent', 'isEnabled', true));
    return {
        items: [],
        nodeType: $9b6a63f7e792d6b0$var$getValidNodes(state),
        title: 'Annotation suppressed toolbar',
        __suppressAllToolbars: userIntentEnabled ? undefined : true
    };
};
const $9b6a63f7e792d6b0$export$6dd6ab35df8f7f86 = (editorAnalyticsAPI)=>({ state: state, intl: intl, isToolbarAbove: isToolbarAbove = false, _supportedNodes: _supportedNodes = [], api: api, createCommentExperience: createCommentExperience, annotationManager: annotationManager, onCommentButtonMount: onCommentButtonMount, getCanAddComments: getCanAddComments = ()=>true, contentType: contentType })=>{
        const selectionValid = (0, $1c6cc12c1e03ecad$export$af7e6fc08350a63d)(state);
        const isMediaSelected = (0, $kfJSC.currentMediaNodeWithPos)(state);
        // comments on media can only be added via media floating toolbar
        if (isMediaSelected || selectionValid === (0, $6ec66a5f4782e56b$export$ad08e20e7e22e394).INVALID) return undefined;
        const createCommentMessage = intl.formatMessage((0, $ahUGI.annotationMessages).createComment);
        const commentDisabledMessage = intl.formatMessage((0, $dh538.fg)('editor_inline_comments_on_inline_nodes') ? (0, $ahUGI.annotationMessages).createCommentDisabled : (0, $ahUGI.annotationMessages).createCommentInvalid);
        const canAddComments = getCanAddComments();
        const isCommentButtonDisabled = !canAddComments || selectionValid === (0, $6ec66a5f4782e56b$export$ad08e20e7e22e394).DISABLED;
        const disabledTooltipContent = !canAddComments ? intl.formatMessage((0, $ahUGI.annotationMessages).noPermissionToAddComment, {
            contentType: contentType
        }) : commentDisabledMessage;
        const createComment = {
            type: 'button',
            showTitle: true,
            disabled: isCommentButtonDisabled || api?.connectivity?.sharedState?.currentState()?.mode === 'offline',
            testId: (0, $6ec66a5f4782e56b$export$711f43d01b7e0019).floatingToolbarCreateButton,
            interactionName: 'start-inline-comment-action',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
            tooltipContent: isCommentButtonDisabled ? disabledTooltipContent : /*#__PURE__*/ (0, $l998X.jsx)((0, $hgeg8.ToolTipContent), {
                description: createCommentMessage,
                keymap: (0, $hgeg8.addInlineComment)
            }),
            title: createCommentMessage,
            onMount: ()=>{
                if ((0, $dh538.fg)('confluence_frontend_preload_inline_comment_editor')) onCommentButtonMount && onCommentButtonMount();
                // Check if the selection includes an non-text inline node
                const inlineCommentPluginState = (0, $1c6cc12c1e03ecad$export$f05434c51e3762e)(state);
                const inlineNodeNames = (0, $bYZ53.getRangeInlineNodeNames)({
                    doc: state.doc,
                    pos: (0, $1c6cc12c1e03ecad$export$196f73a7cbac5e80)(state, inlineCommentPluginState?.bookmark)
                }) ?? [];
                const isNonTextInlineNodeInludedInComment = inlineNodeNames.filter((nodeName)=>nodeName !== 'text').length > 0;
                if (editorAnalyticsAPI) editorAnalyticsAPI.fireAnalyticsEvent({
                    action: (0, $d925B.ACTION).VIEWED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                    eventType: (0, $d925B.EVENT_TYPE).UI,
                    attributes: {
                        isNonTextInlineNodeInludedInComment: isNonTextInlineNodeInludedInComment,
                        isDisabled: selectionValid === (0, $6ec66a5f4782e56b$export$ad08e20e7e22e394).DISABLED,
                        inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB,
                        mode: (0, $e2wMq.MODE).EDITOR
                    }
                });
            },
            onClick: (state, dispatch)=>{
                editorAnalyticsAPI?.fireAnalyticsEvent({
                    action: (0, $d925B.ACTION).CLICKED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                    eventType: (0, $d925B.EVENT_TYPE).UI,
                    attributes: {
                        source: 'highlightActionsMenu',
                        pageMode: 'edit'
                    }
                });
                if (annotationManager) {
                    annotationManager.checkPreemptiveGate().then((canStartDraft)=>{
                        if (canStartDraft) {
                            createCommentExperience?.start({
                                attributes: {
                                    pageClass: 'editor',
                                    commentType: 'inline',
                                    entryPoint: 'highlightActions'
                                }
                            });
                            createCommentExperience?.initExperience.start();
                            const result = annotationManager.startDraft();
                            if (!result.success) // Fire an analytics event to indicate that the user has clicked the button
                            // but the action was not completed, the result should contain a reason.
                            editorAnalyticsAPI?.fireAnalyticsEvent({
                                action: (0, $d925B.ACTION).ERROR,
                                actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                                attributes: {
                                    errorReason: `toolbar-start-draft-failed/${result.reason}`
                                }
                            });
                        }
                    }).catch(()=>{
                        editorAnalyticsAPI?.fireAnalyticsEvent({
                            action: (0, $d925B.ACTION).ERROR,
                            actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                            attributes: {
                                errorReason: `toolbar-start-draft-preemptive-gate-error`
                            }
                        });
                    });
                    return true;
                } else {
                    createCommentExperience?.start({
                        attributes: {
                            pageClass: 'editor',
                            commentType: 'inline',
                            entryPoint: 'highlightActions'
                        }
                    });
                    createCommentExperience?.initExperience.start();
                    return (0, $0f9c6d7837321f71$export$2a7aec6fc438fa0b)(editorAnalyticsAPI)(true)(state, dispatch);
                }
            },
            supportsViewMode: true // TODO: MODES-3950 - Clean up this floating toolbar view mode logic,
        };
        const toolbarTitle = intl.formatMessage((0, $ahUGI.annotationMessages).toolbar);
        const calcToolbarPosition = isToolbarAbove ? (0, $lNDSG.calculateToolbarPositionAboveSelection) : (0, $lNDSG.calculateToolbarPositionTrackHead);
        const onPositionCalculated = calcToolbarPosition(toolbarTitle);
        return {
            title: toolbarTitle,
            nodeType: $9b6a63f7e792d6b0$var$getValidNodes(state),
            items: [
                createComment
            ],
            onPositionCalculated: onPositionCalculated,
            pluginName: 'annotation'
        };
    };



const $5afcd16e23d3e19e$var$fetchProviderStates = async (provider, annotationIds)=>{
    if (!provider || !provider.getState) return {};
    const data = await provider.getState(annotationIds);
    const result = {};
    data.forEach((annotation)=>{
        if (annotation.annotationType === (0, $cUycv.AnnotationTypes).INLINE_COMMENT) result[annotation.id] = annotation.state.resolved;
    });
    return result;
};
// fetchState is unable to return a command as it's runs async and may dispatch at a later time
// Requires `editorView` instead of the decomposition as the async means state may end up stale
const $5afcd16e23d3e19e$var$fetchState = async (provider, annotationIds, editorView, editorAnalyticsAPI)=>{
    const inlineCommentStates = await $5afcd16e23d3e19e$var$fetchProviderStates(provider, annotationIds);
    if (Object.keys(inlineCommentStates).length === 0) {
        const { annotationsLoaded: annotationsLoaded } = (0, $1c6cc12c1e03ecad$export$f05434c51e3762e)(editorView.state) || {};
        if (!annotationsLoaded && (0, $dh538.fg)('confluence_frontend_new_dangling_comments_ux')) (0, $0f9c6d7837321f71$export$a3833f7fc842f6da)()(editorView.state, editorView.dispatch);
        return;
    }
    if (editorView.dispatch) (0, $0f9c6d7837321f71$export$4d8462ca3c146d0e)(editorAnalyticsAPI)(inlineCommentStates)(editorView.state, editorView.dispatch);
};
const $5afcd16e23d3e19e$var$initialState = (disallowOnWhitespace = false, featureFlagsPluginState, isAnnotationManagerEnabled = false)=>{
    return {
        annotationsLoaded: false,
        annotations: {},
        selectedAnnotations: [],
        hoveredAnnotations: [],
        mouseData: {
            isSelecting: false
        },
        disallowOnWhitespace: disallowOnWhitespace,
        isInlineCommentViewClosed: false,
        isVisible: true,
        skipSelectionHandling: false,
        featureFlagsPluginState: featureFlagsPluginState,
        isDrafting: false,
        pendingSelectedAnnotations: [],
        pendingSelectedAnnotationsUpdateCount: 0,
        isAnnotationManagerEnabled: isAnnotationManagerEnabled
    };
};
const $5afcd16e23d3e19e$var$hideToolbar = (state, dispatch)=>()=>{
        (0, $0f9c6d7837321f71$export$ef4c42f03863dce9)({
            isSelecting: true
        })(state, dispatch);
    };
// Subscribe to updates from consumer
const $5afcd16e23d3e19e$var$onResolve = (editorAnalyticsAPI)=>(state, dispatch)=>(annotationId)=>{
            (0, $0f9c6d7837321f71$export$4d8462ca3c146d0e)(editorAnalyticsAPI)({
                [annotationId]: true
            }, (0, $55QXP.RESOLVE_METHOD).CONSUMER)(state, dispatch);
        };
const $5afcd16e23d3e19e$var$onUnResolve = (editorAnalyticsAPI)=>(state, dispatch)=>(annotationId)=>{
            (0, $0f9c6d7837321f71$export$4d8462ca3c146d0e)(editorAnalyticsAPI)({
                [annotationId]: false
            })(state, dispatch);
        };
const $5afcd16e23d3e19e$var$onMouseUp = (state, dispatch)=>(e)=>{
        const { mouseData: mouseData } = (0, $1c6cc12c1e03ecad$export$f05434c51e3762e)(state) || {};
        if (mouseData?.isSelecting) (0, $0f9c6d7837321f71$export$ef4c42f03863dce9)({
            isSelecting: false
        })(state, dispatch);
    };
const $5afcd16e23d3e19e$var$onSetVisibility = (view)=>(isVisible)=>{
        const { state: state, dispatch: dispatch } = view;
        (0, $0f9c6d7837321f71$export$c6dc86fb1ced7a07)(isVisible)(state, dispatch);
        if (isVisible) // PM retains focus when we click away from the editor.
        // This will restore the visual aspect of the selection,
        // otherwise it will seem a floating toolbar will appear
        // for no reason.
        view.focus();
    };
const $5afcd16e23d3e19e$export$e4aab3acac8f34b = (options)=>{
    const { provider: provider, featureFlagsPluginState: featureFlagsPluginState, annotationManager: annotationManager } = options;
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $1c6cc12c1e03ecad$export$544b399faf6001b7),
        state: (0, $5bbbca891262e1f8$export$656c7661095efe2e)(options.dispatch, $5afcd16e23d3e19e$var$initialState(provider.disallowOnWhitespace, featureFlagsPluginState, !!annotationManager)),
        view (editorView) {
            let allowAnnotationFn;
            let startDraftFn;
            let clearDraftFn;
            let applyDraftFn;
            let getDraftFn;
            let setIsAnnotationSelectedFn;
            let setIsAnnotationHoveredFn;
            let clearAnnotationFn;
            if (annotationManager) {
                allowAnnotationFn = (0, $21fc40f8bb03ab3c$export$86f3258f283eb796)(editorView, options);
                startDraftFn = (0, $21fc40f8bb03ab3c$export$768048043e8d2bcd)(editorView, options);
                clearDraftFn = (0, $21fc40f8bb03ab3c$export$eeeb486534738631)(editorView, options);
                applyDraftFn = (0, $21fc40f8bb03ab3c$export$8bc7b93e04771bda)(editorView, options);
                getDraftFn = (0, $21fc40f8bb03ab3c$export$1a473231c51c1d5b)(editorView, options);
                setIsAnnotationSelectedFn = (0, $21fc40f8bb03ab3c$export$b8ac6bdd928e737c)(editorView, options);
                setIsAnnotationHoveredFn = (0, $21fc40f8bb03ab3c$export$5ada3da2e2f0701f)(editorView, options);
                clearAnnotationFn = (0, $21fc40f8bb03ab3c$export$6baae9b3f0f9bdce)(editorView, options);
                annotationManager.hook('allowAnnotation', allowAnnotationFn);
                annotationManager.hook('startDraft', startDraftFn);
                annotationManager.hook('clearDraft', clearDraftFn);
                annotationManager.hook('applyDraft', applyDraftFn);
                annotationManager.hook('getDraft', getDraftFn);
                annotationManager.hook('setIsAnnotationSelected', setIsAnnotationSelectedFn);
                annotationManager.hook('setIsAnnotationHovered', setIsAnnotationHoveredFn);
                annotationManager.hook('clearAnnotation', clearAnnotationFn);
            }
            // Get initial state
            // Need to pass `editorView` to mitigate editor state going stale
            $5afcd16e23d3e19e$var$fetchState(provider, (0, $1c6cc12c1e03ecad$export$2ecc008effaefd6e)(editorView.state.doc), editorView, options.editorAnalyticsAPI);
            const resolve = (annotationId)=>$5afcd16e23d3e19e$var$onResolve(options.editorAnalyticsAPI)(editorView.state, editorView.dispatch)(annotationId);
            const unResolve = (annotationId)=>$5afcd16e23d3e19e$var$onUnResolve(options.editorAnalyticsAPI)(editorView.state, editorView.dispatch)(annotationId);
            const mouseUp = (event)=>$5afcd16e23d3e19e$var$onMouseUp(editorView.state, editorView.dispatch)(event);
            const setVisibility = (isVisible)=>$5afcd16e23d3e19e$var$onSetVisibility(editorView)(isVisible);
            const setSelectedAnnotationFn = (annotationId)=>{
                if (!annotationId) (0, $0f9c6d7837321f71$export$da26c8d097933b72)()(editorView.state, editorView.dispatch);
                else (0, $0f9c6d7837321f71$export$1e715f68ff6f5a2f)(annotationId)(editorView.state, editorView.dispatch);
            };
            const setHoveredAnnotationFn = (annotationId)=>{
                if (!annotationId) (0, $0f9c6d7837321f71$export$da26c8d097933b72)()(editorView.state, editorView.dispatch);
                else (0, $0f9c6d7837321f71$export$c1805eee6fd0cf44)(annotationId)(editorView.state, editorView.dispatch);
            };
            const removeHoveredannotationFn = ()=>{
                (0, $0f9c6d7837321f71$export$c1805eee6fd0cf44)('')(editorView.state, editorView.dispatch);
            };
            const closeInlineCommentFn = ()=>{
                (0, $0f9c6d7837321f71$export$da26c8d097933b72)()(editorView.state, editorView.dispatch);
            };
            const { updateSubscriber: updateSubscriber } = provider;
            if (updateSubscriber) updateSubscriber.on('resolve', resolve).on('delete', resolve).on('unresolve', unResolve).on('create', unResolve).on('setvisibility', setVisibility).on('setselectedannotation', setSelectedAnnotationFn).on('sethoveredannotation', setHoveredAnnotationFn).on('removehoveredannotation', removeHoveredannotationFn).on('closeinlinecomment', closeInlineCommentFn);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            editorView.root.addEventListener('mouseup', mouseUp);
            /**
       * This flag is used to prevent the preemptive gate from being called multiple times while a check is in-flight.
       * If a check is still pending then it's most likely because the product is busy and trying to block the
       * selection of an annotation.
       */ let isPreemptiveGateActive = false;
            return {
                update (view, _prevState) {
                    const { selectedAnnotations: selectedAnnotations, annotations: annotations, isDrafting: isDrafting, bookmark: bookmark } = (0, $1c6cc12c1e03ecad$export$f05434c51e3762e)(view.state) || {};
                    const { selectedAnnotations: prevSelectedAnnotations } = (0, $1c6cc12c1e03ecad$export$f05434c51e3762e)(_prevState) || {};
                    const selectedAnnotationId = selectedAnnotations && selectedAnnotations.length !== 0 && selectedAnnotations[0].id ? selectedAnnotations[0].id : undefined;
                    // If the new state has an unresolved selected annotation, and it's different from
                    // the previous one then...
                    if (//This checks the selected annotation is different from the previous one
                    selectedAnnotationId && selectedAnnotationId !== prevSelectedAnnotations?.[0]?.id && // This ensures that the selected annotation is unresolved
                    annotations && annotations[selectedAnnotationId] === false) {
                        // ...we mark the select annotation experience as complete.
                        // The selectComponentExperience is using a simplified object, which is why it's type asserted.
                        options.selectCommentExperience?.selectAnnotation.complete(selectedAnnotationId);
                        // ...and start a new UFO press trace since the selected comment is changing
                        options.viewInlineCommentTraceUFOPress?.();
                    }
                    const { api: api } = options;
                    if (isDrafting && !view.state.selection.eq(_prevState.selection) && Boolean(api?.toolbar)) // It is possible that user update selection while having a active draft,
                    // so we need to reset the user intent to allow inline text toolbar to be visible
                    api?.core.actions.execute(({ tr: tr })=>{
                        if ((0, $9b6a63f7e792d6b0$export$8921e02ce71849ce)({
                            state: view.state,
                            bookmark: bookmark
                        })) (0, $20ee3e44c93eaa25$export$2c4e3be4c627582b)(api, tr);
                        else (0, $20ee3e44c93eaa25$export$dc07a25f8edf98a5)(api, tr);
                        return tr;
                    });
                    if (annotationManager) {
                        // In the Editor, Annotations can be selected in three ways:
                        // 1. By clicking on the annotation in the editor
                        // 2. By using the annotation manager to select the annotation
                        // 3. By moving the cursor to the annotation and using the keyboard to select it
                        // Item 1 & 3 need to be protected by the preemptive gate. This is because these actions could be performed by a user
                        // at a time when changing the selection could cause data loss.
                        // The following preemptive check is designed to cover these items.
                        const { pendingSelectedAnnotations: pendingSelectedAnnotations, pendingSelectedAnnotationsUpdateCount: pendingSelectedAnnotationsUpdateCount } = (0, $1c6cc12c1e03ecad$export$f05434c51e3762e)(view.state) || {};
                        const { pendingSelectedAnnotationsUpdateCount: prevPendingSelectedAnnotationsUpdateCount } = (0, $1c6cc12c1e03ecad$export$f05434c51e3762e)(_prevState) || {};
                        if (!isPreemptiveGateActive && pendingSelectedAnnotationsUpdateCount !== prevPendingSelectedAnnotationsUpdateCount && !!pendingSelectedAnnotations?.length) {
                            // Need to set a lock to avoid calling gate multiple times. The lock will be released
                            // when the preemptive gate is complete.
                            isPreemptiveGateActive = true;
                            annotationManager.checkPreemptiveGate().then((canSelectAnnotation)=>{
                                const { isDrafting: isDrafting, pendingSelectedAnnotations: latestPendingSelectedAnnotations, selectedAnnotations: latestSelectedAnnotations } = (0, $1c6cc12c1e03ecad$export$f05434c51e3762e)(view.state) || {};
                                if (canSelectAnnotation) {
                                    if (isDrafting) // The user must have chosen to discard there draft. So before we flush the pending selections
                                    // we need to clear the draft if there is one.
                                    (0, $0f9c6d7837321f71$export$2a7aec6fc438fa0b)(options.editorAnalyticsAPI, undefined, options.api)(false)(view.state, view.dispatch);
                                    // Flush the pending selections into the selected annotations list.
                                    (0, $0f9c6d7837321f71$export$940b79a08b19cea6)(options.editorAnalyticsAPI)(true)(view.state, view.dispatch);
                                    latestSelectedAnnotations?.filter((annotation)=>latestPendingSelectedAnnotations?.findIndex((pendingAnnotation)=>pendingAnnotation.id === annotation.id) === -1).forEach((annotation)=>{
                                        annotationManager.emit({
                                            name: 'annotationSelectionChanged',
                                            data: {
                                                annotationId: annotation.id,
                                                isSelected: false,
                                                inlineNodeTypes: (0, $bYZ53.getAnnotationInlineNodeTypes)(editorView.state, annotation.id) ?? []
                                            }
                                        });
                                    });
                                    // Notify the annotation manager that the pending selection has changed.
                                    latestPendingSelectedAnnotations?.forEach(({ id: id })=>{
                                        annotationManager.emit({
                                            name: 'annotationSelectionChanged',
                                            data: {
                                                annotationId: id,
                                                isSelected: true,
                                                inlineNodeTypes: (0, $bYZ53.getAnnotationInlineNodeTypes)(view.state, id) ?? []
                                            }
                                        });
                                    });
                                } else // Clears the pending selections if the preemptive gate returns false.
                                // We should need to worry about dispatching change events here because the pending selections
                                // are being aborted and the selections will remain unchanged.
                                (0, $0f9c6d7837321f71$export$940b79a08b19cea6)(options.editorAnalyticsAPI)(false)(view.state, view.dispatch);
                            }).catch((error)=>{
                                // If an error has occured we will clear any pending selections to avoid accidentally setting the wrong thing.
                                (0, $0f9c6d7837321f71$export$940b79a08b19cea6)(options.editorAnalyticsAPI)(false, 'pending-selection-preemptive-gate-error')(view.state, view.dispatch);
                            }).finally(()=>{
                                isPreemptiveGateActive = false;
                            });
                        }
                    }
                    const { dirtyAnnotations: dirtyAnnotations } = (0, $1c6cc12c1e03ecad$export$f05434c51e3762e)(view.state) || {};
                    if (!dirtyAnnotations) return;
                    (0, $0f9c6d7837321f71$export$ffa869a92c2481c3)()(view.state, view.dispatch);
                    $5afcd16e23d3e19e$var$fetchState(provider, (0, $1c6cc12c1e03ecad$export$2ecc008effaefd6e)(view.state.doc), view, options.editorAnalyticsAPI);
                },
                destroy () {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    editorView.root.removeEventListener('mouseup', mouseUp);
                    if (updateSubscriber) updateSubscriber.off('resolve', resolve).off('delete', resolve).off('unresolve', unResolve).off('create', unResolve).off('setvisibility', setVisibility).off('setselectedannotation', setSelectedAnnotationFn).off('sethoveredannotation', setHoveredAnnotationFn).off('removehoveredannotation', removeHoveredannotationFn).off('closeinlinecomment', closeInlineCommentFn);
                    if (annotationManager) {
                        annotationManager.unhook('allowAnnotation', allowAnnotationFn);
                        annotationManager.unhook('startDraft', startDraftFn);
                        annotationManager.unhook('clearDraft', clearDraftFn);
                        annotationManager.unhook('applyDraft', applyDraftFn);
                        annotationManager.unhook('getDraft', getDraftFn);
                        annotationManager.unhook('setIsAnnotationSelected', setIsAnnotationSelectedFn);
                        annotationManager.unhook('setIsAnnotationHovered', setIsAnnotationHoveredFn);
                        annotationManager.unhook('clearAnnotation', clearAnnotationFn);
                    }
                }
            };
        },
        props: {
            handleDOMEvents: {
                mousedown: (view)=>{
                    const pluginState = (0, $1c6cc12c1e03ecad$export$f05434c51e3762e)(view.state);
                    if (!pluginState?.mouseData.isSelecting) $5afcd16e23d3e19e$var$hideToolbar(view.state, view.dispatch)();
                    return false;
                },
                dragstart: (view, event)=>{
                    // Mouseup won't be triggered after dropping
                    // Hence, update the mouse data to cancel selecting when drag starts
                    return $5afcd16e23d3e19e$var$onMouseUp(view.state, view.dispatch)(event);
                },
                click: (view, event)=>{
                    if (!(event.target instanceof HTMLElement)) return false;
                    // Find the nearest ancestor (or self) with the data-id attribute
                    const annotationId = event.target.closest('[data-id]')?.getAttribute('data-id');
                    if (!annotationId) return false;
                    const pluginState = (0, $1c6cc12c1e03ecad$export$f05434c51e3762e)(view.state);
                    const isSelected = pluginState?.selectedAnnotations?.some((selectedAnnotation)=>selectedAnnotation.id === annotationId);
                    // If the annotation is selected and the inline comment view is open, do nothing
                    // as the user is already in the comment view.
                    if (isSelected && !pluginState?.isInlineCommentViewClosed) return false;
                    const { annotations: annotations } = pluginState || {};
                    const isUnresolved = annotations && annotations[annotationId] === false;
                    if (!isUnresolved) return false;
                    if (annotationManager) {
                        // The manager disable setting the selected annotation on click because in the editor this is already
                        // handled by the selection update handler. When the manager is enabled, and a selection changes it's pushed into
                        // the pendingSelectedAnnotations array. This is then used to update the selection when the preemptive gate
                        // is released.
                        const isPendingSelection = pluginState?.pendingSelectedAnnotations?.some((selectedAnnotation)=>selectedAnnotation.id === annotationId);
                        // If the annotation is selected and the inline comment view is open, do nothing
                        // as the user is already in the comment view.
                        if (isPendingSelection) return false;
                        (0, $0f9c6d7837321f71$export$a99e2fe25edc1abd)(annotationId)(view.state, view.dispatch);
                    } else (0, $0f9c6d7837321f71$export$1e715f68ff6f5a2f)(annotationId)(view.state, view.dispatch);
                    return true;
                }
            },
            decorations (state) {
                // highlight comments, depending on state
                const { draftDecorationSet: draftDecorationSet, annotations: annotations, selectedAnnotations: selectedAnnotations, isVisible: isVisible, isInlineCommentViewClosed: isInlineCommentViewClosed, hoveredAnnotations: hoveredAnnotations } = (0, $1c6cc12c1e03ecad$export$f05434c51e3762e)(state) || {};
                let decorations = draftDecorationSet ?? (0, $ftzrq.DecorationSet).empty;
                const focusDecorations = [];
                // TODO: EDITOR-760 - This needs to be optimised, it's not a good idea to scan the entire document
                // everytime we need to update the decorations. This handler will be called alot. We should be caching
                // the decorations in plugin state and only updating them when required.
                state.doc.descendants((node, pos)=>{
                    // Inline comment on mediaInline is not supported as part of comments on media project
                    // Thus, we skip the decoration for mediaInline node
                    if (node.type.name === 'mediaInline') return false;
                    const isSupportedBlockNode = node.isBlock && provider.supportedBlockNodes?.includes(node.type.name);
                    node.marks.filter((mark)=>mark.type === state.schema.marks.annotation).forEach((mark)=>{
                        if (isVisible) {
                            const isUnresolved = !!annotations && annotations[mark.attrs.id] === false;
                            const isSelected = !isInlineCommentViewClosed && !!selectedAnnotations?.some((selectedAnnotation)=>selectedAnnotation.id === mark.attrs.id);
                            const isHovered = !isInlineCommentViewClosed && !!hoveredAnnotations?.some((hoveredAnnotation)=>hoveredAnnotation.id === mark.attrs.id);
                            if (isSupportedBlockNode) focusDecorations.push((0, $ftzrq.Decoration).node(pos, pos + node.nodeSize, {
                                class: `${(0, $e1a7a5099c215209$export$bb73203a2b3a63e2)(isUnresolved, isSelected)} ${isUnresolved}`
                            }, {
                                key: (0, $1c6cc12c1e03ecad$export$824a8ce0be7d4e38).block
                            }));
                            else if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
                                if (node.isText) focusDecorations.push((0, $ftzrq.Decoration).inline(pos, pos + node.nodeSize, {
                                    class: `${(0, $e1a7a5099c215209$export$b3ab33741101ad90)(isUnresolved, isSelected, isHovered)} ${isUnresolved}`,
                                    nodeName: 'span'
                                }));
                                else focusDecorations.push((0, $ftzrq.Decoration).node(pos, pos + node.nodeSize, {
                                    class: `${(0, $e1a7a5099c215209$export$b3ab33741101ad90)(isUnresolved, isSelected, isHovered)} ${isUnresolved}`
                                }, {
                                    key: (0, $1c6cc12c1e03ecad$export$824a8ce0be7d4e38).block
                                }));
                            } else focusDecorations.push((0, $ftzrq.Decoration).inline(pos, pos + node.nodeSize, {
                                class: `${(0, $e1a7a5099c215209$export$b3ab33741101ad90)(isUnresolved, isSelected, isHovered)} ${isUnresolved}`,
                                nodeName: 'span'
                            }));
                        }
                    });
                });
                decorations = decorations.add(state.doc, focusDecorations);
                return decorations;
            }
        }
    });
};









var $dus6D = parcelRequire("dus6D");


function $d92abb614d3b39aa$export$e832373cff8dec22(api) {
    const list = {};
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.addInlineComment).common, (0, $0f9c6d7837321f71$export$2a7aec6fc438fa0b)(api?.analytics?.actions, undefined, api)(true, (0, $d925B.INPUT_METHOD).SHORTCUT), list);
    return (0, $dus6D.keymap)(list);
}








var $42omo = parcelRequire("42omo");













var $b3YrF = parcelRequire("b3YrF");
















class $6042d03a98409edf$export$1fe5705f230796ba extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentDidMount() {
        const { onViewed: onViewed } = this.props;
        if (onViewed) onViewed();
    }
    render() {
        return this.props.children;
    }
}


const $ae02a84cba9b2c8c$var$findPosForDOM = (sel)=>{
    const { $from: $from, from: from } = sel;
    // Retrieve current TextNode
    const index = $from.index();
    const node = index < $from.parent.childCount && $from.parent.child(index);
    // Right edge of a mark.
    if (!node && $from.nodeBefore && $from.nodeBefore.isText && $from.nodeBefore.marks.find((mark)=>mark.type.name === 'annotation')) return from - 1;
    return from;
};
const $ae02a84cba9b2c8c$var$selector = (states)=>{
    return {
        annotations: states.annotationState?.annotations,
        bookmark: states.annotationState?.bookmark,
        isInlineCommentViewClosed: states.annotationState?.isInlineCommentViewClosed,
        isOpeningMediaCommentFromToolbar: states.annotationState?.isOpeningMediaCommentFromToolbar,
        selectAnnotationMethod: states.annotationState?.selectAnnotationMethod,
        selectedAnnotations: states.annotationState?.selectedAnnotations,
        isAnnotationManagerEnabled: states.annotationState?.isAnnotationManagerEnabled
    };
};
function $ae02a84cba9b2c8c$export$ce99d9856d415465({ providers: providers, editorView: editorView, editorAnalyticsAPI: editorAnalyticsAPI, editorAPI: editorAPI, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
    // As inlineComment is the only annotation present, this function is not generic
    const { inlineComment: inlineCommentProvider } = providers;
    const { state: state, dispatch: dispatch } = editorView;
    const lastSelectedAnnotationId = (0, $42omo.useRef)();
    const { createComponent: CreateComponent, viewComponent: ViewComponent } = inlineCommentProvider;
    const { annotations: annotations, bookmark: bookmark, isInlineCommentViewClosed: isInlineCommentViewClosed, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar, selectAnnotationMethod: selectAnnotationMethod, selectedAnnotations: selectedAnnotations, isAnnotationManagerEnabled: isAnnotationManagerEnabled } = (0, $eiA8Z.useSharedPluginStateWithSelector)(editorAPI, [
        'annotation'
    ], $ae02a84cba9b2c8c$var$selector);
    const annotationsList = (0, $1c6cc12c1e03ecad$export$2ecc008effaefd6e)(editorView.state.doc);
    const selection = (0, $1c6cc12c1e03ecad$export$31c5af77b755d41f)(state, bookmark);
    const position = $ae02a84cba9b2c8c$var$findPosForDOM(selection);
    let dom;
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        dom = (0, $8m4tT.findDomRefAtPos)(position, editorView.domAtPos.bind(editorView));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(error);
        if (dispatchAnalyticsEvent) {
            const payload = {
                action: (0, $d925B.ACTION).ERRORED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).CONTENT_COMPONENT,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    component: (0, $d925B.CONTENT_COMPONENT).INLINE_COMMENT,
                    selection: selection.toJSON(),
                    position: position,
                    docSize: editorView.state.doc.nodeSize,
                    error: error.toString()
                }
            };
            dispatchAnalyticsEvent(payload);
        }
    }
    // Network Status
    const networkStatusSelector = (0, $b3YrF.useSharedPluginStateSelector)(editorAPI, 'connectivity.mode', {
        disabled: (0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', false)
    });
    if (!dom) return null;
    // Create Component
    if (bookmark) {
        if (!CreateComponent) return null;
        const currentlySelectedAnnotation = selectedAnnotations?.[0]?.id;
        const isAnnotationSelectionChanged = currentlySelectedAnnotation !== lastSelectedAnnotationId.current;
        // Update the last selected annotation ID if the selection was updated
        if (isAnnotationSelectionChanged) lastSelectedAnnotationId.current = currentlySelectedAnnotation;
        const inlineNodeTypes = (0, $bYZ53.getRangeInlineNodeNames)({
            doc: state.doc,
            pos: selection
        });
        //getting all text between bookmarked positions
        const textSelection = state.doc.textBetween(selection.from, selection.to);
        return /*#__PURE__*/ (0, $l998X.jsx)("div", {
            "data-testid": (0, $6ec66a5f4782e56b$export$711f43d01b7e0019).floatingComponent,
            "data-editor-popup": "true",
            children: /*#__PURE__*/ (0, $l998X.jsx)(CreateComponent, {
                dom: dom,
                textSelection: textSelection,
                wasNewAnnotationSelected: !!currentlySelectedAnnotation && isAnnotationSelectionChanged,
                onCreate: (id)=>{
                    if (!isAnnotationManagerEnabled) {
                        const createAnnotationResult = (0, $0f9c6d7837321f71$export$51eda81011da4982)(editorAnalyticsAPI, editorAPI)(id, (0, $cUycv.AnnotationTypes).INLINE_COMMENT, inlineCommentProvider.supportedBlockNodes)(editorView.state, editorView.dispatch);
                        !editorView.hasFocus() && editorView.focus();
                        if (!createAnnotationResult) throw new Error('Failed to create annotation');
                    }
                },
                onClose: ()=>{
                    if (!isAnnotationManagerEnabled) {
                        (0, $0f9c6d7837321f71$export$2a7aec6fc438fa0b)(editorAnalyticsAPI, undefined, editorAPI)(false)(editorView.state, editorView.dispatch);
                        !editorView.hasFocus() && editorView.focus();
                    }
                },
                inlineNodeTypes: inlineNodeTypes,
                isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
                isOffline: networkStatusSelector === 'offline'
            })
        });
    }
    // View Component
    const activeAnnotations = selectedAnnotations?.filter((mark)=>annotations && annotations[mark.id] === false) || [];
    if (!ViewComponent || activeAnnotations.length === 0) return null;
    const onAnnotationViewed = ()=>{
        if (!dispatchAnalyticsEvent) return;
        // fire analytics
        const payload = {
            action: (0, $d925B.ACTION).VIEWED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                overlap: activeAnnotations.length ? activeAnnotations.length - 1 : 0,
                targetNodeType: editorView.state.doc.nodeAt(position)?.type.name,
                method: selectAnnotationMethod
            }
        };
        dispatchAnalyticsEvent(payload);
    };
    if (isInlineCommentViewClosed || !selectedAnnotations) return null;
    // For view mode, the finding of inline node types is a bit more complex,
    // that's why we will not provide it as a `inlineNodeTypes` props to the view component,
    // to speed up the rendering process.
    const getInlineNodeTypes = (annotationId)=>(0, $bYZ53.getAnnotationInlineNodeTypes)(editorView.state, annotationId);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6042d03a98409edf$export$1fe5705f230796ba), {
        "data-editor-popup": "true",
        "data-testid": (0, $6ec66a5f4782e56b$export$711f43d01b7e0019).floatingComponent,
        onViewed: onAnnotationViewed,
        children: /*#__PURE__*/ (0, $l998X.jsx)(ViewComponent, {
            annotationsList: annotationsList,
            annotations: activeAnnotations,
            getInlineNodeTypes: getInlineNodeTypes,
            dom: dom,
            onDelete: (id)=>(0, $0f9c6d7837321f71$export$75bee4cee90040)(id, inlineCommentProvider.supportedBlockNodes)(editorView.state, dispatch),
            onResolve: (id)=>(0, $0f9c6d7837321f71$export$4d8462ca3c146d0e)(editorAnalyticsAPI)({
                    [id]: true
                }, (0, $55QXP.RESOLVE_METHOD).COMPONENT)(editorView.state, editorView.dispatch),
            onClose: ()=>{
                (0, $0f9c6d7837321f71$export$da26c8d097933b72)()(editorView.state, editorView.dispatch);
            },
            isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
            isOffline: networkStatusSelector === 'offline'
        })
    }, (0, $1c6cc12c1e03ecad$export$1832a9899106877a)(activeAnnotations));
}





parcelRequire("42omo");


var $cPCP8 = parcelRequire("cPCP8");

var $4Chin = parcelRequire("4Chin");




parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");








var $gzUv9 = parcelRequire("gzUv9");







var $7ERUE = parcelRequire("7ERUE");

var $iIVVb = parcelRequire("iIVVb");






























const $74d3c5d57fc803d2$export$7a6737b74121da6f = ({ state: state, api: api, canAddComments: canAddComments })=>{
    const annotationSelectionType = state ? (0, $1c6cc12c1e03ecad$export$af7e6fc08350a63d)(state) : (0, $6ec66a5f4782e56b$export$ad08e20e7e22e394).INVALID;
    return !canAddComments || annotationSelectionType === (0, $6ec66a5f4782e56b$export$ad08e20e7e22e394).DISABLED || api?.connectivity?.sharedState?.currentState()?.mode === 'offline';
};
const $74d3c5d57fc803d2$export$dd62b022312fd583 = ({ state: state, isVisible: isVisible, annotationSelectionType: annotationSelectionType })=>{
    const isMediaSelected = state ? (0, $kfJSC.currentMediaNodeWithPos)(state) : false;
    let isDrafting = false;
    if ((0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_4', 'isEnabled', true) && state) isDrafting = (0, $1c6cc12c1e03ecad$export$544b399faf6001b7).getState(state)?.isDrafting || false;
    // comments on media can only be added via media floating toolbar
    if (isDrafting || isMediaSelected || annotationSelectionType === (0, $6ec66a5f4782e56b$export$ad08e20e7e22e394).INVALID || !isVisible) return false;
    return true;
};
const $74d3c5d57fc803d2$export$b5fd00fffbd8948d = ({ api: api })=>{
    api.analytics?.actions.fireAnalyticsEvent({
        action: (0, $d925B.ACTION).CLICKED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
        eventType: (0, $d925B.EVENT_TYPE).UI,
        attributes: {
            source: 'highlightActionsMenu',
            pageMode: 'edit'
        }
    });
};
const $74d3c5d57fc803d2$var$fireAnnotationErrorAnalyticsEvent = ({ api: api, errorReason: errorReason })=>{
    api.analytics?.actions?.fireAnalyticsEvent({
        action: (0, $d925B.ACTION).ERROR,
        actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            errorReason: errorReason
        }
    });
};
const $74d3c5d57fc803d2$export$aa79a97671c224b4 = ({ api: api, isNonTextInlineNodeInludedInComment: isNonTextInlineNodeInludedInComment, annotationSelectionType: annotationSelectionType })=>{
    api?.analytics?.actions.fireAnalyticsEvent({
        action: (0, $d925B.ACTION).VIEWED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
        eventType: (0, $d925B.EVENT_TYPE).UI,
        attributes: {
            isNonTextInlineNodeInludedInComment: isNonTextInlineNodeInludedInComment,
            isDisabled: annotationSelectionType === (0, $6ec66a5f4782e56b$export$ad08e20e7e22e394).DISABLED,
            inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB,
            mode: (0, $e2wMq.MODE).EDITOR
        }
    });
};
const $74d3c5d57fc803d2$export$c983cfb71edde6e4 = ({ annotationProviders: annotationProviders, api: api, state: state, dispatch: dispatch })=>{
    const annotationManager = annotationProviders?.annotationManager;
    if (annotationManager) {
        annotationManager.checkPreemptiveGate().then((canStartDraft)=>{
            if (canStartDraft) {
                annotationProviders.createCommentExperience?.start({
                    attributes: {
                        pageClass: 'editor',
                        commentType: 'inline',
                        entryPoint: 'highlightActions'
                    }
                });
                annotationProviders.createCommentExperience?.initExperience.start();
                const result = annotationManager.startDraft();
                if (!result.success) // Fire an analytics event to indicate that the user has clicked the button
                // but the action was not completed, the result should contain a reason.
                $74d3c5d57fc803d2$var$fireAnnotationErrorAnalyticsEvent({
                    api: api,
                    errorReason: `toolbar-start-draft-failed/${result.reason}`
                });
            }
        }).catch(()=>{
            $74d3c5d57fc803d2$var$fireAnnotationErrorAnalyticsEvent({
                api: api,
                errorReason: `toolbar-start-draft-preemptive-gate-error`
            });
        });
        return true;
    } else {
        annotationProviders?.createCommentExperience?.start({
            attributes: {
                pageClass: 'editor',
                commentType: 'inline',
                entryPoint: 'highlightActions'
            }
        });
        annotationProviders?.createCommentExperience?.initExperience.start();
        return (0, $0f9c6d7837321f71$export$2a7aec6fc438fa0b)(api?.analytics?.actions, undefined, api)(true)(state, dispatch);
    }
};


const $4c16e01fcbc0489f$export$b0b121505277a396 = ({ state: state, annotationProviders: annotationProviders, api: api, annotationSelectionType: annotationSelectionType, bookmark: bookmark })=>{
    (0, $42omo.useEffect)(()=>{
        if (!state) return;
        if (annotationProviders?.inlineComment && (0, $dh538.fg)('confluence_frontend_preload_inline_comment_editor')) annotationProviders.inlineComment.onCommentButtonMount?.();
        // Check if the selection includes an non-text inline node
        const inlineNodeNames = (0, $bYZ53.getRangeInlineNodeNames)({
            doc: state.doc,
            pos: (0, $1c6cc12c1e03ecad$export$196f73a7cbac5e80)(state, bookmark)
        }) ?? [];
        const isNonTextInlineNodeInludedInComment = inlineNodeNames.filter((nodeName)=>nodeName !== 'text').length > 0;
        (0, $74d3c5d57fc803d2$export$aa79a97671c224b4)({
            api: api,
            isNonTextInlineNodeInludedInComment: isNonTextInlineNodeInludedInComment,
            annotationSelectionType: annotationSelectionType
        });
    // for now trying to replicate current onMount logic
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};



const $2a7c42f5944ba88b$export$44a3d5aec3da3e9f = ({ api: api, annotationProviders: annotationProviders })=>{
    const isVisible = (0, $b3YrF.useSharedPluginStateSelector)(api, 'annotation.isVisible');
    const bookmark = (0, $b3YrF.useSharedPluginStateSelector)(api, 'annotation.bookmark');
    const { editorView: editorView } = (0, $gzUv9.useEditorToolbar)();
    const annotationSelectionType = editorView?.state ? (0, $1c6cc12c1e03ecad$export$af7e6fc08350a63d)(editorView.state) : (0, $6ec66a5f4782e56b$export$ad08e20e7e22e394).INVALID;
    const { getCanAddComments: getCanAddComments, contentType: contentType } = annotationProviders?.inlineComment ?? {};
    (0, $4c16e01fcbc0489f$export$b0b121505277a396)({
        state: editorView?.state,
        annotationProviders: annotationProviders,
        api: api,
        annotationSelectionType: annotationSelectionType,
        bookmark: bookmark
    });
    const intl = (0, $8C5kA.default)();
    const onClick = ()=>{
        if (!api || !annotationProviders || !editorView?.state || !editorView?.dispatch) return;
        (0, $74d3c5d57fc803d2$export$b5fd00fffbd8948d)({
            api: api
        });
        (0, $74d3c5d57fc803d2$export$c983cfb71edde6e4)({
            annotationProviders: annotationProviders,
            api: api,
            state: editorView.state,
            dispatch: editorView.dispatch
        });
    };
    if (!(0, $74d3c5d57fc803d2$export$dd62b022312fd583)({
        state: editorView?.state,
        isVisible: isVisible,
        annotationSelectionType: annotationSelectionType
    })) return null;
    const canAddComments = getCanAddComments ? getCanAddComments() : true;
    const commentMessage = intl.formatMessage((0, $ahUGI.annotationMessages).createComment);
    const commentDisabledMessage = intl.formatMessage((0, $dh538.fg)('editor_inline_comments_on_inline_nodes') ? (0, $ahUGI.annotationMessages).createCommentDisabled : (0, $ahUGI.annotationMessages).createCommentInvalid);
    const noPermissionToAddCommentMessage = intl.formatMessage((0, $ahUGI.annotationMessages).noPermissionToAddComment, {
        contentType: contentType
    });
    const isDisabled = (0, $74d3c5d57fc803d2$export$7a6737b74121da6f)({
        state: editorView?.state,
        api: api,
        canAddComments: canAddComments
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iIVVb.ToolbarTooltip), {
        content: isDisabled ? !canAddComments ? noPermissionToAddCommentMessage : commentDisabledMessage : /*#__PURE__*/ (0, $l998X.jsx)((0, $hgeg8.ToolTipContent), {
            description: commentMessage,
            keymap: (0, $hgeg8.addInlineComment)
        }),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7ERUE.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                label: "",
                size: "small"
            }),
            onClick: onClick,
            testId: (0, $6ec66a5f4782e56b$export$711f43d01b7e0019).floatingToolbarCreateButton,
            isDisabled: isDisabled,
            children: commentMessage
        })
    });
};


const $8fb9dc28a8dbe648$export$a758406ca53b86a5 = (api, annotationProviders)=>{
    return [
        {
            type: (0, $cPCP8.COLLAB_SECTION).type,
            key: (0, $cPCP8.COLLAB_SECTION).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $cPCP8.TOOLBARS).INLINE_TEXT_TOOLBAR,
                    rank: (0, $4Chin.TOOLBAR_RANK)[(0, $cPCP8.COLLAB_SECTION).key]
                }
            ]
        },
        {
            type: (0, $cPCP8.COMMENT_GROUP).type,
            key: (0, $cPCP8.COMMENT_GROUP).key,
            parents: [
                {
                    type: (0, $cPCP8.COLLAB_SECTION).type,
                    key: (0, $cPCP8.COLLAB_SECTION).key,
                    rank: (0, $4Chin.TOOLBAR_RANK)[(0, $cPCP8.COLLAB_SECTION).key]
                }
            ]
        },
        {
            type: (0, $cPCP8.COMMENT_HERO_BUTTON).type,
            key: (0, $cPCP8.COMMENT_HERO_BUTTON).key,
            parents: [
                {
                    type: (0, $cPCP8.COMMENT_GROUP).type,
                    key: (0, $cPCP8.COMMENT_GROUP).key,
                    rank: (0, $4Chin.COLLAB_SECTION_RANK)[(0, $cPCP8.COMMENT_GROUP).key]
                }
            ],
            component: ()=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $2a7c42f5944ba88b$export$44a3d5aec3da3e9f), {
                    api: api,
                    annotationProviders: annotationProviders
                });
            }
        }
    ];
};


const $6bd0bec877cc506d$export$df895cff1a8daaf7 = ({ config: annotationProviders, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState();
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $8fb9dc28a8dbe648$export$a758406ca53b86a5)(api, annotationProviders));
    return {
        name: 'annotation',
        marks () {
            return [
                {
                    name: 'annotation',
                    mark: (0, $f7a893223e5c2354$export$802ec1d716a6bb1)
                }
            ];
        },
        actions: {
            hasAnyUnResolvedAnnotationInPage: $1c6cc12c1e03ecad$export$98b0a2a6ba343064,
            stripNonExistingAnnotations: $1c6cc12c1e03ecad$export$ca9ec32b395faf65,
            setInlineCommentDraftState: (0, $0f9c6d7837321f71$export$2a7aec6fc438fa0b)(api?.analytics?.actions, annotationProviders?.inlineComment.supportedBlockNodes),
            showCommentForBlockNode: (0, $0f9c6d7837321f71$export$d80af6562490622d)(annotationProviders?.inlineComment.supportedBlockNodes)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $1c6cc12c1e03ecad$export$f05434c51e3762e)(editorState) || undefined;
            const clonedPluginState = Object.assign({}, pluginState);
            delete clonedPluginState?.featureFlagsPluginState;
            return clonedPluginState;
        },
        pmPlugins: ()=>[
                {
                    name: 'annotation',
                    plugin: ({ dispatch: dispatch })=>{
                        if (annotationProviders) return (0, $5afcd16e23d3e19e$export$e4aab3acac8f34b)({
                            dispatch: dispatch,
                            provider: annotationProviders.inlineComment,
                            editorAnalyticsAPI: api?.analytics?.actions,
                            featureFlagsPluginState: featureFlags,
                            selectCommentExperience: annotationProviders.selectCommentExperience,
                            viewInlineCommentTraceUFOPress: annotationProviders.viewInlineCommentTraceUFOPress,
                            annotationManager: annotationProviders.annotationManager,
                            api: api
                        });
                        return;
                    }
                },
                {
                    name: 'annotationKeymap',
                    plugin: ()=>{
                        if (annotationProviders) return (0, $d92abb614d3b39aa$export$e832373cff8dec22)(api);
                        return;
                    }
                }
            ],
        pluginsOptions: {
            floatingToolbar (state) {
                const pluginState = (0, $1c6cc12c1e03ecad$export$f05434c51e3762e)(state);
                const bookmark = pluginState?.bookmark;
                if ((0, $9b6a63f7e792d6b0$export$8921e02ce71849ce)({
                    state: state,
                    bookmark: bookmark
                })) return (0, $9b6a63f7e792d6b0$export$4f0bdd9681380033)(state, api);
            },
            selectionToolbar (state, intl) {
                if (isToolbarAIFCEnabled) return;
                if (!annotationProviders) return;
                const pluginState = (0, $1c6cc12c1e03ecad$export$f05434c51e3762e)(state);
                if (pluginState && pluginState.isVisible && !pluginState.bookmark && !pluginState.mouseData.isSelecting) {
                    const { isToolbarAbove: isToolbarAbove, onCommentButtonMount: onCommentButtonMount, getCanAddComments: getCanAddComments, contentType: contentType } = annotationProviders.inlineComment;
                    const toolbarConfig = (0, $9b6a63f7e792d6b0$export$6dd6ab35df8f7f86)(api?.analytics?.actions)({
                        state: state,
                        intl: intl,
                        isToolbarAbove: isToolbarAbove,
                        api: api,
                        createCommentExperience: annotationProviders.createCommentExperience,
                        annotationManager: annotationProviders.annotationManager,
                        onCommentButtonMount: onCommentButtonMount,
                        getCanAddComments: getCanAddComments,
                        contentType: contentType
                    });
                    if (!toolbarConfig) return undefined;
                    else return {
                        ...toolbarConfig,
                        rank: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? 1 : undefined
                    };
                }
            }
        },
        contentComponent ({ editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
            if (!annotationProviders || !editorView || (0, $eTj7Y.isSSR)() && (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true)) return null;
            return /*#__PURE__*/ (0, $l998X.jsx)($6bd0bec877cc506d$var$AnnotationContentComponent, {
                api: api,
                editorView: editorView,
                annotationProviders: annotationProviders,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent
            });
        }
    };
};
const $6bd0bec877cc506d$var$selector = (states)=>{
    return {
        isVisible: states.annotationState?.isVisible,
        selectedAnnotations: states.annotationState?.selectedAnnotations,
        annotations: states.annotationState?.annotations
    };
};
function $6bd0bec877cc506d$var$AnnotationContentComponent({ api: api, editorView: editorView, annotationProviders: annotationProviders, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
    const annotationState = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'annotation'
    ], $6bd0bec877cc506d$var$selector);
    // need to explicitly check for false as undefined is also a valid value to continue
    if (annotationState?.isVisible === false) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-editor-popup": "true",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ae02a84cba9b2c8c$export$ce99d9856d415465), {
            providers: annotationProviders,
            editorView: editorView,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            editorAnalyticsAPI: api?.analytics?.actions,
            editorAPI: api
        })
    });
}
module.exports["annotationPlugin"] = $6bd0bec877cc506d$export$df895cff1a8daaf7;

});

parcelRegister("cwPVT", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gWpm5 = parcelRequire("gWpm5");


var $eiA8Z = parcelRequire("eiA8Z");


var $1S4f7 = parcelRequire("1S4f7");

const $fe361930a2595c94$export$c21a3b023fccd534 = {
    BREAKOUT_MARK: 'fabric-editor-breakout-mark',
    BREAKOUT_MARK_DOM: 'fabric-editor-breakout-mark-dom'
};



var $6qdjm = parcelRequire("6qdjm");


var $b3YrF = parcelRequire("b3YrF");


var $aFUXX = parcelRequire("aFUXX");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $ks2lK = parcelRequire("ks2lK");

const $c0a482e4157215ff$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('breakoutPlugin');
const $c0a482e4157215ff$export$f05434c51e3762e = (state)=>$c0a482e4157215ff$export$18d4026d1ea86bb1.getState(state) || undefined;






var $kTbzR = parcelRequire("kTbzR");


var $2pjJ5 = parcelRequire("2pjJ5");











var $d7ZU3 = parcelRequire("d7ZU3");











var $dNXVc = parcelRequire("dNXVc");





var $adayn = parcelRequire("adayn");


var $dh538 = parcelRequire("dh538");




const $de180ab218c9eae9$export$cc135306f1c4ff36 = ({ tr: tr, node: node, pos: pos, isLivePage: isLivePage })=>{
    if (isLivePage || (0, $dh538.fg)('platform-editor-single-player-expand')) {
        const wasExpandExpanded = (0, $adayn.expandedState).get(node);
        const newExpand = tr.doc.nodeAt(pos);
        if (wasExpandExpanded !== undefined && newExpand) (0, $adayn.expandedState).set(newExpand, wasExpandExpanded);
    }
};
const $de180ab218c9eae9$export$322e23ed7d99ab86 = (tr, node, isLivePage)=>{
    if ((0, $iu6m9.editorExperiment)('platform_editor_breakout_resizing', true)) $de180ab218c9eae9$export$cc135306f1c4ff36({
        tr: tr,
        node: node.node,
        pos: node.pos,
        isLivePage: isLivePage
    });
    else if (isLivePage || (0, $dh538.fg)('platform-editor-single-player-expand')) {
        const wasExpandExpanded = (0, $adayn.expandedState).get(node.node);
        const newExpand = tr.doc.nodeAt(node.pos);
        if (wasExpandExpanded !== undefined && newExpand) (0, $adayn.expandedState).set(newExpand, wasExpandExpanded);
    }
};


function $1f06cd6ea94cc3ac$export$2347aa63864fccd4(width, mode, pos, isLivePage) {
    return (state, dispatch)=>{
        const node = state.doc.nodeAt(pos);
        if (!node) return false;
        const tr = state.tr.setNodeMarkup(pos, node.type, node.attrs, [
            state.schema.marks.breakout.create({
                width: width,
                mode: mode
            })
        ]);
        if (node.type === state.schema.nodes.expand) (0, $de180ab218c9eae9$export$cc135306f1c4ff36)({
            tr: tr,
            node: node,
            pos: pos,
            isLivePage: isLivePage
        });
        else if (node.type === state.schema.nodes.codeBlock) {
            const newNode = tr.doc.nodeAt(pos);
            const oldNode = node;
            if (newNode) (0, $dNXVc.transferCodeBlockWrappedValue)(oldNode, newNode);
        }
        tr.setMeta('scrollIntoView', false);
        // keep current selection, necessary to not remove NodeSelection for keyboard resizing
        if (state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node.eq(node)) tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, pos));
        if (dispatch) dispatch(tr);
        return true;
    };
}


const $fe1c4be5bd3b93b3$var$KEYBOARD_RESIZE_STEP = 10;
const $fe1c4be5bd3b93b3$var$getAncestorResizableNode = (view, breakoutResizableNodes)=>{
    const selection = view.state.selection;
    if (selection instanceof (0, $ks2lK.NodeSelection)) {
        const selectedNode = selection.node;
        if (breakoutResizableNodes.has(selectedNode.type)) return {
            node: selectedNode,
            pos: selection.$from.pos
        };
    } else if (selection instanceof (0, $ks2lK.TextSelection)) {
        let node = null;
        let nodePos = null;
        // only top level nodes are resizable
        const resolvedPos = view.state.doc.resolve(selection.$from.pos);
        const currentNode = resolvedPos.node(1);
        if (breakoutResizableNodes.has(currentNode.type)) {
            node = currentNode;
            nodePos = resolvedPos.before(1);
            return {
                node: node,
                pos: nodePos
            };
        }
    }
    return null;
};
const $fe1c4be5bd3b93b3$export$bab59f27a7347e45 = (api)=>(view, event)=>{
        const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
        const metaKey = browser.mac ? event.metaKey : event.ctrlKey;
        const isBracketKey = event.code === 'BracketRight' || event.code === 'BracketLeft';
        if (metaKey && event.altKey && isBracketKey) {
            const { expand: expand, codeBlock: codeBlock, layoutSection: layoutSection } = view.state.schema.nodes;
            const breakoutResizableNodes = new Set([
                expand,
                codeBlock,
                layoutSection
            ]);
            const result = $fe1c4be5bd3b93b3$var$getAncestorResizableNode(view, breakoutResizableNodes);
            if (result) {
                const { node: node, pos: pos } = result;
                const breakoutMark = node?.marks.find((mark)=>mark.type.name === 'breakout');
                if (breakoutMark) {
                    const step = event.code === 'BracketRight' ? $fe1c4be5bd3b93b3$var$KEYBOARD_RESIZE_STEP : -$fe1c4be5bd3b93b3$var$KEYBOARD_RESIZE_STEP;
                    const newWidth = breakoutMark.attrs.width + step;
                    if (newWidth < (0, $aFUXX.akEditorFullWidthLayoutWidth) && newWidth > (0, $aFUXX.akEditorDefaultLayoutWidth)) {
                        const isEditMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'edit';
                        (0, $1f06cd6ea94cc3ac$export$2347aa63864fccd4)(breakoutMark.attrs.width + step, breakoutMark.attrs.mode, pos, isEditMode)(view.state, view.dispatch);
                        view.focus();
                    }
                    return true;
                }
            }
        }
        return false;
    };













var $fFa3V = parcelRequire("fFa3V");


var $cUcZ5 = parcelRequire("cUcZ5");


var $5duTD = parcelRequire("5duTD");


var $4T4vf = parcelRequire("4T4vf");


var $5X6QO = parcelRequire("5X6QO");


var $gZctg = parcelRequire("gZctg");


var $3gadb = parcelRequire("3gadb");

const $1a5749845d01d8bf$var$getNodeName = (nodeName)=>{
    if (nodeName === 'layoutSection') return 'layout';
    else if (nodeName === 'codeBlock' || nodeName === 'expand') return nodeName;
    else return 'node';
};
const $1a5749845d01d8bf$export$5c0a5eee165b9845 = {
    expand: (0, $5duTD.messages).resizeExpand,
    codeBlock: (0, $5duTD.messages).resizeCodeBlock,
    layout: (0, $5duTD.messages).resizeLayout,
    node: (0, $5duTD.messages).resizeElement
};
const $1a5749845d01d8bf$var$RailWithTooltip = ({ rail: rail, target: target, intl: intl })=>{
    const [nodeName, setNodeName] = (0, $42omo.useState)('node');
    (0, $42omo.useLayoutEffect)(()=>{
        const node = target.querySelector('[data-prosemirror-node-name]');
        const name = $1a5749845d01d8bf$var$getNodeName(node?.dataset.prosemirrorNodeName);
        setNodeName(name);
    }, [
        target
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: intl.formatMessage($1a5749845d01d8bf$export$5c0a5eee165b9845[nodeName]),
        position: "mouse",
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "pm-breakout-resize-handle-rail-inside-tooltip",
            ref: (el)=>{
                if (el && rail.parentNode !== el) el.appendChild(rail);
            }
        })
    });
};
const $1a5749845d01d8bf$export$2023dee10a108a1 = ({ target: target, onDragStart: onDragStart, onDrag: onDrag, onDrop: onDrop, intl: intl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
    let state = 'default';
    const createHandle = (side)=>{
        const handle = document.createElement('div');
        handle.contentEditable = 'false';
        handle.classList.add('pm-breakout-resize-handle-container');
        handle.style.gridColumn = side === 'left' ? '1' : '3';
        const rail = document.createElement('div');
        rail.classList.add('pm-breakout-resize-handle-rail');
        if (side === 'left') {
            handle.classList.add('pm-breakout-resize-handle-container--left');
            handle.setAttribute('data-testid', 'pragmatic-resizer-handle-left');
        } else {
            handle.classList.add('pm-breakout-resize-handle-container--right');
            handle.setAttribute('data-testid', 'pragmatic-resizer-handle-right');
        }
        const handleHitBox = document.createElement('div');
        handleHitBox.classList.add('pm-breakout-resize-handle-hit-box');
        const thumb = document.createElement('div');
        thumb.classList.add('pm-breakout-resize-handle-thumb');
        rail.appendChild(thumb);
        const tooltipContainer = document.createElement('div');
        tooltipContainer.classList.add('pm-breakout-resize-handle-rail-wrapper');
        handle.appendChild(tooltipContainer);
        handle.appendChild(handleHitBox);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const key = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
        nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $l998X.jsx)($1a5749845d01d8bf$var$RailWithTooltip, {
                rail: rail,
                target: target,
                intl: intl
            }), tooltipContainer, key);
        return {
            handle: handle,
            rail: rail,
            handleHitBox: handleHitBox,
            destroyTooltip: ()=>nodeViewPortalProviderAPI.remove(key)
        };
    };
    const rightHandle = createHandle('right');
    const leftHandle = createHandle('left');
    const registerHandle = (handleElement, handleSide)=>{
        return (0, $4T4vf.draggable)({
            element: handleElement,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $5X6QO.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                });
                (0, $gZctg.preventUnhandled).start();
            },
            getInitialData: ()=>({
                    handleSide: handleSide
                }),
            onDragStart (args) {
                state = 'resizing';
                handleElement.classList.add('pm-breakout-resize-handle-container--active');
                onDragStart(args);
            },
            onDrag: onDrag,
            onDrop (args) {
                (0, $gZctg.preventUnhandled).stop();
                state = 'default';
                handleElement.classList.remove('pm-breakout-resize-handle-container--active');
                onDrop(args);
            }
        });
    };
    const registerEvents = (element)=>{
        return [
            (0, $fFa3V.bind)(element, {
                type: 'mouseenter',
                listener: ()=>{
                    rightHandle.rail.style.setProperty('opacity', '1');
                    leftHandle.rail.style.setProperty('opacity', '1');
                }
            }),
            (0, $fFa3V.bind)(element, {
                type: 'mouseleave',
                listener: ()=>{
                    if (state === 'resizing') return;
                    rightHandle.rail.style.removeProperty('opacity');
                    leftHandle.rail.style.removeProperty('opacity');
                }
            })
        ];
    };
    const unbindFns = [
        ...registerEvents(target),
        ...registerEvents(rightHandle.handleHitBox),
        ...registerEvents(leftHandle.handleHitBox),
        ...registerEvents(rightHandle.rail),
        ...registerEvents(leftHandle.rail)
    ];
    const destroyFns = [
        registerHandle(rightHandle.handle, 'right'),
        registerHandle(leftHandle.handle, 'left'),
        rightHandle.destroyTooltip,
        leftHandle.destroyTooltip
    ];
    return {
        rightHandle: rightHandle.handle,
        leftHandle: leftHandle.handle,
        destroy: (isChangeToViewMode)=>{
            destroyFns.forEach((destroyFn)=>destroyFn());
            unbindFns.forEach((unbindFn)=>unbindFn());
            if (isChangeToViewMode) {
                rightHandle.handle.parentElement?.removeChild(rightHandle.handle);
                leftHandle.handle.parentElement?.removeChild(leftHandle.handle);
            }
        }
    };
};













var $2XqLN = parcelRequire("2XqLN");

const $631ba4830cc4824c$export$6065600df915db53 = 8;


var $boKri = parcelRequire("boKri");

var $7QdQz = parcelRequire("7QdQz");










const $c55c2990d369b072$var$WIDTHS = {
    MIN: (0, $aFUXX.akEditorDefaultLayoutWidth),
    WIDE: (0, $aFUXX.akEditorCalculatedWideLayoutWidth),
    FULL: (0, $aFUXX.akEditorFullWidthLayoutWidth),
    MAX: (0, $aFUXX.akEditorMaxLayoutWidth)
};
const $c55c2990d369b072$export$dd27ecfadfde9946 = {
    lineLengthLeft: 'grid_left',
    lineLengthRight: 'grid_right',
    wideLeft: 'wide_left',
    wideRight: 'wide_right',
    fullWidthLeft: 'full_width_left',
    fullWidthRight: 'full_width_right',
    maxWidthLeft: 'max_width_left',
    maxWidthRight: 'max_width_right'
};
const $c55c2990d369b072$var$AK_NESTED_DND_GUTTER_OFFSET = 8;
const $c55c2990d369b072$var$roundToNearest = (value, interval = 0.5)=>Math.round(value / interval) * interval;
const $c55c2990d369b072$export$47dec483f7d48a59 = (0, $2XqLN.default)((isResizing, newWidth, getEditorWidth, nodeType)=>{
    const guidelines = [];
    if (!isResizing) return guidelines;
    let innerPaddingOffset = 0;
    if (nodeType) switch(nodeType.name){
        case 'expand':
            innerPaddingOffset = (0, $631ba4830cc4824c$export$6065600df915db53) + (0, $7QdQz.resizerHandleThumbWidth) + $c55c2990d369b072$var$AK_NESTED_DND_GUTTER_OFFSET;
            break;
        case 'layoutSection':
            innerPaddingOffset = (0, $boKri.LAYOUT_COLUMN_PADDING) + $c55c2990d369b072$var$AK_NESTED_DND_GUTTER_OFFSET;
            break;
        default:
            break;
    }
    const { width: width } = getEditorWidth() || {};
    const padding = width && width <= (0, $aFUXX.akEditorFullPageNarrowBreakout) && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $aFUXX.akEditorGutterPaddingReduced) : (0, $aFUXX.akEditorGutterPaddingDynamic)();
    const fullWidth = width ? Math.min($c55c2990d369b072$var$WIDTHS.FULL, width - 2 * padding - (0, $aFUXX.akEditorGutterPadding)) : undefined;
    const maxWidth = width && ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) ? Math.min($c55c2990d369b072$var$WIDTHS.MAX, width - 2 * padding - (0, $aFUXX.akEditorGutterPadding)) : undefined;
    guidelines.push({
        key: $c55c2990d369b072$export$dd27ecfadfde9946.lineLengthLeft,
        position: {
            x: -$c55c2990d369b072$var$roundToNearest($c55c2990d369b072$var$WIDTHS.MIN / 2 + innerPaddingOffset)
        },
        active: newWidth === $c55c2990d369b072$var$WIDTHS.MIN
    });
    guidelines.push({
        key: $c55c2990d369b072$export$dd27ecfadfde9946.lineLengthRight,
        position: {
            x: $c55c2990d369b072$var$roundToNearest($c55c2990d369b072$var$WIDTHS.MIN / 2 + innerPaddingOffset)
        },
        active: newWidth === $c55c2990d369b072$var$WIDTHS.MIN
    });
    guidelines.push({
        key: $c55c2990d369b072$export$dd27ecfadfde9946.wideLeft,
        position: {
            x: -$c55c2990d369b072$var$roundToNearest($c55c2990d369b072$var$WIDTHS.WIDE / 2 + innerPaddingOffset)
        },
        active: newWidth === $c55c2990d369b072$var$WIDTHS.WIDE
    });
    guidelines.push({
        key: $c55c2990d369b072$export$dd27ecfadfde9946.wideRight,
        position: {
            x: $c55c2990d369b072$var$roundToNearest($c55c2990d369b072$var$WIDTHS.WIDE / 2 + innerPaddingOffset)
        },
        active: newWidth === $c55c2990d369b072$var$WIDTHS.WIDE
    });
    if (fullWidth) {
        guidelines.push({
            key: $c55c2990d369b072$export$dd27ecfadfde9946.fullWidthLeft,
            position: {
                x: -$c55c2990d369b072$var$roundToNearest(fullWidth / 2 + innerPaddingOffset)
            },
            active: newWidth === fullWidth
        });
        guidelines.push({
            key: $c55c2990d369b072$export$dd27ecfadfde9946.fullWidthRight,
            position: {
                x: $c55c2990d369b072$var$roundToNearest(fullWidth / 2 + innerPaddingOffset)
            },
            active: newWidth === fullWidth
        });
    }
    if (maxWidth) {
        guidelines.push({
            key: $c55c2990d369b072$export$dd27ecfadfde9946.maxWidthLeft,
            position: {
                x: -$c55c2990d369b072$var$roundToNearest(maxWidth / 2 + innerPaddingOffset)
            },
            active: newWidth === maxWidth
        });
        guidelines.push({
            key: $c55c2990d369b072$export$dd27ecfadfde9946.maxWidthRight,
            position: {
                x: $c55c2990d369b072$var$roundToNearest(maxWidth / 2 + innerPaddingOffset)
            },
            active: newWidth === maxWidth
        });
    }
    return guidelines;
});





var $d925B = parcelRequire("d925B");

const $dce7a089fb4e15a6$export$29574a7e6ffc8eb4 = (props)=>{
    return props.frameRateSamples.map((frameRateSample, index)=>({
            action: (0, $d925B.ACTION).RESIZED_PERF_SAMPLING,
            actionSubject: (0, $d925B.ACTION_SUBJECT).ELEMENT,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                nodeType: props.originalNode.type.name,
                frameRate: frameRateSample,
                nodeSize: props.originalNode.nodeSize,
                docSize: props.docSize,
                isInitialSample: index === 0
            }
        }));
};
const $dce7a089fb4e15a6$export$6b143296f4c6108b = ({ node: node, prevWidth: prevWidth, newWidth: newWidth })=>{
    return {
        action: (0, $d925B.ACTION).RESIZED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).ELEMENT,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            nodeType: node.type.name,
            prevWidth: prevWidth,
            newWidth: newWidth
        }
    };
};


/**
 * Measure the FPS of a resizing component.
 *
 * This is a simplified version of the `useMeasureFramerate` hook from `editor-plugin-table`.
 * (packages/editor/editor-plugin-table/src/pm-plugins/utils/analytics.ts)
 */ const $71ded837f678e901$export$52625746d6329c8a = (frameRateSamples)=>{
    if (frameRateSamples.length > 1) {
        const frameRateSum = frameRateSamples.reduce((sum, frameRate, index)=>{
            if (index === 0) return sum;
            else return sum + frameRate;
        }, 0);
        const averageFrameRate = Math.round(frameRateSum / (frameRateSamples.length - 1));
        return [
            frameRateSamples[0],
            averageFrameRate
        ];
    } else return frameRateSamples;
};
const $71ded837f678e901$export$499e6cf908107611 = (config)=>{
    const { maxSamples: maxSamples = 10, minFrames: minFrames = 5, minTimeMs: minTimeMs = 500, sampleRateMs: sampleRateMs = 1000, timeoutMs: timeoutMs = 200 } = config || {};
    let frameCount = 0;
    let lastTime = 0;
    let timeoutId;
    let frameRateSamples = [];
    const startMeasure = ()=>{
        frameCount = 0;
        lastTime = performance.now();
    };
    /**
	 * Returns an array of frame rate samples as integers.
	 * @returns {number[]} An array of frame rate samples as integers.
	 * @example
	 * const samples = endMeasure(); // [60, 58, 62]
	 */ const endMeasure = ()=>{
        const samples = frameRateSamples;
        frameRateSamples = [];
        return samples;
    };
    const sampleFrameRate = (delay = 0)=>{
        const currentTime = performance.now();
        const deltaTime = currentTime - lastTime - delay;
        const isValidSample = deltaTime > minTimeMs && frameCount >= minFrames;
        if (isValidSample) {
            const frameRate = Math.round(frameCount / (deltaTime / 1000));
            frameRateSamples.push(frameRate);
        }
        frameCount = 0;
        lastTime = 0;
    };
    /**
	 * Counts the number of frames that occur within a given time period. Intended to be called
	 * inside a `requestAnimationFrame` callback.
	 * @example
	 * const animate = () => {
	 *   countFrames();
	 *   requestAnimationFrame(animate);
	 * };
	 */ const countFrames = ()=>{
        if (frameRateSamples.length >= maxSamples && timeoutId) {
            clearTimeout(timeoutId);
            return;
        }
        /**
		 * Allows us to keep counting frames even if `startMeasure` is not called
		 */ if (lastTime === 0) lastTime = performance.now();
        frameCount++;
        if (timeoutId) clearTimeout(timeoutId);
        if (performance.now() - lastTime > sampleRateMs) sampleFrameRate();
        else timeoutId = setTimeout(()=>sampleFrameRate(timeoutMs), timeoutMs);
    };
    return {
        startMeasure: startMeasure,
        endMeasure: endMeasure,
        countFrames: countFrames
    };
};


const $5a34cf47b86dc148$var$RESIZE_RATIO = 2;
const $5a34cf47b86dc148$var$SNAP_GAP = 10;
const $5a34cf47b86dc148$var$WIDTHS = {
    MIN: (0, $aFUXX.akEditorDefaultLayoutWidth),
    WIDE: (0, $aFUXX.akEditorCalculatedWideLayoutWidth),
    FULL: (0, $aFUXX.akEditorFullWidthLayoutWidth),
    MAX: (0, $aFUXX.akEditorMaxLayoutWidth)
};
function $5a34cf47b86dc148$export$39e6ff87d188b0e6({ initialWidth: initialWidth, location: location, api: api, source: source }) {
    const directionMultiplier = source.data.handleSide === 'left' ? -1 : 1;
    const diffX = (location.current.input.clientX - location.initial.input.clientX) * $5a34cf47b86dc148$var$RESIZE_RATIO * directionMultiplier;
    const width = api?.width.sharedState?.currentState()?.width || 0;
    const padding = width <= (0, $aFUXX.akEditorFullPageNarrowBreakout) && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $aFUXX.akEditorGutterPaddingReduced) : (0, $aFUXX.akEditorGutterPaddingDynamic)();
    const containerWidth = width - 2 * padding - (0, $aFUXX.akEditorGutterPadding);
    // the node width may be greater than the container width so we resize using the smaller value
    const proposedWidth = Math.min(initialWidth, containerWidth) + diffX;
    const snapPoints = [
        $5a34cf47b86dc148$var$WIDTHS.MIN,
        $5a34cf47b86dc148$var$WIDTHS.WIDE,
        Math.min(containerWidth, $5a34cf47b86dc148$var$WIDTHS.FULL)
    ];
    if ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) snapPoints.push(Math.min(containerWidth, $5a34cf47b86dc148$var$WIDTHS.MAX));
    for (const snapPoint of snapPoints){
        if (snapPoint - $5a34cf47b86dc148$var$SNAP_GAP < proposedWidth && snapPoint + $5a34cf47b86dc148$var$SNAP_GAP > proposedWidth) return snapPoint;
    }
    const hardMax = (0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? Math.min(containerWidth, $5a34cf47b86dc148$var$WIDTHS.MAX) : Math.min(containerWidth, $5a34cf47b86dc148$var$WIDTHS.FULL);
    return Math.max($5a34cf47b86dc148$var$WIDTHS.MIN, Math.min(proposedWidth, hardMax));
}
function $5a34cf47b86dc148$export$d3619fd797e636fb({ dom: dom, view: view, mark: mark, api: api }) {
    let node = null;
    let guidelines = [];
    const { startMeasure: startMeasure, endMeasure: endMeasure, countFrames: countFrames } = (0, $71ded837f678e901$export$499e6cf908107611)();
    const getEditorWidth = ()=>{
        return api?.width?.sharedState.currentState();
    };
    return {
        onDragStart: ()=>{
            startMeasure();
            const pos = view.posAtDOM(dom, 0);
            node = view.state.doc.nodeAt(pos);
            api?.core.actions.execute(({ tr: tr })=>{
                api.userIntent?.commands.setCurrentUserIntent('dragging')({
                    tr: tr
                });
                tr.setMeta('is-resizer-resizing', true);
                tr.setMeta((0, $0270481e4dcc36c1$export$ca33a310187a5f87), {
                    type: 'UPDATE_BREAKOUT_NODE',
                    data: {
                        node: node,
                        pos: pos,
                        start: pos,
                        depth: 0
                    }
                });
                return tr;
            });
        },
        onDrag: ({ location: location, source: source })=>{
            countFrames();
            const initialWidth = mark.attrs.width;
            const newWidth = $5a34cf47b86dc148$export$39e6ff87d188b0e6({
                initialWidth: initialWidth,
                location: location,
                api: api,
                source: source
            });
            guidelines = (0, $c55c2990d369b072$export$47dec483f7d48a59)(true, newWidth, getEditorWidth, node?.type);
            api?.guideline?.actions?.displayGuideline(view)({
                guidelines: guidelines
            });
            const activeGuideline = guidelines.find((guideline)=>guideline.active && !guideline.key.startsWith('grid'));
            if (activeGuideline) api?.core.actions.execute(({ tr: tr })=>{
                tr.setMeta((0, $0270481e4dcc36c1$export$ca33a310187a5f87), {
                    type: 'UPDATE_ACTIVE_GUIDELINE_KEY',
                    data: {
                        activeGuidelineKey: activeGuideline.key
                    }
                });
                return tr;
            });
            if (!activeGuideline && api?.breakout.sharedState.currentState()?.activeGuidelineKey) api?.core.actions.execute(({ tr: tr })=>{
                tr.setMeta((0, $0270481e4dcc36c1$export$ca33a310187a5f87), {
                    type: 'CLEAR_ACTIVE_GUIDELINE_KEY'
                });
                return tr;
            });
            // dom is used for width calculations
            dom.style.setProperty((0, $ddcb98fa7f5afd3a$export$4ce5e59f44ac1e3e), `${newWidth}px`);
        },
        onDrop ({ location: location, source: source }) {
            let payloads = [];
            const frameRateSamples = endMeasure();
            payloads = (0, $dce7a089fb4e15a6$export$29574a7e6ffc8eb4)({
                docSize: view.state.doc.nodeSize,
                frameRateSamples: (0, $71ded837f678e901$export$52625746d6329c8a)(frameRateSamples),
                originalNode: node
            });
            const isResizedToFullWidth = !!guidelines.find((guideline)=>guideline.key.startsWith('full_width') && guideline.active);
            let isResizedToMaxWidth = false;
            if ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) isResizedToMaxWidth = !!guidelines.find((guideline)=>guideline.key.startsWith('max_width') && guideline.active);
            guidelines = (0, $c55c2990d369b072$export$47dec483f7d48a59)(false, 0, getEditorWidth);
            api?.guideline?.actions?.displayGuideline(view)({
                guidelines: guidelines
            });
            const pos = view.posAtDOM(dom, 0);
            const mode = mark.attrs.mode;
            const initialWidth = mark.attrs.width;
            let newWidth = isResizedToFullWidth ? $5a34cf47b86dc148$var$WIDTHS.FULL : $5a34cf47b86dc148$export$39e6ff87d188b0e6({
                initialWidth: initialWidth,
                location: location,
                api: api,
                source: source
            });
            if ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) {
                if (isResizedToMaxWidth) newWidth = $5a34cf47b86dc148$var$WIDTHS.MAX;
            }
            const isEditMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'edit';
            (0, $1f06cd6ea94cc3ac$export$2347aa63864fccd4)(newWidth, mode, pos, isEditMode)(view.state, view.dispatch);
            dom.style.removeProperty((0, $ddcb98fa7f5afd3a$export$4ce5e59f44ac1e3e));
            if (node) {
                const resizedPayload = (0, $dce7a089fb4e15a6$export$6b143296f4c6108b)({
                    node: node,
                    prevWidth: initialWidth,
                    newWidth: newWidth
                });
                payloads.push(resizedPayload);
            }
            api?.core.actions.execute(({ tr: tr })=>{
                api.userIntent?.commands.setCurrentUserIntent('default')({
                    tr: tr
                });
                payloads.forEach((payload)=>{
                    api.analytics?.actions?.attachAnalyticsEvent(payload)(tr);
                });
                tr.setMeta('is-resizer-resizing', false).setMeta('scrollIntoView', false);
                tr.setMeta((0, $0270481e4dcc36c1$export$ca33a310187a5f87), {
                    type: 'RESET_STATE'
                });
                return tr;
            });
        }
    };
}


const $ddcb98fa7f5afd3a$export$4ce5e59f44ac1e3e = '--local-resizing-width';
class $ddcb98fa7f5afd3a$export$4fb684fac6535bde {
    setupResizerCallbacks(dom, contentDOM, view, mark, api) {
        const callbacks = (0, $5a34cf47b86dc148$export$d3619fd797e636fb)({
            dom: dom,
            view: view,
            mark: mark,
            api: api
        });
        const { leftHandle: leftHandle, rightHandle: rightHandle, destroy: destroy } = (0, $1a5749845d01d8bf$export$2023dee10a108a1)({
            target: contentDOM,
            ...callbacks,
            intl: this.intl,
            nodeViewPortalProviderAPI: this.nodeViewPortalProviderAPI
        });
        this.dom.prepend(leftHandle);
        this.dom.appendChild(rightHandle);
        this.destroyFn = destroy;
        this.isResizingInitialised = true;
    }
    ignoreMutation() {
        return true;
    }
    destroy() {
        this.destroyFn?.();
        this.unsubscribeToViewModeChange?.();
    }
    /**
   * Wrap node view in a resizing mark view
   * @param {Mark} mark - The breakout mark to resize
   * @param {EditorView} view - The editor view
   * @param {ExtractInjectionAPI<BreakoutPlugin> | undefined} api - The pluginInjectionAPI
   * @param {Function} getIntl - () => IntlShape
   * @param {PortalProviderAPI} - The nodeViewPortalProviderAPI
   * @example
   * ```ts
   * ```
   */ constructor(mark, view, api, getIntl, nodeViewPortalProviderAPI){
        this.dom = void 0;
        this.contentDOM = void 0;
        this.view = void 0;
        this.mark = void 0;
        this.destroyFn = void 0;
        this.intl = void 0;
        this.nodeViewPortalProviderAPI = void 0;
        this.unsubscribeToViewModeChange = void 0;
        this.isResizingInitialised = false;
        const dom = document.createElement('div');
        const contentDOM = document.createElement('div');
        contentDOM.className = (0, $fe361930a2595c94$export$c21a3b023fccd534).BREAKOUT_MARK_DOM;
        contentDOM.setAttribute('data-testid', 'ak-editor-breakout-mark-dom');
        dom.className = (0, $fe361930a2595c94$export$c21a3b023fccd534).BREAKOUT_MARK;
        dom.setAttribute('data-layout', mark.attrs.mode);
        dom.setAttribute('data-testid', 'ak-editor-breakout-mark');
        // dom - styles
        dom.style.transform = 'none';
        dom.style.display = 'grid';
        dom.style.justifyContent = 'center';
        // contentDOM - styles
        contentDOM.style.gridColumn = '2';
        contentDOM.style.zIndex = '1';
        if ((0, $1oCLl.expValEquals)('platform_editor_breakout_resizing_vc90_fix', 'isEnabled', true)) {
            if (mark.attrs.width) dom.style.gridTemplateColumns = `auto max(var(--ak-editor--breakout-min-width), min(var(${$ddcb98fa7f5afd3a$export$4ce5e59f44ac1e3e}, ${mark.attrs.width}px), var(--ak-editor--breakout-fallback-width))) auto`;
            else {
                if (mark.attrs.mode === 'wide') contentDOM.style.width = `max(var(--ak-editor--line-length), min(var(${$ddcb98fa7f5afd3a$export$4ce5e59f44ac1e3e}, var(--ak-editor--breakout-wide-layout-width)), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
                if (mark.attrs.mode === 'full-width') contentDOM.style.width = `max(var(--ak-editor--line-length), min(var(${$ddcb98fa7f5afd3a$export$4ce5e59f44ac1e3e}, var(--ak-editor--full-width-layout-width)), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
            }
        } else if (mark.attrs.width) dom.style.gridTemplateColumns = `auto min(var(${$ddcb98fa7f5afd3a$export$4ce5e59f44ac1e3e}, ${mark.attrs.width}px), var(--ak-editor--breakout-fallback-width)) auto`;
        else {
            if (mark.attrs.mode === 'wide') contentDOM.style.width = `max(var(--ak-editor--line-length), min(var(${$ddcb98fa7f5afd3a$export$4ce5e59f44ac1e3e}, var(--ak-editor--breakout-wide-layout-width)), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
            if (mark.attrs.mode === 'full-width') contentDOM.style.width = `max(var(--ak-editor--line-length), min(var(${$ddcb98fa7f5afd3a$export$4ce5e59f44ac1e3e}, var(--ak-editor--full-width-layout-width)), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
        }
        dom.appendChild(contentDOM);
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.view = view;
        this.mark = mark;
        this.intl = getIntl();
        this.nodeViewPortalProviderAPI = nodeViewPortalProviderAPI;
        const isLiveViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
        if (!isLiveViewMode) this.setupResizerCallbacks(dom, contentDOM, view, mark, api);
        this.unsubscribeToViewModeChange = api?.editorViewMode?.sharedState.onChange((sharedState)=>{
            if (sharedState.nextSharedState?.mode !== sharedState.prevSharedState?.mode) {
                if (sharedState.nextSharedState?.mode === 'view' && this.isResizingInitialised) {
                    this.destroyFn?.(true);
                    this.isResizingInitialised = false;
                } else if (sharedState.nextSharedState?.mode === 'edit' && !this.isResizingInitialised) this.setupResizerCallbacks(dom, contentDOM, view, mark, api);
            }
        });
    }
}



const $0270481e4dcc36c1$var$addBreakoutToResizableNode = ({ node: node, pos: pos, newState: newState, newTr: newTr, breakoutResizableNodes: breakoutResizableNodes, isFullWidthEnabled: isFullWidthEnabled })=>{
    let updatedDocChanged = false;
    let updatedTr = newTr;
    const $pos = newState.doc.resolve(pos);
    const isTopLevelNode = $pos?.depth === 0;
    if (breakoutResizableNodes.has(node.type) && isTopLevelNode) {
        const { breakout: breakout } = newState.schema.marks;
        const { expand: expand } = newState.schema.nodes;
        const breakoutMark = node.marks.find((mark)=>mark.type === breakout);
        const isExpand = node.type === expand;
        if (!breakoutMark) {
            const width = isFullWidthEnabled ? (0, $aFUXX.akEditorFullWidthLayoutWidth) : (0, $aFUXX.akEditorDefaultLayoutWidth);
            updatedTr = newTr.setNodeMarkup(pos, node.type, node.attrs, [
                breakout.create({
                    width: width
                })
            ]);
            if (isExpand) (0, $de180ab218c9eae9$export$cc135306f1c4ff36)({
                tr: updatedTr,
                node: node,
                pos: pos,
                isLivePage: true
            });
            updatedDocChanged = true;
        } else if (breakoutMark?.attrs.width === null || breakoutMark?.attrs.width === undefined) {
            const mode = breakoutMark.attrs.mode;
            // if breakout is present on node, but page appearance is 'full width' force width to full width to maintain backwards compatibility
            const newWidth = isFullWidthEnabled || mode === 'full-width' ? (0, $aFUXX.akEditorFullWidthLayoutWidth) : (0, $aFUXX.akEditorCalculatedWideLayoutWidth);
            updatedTr = newTr.setNodeMarkup(pos, node.type, node.attrs, [
                breakout.create({
                    width: newWidth,
                    mode: mode
                })
            ]);
            if (isExpand) (0, $de180ab218c9eae9$export$cc135306f1c4ff36)({
                tr: updatedTr,
                node: node,
                pos: pos,
                isLivePage: true
            });
            updatedDocChanged = true;
        }
    }
    return {
        updatedTr: updatedTr,
        updatedDocChanged: updatedDocChanged
    };
};
const $0270481e4dcc36c1$export$ca33a310187a5f87 = new (0, $ks2lK.PluginKey)('breakout-resizing');
const $0270481e4dcc36c1$var$pluginState = {
    init () {
        return {
            breakoutNode: undefined,
            activeGuidelineLabel: undefined
        };
    },
    apply (tr, pluginState) {
        const meta = tr.getMeta($0270481e4dcc36c1$export$ca33a310187a5f87);
        if (meta) switch(meta.type){
            case 'UPDATE_BREAKOUT_NODE':
                return {
                    ...pluginState,
                    breakoutNode: meta.data
                };
            case 'UPDATE_ACTIVE_GUIDELINE_KEY':
                return {
                    ...pluginState,
                    activeGuidelineKey: meta.data.activeGuidelineKey
                };
            case 'CLEAR_ACTIVE_GUIDELINE_KEY':
                return {
                    ...pluginState,
                    activeGuidelineKey: undefined
                };
            case 'RESET_STATE':
                return {
                    activeGuidelineLabel: undefined,
                    breakoutNode: undefined
                };
        }
        return pluginState;
    }
};
const $0270481e4dcc36c1$export$522e3e76a011a0b1 = (api, getIntl, nodeViewPortalProviderAPI, options)=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $0270481e4dcc36c1$export$ca33a310187a5f87,
        state: $0270481e4dcc36c1$var$pluginState,
        props: {
            markViews: {
                breakout: (mark, view)=>{
                    return new (0, $ddcb98fa7f5afd3a$export$4fb684fac6535bde)(mark, view, api, getIntl, nodeViewPortalProviderAPI);
                }
            },
            handleKeyDown: (0, $fe1c4be5bd3b93b3$export$bab59f27a7347e45)(api)
        },
        appendTransaction (transactions, oldState, newState) {
            if (api?.editorViewMode?.sharedState.currentState()?.mode === 'view') return;
            let newTr = newState.tr;
            let hasDocChanged = false;
            const { expand: expand, codeBlock: codeBlock, layoutSection: layoutSection, syncBlock: syncBlock, bodiedSyncBlock: bodiedSyncBlock } = newState.schema.nodes;
            const breakoutResizableNodes = new Set([
                expand,
                codeBlock,
                layoutSection
            ]);
            if ((0, $iu6m9.editorExperiment)('platform_synced_block', true)) {
                breakoutResizableNodes.add(syncBlock);
                breakoutResizableNodes.add(bodiedSyncBlock);
            }
            const isFullWidthEnabled = !(options?.allowBreakoutButton === true);
            if ((0, $2pjJ5.isReplaceDocOperation)(transactions, oldState)) newState.doc.forEach((node, pos)=>{
                const { updatedTr: updatedTr, updatedDocChanged: updatedDocChanged } = $0270481e4dcc36c1$var$addBreakoutToResizableNode({
                    node: node,
                    pos: pos,
                    newState: newState,
                    newTr: newTr,
                    breakoutResizableNodes: breakoutResizableNodes,
                    isFullWidthEnabled: isFullWidthEnabled
                });
                newTr = updatedTr;
                hasDocChanged = hasDocChanged || updatedDocChanged;
            });
            else transactions.forEach((tr)=>{
                const isAddingResizableNodes = tr.steps.some((step)=>(0, $kTbzR.stepAddsOneOf)(step, breakoutResizableNodes));
                if (isAddingResizableNodes) {
                    const changedNodes = (0, $2pjJ5.getChangedNodes)(tr);
                    changedNodes.forEach(({ node: node, pos: pos })=>{
                        const { updatedTr: updatedTr, updatedDocChanged: updatedDocChanged } = $0270481e4dcc36c1$var$addBreakoutToResizableNode({
                            node: node,
                            pos: pos,
                            newState: newState,
                            newTr: newTr,
                            breakoutResizableNodes: breakoutResizableNodes,
                            isFullWidthEnabled: isFullWidthEnabled
                        });
                        newTr = updatedTr;
                        hasDocChanged = hasDocChanged || updatedDocChanged;
                    });
                }
            });
            if (hasDocChanged) return newTr;
        }
    });
};






var $8m4tT = parcelRequire("8m4tT");




const $60e85c3f0a757043$var$supportedNodesForBreakout = [
    'codeBlock',
    'layoutSection',
    'expand'
];
const $60e85c3f0a757043$var$supportedNodesForBreakoutAdvancedLayouts = [
    'codeBlock',
    'expand'
];
function $60e85c3f0a757043$export$2e02ca5ba4632d0a(node) {
    if ((0, $iu6m9.editorExperiment)('advanced_layouts', true)) return $60e85c3f0a757043$var$supportedNodesForBreakoutAdvancedLayouts.indexOf(node.type.name) !== -1;
    return $60e85c3f0a757043$var$supportedNodesForBreakout.indexOf(node.type.name) !== -1;
}


function $18e70c0aec555722$export$b3e00d6ce0602166(selection) {
    if (selection instanceof (0, $ks2lK.NodeSelection)) {
        const supportsBreakout = (0, $60e85c3f0a757043$export$2e02ca5ba4632d0a)(selection.node);
        if (supportsBreakout) return {
            pos: selection.from,
            start: selection.from,
            node: selection.node,
            // If a selected expand is in a doc, the depth of that expand is 0. Therefore
            // we don't need to subtract 1 or instantly return false if the depth is 0
            depth: selection.$anchor.depth
        };
    }
    const breakoutNode = (0, $8m4tT.findParentNode)((0, $60e85c3f0a757043$export$2e02ca5ba4632d0a))(selection);
    if (!breakoutNode || breakoutNode.depth === 0) // If this node doesn't exist or the only supporting node is the document
    // (with depth 0), then we're not inside a node that supports breakout
    return undefined;
    return {
        node: breakoutNode.node,
        start: breakoutNode.start,
        pos: breakoutNode.pos,
        depth: breakoutNode.depth - 1
    };
}



function $b725ae1e8e0afe9c$export$7293881dc293b44d(state) {
    const node = (0, $18e70c0aec555722$export$b3e00d6ce0602166)(state.selection);
    if (!node) return;
    const breakoutMark = node.node.marks.find((m)=>m.type.name === 'breakout');
    if (!breakoutMark) return;
    return breakoutMark.attrs.mode;
}





parcelRequire("42omo");


var $7x0qS = parcelRequire("7x0qS");


var $jwWgu = parcelRequire("jwWgu");







const $43857bfdf468c71f$var$GUIDELINE_KEY_TO_LAYOUT = {
    wide_left: 'wide',
    wide_right: 'wide',
    full_width_left: 'full-width',
    full_width_right: 'full-width',
    max_width_left: 'max',
    max_width_right: 'max'
};
const $43857bfdf468c71f$export$ee321e647107007d = ({ api: api, editorView: editorView, mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement })=>{
    const breakoutNode = (0, $b3YrF.useSharedPluginStateSelector)(api, 'breakout.breakoutNode');
    const activeGuidelineKey = (0, $b3YrF.useSharedPluginStateSelector)(api, 'breakout.activeGuidelineKey');
    if (!breakoutNode || !activeGuidelineKey) return null;
    const element = (0, $8m4tT.findDomRefAtPos)(breakoutNode.pos, editorView.domAtPos.bind(editorView));
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jwWgu.default), {
        target: element && element instanceof HTMLElement ? element : undefined,
        offset: [
            0,
            10
        ],
        alignY: "bottom",
        alignX: "center",
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        stick: true,
        forcePlacement: true,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7x0qS.ResizerBreakoutModeLabel), {
            layout: $43857bfdf468c71f$var$GUIDELINE_KEY_TO_LAYOUT[activeGuidelineKey]
        })
    });
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");


var $gmMgo = parcelRequire("gmMgo");









var $a4eZN = parcelRequire("a4eZN");


var $fJNzZ = parcelRequire("fJNzZ");











var $1kVeP = parcelRequire("1kVeP");


var $64M9v = parcelRequire("64M9v");


var $6fnsQ = parcelRequire("6fnsQ");


var $dTk3A = parcelRequire("dTk3A");















function $68cc69d900fe69e9$export$8adb30fdfe0dc8a3(isLivePage) {
    return (state, dispatch)=>{
        const node = (0, $18e70c0aec555722$export$b3e00d6ce0602166)(state.selection);
        if (!node) return false;
        const marks = node.node.marks.filter((m)=>m.type.name !== 'breakout');
        const tr = state.tr.setNodeMarkup(node.pos, node.node.type, node.node.attrs, marks);
        if (node.node.type === state.schema.nodes.expand) (0, $de180ab218c9eae9$export$322e23ed7d99ab86)(tr, node, isLivePage);
        else if (node.node.type === state.schema.nodes.codeBlock) {
            const newNode = tr.doc.nodeAt(node.pos);
            const oldNode = node.node;
            if (newNode) (0, $dNXVc.transferCodeBlockWrappedValue)(oldNode, newNode);
        }
        tr.setMeta('scrollIntoView', false);
        if (state.selection instanceof (0, $ks2lK.NodeSelection)) {
            if (state.selection.$anchor.pos === node.pos) tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, node.pos));
        }
        if (dispatch) dispatch(tr);
        return true;
    };
}










function $1a1107a596130634$export$835e4fcd1fc926bc(mode, isLivePage) {
    return (state, dispatch)=>{
        const node = (0, $18e70c0aec555722$export$b3e00d6ce0602166)(state.selection);
        if (!node) return false;
        const tr = state.tr.setNodeMarkup(node.pos, node.node.type, node.node.attrs, [
            state.schema.marks.breakout.create({
                mode: mode
            })
        ]);
        if (node.node.type === state.schema.nodes.expand) (0, $de180ab218c9eae9$export$322e23ed7d99ab86)(tr, node, isLivePage);
        else if (node.node.type === state.schema.nodes.codeBlock) {
            const newNode = tr.doc.nodeAt(node.pos);
            const oldNode = node.node;
            if (newNode) (0, $dNXVc.transferCodeBlockWrappedValue)(oldNode, newNode);
        }
        tr.setMeta('scrollIntoView', false);
        if (state.selection instanceof (0, $ks2lK.NodeSelection)) {
            if (state.selection.$anchor.pos === node.pos) tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, node.pos));
        }
        if (dispatch) dispatch(tr);
        return true;
    };
}




function $069dacd057fce6fd$export$caf83e14f3995804(state) {
    if (!state.schema.marks.breakout) return false;
    const supportedNodeParent = (0, $18e70c0aec555722$export$b3e00d6ce0602166)(state.selection);
    if (!supportedNodeParent) return false;
    // At the moment we can only breakout when the depth is 0, ie. doc is the only node
    // that supports breakout. This *could* change though.
    const parent = state.selection.$from.node(supportedNodeParent.depth);
    return parent.type.allowsMarkType(state.schema.marks.breakout);
}



const $a9ff937bba932aa9$var$toolbarButtonWrapperStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& button': {
        background: `var(--ds-background-neutral, ${(0, $6fnsQ.N20A)})`,
        color: `var(--ds-icon, ${(0, $6fnsQ.N300)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':hover': {
            background: `var(--ds-background-neutral-hovered, ${(0, $6fnsQ.B300)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            color: `${"var(--ds-icon, white)"} !important`
        }
    }
});
const $a9ff937bba932aa9$var$toolbarButtonNarrowScreenStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-imported-style-values,  @atlaskit/design-system/no-nested-styles,  @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    [`@container editor-area (max-width: ${0, $aFUXX.akEditorFullPageNarrowBreakout}px)`]: {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button': {
            visibility: 'hidden',
            opacity: 0
        }
    }
});
function $a9ff937bba932aa9$var$getBreakoutNodeElement(pluginState, selection, editorView) {
    if (!pluginState.breakoutNode) return undefined;
    if (selection instanceof (0, $ks2lK.NodeSelection) && (0, $60e85c3f0a757043$export$2e02ca5ba4632d0a)(selection.node)) // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return (0, $8m4tT.findDomRefAtPos)(selection.from, editorView.domAtPos.bind(editorView));
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return (0, $8m4tT.findParentDomRefOfType)(pluginState.breakoutNode.node.type, editorView.domAtPos.bind(editorView))(selection);
}
const $a9ff937bba932aa9$var$LayoutButton = ({ intl: { formatMessage: formatMessage }, mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, editorView: editorView, isLivePage: isLivePage, isBreakoutNodePresent: isBreakoutNodePresent, breakoutMode: breakoutModeProp, api: api })=>{
    const handleClick = (0, $42omo.useCallback)((breakoutMode)=>{
        if ((0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) && !editorView) return;
        // Remove ! during platform_editor_hydratable_ui cleanup
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { state: state, dispatch: dispatch } = editorView;
        const breakoutNode = (0, $c0a482e4157215ff$export$f05434c51e3762e)(state)?.breakoutNode;
        if ([
            'wide',
            'full-width'
        ].indexOf(breakoutMode) !== -1) {
            (0, $1a1107a596130634$export$835e4fcd1fc926bc)(breakoutMode, isLivePage)(state, dispatch);
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).CHANGED_BREAKOUT_MODE,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ELEMENT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    mode: breakoutMode,
                    nodeType: breakoutNode?.node.type.name
                }
            });
        } else {
            (0, $68cc69d900fe69e9$export$8adb30fdfe0dc8a3)(isLivePage)(state, dispatch);
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).CHANGED_BREAKOUT_MODE,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ELEMENT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    mode: 'center',
                    nodeType: breakoutNode?.node.type.name
                }
            });
        }
    }, [
        api?.analytics?.actions,
        editorView,
        isLivePage
    ]);
    if ((0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) && !editorView) return null;
    // Remove ! during platform_editor_hydratable_ui cleanup
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (!isBreakoutNodePresent || !(0, $069dacd057fce6fd$export$caf83e14f3995804)(editorView.state)) return null;
    const breakoutMode = breakoutModeProp;
    const titleMessage = (0, $fJNzZ.getTitle)(breakoutMode);
    const title = formatMessage(titleMessage);
    const nextBreakoutMode = (0, $fJNzZ.getNextBreakoutMode)(breakoutMode);
    const belowOtherPopupsZIndex = (0, $dTk3A.layers).layer() - 1;
    // Remove ! during platform_editor_hydratable_ui cleanup
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const pluginState = (0, $c0a482e4157215ff$export$f05434c51e3762e)(editorView.state);
    if (!pluginState) return null;
    // Remove ! during platform_editor_hydratable_ui cleanup
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    let element = $a9ff937bba932aa9$var$getBreakoutNodeElement(pluginState, editorView.state.selection, editorView);
    if (!element) return null;
    const closestEl = element.querySelector(`.${(0, $fe361930a2595c94$export$c21a3b023fccd534).BREAKOUT_MARK_DOM}`);
    if (closestEl && closestEl.firstChild) // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    element = closestEl.firstChild;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $jwWgu.default), {
        ariaLabel: title,
        target: element,
        offset: [
            5,
            0
        ],
        alignY: "start",
        alignX: "end",
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        stick: true,
        forcePlacement: true,
        zIndex: belowOtherPopupsZIndex
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $a9ff937bba932aa9$var$toolbarButtonWrapperStyles,
            (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true) && $a9ff937bba932aa9$var$toolbarButtonNarrowScreenStyles
        ]
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a4eZN.default), {
        title: title,
        testId: titleMessage.id,
        onClick: ()=>handleClick(nextBreakoutMode),
        iconBefore: breakoutMode === 'full-width' ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($64M9v))), {
            label: title,
            spacing: "spacious"
        }) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1kVeP))), {
            label: title,
            spacing: "spacious"
        })
    })));
};
$a9ff937bba932aa9$var$LayoutButton.displayName = 'LayoutButton';
var $a9ff937bba932aa9$export$2e2bcd8739ae039 = (0, $gmMgo.default)($a9ff937bba932aa9$var$LayoutButton);


class $7cd6ea70a0939c4e$var$BreakoutView {
    constructor(/**
   * Note: this is actually a PMMark -- however our version
   * of the prosemirror and prosemirror types mean using PMNode
   * is not problematic.
   */ mark, view, appearance){
        this.dom = void 0;
        this.contentDOM = void 0;
        this.view = void 0;
        this.mark = void 0;
        const dom = document.createElement('div');
        const contentDOM = document.createElement('div');
        contentDOM.className = (0, $fe361930a2595c94$export$c21a3b023fccd534).BREAKOUT_MARK_DOM;
        contentDOM.setAttribute('data-testid', 'ak-editor-breakout-mark-dom');
        dom.className = (0, $fe361930a2595c94$export$c21a3b023fccd534).BREAKOUT_MARK;
        dom.setAttribute('data-layout', mark.attrs.mode);
        dom.setAttribute('data-testid', 'ak-editor-breakout-mark');
        dom.appendChild(contentDOM);
        dom.style.transform = 'none';
        dom.style.display = 'flex';
        dom.style.justifyContent = 'center';
        contentDOM.style.transition = `min-width 0.5s ${0, $aFUXX.akEditorSwoopCubicBezier}`;
        if ((0, $iu6m9.editorExperiment)('advanced_layouts', true)) {
            if (mark.attrs.width) contentDOM.style.minWidth = `min(${mark.attrs.width}px, calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding)))`;
            else {
                // original breakout algorithm is in calcBreakoutWidth from platform/packages/editor/editor-common/src/utils/breakout.ts
                if (mark.attrs.mode === 'full-width') contentDOM.style.minWidth = `max(var(--ak-editor--line-length), min(var(--ak-editor--full-width-layout-width), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
                if (mark.attrs.mode === 'wide') {
                    if (appearance && appearance === 'full-width' && (0, $iu6m9.editorExperiment)('single_column_layouts', true) && true) contentDOM.style.minWidth = `min(var(--ak-editor--breakout-wide-layout-width), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding)))`;
                    else contentDOM.style.minWidth = `max(var(--ak-editor--line-length), min(var(--ak-editor--breakout-wide-layout-width), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
                }
            }
        } else {
            // original breakout algorithm is in calcBreakoutWidth from platform/packages/editor/editor-common/src/utils/breakout.ts
            if (mark.attrs.mode === 'full-width') contentDOM.style.minWidth = `max(var(--ak-editor--line-length), min(var(--ak-editor--full-width-layout-width), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
            if (mark.attrs.mode === 'wide') contentDOM.style.minWidth = `max(var(--ak-editor--line-length), min(var(--ak-editor--breakout-wide-layout-width), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
        }
        this.dom = dom;
        this.mark = mark;
        this.view = view;
        this.contentDOM = contentDOM;
    }
}
function $7cd6ea70a0939c4e$var$shouldPluginStateUpdate(newBreakoutNode, currentBreakoutNode) {
    if (newBreakoutNode && currentBreakoutNode) return newBreakoutNode !== currentBreakoutNode;
    return newBreakoutNode || currentBreakoutNode ? true : false;
}
function $7cd6ea70a0939c4e$var$createPlugin(api, { dispatch: dispatch }, appearance) {
    return new (0, $1S4f7.SafePlugin)({
        state: {
            init () {
                return {
                    breakoutNode: undefined,
                    activeGuidelineKey: undefined
                };
            },
            apply (tr, pluginState) {
                const breakoutNode = (0, $18e70c0aec555722$export$b3e00d6ce0602166)(tr.selection);
                if ($7cd6ea70a0939c4e$var$shouldPluginStateUpdate(breakoutNode, pluginState.breakoutNode)) {
                    const nextPluginState = {
                        ...pluginState,
                        breakoutNode: breakoutNode
                    };
                    dispatch((0, $c0a482e4157215ff$export$18d4026d1ea86bb1), nextPluginState);
                    return nextPluginState;
                }
                return pluginState;
            }
        },
        key: (0, $c0a482e4157215ff$export$18d4026d1ea86bb1),
        props: {
            nodeViews: {
                // Note: When we upgrade to prosemirror 1.27.2 -- we should
                // move this to markViews.
                // See the following link for more details:
                // https://prosemirror.net/docs/ref/#view.EditorProps.nodeViews.
                breakout: (mark, view)=>{
                    return new $7cd6ea70a0939c4e$var$BreakoutView(mark, view, appearance);
                }
            }
        }
    });
}
const $7cd6ea70a0939c4e$var$LayoutButtonWrapper = ({ api: api, editorView: editorView, boundariesElement: boundariesElement, scrollableElement: scrollableElement, mountPoint: mountPoint })=>{
    const { editorDisabled: editorDisabled, isDragging: isDragging, isPMDragging: isPMDragging, mode: mode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'editorViewMode',
        'editorDisabled',
        'blockControls'
    ], (states)=>({
            isDragging: states.blockControlsState?.isDragging,
            isPMDragging: states.blockControlsState?.isPMDragging,
            mode: states.editorViewModeState?.mode,
            editorDisabled: states.editorDisabledState?.editorDisabled
        }));
    const [breakoutNodePresent, setBreakoutNodePresent] = (0, $42omo.useState)(false);
    const [breakoutMode, setBreakoutMode] = (0, $42omo.useState)((0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) && !editorView ? undefined : // Remove ! during platform_editor_hydratable_ui cleanup
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $b725ae1e8e0afe9c$export$7293881dc293b44d)(editorView.state));
    (0, $6qdjm.usePluginStateEffect)(api, [
        'breakout'
    ], ({ breakoutState: breakoutState })=>{
        if ((0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) && !editorView) return;
        if (breakoutState?.breakoutNode && !breakoutNodePresent) setBreakoutNodePresent(true);
        if (!breakoutState?.breakoutNode && breakoutNodePresent) setBreakoutNodePresent(false);
        // Remove ! during platform_editor_hydratable_ui cleanup
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const nextBreakoutMode = (0, $b725ae1e8e0afe9c$export$7293881dc293b44d)(editorView.state);
        if (nextBreakoutMode !== breakoutMode) setBreakoutMode(nextBreakoutMode);
    });
    const interactionState = (0, $b3YrF.useSharedPluginStateSelector)(api, 'interaction.interactionState');
    if (interactionState === 'hasNotHadInteraction') return null;
    if (isDragging || isPMDragging) {
        if ((0, $iu6m9.editorExperiment)('advanced_layouts', true)) return null;
    }
    const isViewMode = mode === 'view';
    const isEditMode = mode === 'edit';
    return !isViewMode && editorDisabled === false ? /*#__PURE__*/ (0, $l998X.jsx)((0, $a9ff937bba932aa9$export$2e2bcd8739ae039), {
        editorView: editorView,
        mountPoint: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        isLivePage: isEditMode,
        isBreakoutNodePresent: breakoutNodePresent,
        breakoutMode: breakoutMode,
        api: api
    }) : null;
};
const $7cd6ea70a0939c4e$export$f56f43f1e6905418 = ({ config: options, api: api })=>({
        name: 'breakout',
        pmPlugins () {
            if ((0, $1oCLl.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) return [
                {
                    name: 'breakout-resizing',
                    plugin: ({ getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(0, $0270481e4dcc36c1$export$522e3e76a011a0b1)(api, getIntl, nodeViewPortalProviderAPI, options)
                }
            ];
            return [
                {
                    name: 'breakout',
                    plugin: (props)=>$7cd6ea70a0939c4e$var$createPlugin(api, props, options?.appearance)
                }
            ];
        },
        marks () {
            return [
                {
                    name: 'breakout',
                    mark: (0, $gWpm5.breakout)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return {
                breakoutNode: undefined
            };
            if ((0, $1oCLl.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) {
                const resizingPluginState = (0, $0270481e4dcc36c1$export$ca33a310187a5f87).getState(editorState);
                if (!resizingPluginState) return {
                    breakoutNode: undefined,
                    activeGuidelineKey: undefined
                };
                return resizingPluginState;
            }
            const pluginState = (0, $c0a482e4157215ff$export$18d4026d1ea86bb1).getState(editorState);
            if (!pluginState) return {
                breakoutNode: undefined
            };
            return pluginState;
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
            if (!editorView) return null;
            if ((0, $1oCLl.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $43857bfdf468c71f$export$ee321e647107007d), {
                api: api,
                editorView: editorView,
                mountPoint: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement
            });
            // This is a bit crappy, but should be resolved once we move to a static schema.
            if (options && !options.allowBreakoutButton) return null;
            return /*#__PURE__*/ (0, $l998X.jsx)($7cd6ea70a0939c4e$var$LayoutButtonWrapper, {
                api: api,
                mountPoint: popupsMountPoint,
                editorView: editorView,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement
            });
        }
    });
module.exports["breakoutPlugin"] = $7cd6ea70a0939c4e$export$f56f43f1e6905418;

});

parcelRegister("25jxS", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ var $659c2425e3733293$export$d173f08296df529 = /*#__PURE__*/ function(NCS_STORAGE) {
    NCS_STORAGE["NCS_STORAGE_CLIENT_KEY"] = "ncs-session-step-metrics-storage";
    NCS_STORAGE["NCS_SESSION_STEP_METRICS"] = "ncsSessionStepMetrics";
    NCS_STORAGE["NCS_ACTIVE_SESSIONS"] = "ncsActiveSessions";
    return NCS_STORAGE;
}({});
module.exports["NCS_STORAGE"] = $659c2425e3733293$export$d173f08296df529;

});

parcelRegister("1nZXu", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $dh538 = parcelRequire("dh538");


var $1nZXu = parcelRequire("1nZXu");

const $b87598ef7fd9944b$export$6fbe08f3dbfbccb2 = (tr)=>tr.setMeta((0, $1nZXu.pluginKey), {
        changed: true
    });


const $1751bdac665e8ba7$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('contextPanelPluginKey');
function $1751bdac665e8ba7$var$contextPanelPluginFactory(contextPanels, dispatch) {
    return new (0, $1S4f7.SafePlugin)({
        key: $1751bdac665e8ba7$export$18d4026d1ea86bb1,
        state: {
            init (_config, state) {
                return {
                    handlers: contextPanels,
                    contents: contextPanels.map((panelContent)=>panelContent(state))
                };
            },
            apply (tr, pluginState, _oldState, newState) {
                let newPluginState = pluginState;
                const meta = tr.getMeta($1751bdac665e8ba7$export$18d4026d1ea86bb1);
                if (tr.docChanged || tr.selectionSet || meta && meta.changed) {
                    const newContents = pluginState.handlers.map((panelContent)=>panelContent(newState));
                    const contentsLengthChanged = newContents.length !== newPluginState.contents.length;
                    const contentChanged = newContents.some((node, index)=>newPluginState.contents[index] !== node);
                    if (contentsLengthChanged || contentChanged) newPluginState = {
                        ...newPluginState,
                        contents: newContents
                    };
                }
                if (newPluginState !== pluginState) dispatch($1751bdac665e8ba7$export$18d4026d1ea86bb1, newPluginState);
                return newPluginState;
            }
        }
    });
}
const $1751bdac665e8ba7$export$773ed6f43b4b1d8f = ({ config: config })=>({
        name: 'contextPanel',
        actions: {
            applyChange: (0, $b87598ef7fd9944b$export$6fbe08f3dbfbccb2),
            showPanel: config?.objectSideBar.showPanel && (0, $dh538.fg)('platform_editor_ai_object_sidebar_injection') ? (panel, behavior, panelWidth)=>config.objectSideBar.showPanel(panel, behavior, panelWidth) : undefined,
            closePanel: config?.objectSideBar.closePanel && (0, $dh538.fg)('platform_editor_ai_object_sidebar_injection') ? ()=>config.objectSideBar.closePanel() : undefined,
            closePanelById: config?.objectSideBar.closePanelById && (0, $dh538.fg)('platform_editor_ai_object_sidebar_injection') ? (id)=>config.objectSideBar.closePanelById(id) : undefined
        },
        getSharedState (state) {
            if (!state) return undefined;
            const { contents: contents } = $1751bdac665e8ba7$export$18d4026d1ea86bb1.getState(state) ?? {};
            return {
                contents: contents
            };
        },
        pmPlugins (contextPanels = []) {
            return [
                {
                    name: 'contextPanel',
                    plugin: ({ dispatch: dispatch })=>$1751bdac665e8ba7$var$contextPanelPluginFactory(contextPanels.filter(Boolean), dispatch)
                }
            ];
        }
    });
module.exports["pluginKey"] = $1751bdac665e8ba7$export$18d4026d1ea86bb1;
module.exports["contextPanelPlugin"] = $1751bdac665e8ba7$export$773ed6f43b4b1d8f;

});

parcelRegister("dtCIm", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $1S4f7 = parcelRequire("1S4f7");


var $zMjD6 = parcelRequire("zMjD6");


var $dh538 = parcelRequire("dh538");


var $iu6m9 = parcelRequire("iu6m9");


var $ks2lK = parcelRequire("ks2lK");


var $ftzrq = parcelRequire("ftzrq");


var $1oCLl = parcelRequire("1oCLl");


var $dZ8uq = parcelRequire("dZ8uq");

var $0ea83d7668f10440$export$29dff82773c5f10f = /*#__PURE__*/ function(FindReplaceActionTypes) {
    FindReplaceActionTypes["ACTIVATE"] = "ACTIVATE";
    FindReplaceActionTypes["FIND"] = "FIND";
    FindReplaceActionTypes["UPDATE_DECORATIONS"] = "UPDATE_DECORATIONS";
    FindReplaceActionTypes["FIND_NEXT"] = "FIND_NEXT";
    FindReplaceActionTypes["FIND_PREVIOUS"] = "FIND_PREVIOUS";
    FindReplaceActionTypes["REPLACE"] = "REPLACE";
    FindReplaceActionTypes["REPLACE_ALL"] = "REPLACE_ALL";
    FindReplaceActionTypes["CANCEL"] = "CANCEL";
    FindReplaceActionTypes["BLUR"] = "BLUR";
    FindReplaceActionTypes["TOGGLE_MATCH_CASE"] = "TOGGLE_MATCH_CASE";
    return FindReplaceActionTypes;
}({});



var $lkJUe = parcelRequire("lkJUe");

var $kTbzR = parcelRequire("kTbzR");























const $e8b1b385096c80fd$export$e7697da71e34f0a6 = new (0, $ks2lK.PluginKey)('findReplace');


const $797013ea47834520$export$d4c72bab9d6cc13a = {
    isActive: false,
    shouldFocus: false,
    findText: '',
    replaceText: '',
    index: 0,
    matches: [],
    decorationSet: (0, $ftzrq.DecorationSet).empty,
    shouldMatchCase: false
};
const $797013ea47834520$export$ae829ec7b2625219 = (dispatch, getIntl, api)=>{
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $e8b1b385096c80fd$export$e7697da71e34f0a6),
        state: (0, $68a609e009bbcefe$export$656c7661095efe2e)(dispatch, ()=>(0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) || (0, $1oCLl.expValEquals)('platform_editor_toggle_expand_on_match_found', 'isEnabled', true) ? {
                ...$797013ea47834520$export$d4c72bab9d6cc13a,
                getIntl: getIntl,
                api: api
            } : {
                ...$797013ea47834520$export$d4c72bab9d6cc13a
            }),
        props: {
            decorations (state) {
                const { isActive: isActive, findText: findText, decorationSet: decorationSet } = (0, $68a609e009bbcefe$export$f05434c51e3762e)(state);
                if (isActive && findText) return decorationSet;
            }
        }
    });
};







const $ddd7d9e0e4897838$var$reducer = (getInitialState)=>(state, action)=>{
        switch(action.type){
            case (0, $0ea83d7668f10440$export$29dff82773c5f10f).ACTIVATE:
            case (0, $0ea83d7668f10440$export$29dff82773c5f10f).FIND:
                return {
                    ...state,
                    isActive: true,
                    shouldFocus: action.type === (0, $0ea83d7668f10440$export$29dff82773c5f10f).ACTIVATE,
                    findText: action.findText !== undefined ? action.findText : state.findText,
                    matches: action.matches || state.matches,
                    index: action.index !== undefined ? action.index : state.index
                };
            case (0, $0ea83d7668f10440$export$29dff82773c5f10f).UPDATE_DECORATIONS:
                return {
                    ...state,
                    decorationSet: action.decorationSet
                };
            case (0, $0ea83d7668f10440$export$29dff82773c5f10f).FIND_NEXT:
                return {
                    ...state,
                    index: action.index,
                    decorationSet: action.decorationSet
                };
            case (0, $0ea83d7668f10440$export$29dff82773c5f10f).FIND_PREVIOUS:
                return {
                    ...state,
                    index: action.index,
                    decorationSet: action.decorationSet
                };
            case (0, $0ea83d7668f10440$export$29dff82773c5f10f).REPLACE:
            case (0, $0ea83d7668f10440$export$29dff82773c5f10f).REPLACE_ALL:
                return {
                    ...state,
                    replaceText: action.replaceText,
                    decorationSet: action.decorationSet,
                    matches: action.matches,
                    index: action.index
                };
            case (0, $0ea83d7668f10440$export$29dff82773c5f10f).CANCEL:
                const { getIntl: getIntl, api: api } = state;
                return (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? {
                    ...getInitialState(),
                    getIntl: getIntl,
                    api: api
                } : getInitialState();
            case (0, $0ea83d7668f10440$export$29dff82773c5f10f).BLUR:
                return {
                    ...state,
                    shouldFocus: false
                };
            case (0, $0ea83d7668f10440$export$29dff82773c5f10f).TOGGLE_MATCH_CASE:
                return {
                    ...state,
                    shouldMatchCase: !state.shouldMatchCase
                };
            default:
                return state;
        }
    };
var $ddd7d9e0e4897838$export$2e2bcd8739ae039 = $ddd7d9e0e4897838$var$reducer;



var $2daQU = parcelRequire("2daQU");


var $dIxHZ = parcelRequire("dIxHZ");








var $bqMS3 = parcelRequire("bqMS3");


var $6mYMS = parcelRequire("6mYMS");





var $8z9j5 = parcelRequire("8z9j5");

/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
const $a2f418c832d6976a$export$cec6db4af40340f0 = 'search-match';
const $a2f418c832d6976a$export$a19ecadc9ecc39b1 = 'search-match-text';
const $a2f418c832d6976a$export$bf208a338b2a2f1f = 'selected-search-match';
const $a2f418c832d6976a$export$bb09fa712812841f = 'search-match-block';
const $a2f418c832d6976a$export$99146b4c1ad5837a = 'search-match-block-selected';
const $a2f418c832d6976a$export$6cc90c491f952538 = 'search-match-dark';
const $a2f418c832d6976a$export$2414358ab66f419a = 'search-match-expand-title';


function $68ba69b3f7b9f0e7$export$93850515e4be65a3(selection) {
    let text = '';
    const selectedContent = selection.content().content;
    for(let i = 0; i < selectedContent.childCount; i++)text += selectedContent.child(i).textContent;
    return text;
}
const $68ba69b3f7b9f0e7$export$2393fad6cd7faeee = (selectedIndex, matches)=>matches.map(({ start: start, end: end, canReplace: canReplace, nodeType: nodeType }, i)=>$68ba69b3f7b9f0e7$export$83df86cadabd260({
            start: start,
            end: end,
            canReplace: canReplace,
            nodeType: nodeType
        }, i === selectedIndex));
const $68ba69b3f7b9f0e7$var$isElement = (nodeType)=>[
        'blockCard',
        'embedCard',
        'inlineCard',
        'status',
        'mention',
        'date'
    ].includes(nodeType || '');
const $68ba69b3f7b9f0e7$var$isExpandTitle = (match)=>[
        'expand',
        'nestedExpand'
    ].includes(match.nodeType || '') && !match.canReplace;
const $68ba69b3f7b9f0e7$export$83df86cadabd260 = (match, isSelected)=>{
    const { start: start, end: end, nodeType: nodeType } = match;
    if ((0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true)) {
        const { colorMode: colorMode } = (0, $8z9j5.default)();
        if ($68ba69b3f7b9f0e7$var$isElement(nodeType)) {
            const className = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $a2f418c832d6976a$export$bb09fa712812841f), {
                [(0, $a2f418c832d6976a$export$99146b4c1ad5837a)]: isSelected,
                [(0, $a2f418c832d6976a$export$6cc90c491f952538)]: colorMode === 'dark'
            });
            return (0, $ftzrq.Decoration).node(start, end, {
                class: className
            });
        } else if ($68ba69b3f7b9f0e7$var$isExpandTitle(match)) {
            const className = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $a2f418c832d6976a$export$2414358ab66f419a), {
                [(0, $a2f418c832d6976a$export$bf208a338b2a2f1f)]: isSelected,
                [(0, $a2f418c832d6976a$export$6cc90c491f952538)]: colorMode === 'dark'
            });
            return (0, $ftzrq.Decoration).node(start, end, {
                class: className
            });
        } else {
            const className = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $a2f418c832d6976a$export$a19ecadc9ecc39b1), {
                [(0, $a2f418c832d6976a$export$bf208a338b2a2f1f)]: isSelected,
                [(0, $a2f418c832d6976a$export$6cc90c491f952538)]: colorMode === 'dark'
            });
            return (0, $ftzrq.Decoration).inline(start, end, {
                class: className
            });
        }
    } else {
        let className = (0, $a2f418c832d6976a$export$cec6db4af40340f0);
        if (isSelected) className += ` ${0, $a2f418c832d6976a$export$bf208a338b2a2f1f}`;
        return (0, $ftzrq.Decoration).inline(start, end, {
            class: className
        });
    }
};
function $68ba69b3f7b9f0e7$export$f4585c00f32d9257({ content: content, searchText: searchText, shouldMatchCase: shouldMatchCase, contentIndex: contentIndex = 0, getIntl: getIntl, api: api }) {
    const matches = [];
    const searchTextLength = searchText.length;
    let textGrouping = null;
    const collectTextMatch = (textGrouping)=>{
        if (!textGrouping) return;
        let { text: text } = textGrouping;
        const { pos: relativePos } = textGrouping;
        const pos = contentIndex + relativePos;
        if (!shouldMatchCase) {
            searchText = searchText.toLowerCase();
            text = text.toLowerCase();
        }
        let index = text.indexOf(searchText);
        while(index !== -1){
            // Find the next substring from the end of the first, so that they don't overlap
            const end = index + searchTextLength;
            // Add the substring index to the position of the node
            matches.push({
                start: pos + index,
                end: pos + end,
                canReplace: (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? true : undefined,
                nodeType: (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? 'text' : undefined
            });
            index = text.indexOf(searchText, end);
        }
    };
    const collectNodeMatch = (textGrouping, node)=>{
        if (!textGrouping) return;
        const { pos: pos } = textGrouping;
        let { text: text } = textGrouping;
        if (node.type.name === 'status' && shouldMatchCase) text = text.toUpperCase();
        else if (!shouldMatchCase) {
            text = text.toLowerCase();
            searchText = searchText.toLowerCase();
        }
        const index = text.indexOf(searchText);
        if (index !== -1) matches.push({
            start: pos,
            end: pos + node.nodeSize,
            canReplace: false,
            nodeType: node.type.name
        });
    };
    const collectCardTitleMatch = (node, pos)=>{
        const cards = api?.card?.sharedState.currentState()?.cards;
        if (cards) {
            const relevantCard = cards.find((card)=>card.url === node.attrs.url);
            const title = relevantCard?.title;
            if (relevantCard) {
                if (title) collectNodeMatch({
                    text: title,
                    pos: pos
                }, node);
                else // when there is no title, e.g. in an error case like unauthorized
                // the link card just shows the entire url as the title in inline card
                if (node.type.name === 'inlineCard') collectNodeMatch({
                    text: node.attrs.url,
                    pos: pos
                }, node);
            }
        }
    };
    if (searchTextLength > 0) {
        content.descendants((node, pos)=>{
            if (node.isText) {
                if (textGrouping === null) textGrouping = {
                    text: node.text,
                    pos: pos
                };
                else textGrouping.text = textGrouping.text + node.text;
            } else {
                collectTextMatch(textGrouping);
                textGrouping = null;
                if ((0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true)) switch(node.type.name){
                    case 'status':
                        collectNodeMatch({
                            text: node.attrs.text,
                            pos: pos
                        }, node);
                        break;
                    case 'date':
                        collectNodeMatch({
                            text: (0, $dIxHZ.timestampToString)(node.attrs.timestamp, getIntl ? getIntl() : null),
                            pos: pos
                        }, node);
                        break;
                    case 'expand':
                    case 'nestedExpand':
                        collectNodeMatch({
                            text: node.attrs.title,
                            pos: pos
                        }, node);
                        break;
                    case 'mention':
                        let text;
                        if (node.attrs.text) text = node.attrs.text;
                        else {
                            // the text may be sanitised from the node for privacy reasons
                            // so we need to use the mentionProvider to resolve it
                            const mentionProvider = api?.mention?.sharedState.currentState()?.mentionProvider;
                            if ((0, $bqMS3.isResolvingMentionProvider)(mentionProvider)) {
                                const nameDetail = mentionProvider.resolveMentionName(node.attrs.id);
                                if ((0, $6mYMS.isPromise)(nameDetail)) text = '@...';
                                else if (nameDetail.status === (0, $6mYMS.MentionNameStatus).OK) text = `@${nameDetail.name || ''}`;
                                else text = '@_|unknown|_';
                            }
                        }
                        if (text) collectNodeMatch({
                            text: text,
                            pos: pos
                        }, node);
                        break;
                    case 'inlineCard':
                    case 'blockCard':
                    case 'embedCard':
                        collectCardTitleMatch(node, pos);
                        break;
                    default:
                        break;
                }
            }
        });
        // if there's a dangling text grouping and no non-text node to trigger collectTextMatch, manually collectTextMatch
        if (textGrouping) collectTextMatch(textGrouping);
    }
    return matches;
}
function $68ba69b3f7b9f0e7$export$6df7393992287695(selectionPos, matches) {
    const forwardMatchIndex = matches.findIndex((match)=>match.start >= selectionPos);
    if (forwardMatchIndex === -1) // if there are no forward matches, it must be the last match
    return matches.length > 0 ? matches.length - 1 : 0;
    else if (forwardMatchIndex === 0) return forwardMatchIndex;
    const backwardMatchIndex = forwardMatchIndex - 1;
    const forwardMatchPos = matches[forwardMatchIndex].start;
    const backwardMatchPos = matches[backwardMatchIndex].start;
    if (forwardMatchPos - selectionPos < selectionPos - backwardMatchPos) return forwardMatchIndex;
    else return backwardMatchIndex;
}
function $68ba69b3f7b9f0e7$export$1b7f6169b65103e3(selectionPos, matches, backward = false) {
    if (backward) {
        let matchIndex = matches.findIndex((match)=>match.start >= selectionPos) - 1;
        if (matchIndex < 0) matchIndex = matches.length - 1; // wrap around from the end
        return matchIndex;
    }
    return Math.max(matches.findIndex((match)=>match.start >= selectionPos), 0);
}
const $68ba69b3f7b9f0e7$export$7db462fe6be63e0 = (currentIndex, total)=>(currentIndex + 1) % total;
const $68ba69b3f7b9f0e7$export$9041fedbf960fcef = (currentIndex, total)=>(currentIndex - 1 + total) % total;
const $68ba69b3f7b9f0e7$export$91f639c3a212feb2 = (selection, doc, index, matches, offset = 0)=>{
    if (matches[index]) {
        if ($68ba69b3f7b9f0e7$var$isExpandTitle(matches[index])) return (0, $ks2lK.NodeSelection).create(doc, matches[index].start);
        return (0, $ks2lK.TextSelection).create(doc, matches[index].start + offset);
    }
    return selection;
};
const $68ba69b3f7b9f0e7$export$e2521c2c8f72064b = (decorationSet, match)=>{
    if (!match) return;
    const decorations = decorationSet.find(match.start, match.end);
    return decorations.length ? decorations.find(// decorationSet.find() returns any decorations that touch the specifided
    // positions, but we want to be stricter
    (decoration)=>decoration.from === match.start && decoration.to === match.end) : undefined;
};
const $68ba69b3f7b9f0e7$export$ede9cf72df9a3d38 = (decorationSet, decorationsToRemove, doc)=>{
    const prevDecorations = decorationSet.find();
    // it is essential that we copy the decorations otherwise in some rare cases
    // prosemirror-view will update our decorationsToRemove array to contain nulls
    // instead of Decorations which ruins our check for lost decorations below
    decorationSet = decorationSet.remove(decorationsToRemove.map((decoration)=>// copy exists but isn't on the type definition
        decoration.copy(decoration.from, decoration.to)));
    const newDecorations = decorationSet.find();
    // there is a bug in prosemirror-view where it can't cope with deleting inline
    // decorations from a set in some cases (where there are multiple levels of nested
    // children arrays), and it deletes more decorations than it should
    const lostDecorations = $68ba69b3f7b9f0e7$export$3d30681780612963(decorationsToRemove, prevDecorations, newDecorations);
    if (lostDecorations.length > 0) decorationSet = decorationSet.add(doc, lostDecorations);
    return decorationSet;
};
const $68ba69b3f7b9f0e7$export$b5b5304233807f24 = (decorationSet, matches, doc)=>{
    const decorationsToRemove = matches.filter((match)=>!!match).map((match)=>$68ba69b3f7b9f0e7$export$e2521c2c8f72064b(decorationSet, match));
    decorationsToRemove.forEach((decoration)=>{
        if (decoration) decorationSet = $68ba69b3f7b9f0e7$export$ede9cf72df9a3d38(decorationSet, [
            decoration
        ], doc);
    });
    return decorationSet;
};
const $68ba69b3f7b9f0e7$export$3d30681780612963 = (decorationsToRemove, prevDecorations, newDecorations)=>{
    let lostDecorations = [];
    if (prevDecorations.length - decorationsToRemove.length > newDecorations.length) {
        const position = decorationsToRemove.length > 0 ? decorationsToRemove[0].from : 0;
        const prevDecorationsStartIdx = $68ba69b3f7b9f0e7$export$7e4c53b0062d9305(prevDecorations, position);
        const newDecorationsStartIdx = $68ba69b3f7b9f0e7$export$7e4c53b0062d9305(newDecorations, position);
        const startIdx = Math.min(prevDecorationsStartIdx, newDecorationsStartIdx);
        const prevDecorationsToCheck = prevDecorations.slice(startIdx);
        const newDecorationsToCheck = newDecorations.slice(startIdx);
        const uniqueInPrev = [];
        const numToFind = prevDecorationsToCheck.length - newDecorationsToCheck.length;
        let foundAll = false;
        let newDecorationsIdxOffset = 0;
        for(let i = 0; i < prevDecorationsToCheck.length; i++){
            const prevDecoration = prevDecorationsToCheck[i];
            // this was a legit removal, skip and continue
            if (decorationsToRemove.find((decoration)=>decoration.from === prevDecoration.from)) {
                newDecorationsIdxOffset -= 1;
                continue;
            }
            let j = i + newDecorationsIdxOffset;
            // this is a lost decoration
            if (j >= newDecorationsToCheck.length) {
                uniqueInPrev.push(prevDecoration);
                if (uniqueInPrev.length === numToFind) foundAll = true;
            }
            for(; j < newDecorationsToCheck.length; j++){
                const newDecoration = newDecorationsToCheck[j];
                // decoration found in both arrays, skip and continue
                if (prevDecoration.from === newDecoration.from) break;
                // this is a lost decoration
                if (newDecoration.from > prevDecoration.from || j === newDecorationsToCheck.length - 1) {
                    uniqueInPrev.push(prevDecoration);
                    newDecorationsIdxOffset -= 1;
                    if (uniqueInPrev.length === numToFind) foundAll = true;
                    break;
                }
            }
            if (foundAll) break;
        }
        // make sure we ignore any that we wanted to delete
        lostDecorations = uniqueInPrev.filter((decoration)=>!decorationsToRemove.find((decorationToRemove)=>decoration.from === decorationToRemove.from));
    }
    return lostDecorations;
};
const $68ba69b3f7b9f0e7$export$7e4c53b0062d9305 = (items, position)=>{
    // jump in batches to cope with arrays with thousands of decorations
    const increment = 100;
    let index = 0;
    for(let i = items.length - 1; i >= 0; i -= increment){
        if (items[i].from < position) {
            // now we have found the 100 range, we can narrow it down to exact index
            index = i;
            for(let j = i; j <= items.length - 1; j++){
                if (items[j].from <= position) index = j;
                else break;
            }
            break;
        }
        if (i < 100 && i > 0) i = 100;
    }
    return index;
};
const $68ba69b3f7b9f0e7$export$7d11bfeb87290a13 = (match, step, tr)=>{
    const { from: from, to: to, slice: slice } = step;
    const sliceSize = slice.content.size;
    return from + sliceSize >= match.start && to - sliceSize <= match.end || tr.mapping.map(from) + sliceSize >= match.start && tr.mapping.map(to) - sliceSize <= match.end;
};


function $535f326a0ed6ebb6$export$bb98a54aeaa7e0c0(findIn, checkWith, comparator) {
    return findIn.filter((firstItem)=>checkWith.findIndex((secondItem)=>comparator ? comparator(firstItem, secondItem) : firstItem === secondItem) === -1);
}


const $68a609e009bbcefe$var$handleDocChanged = (tr, pluginState)=>{
    const { isActive: isActive, findText: findText } = pluginState;
    if (!isActive || !findText) return pluginState;
    if (!tr.steps.find((0, $kTbzR.stepHasSlice))) return pluginState;
    // Ignored via go/ees005
    // eslint-disable-next-line prefer-const
    let { index: index, decorationSet: decorationSet, matches: matches, shouldMatchCase: shouldMatchCase, getIntl: getIntl, api: api } = pluginState;
    const newMatches = (0, $68ba69b3f7b9f0e7$export$f4585c00f32d9257)({
        content: tr.doc,
        searchText: findText,
        shouldMatchCase: shouldMatchCase,
        getIntl: getIntl,
        api: api
    });
    decorationSet = decorationSet.map(tr.mapping, tr.doc);
    const numDecorations = decorationSet.find().length;
    const mappedMatches = matches.map((match)=>({
            start: tr.mapping.map(match.start),
            end: tr.mapping.map(match.end),
            canReplace: match.canReplace,
            nodeType: match.nodeType
        }));
    let matchesToAdd = [];
    let matchesToDelete = [];
    if (newMatches.length > 0 && numDecorations === 0) matchesToAdd = newMatches;
    else if (newMatches.length === 0 && numDecorations > 0) decorationSet = (0, $ftzrq.DecorationSet).empty;
    else if (newMatches.length > 0 || numDecorations > 0) // go through tr steps and find any new matches from user adding content or
    // any dead matches from user deleting content
    tr.steps.forEach((step)=>{
        if ((0, $kTbzR.stepHasSlice)(step)) {
            // add all matches that are between the affected positions and don't already have
            // corresponding decorations
            matchesToAdd = [
                ...matchesToAdd,
                ...newMatches.filter((match)=>(0, $68ba69b3f7b9f0e7$export$7d11bfeb87290a13)(match, step, tr) && !(0, $68ba69b3f7b9f0e7$export$e2521c2c8f72064b)(decorationSet, match))
            ];
            // delete any matches that are missing from the newMatches array and have a
            // corresponding decoration
            matchesToDelete = [
                ...matchesToDelete,
                ...(0, $535f326a0ed6ebb6$export$bb98a54aeaa7e0c0)(mappedMatches.filter((match)=>(0, $68ba69b3f7b9f0e7$export$7d11bfeb87290a13)(match, step, tr) && !!(0, $68ba69b3f7b9f0e7$export$e2521c2c8f72064b)(decorationSet, match)), newMatches, (firstMatch, secondMatch)=>firstMatch.start === secondMatch.start && firstMatch.end === secondMatch.end)
            ];
        }
    });
    // update decorations if matches changed following document update
    if (matchesToDelete.length > 0) {
        const decorationsToDelete = matchesToDelete.reduce((decorations, match)=>[
                ...decorations,
                ...decorationSet.find(match.start, match.end)
            ], []);
        decorationSet = (0, $68ba69b3f7b9f0e7$export$ede9cf72df9a3d38)(decorationSet, decorationsToDelete, tr.doc);
    }
    if (matchesToAdd.length > 0) decorationSet = decorationSet.add(tr.doc, (0, $68ba69b3f7b9f0e7$export$2393fad6cd7faeee)(tr.selection.from, matchesToAdd));
    // update selected match if it has changed
    let newIndex = index;
    const selectedMatch = mappedMatches[index];
    if (selectedMatch) newIndex = newMatches.findIndex((match)=>match.start === selectedMatch.start);
    if (newIndex === undefined || newIndex === -1) newIndex = (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? (0, $68ba69b3f7b9f0e7$export$6df7393992287695)(tr.selection.from, newMatches) : (0, $68ba69b3f7b9f0e7$export$1b7f6169b65103e3)(tr.selection.from, newMatches);
    const newSelectedMatch = newMatches[newIndex];
    decorationSet = (0, $68ba69b3f7b9f0e7$export$b5b5304233807f24)(decorationSet, [
        selectedMatch,
        newSelectedMatch
    ], tr.doc);
    if (newSelectedMatch) decorationSet = decorationSet.add(tr.doc, (0, $68ba69b3f7b9f0e7$export$2393fad6cd7faeee)(0, [
        newSelectedMatch
    ]));
    if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_toggle_expand_on_match_found', 'isEnabled', true)) {
        const newSelection = (0, $68ba69b3f7b9f0e7$export$91f639c3a212feb2)(tr.selection, tr.doc, newIndex, newMatches);
        // the exposure is fired inside toggleExpandWithMatch when user is exposed to the experiment
        api?.expand?.commands.toggleExpandWithMatch(newSelection)({
            tr: tr
        });
    }
    return {
        ...pluginState,
        matches: newMatches,
        index: newIndex,
        decorationSet: decorationSet
    };
};
const { createCommand: $68a609e009bbcefe$export$8d4021544bdece00, getPluginState: $68a609e009bbcefe$export$f05434c51e3762e, createPluginState: $68a609e009bbcefe$export$656c7661095efe2e } = (0, $lkJUe.pluginFactory)((0, $e8b1b385096c80fd$export$e7697da71e34f0a6), (0, $ddd7d9e0e4897838$export$2e2bcd8739ae039)(()=>(0, $797013ea47834520$export$d4c72bab9d6cc13a)), {
    onDocChanged: $68a609e009bbcefe$var$handleDocChanged
});








// max number of decorations to apply at once
const $327618b7c36ee16b$var$batchIncrement = 100;
// position range to apply decorations between before alternating above or below viewport
const $327618b7c36ee16b$var$posIncrement = 2000;
/**
 * Provides support for applying search match highlight decorations in batches
 */ class $327618b7c36ee16b$var$BatchDecorations {
    stop() {
        if (this.rafId) cancelAnimationFrame(this.rafId);
    }
    /**
   * Applies the decorations needed for the current search results
   * It does so async, splitting them up into batches to help with performance
   */ async applyAllSearchDecorations(editorView, containerElement, addDecorations, removeDecorations) {
        this.stop();
        this.addDecorations = addDecorations;
        this.removeDecorations = removeDecorations;
        if (!containerElement) return;
        const pmElement = containerElement.querySelector('.ProseMirror');
        if (!pmElement) return;
        const positions = this.calcDecorationPositions(editorView, containerElement, pmElement);
        const { startPos: startPos, endPos: endPos, viewportStartPos: viewportStartPos, viewportEndPos: viewportEndPos } = positions;
        let dir = 0;
        let before = viewportStartPos;
        let after = viewportEndPos - $327618b7c36ee16b$var$posIncrement;
        await this.updateDecorationsBetween(editorView, viewportStartPos, viewportEndPos);
        while(before > startPos || after < endPos)if (dir++ % 2 === 0 && before > startPos || after >= endPos) {
            const diff = before - startPos;
            before = Math.max(before - $327618b7c36ee16b$var$posIncrement, startPos);
            await this.updateDecorationsBetween(editorView, before, before + Math.min(diff, $327618b7c36ee16b$var$posIncrement));
        } else {
            after = Math.min(after + $327618b7c36ee16b$var$posIncrement, endPos);
            await this.updateDecorationsBetween(editorView, after, Math.min(after + $327618b7c36ee16b$var$posIncrement, endPos));
        }
    }
    async updateDecorationsBetween(editorView, startPos, endPos) {
        await this.removeDecorationsBetween(editorView, startPos, endPos);
        await this.addDecorationsBetween(editorView, startPos, endPos);
    }
    async addDecorationsBetween(editorView, startPos, endPos) {
        const { selection: selection } = editorView.state;
        const { matches: matches, decorationSet: decorationSet } = (0, $68a609e009bbcefe$export$f05434c51e3762e)(editorView.state);
        if (matches.length === 0) return;
        const matchesBetween = matches.filter((m)=>m.start >= startPos && (endPos === undefined || m.start < endPos));
        const selectionMatch = matches.find((match)=>match.start >= selection.from);
        const selectionIndex = matchesBetween.findIndex((match)=>match === selectionMatch);
        return await this.batchRequests((counter)=>{
            const matchesToDecorate = matchesBetween.slice(counter, counter + $327618b7c36ee16b$var$batchIncrement);
            if (matchesToDecorate.length === 0) return false;
            let useSelectionIndex = selectionIndex >= counter && selectionIndex < counter + $327618b7c36ee16b$var$batchIncrement;
            if (selectionMatch && useSelectionIndex) {
                const selectionMatchDecoration = (0, $68ba69b3f7b9f0e7$export$e2521c2c8f72064b)(decorationSet, selectionMatch);
                if (selectionMatchDecoration) {
                    matchesToDecorate.splice(selectionIndex % $327618b7c36ee16b$var$batchIncrement, 1);
                    useSelectionIndex = false;
                }
            }
            if (this.addDecorations) this.addDecorations((0, $68ba69b3f7b9f0e7$export$2393fad6cd7faeee)(useSelectionIndex ? selectionIndex % $327618b7c36ee16b$var$batchIncrement : -1, matchesToDecorate));
        }, {
            increment: $327618b7c36ee16b$var$batchIncrement,
            until: matchesBetween.length
        });
    }
    async removeDecorationsBetween(editorView, startPos, endPos) {
        const { decorationSet: decorationSet } = (0, $68a609e009bbcefe$export$f05434c51e3762e)(editorView.state);
        const decorations = decorationSet.find(startPos, endPos);
        if (decorations.length === 0) return;
        return await this.batchRequests((counter)=>{
            let decorationsToRemove = decorations.slice(counter, counter + $327618b7c36ee16b$var$batchIncrement);
            if (decorationsToRemove.length === 0) return false;
            // only get those decorations whose from >= startPos
            for(let i = 0; i < decorationsToRemove.length; i++){
                if (decorationsToRemove[i].from >= startPos) break;
                decorationsToRemove = decorationsToRemove.slice(1);
            }
            if (this.removeDecorations) this.removeDecorations(decorationsToRemove);
        }, {
            increment: $327618b7c36ee16b$var$batchIncrement,
            until: decorations.length
        });
    }
    /**
   * Calculates Prosemirror start and end positions we want to apply the decorations
   * between
   * Also calculates the positions the are the start and end of the user's viewport
   * so we can apply decorations there first and work outwards
   */ calcDecorationPositions(editorView, containerElement, pmElement) {
        const containerRect = containerElement.getBoundingClientRect();
        const pmRect = pmElement.getBoundingClientRect();
        const viewportStartPos = this.getStartPos(editorView, 0, pmRect.left);
        const viewportEndPos = this.getEndPos(editorView, containerRect.top + containerRect.height, pmRect.left);
        return {
            viewportStartPos: viewportStartPos,
            viewportEndPos: viewportEndPos,
            startPos: (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? 0 : 1,
            endPos: editorView.state.doc.nodeSize
        };
    }
    getStartPos(editorView, y, x) {
        const startPos = editorView.posAtCoords({
            top: y,
            left: x
        });
        if ((0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true)) return startPos ? startPos.pos : 0;
        else return startPos ? startPos.pos : 1;
    }
    getEndPos(editorView, y, x) {
        const maxPos = editorView.state.doc.nodeSize;
        const endPos = editorView.posAtCoords({
            top: y,
            left: x
        });
        return endPos ? endPos.pos : maxPos;
    }
    /**
   * Util to batch function calls by animation frames
   * A counter will start at 0 and increment by provided value until reaches limit
   * Passed in fn receives the counter as a param, return false to skip waiting
   * for the animation frame for the next call
   */ batchRequests(fn, opts) {
        let counter = 0;
        const { increment: increment, until: until } = opts;
        return new Promise((resolve)=>{
            const batchedFn = ()=>{
                let result = fn(counter);
                while(result === false && counter < until){
                    counter += increment;
                    result = fn(counter);
                }
                if (counter < until) {
                    counter += increment;
                    this.rafId = requestAnimationFrame(batchedFn);
                } else {
                    this.rafId = undefined;
                    resolve();
                }
            };
            this.rafId = requestAnimationFrame(batchedFn);
        });
    }
    constructor(){
        this.rafId = void 0;
        this.addDecorations = void 0;
        this.removeDecorations = void 0;
    }
}
const $327618b7c36ee16b$var$batchDecorations = new $327618b7c36ee16b$var$BatchDecorations();
var $327618b7c36ee16b$export$2e2bcd8739ae039 = $327618b7c36ee16b$var$batchDecorations;


const $77b74506ab92b199$export$b252ecff1878cab7 = (command)=>(state, dispatch, view)=>command(state, (tr)=>{
            tr.scrollIntoView();
            if (dispatch) dispatch(tr);
        }, view);


const $92ce31c77152d962$export$234c45b355edd85b = ()=>(0, $68a609e009bbcefe$export$8d4021544bdece00)((state)=>{
        const { selection: selection } = state;
        let findText;
        let matches;
        let index;
        // if user has selected text and hit cmd-f, set that as the keyword
        if (selection instanceof (0, $ks2lK.TextSelection) && !selection.empty) {
            findText = (0, $68ba69b3f7b9f0e7$export$93850515e4be65a3)(selection);
            const { shouldMatchCase: shouldMatchCase, getIntl: getIntl, api: api } = (0, $68a609e009bbcefe$export$f05434c51e3762e)(state);
            matches = (0, $68ba69b3f7b9f0e7$export$f4585c00f32d9257)({
                content: state.doc,
                searchText: findText,
                shouldMatchCase: shouldMatchCase,
                getIntl: getIntl,
                api: api
            });
            index = (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? (0, $68ba69b3f7b9f0e7$export$6df7393992287695)(selection.from, matches) : (0, $68ba69b3f7b9f0e7$export$1b7f6169b65103e3)(selection.from, matches);
        }
        return {
            type: (0, $0ea83d7668f10440$export$29dff82773c5f10f).ACTIVATE,
            findText: findText,
            matches: matches,
            index: index
        };
    });
const $92ce31c77152d962$export$71aa6c912b956294 = (editorView, containerElement, keyword)=>(0, $77b74506ab92b199$export$b252ecff1878cab7)((0, $68a609e009bbcefe$export$8d4021544bdece00)((state)=>{
        const { selection: selection } = state;
        const { shouldMatchCase: shouldMatchCase, getIntl: getIntl, api: api } = (0, $68a609e009bbcefe$export$f05434c51e3762e)(state);
        const matches = keyword !== undefined ? (0, $68ba69b3f7b9f0e7$export$f4585c00f32d9257)({
            content: state.doc,
            searchText: keyword,
            shouldMatchCase: shouldMatchCase,
            getIntl: getIntl,
            api: api
        }) : [];
        const index = (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? (0, $68ba69b3f7b9f0e7$export$6df7393992287695)(selection.from, matches) : (0, $68ba69b3f7b9f0e7$export$1b7f6169b65103e3)(selection.from, matches);
        // we can't just apply all the decorations to highlight the search results at once
        // as if there are a lot ProseMirror cries :'(
        (0, $327618b7c36ee16b$export$2e2bcd8739ae039).applyAllSearchDecorations(editorView, containerElement, (decorations)=>$92ce31c77152d962$export$e17d1d1acde229e1(decorations)(editorView.state, editorView.dispatch), (decorations)=>$92ce31c77152d962$export$f9e1c8eeab9872dc(decorations)(editorView.state, editorView.dispatch));
        return {
            type: (0, $0ea83d7668f10440$export$29dff82773c5f10f).FIND,
            findText: keyword || '',
            matches: matches,
            index: index
        };
    }, (tr, state)=>{
        const { selection: selection } = state;
        const { shouldMatchCase: shouldMatchCase, getIntl: getIntl, api: api } = (0, $68a609e009bbcefe$export$f05434c51e3762e)(state);
        const matches = keyword !== undefined ? (0, $68ba69b3f7b9f0e7$export$f4585c00f32d9257)({
            content: state.doc,
            searchText: keyword,
            shouldMatchCase: shouldMatchCase,
            getIntl: getIntl,
            api: api
        }) : [];
        if (matches.length > 0) {
            const index = (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? (0, $68ba69b3f7b9f0e7$export$6df7393992287695)(selection.from, matches) : (0, $68ba69b3f7b9f0e7$export$1b7f6169b65103e3)(selection.from, matches);
            const newSelection = (0, $68ba69b3f7b9f0e7$export$91f639c3a212feb2)(tr.selection, tr.doc, index, matches);
            if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_toggle_expand_on_match_found', 'isEnabled', true)) // the exposure is fired inside toggleExpandWithMatch when user is exposed to the experiment
            api?.expand?.commands.toggleExpandWithMatch(newSelection)({
                tr: tr
            });
            return tr.setSelection(newSelection);
        }
        return tr;
    }));
const $92ce31c77152d962$export$ebdf538520f8717 = (editorView)=>(0, $77b74506ab92b199$export$b252ecff1878cab7)((0, $68a609e009bbcefe$export$8d4021544bdece00)((state)=>$92ce31c77152d962$var$findInDirection(state, 'next'), (tr, state)=>{
        const { matches: matches, index: index, api: api } = (0, $68a609e009bbcefe$export$f05434c51e3762e)(state);
        // can't use index from plugin state because if the cursor has moved, it will still be the
        // OLD index (the find next operation should look for the first match forward starting
        // from the current cursor position)
        let searchIndex = (0, $68ba69b3f7b9f0e7$export$1b7f6169b65103e3)(state.selection.from, matches);
        if (searchIndex === index) // cursor has not moved, so we just want to find the next in matches array
        searchIndex = (0, $68ba69b3f7b9f0e7$export$7db462fe6be63e0)(searchIndex, matches.length);
        const newSelection = (0, $68ba69b3f7b9f0e7$export$91f639c3a212feb2)(tr.selection, tr.doc, searchIndex, matches);
        if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_toggle_expand_on_match_found', 'isEnabled', true)) // the exposure is fired inside toggleExpandWithMatch when user is exposed to the experiment
        api?.expand?.commands.toggleExpandWithMatch(newSelection)({
            tr: tr
        });
        return tr.setSelection(newSelection);
    }));
const $92ce31c77152d962$export$eef4841c27f82c55 = (editorView)=>(0, $77b74506ab92b199$export$b252ecff1878cab7)((0, $68a609e009bbcefe$export$8d4021544bdece00)((state)=>$92ce31c77152d962$var$findInDirection(state, 'previous'), (tr, state)=>{
        const { matches: matches, api: api } = (0, $68a609e009bbcefe$export$f05434c51e3762e)(state);
        // can't use index from plugin state because if the cursor has moved, it will still be the
        // OLD index (the find prev operation should look for the first match backward starting
        // from the current cursor position)
        const searchIndex = (0, $68ba69b3f7b9f0e7$export$1b7f6169b65103e3)(state.selection.from, matches, true);
        const newSelection = (0, $68ba69b3f7b9f0e7$export$91f639c3a212feb2)(tr.selection, tr.doc, searchIndex, matches);
        if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_toggle_expand_on_match_found', 'isEnabled', true)) // the exposure is fired inside toggleExpandWithMatch when user is exposed to the experiment
        api?.expand?.commands.toggleExpandWithMatch(newSelection)({
            tr: tr
        });
        return tr.setSelection(newSelection);
    }));
const $92ce31c77152d962$var$findInDirection = (state, dir)=>{
    const pluginState = (0, $68a609e009bbcefe$export$f05434c51e3762e)(state);
    const { matches: matches, findText: findText } = pluginState;
    let { decorationSet: decorationSet, index: index } = pluginState;
    if (findText) {
        const searchIndex = (0, $68ba69b3f7b9f0e7$export$1b7f6169b65103e3)(state.selection.from, matches, dir === 'previous');
        // compare index from plugin state and index of first match forward from cursor position
        if (index === searchIndex) // normal case, cycling through matches
        index = dir === 'next' ? (0, $68ba69b3f7b9f0e7$export$7db462fe6be63e0)(index, matches.length) : (0, $68ba69b3f7b9f0e7$export$9041fedbf960fcef)(index, matches.length);
        else // cursor has moved
        index = searchIndex;
        decorationSet = $92ce31c77152d962$var$updateSelectedHighlight(state, index);
    }
    return {
        type: dir === 'next' ? (0, $0ea83d7668f10440$export$29dff82773c5f10f).FIND_NEXT : (0, $0ea83d7668f10440$export$29dff82773c5f10f).FIND_PREVIOUS,
        index: index,
        decorationSet: decorationSet
    };
};
const $92ce31c77152d962$export$77ad94ebf1c2b9ed = (replaceText)=>(0, $77b74506ab92b199$export$b252ecff1878cab7)((0, $68a609e009bbcefe$export$8d4021544bdece00)((state)=>{
        const pluginState = (0, $68a609e009bbcefe$export$f05434c51e3762e)(state);
        const { findText: findText, matches: matches } = pluginState;
        let { decorationSet: decorationSet, index: index } = pluginState;
        decorationSet = $92ce31c77152d962$var$updateSelectedHighlight(state, (0, $68ba69b3f7b9f0e7$export$7db462fe6be63e0)(index, matches.length));
        if (replaceText.toLowerCase().indexOf(findText.toLowerCase()) === -1) {
            decorationSet = (0, $68ba69b3f7b9f0e7$export$b5b5304233807f24)(decorationSet, [
                matches[index]
            ], state.doc);
            matches.splice(index, 1);
            if (index > matches.length - 1) index = 0;
        } else index = (0, $68ba69b3f7b9f0e7$export$7db462fe6be63e0)(index, matches.length);
        return {
            type: (0, $0ea83d7668f10440$export$29dff82773c5f10f).REPLACE,
            replaceText: replaceText,
            decorationSet: decorationSet,
            matches: matches,
            index: index
        };
    }, (tr, state)=>{
        const { matches: matches, index: index, findText: findText } = (0, $68a609e009bbcefe$export$f05434c51e3762e)(state);
        if (matches[index]) {
            if (!matches[index].canReplace && (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true)) return tr;
            const { start: start, end: end } = matches[index];
            const newIndex = (0, $68ba69b3f7b9f0e7$export$7db462fe6be63e0)(index, matches.length);
            tr.insertText(replaceText, start, end).setSelection((0, $68ba69b3f7b9f0e7$export$91f639c3a212feb2)(tr.selection, tr.doc, newIndex, matches, newIndex === 0 ? 0 : replaceText.length - findText.length));
        }
        return tr;
    }));
const $92ce31c77152d962$export$b8b3234b4edfc4c2 = (replaceText)=>(0, $68a609e009bbcefe$export$8d4021544bdece00)({
        type: (0, $0ea83d7668f10440$export$29dff82773c5f10f).REPLACE_ALL,
        replaceText: replaceText,
        decorationSet: (0, $ftzrq.DecorationSet).empty,
        matches: [],
        index: 0
    }, (tr, state)=>{
        const pluginState = (0, $68a609e009bbcefe$export$f05434c51e3762e)(state);
        pluginState.matches.forEach((match)=>{
            if (!match.canReplace && (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true)) return tr;
            tr.insertText(replaceText, tr.mapping.map(match.start), tr.mapping.map(match.end));
        });
        tr.setMeta('scrollIntoView', false);
        return tr;
    });
const $92ce31c77152d962$export$e17d1d1acde229e1 = (decorations)=>(0, $68a609e009bbcefe$export$8d4021544bdece00)((state)=>{
        const { decorationSet: decorationSet } = (0, $68a609e009bbcefe$export$f05434c51e3762e)(state);
        return {
            type: (0, $0ea83d7668f10440$export$29dff82773c5f10f).UPDATE_DECORATIONS,
            decorationSet: decorationSet.add(state.doc, decorations)
        };
    });
const $92ce31c77152d962$export$f9e1c8eeab9872dc = (decorations)=>(0, $68a609e009bbcefe$export$8d4021544bdece00)((state)=>{
        const { decorationSet: decorationSet } = (0, $68a609e009bbcefe$export$f05434c51e3762e)(state);
        return {
            type: (0, $0ea83d7668f10440$export$29dff82773c5f10f).UPDATE_DECORATIONS,
            decorationSet: (0, $68ba69b3f7b9f0e7$export$ede9cf72df9a3d38)(decorationSet, decorations, state.doc)
        };
    });
const $92ce31c77152d962$export$58f3f9b95b84be3c = ()=>(0, $68a609e009bbcefe$export$8d4021544bdece00)(()=>{
        (0, $327618b7c36ee16b$export$2e2bcd8739ae039).stop();
        return {
            type: (0, $0ea83d7668f10440$export$29dff82773c5f10f).CANCEL
        };
    });
const $92ce31c77152d962$export$2cc7ff91bcacba5e = ()=>(0, $68a609e009bbcefe$export$8d4021544bdece00)({
        type: (0, $0ea83d7668f10440$export$29dff82773c5f10f).BLUR
    });
const $92ce31c77152d962$export$4e987d48fa8a04d7 = ()=>(0, $68a609e009bbcefe$export$8d4021544bdece00)({
        type: (0, $0ea83d7668f10440$export$29dff82773c5f10f).TOGGLE_MATCH_CASE
    });
const $92ce31c77152d962$var$updateSelectedHighlight = (state, nextSelectedIndex)=>{
    const { index: index, matches: matches } = (0, $68a609e009bbcefe$export$f05434c51e3762e)(state);
    let { decorationSet: decorationSet } = (0, $68a609e009bbcefe$export$f05434c51e3762e)(state);
    const currentSelectedMatch = matches[index];
    const nextSelectedMatch = matches[nextSelectedIndex];
    if (index === nextSelectedIndex) return decorationSet;
    const currentSelectedDecoration = (0, $68ba69b3f7b9f0e7$export$e2521c2c8f72064b)(decorationSet, currentSelectedMatch);
    const nextSelectedDecoration = (0, $68ba69b3f7b9f0e7$export$e2521c2c8f72064b)(decorationSet, nextSelectedMatch);
    // Update decorations so the current selected match becomes a normal match
    // and the next selected gets the selected styling
    const decorationsToRemove = [];
    if (currentSelectedDecoration) decorationsToRemove.push(currentSelectedDecoration);
    if (nextSelectedDecoration) decorationsToRemove.push(nextSelectedDecoration);
    if (decorationsToRemove.length > 0) {
        // removeDecorationsFromSet depends on decorations being pre-sorted
        decorationsToRemove.sort((a, b)=>a.from < b.from ? -1 : 1);
        decorationSet = (0, $68ba69b3f7b9f0e7$export$ede9cf72df9a3d38)(decorationSet, decorationsToRemove, state.doc);
    }
    if (currentSelectedMatch) decorationSet = decorationSet.add(state.doc, [
        (0, $68ba69b3f7b9f0e7$export$83df86cadabd260)(currentSelectedMatch)
    ]);
    if (nextSelectedMatch) decorationSet = decorationSet.add(state.doc, [
        (0, $68ba69b3f7b9f0e7$export$83df86cadabd260)(nextSelectedMatch, true)
    ]);
    return decorationSet;
};






var $dAtrv = parcelRequire("dAtrv");





const $11e7df9f05f7da42$export$f4a2dfcbc300db1a = (editorAnalyticsAPI)=>({ triggerMethod: triggerMethod })=>(0, $dAtrv.withAnalytics)(editorAnalyticsAPI, (state)=>({
                eventType: (0, $d925B.EVENT_TYPE).UI,
                action: (0, $d925B.ACTION).ACTIVATED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).FIND_REPLACE_DIALOG,
                attributes: {
                    inputMethod: state.selection instanceof (0, $ks2lK.TextSelection) && !state.selection.empty ? (0, $d925B.INPUT_METHOD).PREFILL : (0, $d925B.INPUT_METHOD).KEYBOARD,
                    triggerMethod: triggerMethod
                }
            }))((0, $92ce31c77152d962$export$234c45b355edd85b)());
const $11e7df9f05f7da42$export$a1f845c5f9c28dec = (editorAnalyticsAPI)=>({ editorView: editorView, containerElement: containerElement, keyword: keyword })=>(0, $dAtrv.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            action: (0, $d925B.ACTION).FIND_PERFORMED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT
        })((0, $92ce31c77152d962$export$71aa6c912b956294)(editorView, containerElement, keyword));
const $11e7df9f05f7da42$export$da0da8f66917d4cd = (editorAnalyticsAPI, editorView)=>({ triggerMethod: triggerMethod })=>{
        return (0, $dAtrv.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            action: (0, $d925B.ACTION).FIND_NEXT_PERFORMED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
            attributes: {
                triggerMethod: triggerMethod
            }
        })((0, $92ce31c77152d962$export$ebdf538520f8717)(editorView));
    };
const $11e7df9f05f7da42$export$67b10f9d7f5c44e1 = (editorAnalyticsAPI, editorView)=>({ triggerMethod: triggerMethod })=>(0, $dAtrv.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            action: (0, $d925B.ACTION).FIND_PREV_PERFORMED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
            attributes: {
                triggerMethod: triggerMethod
            }
        })((0, $92ce31c77152d962$export$eef4841c27f82c55)(editorView));
const $11e7df9f05f7da42$export$95c81501036a7f64 = (editorAnalyticsAPI)=>({ triggerMethod: triggerMethod, replaceText: replaceText })=>(0, $dAtrv.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            action: (0, $d925B.ACTION).REPLACED_ONE,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
            attributes: {
                triggerMethod: triggerMethod
            }
        })((0, $92ce31c77152d962$export$77ad94ebf1c2b9ed)(replaceText));
const $11e7df9f05f7da42$export$99b6462294b19fcd = (editorAnalyticsAPI)=>({ replaceText: replaceText })=>(0, $dAtrv.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            action: (0, $d925B.ACTION).REPLACED_ALL,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT
        })((0, $92ce31c77152d962$export$b8b3234b4edfc4c2)(replaceText));
const $11e7df9f05f7da42$export$330be886194dc3c6 = (editorAnalyticsAPI)=>({ triggerMethod: triggerMethod })=>(0, $dAtrv.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $d925B.EVENT_TYPE).UI,
            action: (0, $d925B.ACTION).DEACTIVATED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).FIND_REPLACE_DIALOG,
            attributes: {
                triggerMethod: triggerMethod
            }
        })((0, $92ce31c77152d962$export$58f3f9b95b84be3c)());






var $hgeg8 = parcelRequire("hgeg8");


var $dus6D = parcelRequire("dus6D");


const $0cc9e4cfac335e7b$var$activateFindReplace = (editorAnalyticsAPI)=>(state, dispatch)=>{
        (0, $11e7df9f05f7da42$export$f4a2dfcbc300db1a)(editorAnalyticsAPI)({
            triggerMethod: (0, $d925B.TRIGGER_METHOD).SHORTCUT
        })(state, dispatch);
        return true;
    };
const $0cc9e4cfac335e7b$var$keymapPlugin = (editorAnalyticsAPI)=>{
    const list = {};
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.find).common, $0cc9e4cfac335e7b$var$activateFindReplace(editorAnalyticsAPI), list);
    return (0, $dus6D.keymap)(list);
};
var $0cc9e4cfac335e7b$export$2e2bcd8739ae039 = $0cc9e4cfac335e7b$var$keymapPlugin;








var $42omo = parcelRequire("42omo");












parcelRequire("42omo");


var $gmMgo = parcelRequire("gmMgo");





var $5v8Ta = parcelRequire("5v8Ta");

var $6qITU = parcelRequire("6qITU");


var $aFUXX = parcelRequire("aFUXX");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");


var $lzn6v = parcelRequire("lzn6v");







/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $jSnXV = parcelRequire("jSnXV");


var $2P8Ax = parcelRequire("2P8Ax");











var $bfgIy = parcelRequire("bfgIy");


var $1FOj2 = parcelRequire("1FOj2");


var $5gydP = parcelRequire("5gydP");





var $4noo5 = parcelRequire("4noo5");











var $1qfLF = parcelRequire("1qfLF");





var $3gadb = parcelRequire("3gadb");

class $77fa80c59f0bb86c$export$d7a26608845e3a06 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        const { title: title, icon: Icon, iconSize: iconSize, keymapDescription: keymapDescription, disabled: disabled, isPressed: isPressed, appearance: appearance } = this.props;
        const pressedProps = {
            ...typeof isPressed === 'boolean' && {
                'aria-pressed': isPressed
            }
        };
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
            content: /*#__PURE__*/ (0, $l998X.jsx)((0, $hgeg8.ToolTipContent), {
                description: title,
                keymap: (0, $hgeg8.findKeymapByDescription)(keymapDescription)
            }),
            hideTooltipOnClick: true,
            position: 'top',
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                id: "afterInputSection",
                label: title,
                appearance: appearance,
                testId: title,
                ref: this.buttonRef,
                // Ignored via go/ees005
                // eslint-disable-next-line react/jsx-props-no-spreading
                icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                        ...iconProps,
                        size: iconSize
                    }),
                isDisabled: disabled,
                onClick: this.handleClick,
                isSelected: isPressed,
                ...pressedProps
            })
        });
    }
    constructor(...args){
        super(...args);
        this.buttonRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.handleClick = ()=>{
            this.props.onClick(this.buttonRef);
        };
    }
}
$77fa80c59f0bb86c$export$d7a26608845e3a06.defaultProps = {
    keymapDescription: 'no-keymap',
    appearance: 'subtle'
};


/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @repo/internal/styles/no-exported-styles */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766







var $6fnsQ = parcelRequire("6fnsQ");

function $6f19b0f678d47301$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6f19b0f678d47301$var$fontSize = 14;
const $6f19b0f678d47301$export$2413e968422424ec = /*#__PURE__*/ (0, $9K4OG.css)({
    width: '100%',
    border: 'none',
    backgroundColor: `${`var(--ds-border, ${(0, $6fnsQ.N30A)})`}`,
    margin: `${"var(--ds-space-050, 4px)"} 0px`,
    height: '1px',
    borderRadius: "var(--ds-border-width, 1px)"
});
const $6f19b0f678d47301$export$491e6397d7c1480b = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    flexDirection: 'column',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '> *:not(#replace-hr-element)': {
        margin: `0px ${"var(--ds-space-050, 4px)"}`
    }
});
const $6f19b0f678d47301$export$263284dac1af2f8a = /*#__PURE__*/ (0, $9K4OG.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"}`
});
const $6f19b0f678d47301$export$4fcc6c669daa3229 = {
    name: "7ag069",
    styles: "display:flex;& > *{display:inline-flex;height:32px;flex:0 0 auto;}& > [data-ds--text-field--container]{display:flex;flex:1 1 auto;}"
};
const $6f19b0f678d47301$export$1c21208bb1fdf473 = {
    name: "14m6ydf",
    styles: "display:flex;padding:var(--ds-space-100, 8px);& > *{height:unset;}"
};
const $6f19b0f678d47301$export$b80151ecaea7abf0 = /*#__PURE__*/ (0, $9K4OG.css)({
    justifyContent: 'space-between',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $aFUXX.relativeFontSizeToBase16)(14)
});
const $6f19b0f678d47301$export$7910eaff0a3df2fc = /*#__PURE__*/ (0, $9K4OG.css)({
    flex: '1 100%',
    flexWrap: 'wrap',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '#find-text-field, #replace-text-field': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${36 / $6f19b0f678d47301$var$fontSize}em`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    label: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: (0, $aFUXX.relativeFontSizeToBase16)(14),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
        lineHeight: '16px'
    }
});
const $6f19b0f678d47301$export$d449744ea6979b42 = {
    name: "pxta9y",
    styles: "display:flex;flex:0 0 auto;align-items:center"
};
const $6f19b0f678d47301$export$24f07703e9463557 = {
    name: "1v69wxd",
    styles: "padding-right:var(--ds-space-100, 8px);button{width:20px;height:20px;}"
};
const $6f19b0f678d47301$export$df58af0590d04217 = /*#__PURE__*/ (0, $9K4OG.css)({
    padding: `0px ${"var(--ds-space-025, 2px)"}`
});
const $6f19b0f678d47301$export$1e2581329286cf31 = /*#__PURE__*/ (0, $9K4OG.css)({
    color: `${"var(--ds-text-subtlest, #626F86)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
    fontSize: `${(0, $aFUXX.relativeFontSizeToBase16)(12)}`,
    flex: '0 0 auto',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: "var(--ds-space-050, 4px)",
    marginRight: "var(--ds-space-100, 8px)"
});
const $6f19b0f678d47301$export$3fc34436808d2893 = {
    name: "1bc3mbb",
    styles: "display:inline-flex;height:32px"
};
const $6f19b0f678d47301$export$72d821739cf2fba2 = {
    name: "1h3rtzg",
    styles: "align-items:center"
};
const $6f19b0f678d47301$export$3321a5b8c800c311 = /*#__PURE__*/ (0, $9K4OG.css)({
    order: '0',
    marginInline: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"}`
});
const $6f19b0f678d47301$export$34fb77e33ae94982 = {
    name: "1r7keks",
    styles: "order:1"
};


const $f64d7eaf6f543352$export$c7a15a679416091a = 100;
// eslint-disable-next-line @repo/internal/react/no-class-components
class $f64d7eaf6f543352$var$Find extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidMount() {
        this.props.onFindTextfieldRefSet(this.findTextfieldRef);
        // focus initially on dialog mount if there is no find text provided
        if (!this.props.findText) {
            if ((0, $dh538.fg)('platform_editor_a11y_find_replace_focus_fix')) // Wait for findTextfieldRef to become available then focus
            setTimeout(()=>{
                this.focusFindTextfield();
            }, 100);
            else this.focusFindTextfield();
        }
        this.syncFindText(()=>{
            // focus after input is synced if find text provided
            if (this.props.findText) this.focusFindTextfield();
        });
    }
    componentDidUpdate(prevProps) {
        // focus on update if find text did not change
        if (this.props.findText === this.state?.localFindText) this.focusFindTextfield();
        if (this.props.findText !== prevProps.findText && this.props.shouldFocus) this.syncFindText(()=>{
            // focus after input is synced if find text provided
            if (this.props.findText) this.focusFindTextfield();
        });
    }
    componentWillUnmount() {
        this.debouncedFind.cancel();
        this.handleFindKeyDownThrottled.cancel();
    }
    render() {
        const { findText: findText, count: count, shouldMatchCase: shouldMatchCase, intl: { formatMessage: formatMessage } } = this.props;
        const resultsCount = formatMessage((0, $lzn6v.findReplaceMessages).resultsCount, {
            selectedMatchPosition: count.index + 1,
            totalResultsCount: count.total
        });
        const elemAfterInput = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: (0, $6f19b0f678d47301$export$d449744ea6979b42)
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            "aria-live": "polite"
        }, findText && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            "data-testid": "textfield-count",
            css: [
                (0, $6f19b0f678d47301$export$1e2581329286cf31),
                (0, $6f19b0f678d47301$export$3fc34436808d2893)
            ]
        }, count.total === 0 ? this.noResultsFound : resultsCount)), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: (0, $6f19b0f678d47301$export$24f07703e9463557)
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $77fa80c59f0bb86c$export$d7a26608845e3a06), {
            title: this.matchCase,
            appearance: "default",
            icon: this.matchCaseIconEle,
            iconLabel: this.matchCase,
            onClick: this.handleMatchCaseClick,
            isPressed: shouldMatchCase
        })));
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: [
                (0, $6f19b0f678d47301$export$4fcc6c669daa3229),
                (0, $6f19b0f678d47301$export$1c21208bb1fdf473)
            ]
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: (0, $6f19b0f678d47301$export$7910eaff0a3df2fc)
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bfgIy.Label), {
            htmlFor: "find-text-field"
        }, this.find), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4noo5.default), {
            name: "find",
            id: "find-text-field",
            testId: "find-field",
            appearance: "standard",
            value: this.state.localFindText,
            ref: this.findTextfieldRef,
            autoComplete: "off",
            onChange: this.handleFindChange,
            onKeyDown: this.handleFindKeyDown,
            onKeyUp: this.handleFindKeyUp,
            onBlur: this.props.onFindBlur,
            onCompositionStart: this.handleCompositionStart,
            onCompositionEnd: this.handleCompositionEnd,
            elemAfterInput: elemAfterInput
        }))));
    }
    constructor(props){
        super(props);
        this.findTextfieldRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.isComposing = false;
        this.find = void 0;
        this.noResultsFound = void 0;
        this.matchCase = void 0;
        this.syncFindText = (onSynced)=>{
            // If the external prop findText changes and we aren't in a composition we should update to
            // use the external prop value.
            //
            // An example of where this may happen is when a find occurs through the user selecting some text
            // and pressing Mod-f.
            if (!this.isComposing && this.props.findText !== this.state?.localFindText) this.updateFindValue(this.props.findText || '', onSynced);
        };
        this.focusFindTextfield = ()=>{
            const input = this.findTextfieldRef.current;
            if (this.props.shouldFocus && input) input.select();
        };
        this.handleFindChange = (event)=>{
            this.updateFindValue(event.target.value);
        };
        // debounce (vs throttle) to not block typing inside find input while onFind runs
        this.debouncedFind = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))((value)=>{
            this.props.onFind(value);
        }, $f64d7eaf6f543352$export$c7a15a679416091a);
        this.updateFindValue = (value, onSynced)=>{
            this.setState({
                localFindText: value
            }, ()=>{
                if (this.isComposing) return;
                onSynced && onSynced();
                this.debouncedFind(value);
            });
            this.props.setFindTyped(true);
        };
        // throtlle between animation frames gives better experience on Enter compared to arbitrary value
        // it adjusts based on performance (and document size)
        this.handleFindKeyDownThrottled = (0, $2P8Ax.default)((event)=>{
            if (event.key === 'Enter') {
                if (event.shiftKey) this.props.onFindPrev({
                    triggerMethod: (0, $d925B.TRIGGER_METHOD).KEYBOARD
                });
                else this.props.onFindNext({
                    triggerMethod: (0, $d925B.TRIGGER_METHOD).KEYBOARD
                });
            } else if (event.key === 'ArrowDown') // we want to move focus between find & replace texfields when user hits up/down arrows
            this.props.onArrowDown();
        });
        this.handleFindKeyDown = (event)=>{
            if (this.isComposing) return;
            event.persist();
            this.handleFindKeyDownThrottled(event);
        };
        this.handleFindKeyUp = ()=>{
            this.handleFindKeyDownThrottled.cancel();
        };
        this.handleFindNextClick = (ref)=>{
            if (this.isComposing) return;
            this.props.onFindNext({
                triggerMethod: (0, $d925B.TRIGGER_METHOD).BUTTON
            });
        };
        this.handleFindPrevClick = (ref)=>{
            if (this.isComposing) return;
            this.props.onFindPrev({
                triggerMethod: (0, $d925B.TRIGGER_METHOD).BUTTON
            });
        };
        this.handleCompositionStart = ()=>{
            this.isComposing = true;
        };
        this.handleCompositionEnd = (event)=>{
            this.isComposing = false;
            // type for React.CompositionEvent doesn't set type for target correctly
            this.updateFindValue(event.target.value);
        };
        this.clearSearch = ()=>{
            this.props.onCancel({
                triggerMethod: (0, $d925B.TRIGGER_METHOD).BUTTON
            });
        };
        this.handleMatchCaseClick = (buttonRef)=>{
            if (this.props.onToggleMatchCase) {
                this.props.onToggleMatchCase();
                this.props.onFind(this.props.findText);
            }
        };
        this.matchCaseIconEle = (iconProps)=>{
            return (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1FOj2))), {
                label: iconProps.label,
                size: "small"
            }) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5gydP))), {
                label: this.matchCase
            });
        };
        const { intl: { formatMessage: formatMessage } } = props;
        this.find = formatMessage((0, $lzn6v.findReplaceMessages).find);
        this.noResultsFound = formatMessage((0, $lzn6v.findReplaceMessages).noResultsFound);
        this.matchCase = formatMessage((0, $lzn6v.findReplaceMessages).matchCase);
        // We locally manage the value of the input inside this component in order to support compositions.
        // This requires some additional work inside componentDidUpdate to ensure we support changes that
        // occur to this value which do not originate from this component.
        this.state = {
            localFindText: ''
        };
    }
}
var $f64d7eaf6f543352$export$2e2bcd8739ae039 = (0, $gmMgo.default)($f64d7eaf6f543352$var$Find);












var $ccHMk = parcelRequire("ccHMk");








var $gQhRa = parcelRequire("gQhRa");


var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");




var $dcJ7R = parcelRequire("dcJ7R");

var $5dK2X = parcelRequire("5dK2X");










const $c7ca968779a672f3$var$replaceContainerStyles = (0, $ecnYn.xcss)({
    padding: 'space.100'
});
const $c7ca968779a672f3$var$replaceWithLabelStyle = (0, $ecnYn.xcss)({
    paddingBottom: 'space.050'
});
const $c7ca968779a672f3$var$actionButtonContainerStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.200'
});
const $c7ca968779a672f3$var$actionButtonParentInlineStyles = (0, $ecnYn.xcss)({
    justifyContent: 'space-between',
    flexDirection: 'row-reverse'
});
const $c7ca968779a672f3$var$actionButtonParentInlineStylesNew = (0, $ecnYn.xcss)({
    justifyContent: 'space-between',
    flexDirection: 'row-reverse',
    flexWrap: 'wrap'
});
const $c7ca968779a672f3$var$actionButtonInlineStyles = (0, $ecnYn.xcss)({
    gap: 'space.075'
});
const $c7ca968779a672f3$var$closeButtonInlineStyles = (0, $ecnYn.xcss)({
    marginRight: 'auto'
});
const $c7ca968779a672f3$var$Replace = ({ canReplace: canReplace, replaceText: initialReplaceText, onReplace: onReplace, onReplaceAll: onReplaceAll, onReplaceTextfieldRefSet: onReplaceTextfieldRefSet, onArrowUp: onArrowUp, onCancel: onCancel, count: count, onFindNext: onFindNext, onFindPrev: onFindPrev, dispatchAnalyticsEvent: dispatchAnalyticsEvent, setFindTyped: setFindTyped, findTyped: findTyped, focusToolbarButton: focusToolbarButton, intl: { formatMessage: formatMessage } })=>{
    const [replaceText, setReplaceText] = (0, $42omo.useState)(initialReplaceText || '');
    const [isComposing, setIsComposing] = (0, $42omo.useState)(false);
    const [isHelperMessageVisible, setIsHelperMessageVisible] = (0, $42omo.useState)(false);
    const [fakeSuccessReplacementMessageUpdate, setFakeSuccessReplacementMessageUpdate] = (0, $42omo.useState)(false);
    const [replaceCount, setReplaceCount] = (0, $42omo.useState)(0);
    const replaceTextfieldRef = (0, $42omo.useRef)(null);
    const successReplacementMessageRef = (0, $42omo.useRef)(null);
    const replaceWith = formatMessage((0, $lzn6v.findReplaceMessages).replaceWith);
    const replaceAll = formatMessage((0, $lzn6v.findReplaceMessages).replaceAll);
    const findPrevious = formatMessage((0, $lzn6v.findReplaceMessages).findPrevious);
    const closeFindReplaceDialog = formatMessage((0, $lzn6v.findReplaceMessages).closeFindReplaceDialog);
    (0, $42omo.useEffect)(()=>{
        onReplaceTextfieldRefSet(replaceTextfieldRef);
    }, [
        onReplaceTextfieldRefSet
    ]);
    (0, $42omo.useEffect)(()=>{
        setReplaceText(initialReplaceText || '');
    }, [
        initialReplaceText
    ]);
    const skipWhileComposing = (fn)=>{
        if (!isComposing) fn();
    };
    const triggerSuccessReplacementMessageUpdate = (currentReplaceCount)=>{
        if (replaceCount === currentReplaceCount) setFakeSuccessReplacementMessageUpdate(!fakeSuccessReplacementMessageUpdate);
        if (successReplacementMessageRef.current) {
            const ariaLiveRegion = successReplacementMessageRef.current.querySelector('[aria-live="polite"]');
            ariaLiveRegion?.removeAttribute('aria-live');
            ariaLiveRegion?.setAttribute('aria-live', 'polite');
        }
    };
    const handleReplaceClick = ()=>skipWhileComposing(()=>{
            onReplace({
                triggerMethod: (0, $d925B.TRIGGER_METHOD).BUTTON,
                replaceText: replaceText
            });
            triggerSuccessReplacementMessageUpdate(1);
            setIsHelperMessageVisible(true);
            setReplaceCount(1);
            setFindTyped(false);
        });
    const handleReplaceChange = (event)=>skipWhileComposing(()=>{
            updateReplaceValue(event.target.value);
        });
    const updateReplaceValue = (text)=>{
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            action: (0, $d925B.ACTION).CHANGED_REPLACEMENT_TEXT,
            actionSubject: (0, $d925B.ACTION_SUBJECT).FIND_REPLACE_DIALOG
        });
        setReplaceText(text);
    };
    const handleReplaceKeyDown = (event)=>skipWhileComposing(()=>{
            if (event.key === 'Enter') onReplace({
                triggerMethod: (0, $d925B.TRIGGER_METHOD).KEYBOARD,
                replaceText: replaceText
            });
            else if (event.key === 'ArrowUp') onArrowUp();
        });
    const handleReplaceAllClick = ()=>skipWhileComposing(()=>{
            onReplaceAll({
                replaceText: replaceText
            });
            setIsHelperMessageVisible(true);
            if (count.totalReplaceable && (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true)) {
                triggerSuccessReplacementMessageUpdate(count.totalReplaceable);
                setReplaceCount(count.totalReplaceable);
            } else {
                triggerSuccessReplacementMessageUpdate(count.total);
                setReplaceCount(count.total);
            }
            setFindTyped(false);
        });
    const handleCompositionStart = ()=>{
        setIsComposing(true);
    };
    const handleCompositionEnd = (event)=>{
        setIsComposing(false);
        // type for React.CompositionEvent doesn't set type for target correctly
        updateReplaceValue(event.target.value);
    };
    const clearSearch = ()=>{
        onCancel({
            triggerMethod: (0, $d925B.TRIGGER_METHOD).BUTTON
        });
        focusToolbarButton();
    };
    const handleFindNextClick = ()=>{
        if (!isComposing) onFindNext({
            triggerMethod: (0, $d925B.TRIGGER_METHOD).BUTTON
        });
    };
    const handleFindPrevClick = ()=>{
        if (!isComposing) onFindPrev({
            triggerMethod: (0, $d925B.TRIGGER_METHOD).BUTTON
        });
    };
    const resultsReplace = formatMessage((0, $lzn6v.findReplaceMessages).replaceSuccess, {
        numberOfMatches: replaceCount
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $c7ca968779a672f3$var$replaceContainerStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $c7ca968779a672f3$var$replaceWithLabelStyle,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                    id: "replace-text-field-label",
                    size: "medium",
                    weight: "bold",
                    color: "color.text.subtle",
                    children: replaceWith
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default), {
                name: "replace",
                "aria-labelledby": "replace-text-field-label",
                testId: "replace-field",
                appearance: "standard",
                defaultValue: replaceText,
                ref: replaceTextfieldRef,
                autoComplete: "off",
                onChange: handleReplaceChange,
                onKeyDown: handleReplaceKeyDown,
                onCompositionStart: handleCompositionStart,
                onCompositionEnd: handleCompositionEnd
            }),
            isHelperMessageVisible && !findTyped && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                ref: successReplacementMessageRef,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ValidMessage), {
                    testId: "message-success-replacement",
                    children: fakeSuccessReplacementMessageUpdate ? // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
                    resultsReplace.replace(/ /u, '\u00a0') : resultsReplace
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $c7ca968779a672f3$var$actionButtonContainerStyles,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                    xcss: (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? [
                        $c7ca968779a672f3$var$actionButtonInlineStyles,
                        $c7ca968779a672f3$var$actionButtonParentInlineStylesNew
                    ] : [
                        $c7ca968779a672f3$var$actionButtonInlineStyles,
                        $c7ca968779a672f3$var$actionButtonParentInlineStyles
                    ],
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                            xcss: $c7ca968779a672f3$var$actionButtonInlineStyles,
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $77fa80c59f0bb86c$export$d7a26608845e3a06), {
                                    title: formatMessage((0, $lzn6v.findReplaceMessages).findNext),
                                    icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                                            label: iconProps.label,
                                            size: "small"
                                        }),
                                    iconLabel: formatMessage((0, $lzn6v.findReplaceMessages).findNext),
                                    keymapDescription: 'Enter',
                                    onClick: handleFindNextClick,
                                    disabled: count.total <= 1
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $77fa80c59f0bb86c$export$d7a26608845e3a06), {
                                    title: findPrevious,
                                    icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                                            label: iconProps.label,
                                            size: "small"
                                        }),
                                    iconLabel: findPrevious,
                                    keymapDescription: 'Shift Enter',
                                    onClick: handleFindPrevClick,
                                    disabled: count.total <= 1
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                    testId: 'Replace',
                                    id: "replace-button",
                                    onClick: handleReplaceClick,
                                    isDisabled: !canReplace,
                                    children: formatMessage((0, $lzn6v.findReplaceMessages).replace)
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                    appearance: "primary",
                                    testId: replaceAll,
                                    id: "replaceAll-button",
                                    onClick: handleReplaceAllClick,
                                    isDisabled: (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? count.totalReplaceable === 0 : !canReplace,
                                    children: replaceAll
                                })
                            ]
                        }),
                        (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
                            xcss: $c7ca968779a672f3$var$closeButtonInlineStyles,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                appearance: "subtle",
                                testId: closeFindReplaceDialog,
                                onClick: clearSearch,
                                children: closeFindReplaceDialog
                            })
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            appearance: "subtle",
                            testId: closeFindReplaceDialog,
                            onClick: clearSearch,
                            children: closeFindReplaceDialog
                        })
                    ]
                })
            })
        ]
    });
};
var $c7ca968779a672f3$export$2e2bcd8739ae039 = (0, $gmMgo.default)($c7ca968779a672f3$var$Replace);



// eslint-disable-next-line @repo/internal/react/no-class-components
class $a6441227f3fef772$var$FindReplace extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        const { findText: findText, count: count, isReplaceable: isReplaceable, shouldFocus: shouldFocus, onFind: onFind, onFindBlur: onFindBlur, onFindNext: onFindNext, onFindPrev: onFindPrev, onCancel: onCancel, replaceText: replaceText, onReplace: onReplace, onReplaceAll: onReplaceAll, dispatchAnalyticsEvent: dispatchAnalyticsEvent, allowMatchCase: allowMatchCase, shouldMatchCase: shouldMatchCase, onToggleMatchCase: onToggleMatchCase, intl: intl } = this.props;
        const focusToolbarButton = this.props.focusToolbarButton || (()=>{});
        return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            role: 'dialog',
            "aria-label": (0, $dh538.fg)('platform_editor_dec_a11y_fixes') ? intl?.formatMessage((0, $lzn6v.findReplaceMessages).findReplaceDialogAriaLabel) : 'Find and Replace',
            "aria-modal": false,
            ref: this.modalRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: [
                (0, $6f19b0f678d47301$export$491e6397d7c1480b),
                (0, $6f19b0f678d47301$export$263284dac1af2f8a)
            ]
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $f64d7eaf6f543352$export$2e2bcd8739ae039), {
            allowMatchCase: allowMatchCase,
            shouldMatchCase: shouldMatchCase,
            onToggleMatchCase: onToggleMatchCase,
            findText: findText,
            count: count,
            shouldFocus: shouldFocus,
            onFind: onFind,
            onFindBlur: onFindBlur,
            onFindPrev: onFindPrev,
            onFindNext: onFindNext,
            onFindTextfieldRefSet: this.setFindTextfieldRef,
            onCancel: onCancel,
            onArrowDown: this.setFocusToReplace,
            findTyped: this.state.findTyped,
            setFindTyped: this.setFindTyped
        }), /*#__PURE__*/ (0, $9K4OG.jsx)("hr", {
            role: "presentation",
            css: (0, $6f19b0f678d47301$export$2413e968422424ec),
            id: "replace-hr-element"
        }), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $c7ca968779a672f3$export$2e2bcd8739ae039), {
            canReplace: (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? !!isReplaceable : count.total > 0,
            replaceText: replaceText,
            onReplace: onReplace,
            onReplaceAll: onReplaceAll,
            onReplaceTextfieldRefSet: this.setReplaceTextfieldRef,
            onArrowUp: this.setFocusToFind,
            onCancel: onCancel,
            count: count,
            onFindPrev: onFindPrev,
            onFindNext: onFindNext,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            findTyped: this.state.findTyped,
            setFindTyped: this.setFindTyped,
            focusToolbarButton: focusToolbarButton
        }));
    }
    constructor(props){
        super(props);
        this.findTextfield = null;
        this.replaceTextfield = null;
        this.modalRef = void 0;
        this.state = {
            findTyped: false
        };
        this.setFindTyped = (value)=>{
            this.setState({
                findTyped: value
            });
        };
        this.setFindTextfieldRef = (findTextfieldRef)=>{
            this.findTextfield = findTextfieldRef.current;
        };
        this.setReplaceTextfieldRef = (replaceTextfieldRef)=>{
            this.replaceTextfield = replaceTextfieldRef.current;
        };
        this.setFocusToFind = ()=>{
            if (this.findTextfield) this.findTextfield.focus();
        };
        this.setFocusToReplace = ()=>{
            if (this.replaceTextfield) this.replaceTextfield.focus();
        };
        this.modalRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
    }
}
var $a6441227f3fef772$export$2e2bcd8739ae039 = $a6441227f3fef772$var$FindReplace;


const $f0283781bba03353$var$findReplaceWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column'
});
// Magic number taken from ../FindReplaceToolbarButton.tsx
const $f0283781bba03353$var$dropdownWidthNewDesign = 382;
const $f0283781bba03353$var$FindReplaceDropdown = (props)=>{
    const { findText: findText, replaceText: replaceText, isActive: isActive, index: index, numMatches: numMatches, popupsMountPoint: popupsMountPoint, numReplaceable: numReplaceable, onCancel: onCancel } = props;
    if (!popupsMountPoint) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6qITU.default), {
        target: popupsMountPoint,
        mountTo: popupsMountPoint,
        forcePlacement: true,
        alignX: 'right',
        alignY: 'start',
        offset: [
            4,
            0
        ],
        isOpen: isActive,
        handleEscapeKeydown: ()=>{
            if (isActive) onCancel({
                triggerMethod: (0, $d925B.TRIGGER_METHOD).KEYBOARD
            });
        },
        fitWidth: $f0283781bba03353$var$dropdownWidthNewDesign,
        zIndex: (0, $aFUXX.akEditorFloatingPanelZIndex),
        arrowKeyNavigationProviderOptions: {
            type: (0, $5v8Ta.ArrowKeyNavigationType).MENU,
            disableArrowKeyNavigation: true
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $f0283781bba03353$var$findReplaceWrapperStyles,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a6441227f3fef772$export$2e2bcd8739ae039), {
                findText: findText,
                replaceText: replaceText,
                count: {
                    index: index,
                    total: numMatches,
                    totalReplaceable: numReplaceable
                },
                ...props
            })
        })
    });
};
var $f0283781bba03353$export$2e2bcd8739ae039 = (0, $gmMgo.default)($f0283781bba03353$var$FindReplaceDropdown);


/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






















var $8TW6I = parcelRequire("8TW6I");

var $a4eZN = parcelRequire("a4eZN");





var $jEno1 = parcelRequire("jEno1");





function $5b4854d00022f7d3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
const $5b4854d00022f7d3$var$toolbarButtonWrapper = /*#__PURE__*/ (0, $9K4OG.css)("display:flex;flex:1 1 auto;flex-grow:0;justify-content:flex-end;align-items:center;padding:0 var(--ds-space-100, 8px);@media (max-width: ", (0, $aFUXX.akEditorMobileMaxWidth), "px){justify-content:center;padding:0;}");
const $5b4854d00022f7d3$var$TriggerButtonWrapper = ({ isButtonHidden: isButtonHidden, children: children })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $9K4OG.css)({
            display: isButtonHidden ? 'none' : 'block'
        })
    }, children);
};
const $5b4854d00022f7d3$var$toolbarButtonWrapperFullWidth = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
const $5b4854d00022f7d3$var$toolbarButtonWrapperHidden = {
    name: "n1rao0",
    styles: "flex-grow:0;padding:0"
};
const $5b4854d00022f7d3$var$wrapper = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
const $5b4854d00022f7d3$var$dropdownWidthNewDesign = 382;
// eslint-disable-next-line @repo/internal/react/no-class-components
class $5b4854d00022f7d3$var$FindReplaceToolbarButton extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isReducedSpacing: isReducedSpacing, findText: findText, replaceText: replaceText, isActive: isActive, index: index, numMatches: numMatches, numReplaceable: numReplaceable, intl: { formatMessage: formatMessage }, takeFullWidth: takeFullWidth, isButtonHidden: isButtonHidden = false } = this.props;
        const title = formatMessage((0, $lzn6v.findReplaceMessages).findReplaceToolbarButton);
        const stackBelowOtherEditorFloatingPanels = (0, $aFUXX.akEditorFloatingPanelZIndex) - 1;
        const keymap = (0, $hgeg8.findKeymapByDescription)('Find');
        return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: [
                $5b4854d00022f7d3$var$toolbarButtonWrapper,
                takeFullWidth && $5b4854d00022f7d3$var$toolbarButtonWrapperFullWidth,
                isButtonHidden && (0, $dh538.fg)('platform_editor_toolbar_responsive_fixes') && $5b4854d00022f7d3$var$toolbarButtonWrapperHidden
            ]
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6qITU.default), {
            mountTo: popupsMountPoint,
            boundariesElement: popupsBoundariesElement,
            scrollableElement: popupsScrollableElement,
            isOpen: isActive,
            handleEscapeKeydown: ()=>{
                if (isActive) {
                    this.props.onCancel({
                        triggerMethod: (0, $d925B.TRIGGER_METHOD).KEYBOARD
                    });
                    if (this.state.openedByClick && this.toolbarButtonRef.current) this.toolbarButtonRef.current.focus();
                    this.setState({
                        openedByClick: false
                    });
                }
            },
            fitWidth: $5b4854d00022f7d3$var$dropdownWidthNewDesign,
            zIndex: stackBelowOtherEditorFloatingPanels,
            arrowKeyNavigationProviderOptions: {
                type: (0, $5v8Ta.ArrowKeyNavigationType).MENU,
                disableArrowKeyNavigation: true
            },
            trigger: (0, $dh538.fg)('platform_editor_toolbar_responsive_fixes') ? /*#__PURE__*/ (0, $9K4OG.jsx)($5b4854d00022f7d3$var$TriggerButtonWrapper, {
                isButtonHidden: isButtonHidden
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a4eZN.default), {
                buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).FIND_REPLACE,
                testId: `editor-toolbar__${(0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).FIND_REPLACE}`,
                spacing: isReducedSpacing ? 'none' : 'default',
                selected: isActive,
                title: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hgeg8.ToolTipContent), {
                    description: title,
                    keymap: keymap
                }),
                iconBefore: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jEno1))), {
                    label: title,
                    spacing: "spacious"
                }),
                onClick: this.toggleOpen,
                "aria-expanded": isActive,
                "aria-haspopup": true,
                "aria-label": keymap ? (0, $hgeg8.tooltip)(keymap, title) : title,
                "aria-keyshortcuts": (0, $hgeg8.getAriaKeyshortcuts)(keymap),
                ref: this.toolbarButtonRef
            })) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a4eZN.default), {
                buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).FIND_REPLACE,
                testId: `editor-toolbar__${(0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).FIND_REPLACE}`,
                spacing: isReducedSpacing ? 'none' : 'default',
                selected: isActive,
                title: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hgeg8.ToolTipContent), {
                    description: title,
                    keymap: keymap
                }),
                iconBefore: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jEno1))), {
                    label: title,
                    spacing: "spacious"
                }),
                onClick: this.toggleOpen,
                "aria-expanded": isActive,
                "aria-haspopup": true,
                "aria-label": keymap ? (0, $hgeg8.tooltip)(keymap, title) : title,
                "aria-keyshortcuts": (0, $hgeg8.getAriaKeyshortcuts)(keymap),
                ref: this.toolbarButtonRef
            })
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $5b4854d00022f7d3$var$wrapper
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a6441227f3fef772$export$2e2bcd8739ae039), {
            findText: findText,
            replaceText: replaceText,
            count: {
                index: index,
                total: numMatches,
                totalReplaceable: numReplaceable
            },
            focusToolbarButton: this.focusToolbarButton,
            ...this.props
        }))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            openedByClick: false
        };
        this.toggleOpen = ()=>{
            if (this.props.isActive) this.props.onCancel({
                triggerMethod: (0, $d925B.TRIGGER_METHOD).TOOLBAR
            });
            else {
                this.setState({
                    openedByClick: true
                });
                this.props.onActivate();
            }
        };
        this.focusToolbarButton = ()=>{
            if (this.state.openedByClick && this.toolbarButtonRef.current) this.toolbarButtonRef.current.focus();
            this.setState({
                openedByClick: false
            });
        };
        this.toolbarButtonRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
    }
}
var $5b4854d00022f7d3$export$2e2bcd8739ae039 = (0, $gmMgo.default)($5b4854d00022f7d3$var$FindReplaceToolbarButton);


// light implementation of useSharedPluginState(). This is due to findreplace
// being the only plugin that previously used WithPluginState with
// debounce=false. That was implemented because of text sync issues
// between editor & findreplace dialog.
// To address under ENGHEALTH-5853
const $325a0911b0fccbbc$var$useSharedPluginStateNoDebounce = (api)=>{
    const [state, setState] = (0, $42omo.useState)(api?.findReplace?.sharedState.currentState());
    (0, $42omo.useLayoutEffect)(()=>{
        const unsub = api?.findReplace?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            setState(nextSharedState);
        });
        return ()=>{
            unsub?.();
        };
    }, [
        api
    ]);
    return {
        findReplaceState: state
    };
};
const $325a0911b0fccbbc$var$FindReplaceToolbarButtonWithState = ({ popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, editorView: editorView, containerElement: containerElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent, takeFullWidth: takeFullWidth, api: api, isButtonHidden: isButtonHidden, doesNotHaveButton: doesNotHaveButton })=>{
    const editorAnalyticsAPI = api?.analytics?.actions;
    const { findReplaceState: findReplaceState } = $325a0911b0fccbbc$var$useSharedPluginStateNoDebounce(api);
    const shouldMatchCase = findReplaceState?.shouldMatchCase;
    const isActive = findReplaceState?.isActive;
    const findText = findReplaceState?.findText;
    const replaceText = findReplaceState?.replaceText;
    const index = findReplaceState?.index;
    const matches = findReplaceState?.matches;
    const shouldFocus = findReplaceState?.shouldFocus;
    if (!editorView) return null;
    // we need the editor to be in focus for scrollIntoView() to work
    // so we focus it while we run the command, then put focus back into
    // whatever element was previously focused in find replace component
    const runWithEditorFocused = (fn)=>{
        const activeElement = document.activeElement;
        editorView.focus();
        fn();
        activeElement?.focus();
    };
    const dispatchCommand = (cmd)=>{
        const { state: state, dispatch: dispatch } = editorView;
        cmd(state, dispatch);
    };
    const handleActivate = ()=>{
        runWithEditorFocused(()=>dispatchCommand((0, $11e7df9f05f7da42$export$f4a2dfcbc300db1a)(editorAnalyticsAPI)({
                triggerMethod: (0, $d925B.TRIGGER_METHOD).TOOLBAR
            })));
    };
    const handleFind = (keyword)=>{
        runWithEditorFocused(()=>dispatchCommand((0, $11e7df9f05f7da42$export$a1f845c5f9c28dec)(editorAnalyticsAPI)({
                editorView: editorView,
                containerElement: containerElement,
                keyword: keyword
            })));
    };
    const handleFindNext = ({ triggerMethod: triggerMethod })=>{
        runWithEditorFocused(()=>dispatchCommand((0, $11e7df9f05f7da42$export$da0da8f66917d4cd)(editorAnalyticsAPI, editorView)({
                triggerMethod: triggerMethod
            })));
    };
    const handleFindPrev = ({ triggerMethod: triggerMethod })=>{
        runWithEditorFocused(()=>dispatchCommand((0, $11e7df9f05f7da42$export$67b10f9d7f5c44e1)(editorAnalyticsAPI, editorView)({
                triggerMethod: triggerMethod
            })));
    };
    const handleReplace = ({ triggerMethod: triggerMethod, replaceText: replaceText })=>{
        runWithEditorFocused(()=>dispatchCommand((0, $11e7df9f05f7da42$export$95c81501036a7f64)(editorAnalyticsAPI)({
                triggerMethod: triggerMethod,
                replaceText: replaceText
            })));
    };
    const handleReplaceAll = ({ replaceText: replaceText })=>{
        runWithEditorFocused(()=>dispatchCommand((0, $11e7df9f05f7da42$export$99b6462294b19fcd)(editorAnalyticsAPI)({
                replaceText: replaceText
            })));
    };
    const handleFindBlur = ()=>{
        dispatchCommand((0, $92ce31c77152d962$export$2cc7ff91bcacba5e)());
    };
    const handleCancel = ({ triggerMethod: triggerMethod })=>{
        dispatchCommand((0, $11e7df9f05f7da42$export$330be886194dc3c6)(editorAnalyticsAPI)({
            triggerMethod: triggerMethod
        }));
        editorView.focus();
    };
    const handleToggleMatchCase = ()=>{
        dispatchCommand((0, $92ce31c77152d962$export$4e987d48fa8a04d7)());
    };
    if (shouldMatchCase === undefined || isActive === undefined || findText === undefined || replaceText === undefined || index === undefined || matches === undefined || shouldFocus === undefined) return null;
    const DropDownComponent = doesNotHaveButton ? (0, $f0283781bba03353$export$2e2bcd8739ae039) : (0, $5b4854d00022f7d3$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $l998X.jsx)(DropDownComponent, {
        shouldMatchCase: shouldMatchCase,
        onToggleMatchCase: handleToggleMatchCase,
        isActive: isActive,
        findText: findText,
        index: index,
        numMatches: matches.length,
        isReplaceable: (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? matches[index]?.canReplace : undefined,
        numReplaceable: (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? matches.filter((match)=>match.canReplace === true).length : undefined,
        replaceText: replaceText,
        shouldFocus: shouldFocus,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement,
        isReducedSpacing: !!isToolbarReducedSpacing,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        onFindBlur: handleFindBlur,
        onCancel: handleCancel,
        onActivate: handleActivate,
        onFind: handleFind,
        onFindNext: handleFindNext,
        onFindPrev: handleFindPrev,
        onReplace: handleReplace,
        onReplaceAll: handleReplaceAll,
        takeFullWidth: !!takeFullWidth,
        isButtonHidden: isButtonHidden
    });
};
var $325a0911b0fccbbc$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo($325a0911b0fccbbc$var$FindReplaceToolbarButtonWithState);


const $1a62205aee226efe$export$e5ceda4aabe9bb08 = ({ config: props, api: api })=>{
    const editorViewRef = {
        current: null
    };
    const toolbarButtonRegisteredExternally = {
        current: false
    };
    const primaryToolbarComponent = ({ popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, toolbarSize: toolbarSize, editorView: editorView, containerElement: containerElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
        if (!editorView) return null;
        const isButtonHidden = (0, $dh538.fg)('platform_editor_toolbar_responsive_fixes') ? toolbarSize < (0, $zMjD6.ToolbarSize).XL : false;
        if (props?.twoLineEditorToolbar) return null;
        else if (toolbarButtonRegisteredExternally.current && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) return null;
        else return /*#__PURE__*/ (0, $l998X.jsx)((0, $325a0911b0fccbbc$export$2e2bcd8739ae039), {
            popupsBoundariesElement: popupsBoundariesElement,
            popupsMountPoint: popupsMountPoint,
            popupsScrollableElement: popupsScrollableElement,
            isToolbarReducedSpacing: isToolbarReducedSpacing,
            editorView: editorView,
            containerElement: containerElement,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            takeFullWidth: props?.takeFullWidth,
            api: api,
            isButtonHidden: isButtonHidden
        });
    };
    api?.primaryToolbar?.actions.registerComponent({
        name: 'findReplace',
        component: primaryToolbarComponent
    });
    return {
        name: 'findReplace',
        pmPlugins () {
            const plugins = [
                {
                    name: 'findReplace',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl })=>(0, $797013ea47834520$export$ae829ec7b2625219)(dispatch, getIntl, api)
                },
                {
                    name: 'findReplaceKeymap',
                    plugin: ()=>(0, $0cc9e4cfac335e7b$export$2e2bcd8739ae039)(api?.analytics?.actions)
                }
            ];
            if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
                exposure: false
            })) plugins.push({
                name: 'findReplaceEditorViewReferencePlugin',
                plugin: ()=>{
                    return new (0, $1S4f7.SafePlugin)({
                        view: (editorView)=>{
                            editorViewRef.current = editorView;
                            return {
                                destroy: ()=>{
                                    editorViewRef.current = null;
                                }
                            };
                        }
                    });
                }
            });
            return plugins;
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $e8b1b385096c80fd$export$e7697da71e34f0a6).getState(editorState) || undefined;
        },
        actions: {
            registerToolbarButton: ({ popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, editorView: editorView, containerElement: containerElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
                toolbarButtonRegisteredExternally.current = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1');
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $325a0911b0fccbbc$export$2e2bcd8739ae039), {
                    popupsBoundariesElement: popupsBoundariesElement,
                    popupsMountPoint: popupsMountPoint,
                    popupsScrollableElement: popupsScrollableElement,
                    editorView: editorView,
                    containerElement: containerElement,
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                    isToolbarReducedSpacing: isToolbarReducedSpacing,
                    api: api
                });
            },
            activateFindReplace: (triggerMethod)=>{
                if (!editorViewRef.current) return false;
                const { state: state, dispatch: dispatch } = editorViewRef.current;
                if (api?.analytics?.actions) (0, $11e7df9f05f7da42$export$f4a2dfcbc300db1a)(api?.analytics?.actions)({
                    triggerMethod: triggerMethod || (0, $d925B.TRIGGER_METHOD).EXTERNAL
                })(state, dispatch);
                else (0, $92ce31c77152d962$export$234c45b355edd85b)()(state, dispatch);
                return true;
            }
        },
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined,
        contentComponent: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
            exposure: true
        }) ? ({ editorView: editorView, containerElement: containerElement, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, wrapperElement: wrapperElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
            if (toolbarButtonRegisteredExternally.current || !editorView) return null;
            const popupsMountPointEl = popupsMountPoint || // eslint-disable-next-line @atlaskit/editor/no-as-casting
            wrapperElement?.querySelector("[data-editor-container='true']");
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $325a0911b0fccbbc$export$2e2bcd8739ae039), {
                popupsBoundariesElement: popupsBoundariesElement,
                popupsMountPoint: popupsMountPointEl,
                popupsScrollableElement: popupsScrollableElement || containerElement || undefined,
                isToolbarReducedSpacing: false,
                editorView: editorView,
                containerElement: containerElement,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                takeFullWidth: props?.takeFullWidth,
                api: api,
                doesNotHaveButton: true
            });
        } : undefined
    };
};
module.exports["findReplacePlugin"] = $1a62205aee226efe$export$e5ceda4aabe9bb08;

});

parcelRegister("6q6xk", function(module, exports) {

var $jTb2k = parcelRequire("jTb2k");

/**
 * This plugin ensures that certain nodes (such as tables, and various extension ones)
 * have a unique `localId` attribute value for `fragment` marks.
 * It also ensures the preservation of these IDs when nodes are being cut-and-pasted
 * around the document.
 *
 * The implementation has been _heavily_ borrowed from
 * - packages/editor/editor-core/src/plugins/table/pm-plugins/table-local-id.ts
 */ 
var $fO7hX = parcelRequire("fO7hX");


var $1S4f7 = parcelRequire("1S4f7");


var $2pjJ5 = parcelRequire("2pjJ5");


var $ks2lK = parcelRequire("ks2lK");

const $4a71249a4b84ed5d$var$pluginKey = new (0, $ks2lK.PluginKey)('fragmentMarkConsistencyPlugin');
const $4a71249a4b84ed5d$var$getNodesSupportingFragmentMark = (schema)=>{
    const { table: table, extension: extension, bodiedExtension: bodiedExtension, inlineExtension: inlineExtension } = schema.nodes;
    return [
        table,
        extension,
        bodiedExtension,
        inlineExtension
    ];
};
const $4a71249a4b84ed5d$export$ae829ec7b2625219 = (dispatch)=>new (0, $1S4f7.SafePlugin)({
        key: $4a71249a4b84ed5d$var$pluginKey,
        appendTransaction: (transactions, _oldState, newState)=>{
            let modified = false;
            const tr = newState.tr;
            const { fragment: fragment } = newState.schema.marks;
            const supportedNodeTypes = $4a71249a4b84ed5d$var$getNodesSupportingFragmentMark(newState.schema);
            const addedSupportedNodes = new Set();
            const addedSupportedNodesPos = new Map();
            const localIds = new Set();
            transactions.forEach((transaction)=>{
                if (!transaction.docChanged) return;
                // Don't interfere with cut as it clashes with fixTables & we don't need
                // to handle any extra cut cases in this plugin
                const uiEvent = transaction.getMeta('uiEvent');
                if (uiEvent === 'cut') return;
                const changedNodes = (0, $2pjJ5.getChangedNodes)(transaction);
                for (const { node: node } of changedNodes){
                    if (!supportedNodeTypes.includes(node.type)) continue;
                    addedSupportedNodes.add(node);
                }
            });
            if (!addedSupportedNodes.size) return;
            // Get existing fragment marks localIds on the page
            newState.doc.descendants((node, pos)=>{
                if (addedSupportedNodes.has(node)) {
                    addedSupportedNodesPos.set(node, pos);
                    return true;
                }
                if (!supportedNodeTypes.includes(node.type)) return true;
                const existingFragmentMark = node.marks.find((mark)=>mark.type === fragment);
                if (!existingFragmentMark) // continue traversing
                return true;
                localIds.add(existingFragmentMark.attrs.localId);
                return true;
            });
            // If an added node has localId that collides with existing node, generate new localId
            for (const node of addedSupportedNodes){
                const pos = addedSupportedNodesPos.get(node);
                if (pos === undefined) continue;
                const existingFragmentMark = node.marks.find((mark)=>mark.type === fragment);
                if (!existingFragmentMark) continue;
                if (localIds.has(existingFragmentMark.attrs.localId)) {
                    tr.setNodeMarkup(pos, undefined, node.attrs, node.marks.map((mark)=>{
                        if (mark.type !== fragment) return mark;
                        const fragmentMark = fragment.create({
                            ...mark.attrs,
                            localId: (0, $fO7hX.uuid).generate(),
                            name: null
                        });
                        return fragmentMark;
                    }));
                    modified = true;
                }
            }
            if (modified) return tr;
            return;
        }
    });


const $bf157b4cb7a600ae$export$36fc1707093eff41 = ()=>({
        name: 'fragmentPlugin',
        marks () {
            return [
                {
                    name: 'fragment',
                    mark: (0, $jTb2k.fragment)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'fragmentMarkConsistency',
                    plugin: ({ dispatch: dispatch })=>(0, $4a71249a4b84ed5d$export$ae829ec7b2625219)(dispatch)
                }
            ];
        }
    });
module.exports["fragmentPlugin"] = $bf157b4cb7a600ae$export$36fc1707093eff41;

});

parcelRegister("cZifa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc4009de593579510dac1f1a04fe71b8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9749555ac70e813c$var$_react = $9749555ac70e813c$var$_interopRequireDefault((parcelRequire("42omo")));

var $9749555ac70e813c$var$_baseNew = $9749555ac70e813c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $9749555ac70e813c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ExpandElement".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for inserting expand elements in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9749555ac70e813c$var$ExpandElementIcon = (props)=>/*#__PURE__*/ $9749555ac70e813c$var$_react.default.createElement($9749555ac70e813c$var$_baseNew.default, Object.assign({
        name: "ExpandElementIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h12v1.5H3a.5.5 0 0 0-.5.5v12H1z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.48 8.42 4.61 5.67l1.04-1.08L8 6.84l2.36-2.25 1.04 1.08-2.87 2.75a.75.75 0 0 1-1.04 0M15 12H4.5v-1.5H15zm0 3H4.5v-1.5H15z" clip-rule="evenodd"/>`
    }, props));
$9749555ac70e813c$var$ExpandElementIcon.displayName = 'ExpandElementIcon';
var $9749555ac70e813c$var$_default = module.exports.default = $9749555ac70e813c$var$ExpandElementIcon;

});

parcelRegister("gF8oK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::718366f0455684b58aea71d9f899bda7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c216fd66503e26dc$var$_react = $c216fd66503e26dc$var$_interopRequireDefault((parcelRequire("42omo")));

var $c216fd66503e26dc$var$_baseNew = $c216fd66503e26dc$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c216fd66503e26dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutFiveColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for 5 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c216fd66503e26dc$var$LayoutFiveColumnsIcon = (props)=>/*#__PURE__*/ $c216fd66503e26dc$var$_react.default.createElement($c216fd66503e26dc$var$_baseNew.default, Object.assign({
        name: "LayoutFiveColumnsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 1.75A.75.75 0 0 1 .75 1h.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75zm3.5 0A.75.75 0 0 1 4.25 1h.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75zm3.5 0A.75.75 0 0 1 7.75 1h.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75zm3.5 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75zm3.5 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75z" clip-rule="evenodd"/>`
    }, props));
$c216fd66503e26dc$var$LayoutFiveColumnsIcon.displayName = 'LayoutFiveColumnsIcon';
var $c216fd66503e26dc$var$_default = module.exports.default = $c216fd66503e26dc$var$LayoutFiveColumnsIcon;

});

parcelRegister("2q3lZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4a5e2e2e2e660297affa5a42c34e8591>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1c309c73290ae2d8$var$_react = $1c309c73290ae2d8$var$_interopRequireDefault((parcelRequire("42omo")));

var $1c309c73290ae2d8$var$_baseNew = $1c309c73290ae2d8$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $1c309c73290ae2d8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutFourColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for 4 columns layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1c309c73290ae2d8$var$LayoutFourColumnsIcon = (props)=>/*#__PURE__*/ $1c309c73290ae2d8$var$_react.default.createElement($1c309c73290ae2d8$var$_baseNew.default, Object.assign({
        name: "LayoutFourColumnsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 1.75A.75.75 0 0 1 .75 1h1.375a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75H.75a.75.75 0 0 1-.75-.75zm4.375 0a.75.75 0 0 1 .75-.75H6.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75H5.125a.75.75 0 0 1-.75-.75zm4.375 0A.75.75 0 0 1 9.5 1h1.375a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75H9.5a.75.75 0 0 1-.75-.75zm4.375 0a.75.75 0 0 1 .75-.75h1.375a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-1.375a.75.75 0 0 1-.75-.75z" clip-rule="evenodd"/>`
    }, props));
$1c309c73290ae2d8$var$LayoutFourColumnsIcon.displayName = 'LayoutFourColumnsIcon';
var $1c309c73290ae2d8$var$_default = module.exports.default = $1c309c73290ae2d8$var$LayoutFourColumnsIcon;

});

parcelRegister("4ED0i", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0bb7f91405d2eac61849c57ae62c714b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3639272af2b0a146$var$_react = $3639272af2b0a146$var$_interopRequireDefault((parcelRequire("42omo")));

var $3639272af2b0a146$var$_baseNew = $3639272af2b0a146$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $3639272af2b0a146$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutThreeColumnsSidebarsLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for 3 column layout with 2 sidebars on left option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3639272af2b0a146$var$LayoutThreeColumnsSidebarsLeftIcon = (props)=>/*#__PURE__*/ $3639272af2b0a146$var$_react.default.createElement($3639272af2b0a146$var$_baseNew.default, Object.assign({
        name: "LayoutThreeColumnsSidebarsLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75C.615 15 0 14.384 0 13.625zm1.5.125v11H2v-11zM5 2.375C5 1.615 5.616 1 6.375 1h.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75C5.615 15 5 14.384 5 13.625zm1.5.125v11H7v-11zm3.5-.125C10 1.615 10.616 1 11.375 1h3.25C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-3.25c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h3v-11z" clip-rule="evenodd"/>`
    }, props));
$3639272af2b0a146$var$LayoutThreeColumnsSidebarsLeftIcon.displayName = 'LayoutThreeColumnsSidebarsLeftIcon';
var $3639272af2b0a146$var$_default = module.exports.default = $3639272af2b0a146$var$LayoutThreeColumnsSidebarsLeftIcon;

});

parcelRegister("hLZr6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::27da858e2434ed3b2bc030478f1ba16b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cf067b6321a11929$var$_react = $cf067b6321a11929$var$_interopRequireDefault((parcelRequire("42omo")));

var $cf067b6321a11929$var$_baseNew = $cf067b6321a11929$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $cf067b6321a11929$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutThreeColumnsSidebarsRight".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for 3 column layout with 2 sidebars on right option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cf067b6321a11929$var$LayoutThreeColumnsSidebarsRightIcon = (props)=>/*#__PURE__*/ $cf067b6321a11929$var$_react.default.createElement($cf067b6321a11929$var$_baseNew.default, Object.assign({
        name: "LayoutThreeColumnsSidebarsRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h3.25C5.385 1 6 1.616 6 2.375v11.25C6 14.385 5.384 15 4.625 15h-3.25C.615 15 0 14.384 0 13.625zm1.5.125v11h3v-11zm6-.125C7.5 1.615 8.116 1 8.875 1h.75C10.385 1 11 1.616 11 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75c-.76 0-1.375-.616-1.375-1.375zM9 2.5v11h.5v-11zm3.5-.125c0-.76.616-1.375 1.375-1.375h.75C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75c-.76 0-1.375-.616-1.375-1.375zM14 2.5v11h.5v-11z" clip-rule="evenodd"/>`
    }, props));
$cf067b6321a11929$var$LayoutThreeColumnsSidebarsRightIcon.displayName = 'LayoutThreeColumnsSidebarsRightIcon';
var $cf067b6321a11929$var$_default = module.exports.default = $cf067b6321a11929$var$LayoutThreeColumnsSidebarsRightIcon;

});

parcelRegister("1FOj2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e437ff979ed52fe3fc89de1b184e851d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1380a486f7d5942d$var$_react = $1380a486f7d5942d$var$_interopRequireDefault((parcelRequire("42omo")));

var $1380a486f7d5942d$var$_baseNew = $1380a486f7d5942d$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $1380a486f7d5942d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextLetterCase".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for letter casing and text-transform
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1380a486f7d5942d$var$TextLetterCaseIcon = (props)=>/*#__PURE__*/ $1380a486f7d5942d$var$_react.default.createElement($1380a486f7d5942d$var$_baseNew.default, Object.assign({
        name: "TextLetterCaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 13h-1.5v-.38a3.1 3.1 0 0 1-1.87.63c-1.95 0-3.37-1.78-3.37-3.75s1.42-3.75 3.38-3.75c.71 0 1.35.24 1.88.63v-.63H16zm-3.37-5.75c-.94 0-1.87.91-1.87 2.25s.93 2.25 1.88 2.25 1.86-.91 1.86-2.25-.93-2.25-1.87-2.25M5.71 3.51 8.92 13H7.33l-.84-2.5H2.51L1.67 13H.09l3.2-9.49.17-.51h2.08zM3.02 9h2.96L4.5 4.61z" clip-rule="evenodd"/>`
    }, props));
$1380a486f7d5942d$var$TextLetterCaseIcon.displayName = 'TextLetterCaseIcon';
var $1380a486f7d5942d$var$_default = module.exports.default = $1380a486f7d5942d$var$TextLetterCaseIcon;

});


$parcel$global.rlb("fwZcf")
//# sourceMappingURL=FullPageEditorComponent.a06ac86c.js.map
